var tg = Object.defineProperty;
var ng = (e, t, n) => (t in e ? tg(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : (e[t] = n));
var vs = (e, t, n) => (ng(e, typeof t != 'symbol' ? t + '' : t, n), n);
function ig(e, t) {
  for (var n = 0; n < t.length; n++) {
    const i = t[n];
    if (typeof i != 'string' && !Array.isArray(i)) {
      for (const r in i)
        if (r !== 'default' && !(r in e)) {
          const o = Object.getOwnPropertyDescriptor(i, r);
          o && Object.defineProperty(e, r, o.get ? o : { enumerable: !0, get: () => i[r] });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }));
}
(function () {
  const t = document.createElement('link').relList;
  if (t && t.supports && t.supports('modulepreload')) return;
  for (const r of document.querySelectorAll('link[rel="modulepreload"]')) i(r);
  new MutationObserver((r) => {
    for (const o of r)
      if (o.type === 'childList')
        for (const a of o.addedNodes) a.tagName === 'LINK' && a.rel === 'modulepreload' && i(a);
  }).observe(document, { childList: !0, subtree: !0 });
  function n(r) {
    const o = {};
    return (
      r.integrity && (o.integrity = r.integrity),
      r.referrerpolicy && (o.referrerPolicy = r.referrerpolicy),
      r.crossorigin === 'use-credentials'
        ? (o.credentials = 'include')
        : r.crossorigin === 'anonymous'
          ? (o.credentials = 'omit')
          : (o.credentials = 'same-origin'),
      o
    );
  }
  function i(r) {
    if (r.ep) return;
    r.ep = !0;
    const o = n(r);
    fetch(r.href, o);
  }
})();
var rg =
  typeof globalThis < 'u'
    ? globalThis
    : typeof window < 'u'
      ? window
      : typeof global < 'u'
        ? global
        : typeof self < 'u'
          ? self
          : {};
function og(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, 'default') ? e.default : e;
}
var B = { exports: {} },
  K = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var Zr = Symbol.for('react.element'),
  ag = Symbol.for('react.portal'),
  sg = Symbol.for('react.fragment'),
  lg = Symbol.for('react.strict_mode'),
  cg = Symbol.for('react.profiler'),
  ug = Symbol.for('react.provider'),
  dg = Symbol.for('react.context'),
  pg = Symbol.for('react.forward_ref'),
  hg = Symbol.for('react.suspense'),
  fg = Symbol.for('react.memo'),
  mg = Symbol.for('react.lazy'),
  zu = Symbol.iterator;
function gg(e) {
  return e === null || typeof e != 'object'
    ? null
    : ((e = (zu && e[zu]) || e['@@iterator']), typeof e == 'function' ? e : null);
}
var Rp = {
    isMounted: function () {
      return !1;
    },
    enqueueForceUpdate: function () {},
    enqueueReplaceState: function () {},
    enqueueSetState: function () {},
  },
  Dp = Object.assign,
  Hp = {};
function Ji(e, t, n) {
  (this.props = e), (this.context = t), (this.refs = Hp), (this.updater = n || Rp);
}
Ji.prototype.isReactComponent = {};
Ji.prototype.setState = function (e, t) {
  if (typeof e != 'object' && typeof e != 'function' && e != null)
    throw Error(
      'setState(...): takes an object of state variables to update or a function which returns an object of state variables.',
    );
  this.updater.enqueueSetState(this, e, t, 'setState');
};
Ji.prototype.forceUpdate = function (e) {
  this.updater.enqueueForceUpdate(this, e, 'forceUpdate');
};
function Op() {}
Op.prototype = Ji.prototype;
function lc(e, t, n) {
  (this.props = e), (this.context = t), (this.refs = Hp), (this.updater = n || Rp);
}
var cc = (lc.prototype = new Op());
cc.constructor = lc;
Dp(cc, Ji.prototype);
cc.isPureReactComponent = !0;
var Bu = Array.isArray,
  jp = Object.prototype.hasOwnProperty,
  uc = { current: null },
  Fp = { key: !0, ref: !0, __self: !0, __source: !0 };
function zp(e, t, n) {
  var i,
    r = {},
    o = null,
    a = null;
  if (t != null)
    for (i in (t.ref !== void 0 && (a = t.ref), t.key !== void 0 && (o = '' + t.key), t))
      jp.call(t, i) && !Fp.hasOwnProperty(i) && (r[i] = t[i]);
  var s = arguments.length - 2;
  if (s === 1) r.children = n;
  else if (1 < s) {
    for (var l = Array(s), c = 0; c < s; c++) l[c] = arguments[c + 2];
    r.children = l;
  }
  if (e && e.defaultProps) for (i in ((s = e.defaultProps), s)) r[i] === void 0 && (r[i] = s[i]);
  return { $$typeof: Zr, type: e, key: o, ref: a, props: r, _owner: uc.current };
}
function vg(e, t) {
  return { $$typeof: Zr, type: e.type, key: t, ref: e.ref, props: e.props, _owner: e._owner };
}
function dc(e) {
  return typeof e == 'object' && e !== null && e.$$typeof === Zr;
}
function _g(e) {
  var t = { '=': '=0', ':': '=2' };
  return (
    '$' +
    e.replace(/[=:]/g, function (n) {
      return t[n];
    })
  );
}
var Uu = /\/+/g;
function _s(e, t) {
  return typeof e == 'object' && e !== null && e.key != null ? _g('' + e.key) : t.toString(36);
}
function Ro(e, t, n, i, r) {
  var o = typeof e;
  (o === 'undefined' || o === 'boolean') && (e = null);
  var a = !1;
  if (e === null) a = !0;
  else
    switch (o) {
      case 'string':
      case 'number':
        a = !0;
        break;
      case 'object':
        switch (e.$$typeof) {
          case Zr:
          case ag:
            a = !0;
        }
    }
  if (a)
    return (
      (a = e),
      (r = r(a)),
      (e = i === '' ? '.' + _s(a, 0) : i),
      Bu(r)
        ? ((n = ''),
          e != null && (n = e.replace(Uu, '$&/') + '/'),
          Ro(r, t, n, '', function (c) {
            return c;
          }))
        : r != null &&
          (dc(r) &&
            (r = vg(r, n + (!r.key || (a && a.key === r.key) ? '' : ('' + r.key).replace(Uu, '$&/') + '/') + e)),
          t.push(r)),
      1
    );
  if (((a = 0), (i = i === '' ? '.' : i + ':'), Bu(e)))
    for (var s = 0; s < e.length; s++) {
      o = e[s];
      var l = i + _s(o, s);
      a += Ro(o, t, n, l, r);
    }
  else if (((l = gg(e)), typeof l == 'function'))
    for (e = l.call(e), s = 0; !(o = e.next()).done; ) (o = o.value), (l = i + _s(o, s++)), (a += Ro(o, t, n, l, r));
  else if (o === 'object')
    throw (
      ((t = String(e)),
      Error(
        'Objects are not valid as a React child (found: ' +
          (t === '[object Object]' ? 'object with keys {' + Object.keys(e).join(', ') + '}' : t) +
          '). If you meant to render a collection of children, use an array instead.',
      ))
    );
  return a;
}
function mo(e, t, n) {
  if (e == null) return e;
  var i = [],
    r = 0;
  return (
    Ro(e, i, '', '', function (o) {
      return t.call(n, o, r++);
    }),
    i
  );
}
function xg(e) {
  if (e._status === -1) {
    var t = e._result;
    (t = t()),
      t.then(
        function (n) {
          (e._status === 0 || e._status === -1) && ((e._status = 1), (e._result = n));
        },
        function (n) {
          (e._status === 0 || e._status === -1) && ((e._status = 2), (e._result = n));
        },
      ),
      e._status === -1 && ((e._status = 0), (e._result = t));
  }
  if (e._status === 1) return e._result.default;
  throw e._result;
}
var tt = { current: null },
  Do = { transition: null },
  yg = { ReactCurrentDispatcher: tt, ReactCurrentBatchConfig: Do, ReactCurrentOwner: uc };
K.Children = {
  map: mo,
  forEach: function (e, t, n) {
    mo(
      e,
      function () {
        t.apply(this, arguments);
      },
      n,
    );
  },
  count: function (e) {
    var t = 0;
    return (
      mo(e, function () {
        t++;
      }),
      t
    );
  },
  toArray: function (e) {
    return (
      mo(e, function (t) {
        return t;
      }) || []
    );
  },
  only: function (e) {
    if (!dc(e)) throw Error('React.Children.only expected to receive a single React element child.');
    return e;
  },
};
K.Component = Ji;
K.Fragment = sg;
K.Profiler = cg;
K.PureComponent = lc;
K.StrictMode = lg;
K.Suspense = hg;
K.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = yg;
K.cloneElement = function (e, t, n) {
  if (e == null)
    throw Error('React.cloneElement(...): The argument must be a React element, but you passed ' + e + '.');
  var i = Dp({}, e.props),
    r = e.key,
    o = e.ref,
    a = e._owner;
  if (t != null) {
    if (
      (t.ref !== void 0 && ((o = t.ref), (a = uc.current)),
      t.key !== void 0 && (r = '' + t.key),
      e.type && e.type.defaultProps)
    )
      var s = e.type.defaultProps;
    for (l in t) jp.call(t, l) && !Fp.hasOwnProperty(l) && (i[l] = t[l] === void 0 && s !== void 0 ? s[l] : t[l]);
  }
  var l = arguments.length - 2;
  if (l === 1) i.children = n;
  else if (1 < l) {
    s = Array(l);
    for (var c = 0; c < l; c++) s[c] = arguments[c + 2];
    i.children = s;
  }
  return { $$typeof: Zr, type: e.type, key: r, ref: o, props: i, _owner: a };
};
K.createContext = function (e) {
  return (
    (e = {
      $$typeof: dg,
      _currentValue: e,
      _currentValue2: e,
      _threadCount: 0,
      Provider: null,
      Consumer: null,
      _defaultValue: null,
      _globalName: null,
    }),
    (e.Provider = { $$typeof: ug, _context: e }),
    (e.Consumer = e)
  );
};
K.createElement = zp;
K.createFactory = function (e) {
  var t = zp.bind(null, e);
  return (t.type = e), t;
};
K.createRef = function () {
  return { current: null };
};
K.forwardRef = function (e) {
  return { $$typeof: pg, render: e };
};
K.isValidElement = dc;
K.lazy = function (e) {
  return { $$typeof: mg, _payload: { _status: -1, _result: e }, _init: xg };
};
K.memo = function (e, t) {
  return { $$typeof: fg, type: e, compare: t === void 0 ? null : t };
};
K.startTransition = function (e) {
  var t = Do.transition;
  Do.transition = {};
  try {
    e();
  } finally {
    Do.transition = t;
  }
};
K.unstable_act = function () {
  throw Error('act(...) is not supported in production builds of React.');
};
K.useCallback = function (e, t) {
  return tt.current.useCallback(e, t);
};
K.useContext = function (e) {
  return tt.current.useContext(e);
};
K.useDebugValue = function () {};
K.useDeferredValue = function (e) {
  return tt.current.useDeferredValue(e);
};
K.useEffect = function (e, t) {
  return tt.current.useEffect(e, t);
};
K.useId = function () {
  return tt.current.useId();
};
K.useImperativeHandle = function (e, t, n) {
  return tt.current.useImperativeHandle(e, t, n);
};
K.useInsertionEffect = function (e, t) {
  return tt.current.useInsertionEffect(e, t);
};
K.useLayoutEffect = function (e, t) {
  return tt.current.useLayoutEffect(e, t);
};
K.useMemo = function (e, t) {
  return tt.current.useMemo(e, t);
};
K.useReducer = function (e, t, n) {
  return tt.current.useReducer(e, t, n);
};
K.useRef = function (e) {
  return tt.current.useRef(e);
};
K.useState = function (e) {
  return tt.current.useState(e);
};
K.useSyncExternalStore = function (e, t, n) {
  return tt.current.useSyncExternalStore(e, t, n);
};
K.useTransition = function () {
  return tt.current.useTransition();
};
K.version = '18.2.0';
(function (e) {
  e.exports = K;
})(B);
const pc = og(B.exports),
  tl = ig({ __proto__: null, default: pc }, [B.exports]);
var Bp = { exports: {} },
  _t = {},
  Up = { exports: {} },
  Gp = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ (function (e) {
  function t(N, C) {
    var q = N.length;
    N.push(C);
    e: for (; 0 < q; ) {
      var Z = (q - 1) >>> 1,
        he = N[Z];
      if (0 < r(he, C)) (N[Z] = C), (N[q] = he), (q = Z);
      else break e;
    }
  }
  function n(N) {
    return N.length === 0 ? null : N[0];
  }
  function i(N) {
    if (N.length === 0) return null;
    var C = N[0],
      q = N.pop();
    if (q !== C) {
      N[0] = q;
      e: for (var Z = 0, he = N.length, Ht = he >>> 1; Z < Ht; ) {
        var it = 2 * (Z + 1) - 1,
          On = N[it],
          pt = it + 1,
          un = N[pt];
        if (0 > r(On, q))
          pt < he && 0 > r(un, On) ? ((N[Z] = un), (N[pt] = q), (Z = pt)) : ((N[Z] = On), (N[it] = q), (Z = it));
        else if (pt < he && 0 > r(un, q)) (N[Z] = un), (N[pt] = q), (Z = pt);
        else break e;
      }
    }
    return C;
  }
  function r(N, C) {
    var q = N.sortIndex - C.sortIndex;
    return q !== 0 ? q : N.id - C.id;
  }
  if (typeof performance == 'object' && typeof performance.now == 'function') {
    var o = performance;
    e.unstable_now = function () {
      return o.now();
    };
  } else {
    var a = Date,
      s = a.now();
    e.unstable_now = function () {
      return a.now() - s;
    };
  }
  var l = [],
    c = [],
    u = 1,
    f = null,
    h = 3,
    x = !1,
    y = !1,
    m = !1,
    j = typeof setTimeout == 'function' ? setTimeout : null,
    p = typeof clearTimeout == 'function' ? clearTimeout : null,
    d = typeof setImmediate < 'u' ? setImmediate : null;
  typeof navigator < 'u' &&
    navigator.scheduling !== void 0 &&
    navigator.scheduling.isInputPending !== void 0 &&
    navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function g(N) {
    for (var C = n(c); C !== null; ) {
      if (C.callback === null) i(c);
      else if (C.startTime <= N) i(c), (C.sortIndex = C.expirationTime), t(l, C);
      else break;
      C = n(c);
    }
  }
  function k(N) {
    if (((m = !1), g(N), !y))
      if (n(l) !== null) (y = !0), Wt(T);
      else {
        var C = n(c);
        C !== null && ie(k, C.startTime - N);
      }
  }
  function T(N, C) {
    (y = !1), m && ((m = !1), p(z), (z = -1)), (x = !0);
    var q = h;
    try {
      for (g(C), f = n(l); f !== null && (!(f.expirationTime > C) || (N && !Te())); ) {
        var Z = f.callback;
        if (typeof Z == 'function') {
          (f.callback = null), (h = f.priorityLevel);
          var he = Z(f.expirationTime <= C);
          (C = e.unstable_now()), typeof he == 'function' ? (f.callback = he) : f === n(l) && i(l), g(C);
        } else i(l);
        f = n(l);
      }
      if (f !== null) var Ht = !0;
      else {
        var it = n(c);
        it !== null && ie(k, it.startTime - C), (Ht = !1);
      }
      return Ht;
    } finally {
      (f = null), (h = q), (x = !1);
    }
  }
  var R = !1,
    b = null,
    z = -1,
    te = 5,
    Q = -1;
  function Te() {
    return !(e.unstable_now() - Q < te);
  }
  function _e() {
    if (b !== null) {
      var N = e.unstable_now();
      Q = N;
      var C = !0;
      try {
        C = b(!0, N);
      } finally {
        C ? Xe() : ((R = !1), (b = null));
      }
    } else R = !1;
  }
  var Xe;
  if (typeof d == 'function')
    Xe = function () {
      d(_e);
    };
  else if (typeof MessageChannel < 'u') {
    var li = new MessageChannel(),
      Ae = li.port2;
    (li.port1.onmessage = _e),
      (Xe = function () {
        Ae.postMessage(null);
      });
  } else
    Xe = function () {
      j(_e, 0);
    };
  function Wt(N) {
    (b = N), R || ((R = !0), Xe());
  }
  function ie(N, C) {
    z = j(function () {
      N(e.unstable_now());
    }, C);
  }
  (e.unstable_IdlePriority = 5),
    (e.unstable_ImmediatePriority = 1),
    (e.unstable_LowPriority = 4),
    (e.unstable_NormalPriority = 3),
    (e.unstable_Profiling = null),
    (e.unstable_UserBlockingPriority = 2),
    (e.unstable_cancelCallback = function (N) {
      N.callback = null;
    }),
    (e.unstable_continueExecution = function () {
      y || x || ((y = !0), Wt(T));
    }),
    (e.unstable_forceFrameRate = function (N) {
      0 > N || 125 < N
        ? console.error(
            'forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported',
          )
        : (te = 0 < N ? Math.floor(1e3 / N) : 5);
    }),
    (e.unstable_getCurrentPriorityLevel = function () {
      return h;
    }),
    (e.unstable_getFirstCallbackNode = function () {
      return n(l);
    }),
    (e.unstable_next = function (N) {
      switch (h) {
        case 1:
        case 2:
        case 3:
          var C = 3;
          break;
        default:
          C = h;
      }
      var q = h;
      h = C;
      try {
        return N();
      } finally {
        h = q;
      }
    }),
    (e.unstable_pauseExecution = function () {}),
    (e.unstable_requestPaint = function () {}),
    (e.unstable_runWithPriority = function (N, C) {
      switch (N) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          N = 3;
      }
      var q = h;
      h = N;
      try {
        return C();
      } finally {
        h = q;
      }
    }),
    (e.unstable_scheduleCallback = function (N, C, q) {
      var Z = e.unstable_now();
      switch (
        (typeof q == 'object' && q !== null
          ? ((q = q.delay), (q = typeof q == 'number' && 0 < q ? Z + q : Z))
          : (q = Z),
        N)
      ) {
        case 1:
          var he = -1;
          break;
        case 2:
          he = 250;
          break;
        case 5:
          he = 1073741823;
          break;
        case 4:
          he = 1e4;
          break;
        default:
          he = 5e3;
      }
      return (
        (he = q + he),
        (N = { id: u++, callback: C, priorityLevel: N, startTime: q, expirationTime: he, sortIndex: -1 }),
        q > Z
          ? ((N.sortIndex = q), t(c, N), n(l) === null && N === n(c) && (m ? (p(z), (z = -1)) : (m = !0), ie(k, q - Z)))
          : ((N.sortIndex = he), t(l, N), y || x || ((y = !0), Wt(T))),
        N
      );
    }),
    (e.unstable_shouldYield = Te),
    (e.unstable_wrapCallback = function (N) {
      var C = h;
      return function () {
        var q = h;
        h = C;
        try {
          return N.apply(this, arguments);
        } finally {
          h = q;
        }
      };
    });
})(Gp);
(function (e) {
  e.exports = Gp;
})(Up);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $p = B.exports,
  vt = Up.exports;
function w(e) {
  for (var t = 'https://reactjs.org/docs/error-decoder.html?invariant=' + e, n = 1; n < arguments.length; n++)
    t += '&args[]=' + encodeURIComponent(arguments[n]);
  return (
    'Minified React error #' +
    e +
    '; visit ' +
    t +
    ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
  );
}
var qp = new Set(),
  Dr = {};
function oi(e, t) {
  Ui(e, t), Ui(e + 'Capture', t);
}
function Ui(e, t) {
  for (Dr[e] = t, e = 0; e < t.length; e++) qp.add(t[e]);
}
var rn = !(typeof window > 'u' || typeof window.document > 'u' || typeof window.document.createElement > 'u'),
  nl = Object.prototype.hasOwnProperty,
  Eg =
    /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
  Gu = {},
  $u = {};
function kg(e) {
  return nl.call($u, e) ? !0 : nl.call(Gu, e) ? !1 : Eg.test(e) ? ($u[e] = !0) : ((Gu[e] = !0), !1);
}
function Sg(e, t, n, i) {
  if (n !== null && n.type === 0) return !1;
  switch (typeof t) {
    case 'function':
    case 'symbol':
      return !0;
    case 'boolean':
      return i
        ? !1
        : n !== null
          ? !n.acceptsBooleans
          : ((e = e.toLowerCase().slice(0, 5)), e !== 'data-' && e !== 'aria-');
    default:
      return !1;
  }
}
function Ag(e, t, n, i) {
  if (t === null || typeof t > 'u' || Sg(e, t, n, i)) return !0;
  if (i) return !1;
  if (n !== null)
    switch (n.type) {
      case 3:
        return !t;
      case 4:
        return t === !1;
      case 5:
        return isNaN(t);
      case 6:
        return isNaN(t) || 1 > t;
    }
  return !1;
}
function nt(e, t, n, i, r, o, a) {
  (this.acceptsBooleans = t === 2 || t === 3 || t === 4),
    (this.attributeName = i),
    (this.attributeNamespace = r),
    (this.mustUseProperty = n),
    (this.propertyName = e),
    (this.type = t),
    (this.sanitizeURL = o),
    (this.removeEmptyString = a);
}
var Fe = {};
'children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style'
  .split(' ')
  .forEach(function (e) {
    Fe[e] = new nt(e, 0, !1, e, null, !1, !1);
  });
[
  ['acceptCharset', 'accept-charset'],
  ['className', 'class'],
  ['htmlFor', 'for'],
  ['httpEquiv', 'http-equiv'],
].forEach(function (e) {
  var t = e[0];
  Fe[t] = new nt(t, 1, !1, e[1], null, !1, !1);
});
['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (e) {
  Fe[e] = new nt(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (e) {
  Fe[e] = new nt(e, 2, !1, e, null, !1, !1);
});
'allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope'
  .split(' ')
  .forEach(function (e) {
    Fe[e] = new nt(e, 3, !1, e.toLowerCase(), null, !1, !1);
  });
['checked', 'multiple', 'muted', 'selected'].forEach(function (e) {
  Fe[e] = new nt(e, 3, !0, e, null, !1, !1);
});
['capture', 'download'].forEach(function (e) {
  Fe[e] = new nt(e, 4, !1, e, null, !1, !1);
});
['cols', 'rows', 'size', 'span'].forEach(function (e) {
  Fe[e] = new nt(e, 6, !1, e, null, !1, !1);
});
['rowSpan', 'start'].forEach(function (e) {
  Fe[e] = new nt(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var hc = /[\-:]([a-z])/g;
function fc(e) {
  return e[1].toUpperCase();
}
'accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height'
  .split(' ')
  .forEach(function (e) {
    var t = e.replace(hc, fc);
    Fe[t] = new nt(t, 1, !1, e, null, !1, !1);
  });
'xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type'.split(' ').forEach(function (e) {
  var t = e.replace(hc, fc);
  Fe[t] = new nt(t, 1, !1, e, 'http://www.w3.org/1999/xlink', !1, !1);
});
['xml:base', 'xml:lang', 'xml:space'].forEach(function (e) {
  var t = e.replace(hc, fc);
  Fe[t] = new nt(t, 1, !1, e, 'http://www.w3.org/XML/1998/namespace', !1, !1);
});
['tabIndex', 'crossOrigin'].forEach(function (e) {
  Fe[e] = new nt(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
Fe.xlinkHref = new nt('xlinkHref', 1, !1, 'xlink:href', 'http://www.w3.org/1999/xlink', !0, !1);
['src', 'href', 'action', 'formAction'].forEach(function (e) {
  Fe[e] = new nt(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
function mc(e, t, n, i) {
  var r = Fe.hasOwnProperty(t) ? Fe[t] : null;
  (r !== null
    ? r.type !== 0
    : i || !(2 < t.length) || (t[0] !== 'o' && t[0] !== 'O') || (t[1] !== 'n' && t[1] !== 'N')) &&
    (Ag(t, n, r, i) && (n = null),
    i || r === null
      ? kg(t) && (n === null ? e.removeAttribute(t) : e.setAttribute(t, '' + n))
      : r.mustUseProperty
        ? (e[r.propertyName] = n === null ? (r.type === 3 ? !1 : '') : n)
        : ((t = r.attributeName),
          (i = r.attributeNamespace),
          n === null
            ? e.removeAttribute(t)
            : ((r = r.type),
              (n = r === 3 || (r === 4 && n === !0) ? '' : '' + n),
              i ? e.setAttributeNS(i, t, n) : e.setAttribute(t, n))));
}
var cn = $p.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
  go = Symbol.for('react.element'),
  ki = Symbol.for('react.portal'),
  Si = Symbol.for('react.fragment'),
  gc = Symbol.for('react.strict_mode'),
  il = Symbol.for('react.profiler'),
  Vp = Symbol.for('react.provider'),
  Qp = Symbol.for('react.context'),
  vc = Symbol.for('react.forward_ref'),
  rl = Symbol.for('react.suspense'),
  ol = Symbol.for('react.suspense_list'),
  _c = Symbol.for('react.memo'),
  vn = Symbol.for('react.lazy'),
  Wp = Symbol.for('react.offscreen'),
  qu = Symbol.iterator;
function ur(e) {
  return e === null || typeof e != 'object'
    ? null
    : ((e = (qu && e[qu]) || e['@@iterator']), typeof e == 'function' ? e : null);
}
var ge = Object.assign,
  xs;
function yr(e) {
  if (xs === void 0)
    try {
      throw Error();
    } catch (n) {
      var t = n.stack.trim().match(/\n( *(at )?)/);
      xs = (t && t[1]) || '';
    }
  return (
    `
` +
    xs +
    e
  );
}
var ys = !1;
function Es(e, t) {
  if (!e || ys) return '';
  ys = !0;
  var n = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (t)
      if (
        ((t = function () {
          throw Error();
        }),
        Object.defineProperty(t.prototype, 'props', {
          set: function () {
            throw Error();
          },
        }),
        typeof Reflect == 'object' && Reflect.construct)
      ) {
        try {
          Reflect.construct(t, []);
        } catch (c) {
          var i = c;
        }
        Reflect.construct(e, [], t);
      } else {
        try {
          t.call();
        } catch (c) {
          i = c;
        }
        e.call(t.prototype);
      }
    else {
      try {
        throw Error();
      } catch (c) {
        i = c;
      }
      e();
    }
  } catch (c) {
    if (c && i && typeof c.stack == 'string') {
      for (
        var r = c.stack.split(`
`),
          o = i.stack.split(`
`),
          a = r.length - 1,
          s = o.length - 1;
        1 <= a && 0 <= s && r[a] !== o[s];

      )
        s--;
      for (; 1 <= a && 0 <= s; a--, s--)
        if (r[a] !== o[s]) {
          if (a !== 1 || s !== 1)
            do
              if ((a--, s--, 0 > s || r[a] !== o[s])) {
                var l =
                  `
` + r[a].replace(' at new ', ' at ');
                return e.displayName && l.includes('<anonymous>') && (l = l.replace('<anonymous>', e.displayName)), l;
              }
            while (1 <= a && 0 <= s);
          break;
        }
    }
  } finally {
    (ys = !1), (Error.prepareStackTrace = n);
  }
  return (e = e ? e.displayName || e.name : '') ? yr(e) : '';
}
function wg(e) {
  switch (e.tag) {
    case 5:
      return yr(e.type);
    case 16:
      return yr('Lazy');
    case 13:
      return yr('Suspense');
    case 19:
      return yr('SuspenseList');
    case 0:
    case 2:
    case 15:
      return (e = Es(e.type, !1)), e;
    case 11:
      return (e = Es(e.type.render, !1)), e;
    case 1:
      return (e = Es(e.type, !0)), e;
    default:
      return '';
  }
}
function al(e) {
  if (e == null) return null;
  if (typeof e == 'function') return e.displayName || e.name || null;
  if (typeof e == 'string') return e;
  switch (e) {
    case Si:
      return 'Fragment';
    case ki:
      return 'Portal';
    case il:
      return 'Profiler';
    case gc:
      return 'StrictMode';
    case rl:
      return 'Suspense';
    case ol:
      return 'SuspenseList';
  }
  if (typeof e == 'object')
    switch (e.$$typeof) {
      case Qp:
        return (e.displayName || 'Context') + '.Consumer';
      case Vp:
        return (e._context.displayName || 'Context') + '.Provider';
      case vc:
        var t = e.render;
        return (
          (e = e.displayName),
          e || ((e = t.displayName || t.name || ''), (e = e !== '' ? 'ForwardRef(' + e + ')' : 'ForwardRef')),
          e
        );
      case _c:
        return (t = e.displayName || null), t !== null ? t : al(e.type) || 'Memo';
      case vn:
        (t = e._payload), (e = e._init);
        try {
          return al(e(t));
        } catch {}
    }
  return null;
}
function Mg(e) {
  var t = e.type;
  switch (e.tag) {
    case 24:
      return 'Cache';
    case 9:
      return (t.displayName || 'Context') + '.Consumer';
    case 10:
      return (t._context.displayName || 'Context') + '.Provider';
    case 18:
      return 'DehydratedFragment';
    case 11:
      return (
        (e = t.render),
        (e = e.displayName || e.name || ''),
        t.displayName || (e !== '' ? 'ForwardRef(' + e + ')' : 'ForwardRef')
      );
    case 7:
      return 'Fragment';
    case 5:
      return t;
    case 4:
      return 'Portal';
    case 3:
      return 'Root';
    case 6:
      return 'Text';
    case 16:
      return al(t);
    case 8:
      return t === gc ? 'StrictMode' : 'Mode';
    case 22:
      return 'Offscreen';
    case 12:
      return 'Profiler';
    case 21:
      return 'Scope';
    case 13:
      return 'Suspense';
    case 19:
      return 'SuspenseList';
    case 25:
      return 'TracingMarker';
    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if (typeof t == 'function') return t.displayName || t.name || null;
      if (typeof t == 'string') return t;
  }
  return null;
}
function In(e) {
  switch (typeof e) {
    case 'boolean':
    case 'number':
    case 'string':
    case 'undefined':
      return e;
    case 'object':
      return e;
    default:
      return '';
  }
}
function Kp(e) {
  var t = e.type;
  return (e = e.nodeName) && e.toLowerCase() === 'input' && (t === 'checkbox' || t === 'radio');
}
function Pg(e) {
  var t = Kp(e) ? 'checked' : 'value',
    n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
    i = '' + e[t];
  if (!e.hasOwnProperty(t) && typeof n < 'u' && typeof n.get == 'function' && typeof n.set == 'function') {
    var r = n.get,
      o = n.set;
    return (
      Object.defineProperty(e, t, {
        configurable: !0,
        get: function () {
          return r.call(this);
        },
        set: function (a) {
          (i = '' + a), o.call(this, a);
        },
      }),
      Object.defineProperty(e, t, { enumerable: n.enumerable }),
      {
        getValue: function () {
          return i;
        },
        setValue: function (a) {
          i = '' + a;
        },
        stopTracking: function () {
          (e._valueTracker = null), delete e[t];
        },
      }
    );
  }
}
function vo(e) {
  e._valueTracker || (e._valueTracker = Pg(e));
}
function Jp(e) {
  if (!e) return !1;
  var t = e._valueTracker;
  if (!t) return !0;
  var n = t.getValue(),
    i = '';
  return e && (i = Kp(e) ? (e.checked ? 'true' : 'false') : e.value), (e = i), e !== n ? (t.setValue(e), !0) : !1;
}
function Qo(e) {
  if (((e = e || (typeof document < 'u' ? document : void 0)), typeof e > 'u')) return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function sl(e, t) {
  var n = t.checked;
  return ge({}, t, {
    defaultChecked: void 0,
    defaultValue: void 0,
    value: void 0,
    checked: n != null ? n : e._wrapperState.initialChecked,
  });
}
function Vu(e, t) {
  var n = t.defaultValue == null ? '' : t.defaultValue,
    i = t.checked != null ? t.checked : t.defaultChecked;
  (n = In(t.value != null ? t.value : n)),
    (e._wrapperState = {
      initialChecked: i,
      initialValue: n,
      controlled: t.type === 'checkbox' || t.type === 'radio' ? t.checked != null : t.value != null,
    });
}
function Xp(e, t) {
  (t = t.checked), t != null && mc(e, 'checked', t, !1);
}
function ll(e, t) {
  Xp(e, t);
  var n = In(t.value),
    i = t.type;
  if (n != null)
    i === 'number'
      ? ((n === 0 && e.value === '') || e.value != n) && (e.value = '' + n)
      : e.value !== '' + n && (e.value = '' + n);
  else if (i === 'submit' || i === 'reset') {
    e.removeAttribute('value');
    return;
  }
  t.hasOwnProperty('value') ? cl(e, t.type, n) : t.hasOwnProperty('defaultValue') && cl(e, t.type, In(t.defaultValue)),
    t.checked == null && t.defaultChecked != null && (e.defaultChecked = !!t.defaultChecked);
}
function Qu(e, t, n) {
  if (t.hasOwnProperty('value') || t.hasOwnProperty('defaultValue')) {
    var i = t.type;
    if (!((i !== 'submit' && i !== 'reset') || (t.value !== void 0 && t.value !== null))) return;
    (t = '' + e._wrapperState.initialValue), n || t === e.value || (e.value = t), (e.defaultValue = t);
  }
  (n = e.name),
    n !== '' && (e.name = ''),
    (e.defaultChecked = !!e._wrapperState.initialChecked),
    n !== '' && (e.name = n);
}
function cl(e, t, n) {
  (t !== 'number' || Qo(e.ownerDocument) !== e) &&
    (n == null
      ? (e.defaultValue = '' + e._wrapperState.initialValue)
      : e.defaultValue !== '' + n && (e.defaultValue = '' + n));
}
var Er = Array.isArray;
function Di(e, t, n, i) {
  if (((e = e.options), t)) {
    t = {};
    for (var r = 0; r < n.length; r++) t['$' + n[r]] = !0;
    for (n = 0; n < e.length; n++)
      (r = t.hasOwnProperty('$' + e[n].value)),
        e[n].selected !== r && (e[n].selected = r),
        r && i && (e[n].defaultSelected = !0);
  } else {
    for (n = '' + In(n), t = null, r = 0; r < e.length; r++) {
      if (e[r].value === n) {
        (e[r].selected = !0), i && (e[r].defaultSelected = !0);
        return;
      }
      t !== null || e[r].disabled || (t = e[r]);
    }
    t !== null && (t.selected = !0);
  }
}
function ul(e, t) {
  if (t.dangerouslySetInnerHTML != null) throw Error(w(91));
  return ge({}, t, { value: void 0, defaultValue: void 0, children: '' + e._wrapperState.initialValue });
}
function Wu(e, t) {
  var n = t.value;
  if (n == null) {
    if (((n = t.children), (t = t.defaultValue), n != null)) {
      if (t != null) throw Error(w(92));
      if (Er(n)) {
        if (1 < n.length) throw Error(w(93));
        n = n[0];
      }
      t = n;
    }
    t == null && (t = ''), (n = t);
  }
  e._wrapperState = { initialValue: In(n) };
}
function Zp(e, t) {
  var n = In(t.value),
    i = In(t.defaultValue);
  n != null &&
    ((n = '' + n),
    n !== e.value && (e.value = n),
    t.defaultValue == null && e.defaultValue !== n && (e.defaultValue = n)),
    i != null && (e.defaultValue = '' + i);
}
function Ku(e) {
  var t = e.textContent;
  t === e._wrapperState.initialValue && t !== '' && t !== null && (e.value = t);
}
function Yp(e) {
  switch (e) {
    case 'svg':
      return 'http://www.w3.org/2000/svg';
    case 'math':
      return 'http://www.w3.org/1998/Math/MathML';
    default:
      return 'http://www.w3.org/1999/xhtml';
  }
}
function dl(e, t) {
  return e == null || e === 'http://www.w3.org/1999/xhtml'
    ? Yp(t)
    : e === 'http://www.w3.org/2000/svg' && t === 'foreignObject'
      ? 'http://www.w3.org/1999/xhtml'
      : e;
}
var _o,
  eh = (function (e) {
    return typeof MSApp < 'u' && MSApp.execUnsafeLocalFunction
      ? function (t, n, i, r) {
          MSApp.execUnsafeLocalFunction(function () {
            return e(t, n, i, r);
          });
        }
      : e;
  })(function (e, t) {
    if (e.namespaceURI !== 'http://www.w3.org/2000/svg' || 'innerHTML' in e) e.innerHTML = t;
    else {
      for (
        _o = _o || document.createElement('div'),
          _o.innerHTML = '<svg>' + t.valueOf().toString() + '</svg>',
          t = _o.firstChild;
        e.firstChild;

      )
        e.removeChild(e.firstChild);
      for (; t.firstChild; ) e.appendChild(t.firstChild);
    }
  });
function Hr(e, t) {
  if (t) {
    var n = e.firstChild;
    if (n && n === e.lastChild && n.nodeType === 3) {
      n.nodeValue = t;
      return;
    }
  }
  e.textContent = t;
}
var wr = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0,
  },
  Tg = ['Webkit', 'ms', 'Moz', 'O'];
Object.keys(wr).forEach(function (e) {
  Tg.forEach(function (t) {
    (t = t + e.charAt(0).toUpperCase() + e.substring(1)), (wr[t] = wr[e]);
  });
});
function th(e, t, n) {
  return t == null || typeof t == 'boolean' || t === ''
    ? ''
    : n || typeof t != 'number' || t === 0 || (wr.hasOwnProperty(e) && wr[e])
      ? ('' + t).trim()
      : t + 'px';
}
function nh(e, t) {
  e = e.style;
  for (var n in t)
    if (t.hasOwnProperty(n)) {
      var i = n.indexOf('--') === 0,
        r = th(n, t[n], i);
      n === 'float' && (n = 'cssFloat'), i ? e.setProperty(n, r) : (e[n] = r);
    }
}
var Cg = ge(
  { menuitem: !0 },
  {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0,
  },
);
function pl(e, t) {
  if (t) {
    if (Cg[e] && (t.children != null || t.dangerouslySetInnerHTML != null)) throw Error(w(137, e));
    if (t.dangerouslySetInnerHTML != null) {
      if (t.children != null) throw Error(w(60));
      if (typeof t.dangerouslySetInnerHTML != 'object' || !('__html' in t.dangerouslySetInnerHTML)) throw Error(w(61));
    }
    if (t.style != null && typeof t.style != 'object') throw Error(w(62));
  }
}
function hl(e, t) {
  if (e.indexOf('-') === -1) return typeof t.is == 'string';
  switch (e) {
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return !1;
    default:
      return !0;
  }
}
var fl = null;
function xc(e) {
  return (
    (e = e.target || e.srcElement || window),
    e.correspondingUseElement && (e = e.correspondingUseElement),
    e.nodeType === 3 ? e.parentNode : e
  );
}
var ml = null,
  Hi = null,
  Oi = null;
function Ju(e) {
  if ((e = to(e))) {
    if (typeof ml != 'function') throw Error(w(280));
    var t = e.stateNode;
    t && ((t = Sa(t)), ml(e.stateNode, e.type, t));
  }
}
function ih(e) {
  Hi ? (Oi ? Oi.push(e) : (Oi = [e])) : (Hi = e);
}
function rh() {
  if (Hi) {
    var e = Hi,
      t = Oi;
    if (((Oi = Hi = null), Ju(e), t)) for (e = 0; e < t.length; e++) Ju(t[e]);
  }
}
function oh(e, t) {
  return e(t);
}
function ah() {}
var ks = !1;
function sh(e, t, n) {
  if (ks) return e(t, n);
  ks = !0;
  try {
    return oh(e, t, n);
  } finally {
    (ks = !1), (Hi !== null || Oi !== null) && (ah(), rh());
  }
}
function Or(e, t) {
  var n = e.stateNode;
  if (n === null) return null;
  var i = Sa(n);
  if (i === null) return null;
  n = i[t];
  e: switch (t) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
    case 'onMouseEnter':
      (i = !i.disabled) ||
        ((e = e.type), (i = !(e === 'button' || e === 'input' || e === 'select' || e === 'textarea'))),
        (e = !i);
      break e;
    default:
      e = !1;
  }
  if (e) return null;
  if (n && typeof n != 'function') throw Error(w(231, t, typeof n));
  return n;
}
var gl = !1;
if (rn)
  try {
    var dr = {};
    Object.defineProperty(dr, 'passive', {
      get: function () {
        gl = !0;
      },
    }),
      window.addEventListener('test', dr, dr),
      window.removeEventListener('test', dr, dr);
  } catch {
    gl = !1;
  }
function bg(e, t, n, i, r, o, a, s, l) {
  var c = Array.prototype.slice.call(arguments, 3);
  try {
    t.apply(n, c);
  } catch (u) {
    this.onError(u);
  }
}
var Mr = !1,
  Wo = null,
  Ko = !1,
  vl = null,
  Ig = {
    onError: function (e) {
      (Mr = !0), (Wo = e);
    },
  };
function Lg(e, t, n, i, r, o, a, s, l) {
  (Mr = !1), (Wo = null), bg.apply(Ig, arguments);
}
function Ng(e, t, n, i, r, o, a, s, l) {
  if ((Lg.apply(this, arguments), Mr)) {
    if (Mr) {
      var c = Wo;
      (Mr = !1), (Wo = null);
    } else throw Error(w(198));
    Ko || ((Ko = !0), (vl = c));
  }
}
function ai(e) {
  var t = e,
    n = e;
  if (e.alternate) for (; t.return; ) t = t.return;
  else {
    e = t;
    do (t = e), (t.flags & 4098) !== 0 && (n = t.return), (e = t.return);
    while (e);
  }
  return t.tag === 3 ? n : null;
}
function lh(e) {
  if (e.tag === 13) {
    var t = e.memoizedState;
    if ((t === null && ((e = e.alternate), e !== null && (t = e.memoizedState)), t !== null)) return t.dehydrated;
  }
  return null;
}
function Xu(e) {
  if (ai(e) !== e) throw Error(w(188));
}
function Rg(e) {
  var t = e.alternate;
  if (!t) {
    if (((t = ai(e)), t === null)) throw Error(w(188));
    return t !== e ? null : e;
  }
  for (var n = e, i = t; ; ) {
    var r = n.return;
    if (r === null) break;
    var o = r.alternate;
    if (o === null) {
      if (((i = r.return), i !== null)) {
        n = i;
        continue;
      }
      break;
    }
    if (r.child === o.child) {
      for (o = r.child; o; ) {
        if (o === n) return Xu(r), e;
        if (o === i) return Xu(r), t;
        o = o.sibling;
      }
      throw Error(w(188));
    }
    if (n.return !== i.return) (n = r), (i = o);
    else {
      for (var a = !1, s = r.child; s; ) {
        if (s === n) {
          (a = !0), (n = r), (i = o);
          break;
        }
        if (s === i) {
          (a = !0), (i = r), (n = o);
          break;
        }
        s = s.sibling;
      }
      if (!a) {
        for (s = o.child; s; ) {
          if (s === n) {
            (a = !0), (n = o), (i = r);
            break;
          }
          if (s === i) {
            (a = !0), (i = o), (n = r);
            break;
          }
          s = s.sibling;
        }
        if (!a) throw Error(w(189));
      }
    }
    if (n.alternate !== i) throw Error(w(190));
  }
  if (n.tag !== 3) throw Error(w(188));
  return n.stateNode.current === n ? e : t;
}
function ch(e) {
  return (e = Rg(e)), e !== null ? uh(e) : null;
}
function uh(e) {
  if (e.tag === 5 || e.tag === 6) return e;
  for (e = e.child; e !== null; ) {
    var t = uh(e);
    if (t !== null) return t;
    e = e.sibling;
  }
  return null;
}
var dh = vt.unstable_scheduleCallback,
  Zu = vt.unstable_cancelCallback,
  Dg = vt.unstable_shouldYield,
  Hg = vt.unstable_requestPaint,
  ye = vt.unstable_now,
  Og = vt.unstable_getCurrentPriorityLevel,
  yc = vt.unstable_ImmediatePriority,
  ph = vt.unstable_UserBlockingPriority,
  Jo = vt.unstable_NormalPriority,
  jg = vt.unstable_LowPriority,
  hh = vt.unstable_IdlePriority,
  xa = null,
  qt = null;
function Fg(e) {
  if (qt && typeof qt.onCommitFiberRoot == 'function')
    try {
      qt.onCommitFiberRoot(xa, e, void 0, (e.current.flags & 128) === 128);
    } catch {}
}
var Nt = Math.clz32 ? Math.clz32 : Ug,
  zg = Math.log,
  Bg = Math.LN2;
function Ug(e) {
  return (e >>>= 0), e === 0 ? 32 : (31 - ((zg(e) / Bg) | 0)) | 0;
}
var xo = 64,
  yo = 4194304;
function kr(e) {
  switch (e & -e) {
    case 1:
      return 1;
    case 2:
      return 2;
    case 4:
      return 4;
    case 8:
      return 8;
    case 16:
      return 16;
    case 32:
      return 32;
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return e & 4194240;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return e & 130023424;
    case 134217728:
      return 134217728;
    case 268435456:
      return 268435456;
    case 536870912:
      return 536870912;
    case 1073741824:
      return 1073741824;
    default:
      return e;
  }
}
function Xo(e, t) {
  var n = e.pendingLanes;
  if (n === 0) return 0;
  var i = 0,
    r = e.suspendedLanes,
    o = e.pingedLanes,
    a = n & 268435455;
  if (a !== 0) {
    var s = a & ~r;
    s !== 0 ? (i = kr(s)) : ((o &= a), o !== 0 && (i = kr(o)));
  } else (a = n & ~r), a !== 0 ? (i = kr(a)) : o !== 0 && (i = kr(o));
  if (i === 0) return 0;
  if (t !== 0 && t !== i && (t & r) === 0 && ((r = i & -i), (o = t & -t), r >= o || (r === 16 && (o & 4194240) !== 0)))
    return t;
  if (((i & 4) !== 0 && (i |= n & 16), (t = e.entangledLanes), t !== 0))
    for (e = e.entanglements, t &= i; 0 < t; ) (n = 31 - Nt(t)), (r = 1 << n), (i |= e[n]), (t &= ~r);
  return i;
}
function Gg(e, t) {
  switch (e) {
    case 1:
    case 2:
    case 4:
      return t + 250;
    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return t + 5e3;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;
    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;
    default:
      return -1;
  }
}
function $g(e, t) {
  for (var n = e.suspendedLanes, i = e.pingedLanes, r = e.expirationTimes, o = e.pendingLanes; 0 < o; ) {
    var a = 31 - Nt(o),
      s = 1 << a,
      l = r[a];
    l === -1 ? ((s & n) === 0 || (s & i) !== 0) && (r[a] = Gg(s, t)) : l <= t && (e.expiredLanes |= s), (o &= ~s);
  }
}
function _l(e) {
  return (e = e.pendingLanes & -1073741825), e !== 0 ? e : e & 1073741824 ? 1073741824 : 0;
}
function fh() {
  var e = xo;
  return (xo <<= 1), (xo & 4194240) === 0 && (xo = 64), e;
}
function Ss(e) {
  for (var t = [], n = 0; 31 > n; n++) t.push(e);
  return t;
}
function Yr(e, t, n) {
  (e.pendingLanes |= t),
    t !== 536870912 && ((e.suspendedLanes = 0), (e.pingedLanes = 0)),
    (e = e.eventTimes),
    (t = 31 - Nt(t)),
    (e[t] = n);
}
function qg(e, t) {
  var n = e.pendingLanes & ~t;
  (e.pendingLanes = t),
    (e.suspendedLanes = 0),
    (e.pingedLanes = 0),
    (e.expiredLanes &= t),
    (e.mutableReadLanes &= t),
    (e.entangledLanes &= t),
    (t = e.entanglements);
  var i = e.eventTimes;
  for (e = e.expirationTimes; 0 < n; ) {
    var r = 31 - Nt(n),
      o = 1 << r;
    (t[r] = 0), (i[r] = -1), (e[r] = -1), (n &= ~o);
  }
}
function Ec(e, t) {
  var n = (e.entangledLanes |= t);
  for (e = e.entanglements; n; ) {
    var i = 31 - Nt(n),
      r = 1 << i;
    (r & t) | (e[i] & t) && (e[i] |= t), (n &= ~r);
  }
}
var oe = 0;
function mh(e) {
  return (e &= -e), 1 < e ? (4 < e ? ((e & 268435455) !== 0 ? 16 : 536870912) : 4) : 1;
}
var gh,
  kc,
  vh,
  _h,
  xh,
  xl = !1,
  Eo = [],
  Sn = null,
  An = null,
  wn = null,
  jr = new Map(),
  Fr = new Map(),
  xn = [],
  Vg =
    'mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit'.split(
      ' ',
    );
function Yu(e, t) {
  switch (e) {
    case 'focusin':
    case 'focusout':
      Sn = null;
      break;
    case 'dragenter':
    case 'dragleave':
      An = null;
      break;
    case 'mouseover':
    case 'mouseout':
      wn = null;
      break;
    case 'pointerover':
    case 'pointerout':
      jr.delete(t.pointerId);
      break;
    case 'gotpointercapture':
    case 'lostpointercapture':
      Fr.delete(t.pointerId);
  }
}
function pr(e, t, n, i, r, o) {
  return e === null || e.nativeEvent !== o
    ? ((e = { blockedOn: t, domEventName: n, eventSystemFlags: i, nativeEvent: o, targetContainers: [r] }),
      t !== null && ((t = to(t)), t !== null && kc(t)),
      e)
    : ((e.eventSystemFlags |= i), (t = e.targetContainers), r !== null && t.indexOf(r) === -1 && t.push(r), e);
}
function Qg(e, t, n, i, r) {
  switch (t) {
    case 'focusin':
      return (Sn = pr(Sn, e, t, n, i, r)), !0;
    case 'dragenter':
      return (An = pr(An, e, t, n, i, r)), !0;
    case 'mouseover':
      return (wn = pr(wn, e, t, n, i, r)), !0;
    case 'pointerover':
      var o = r.pointerId;
      return jr.set(o, pr(jr.get(o) || null, e, t, n, i, r)), !0;
    case 'gotpointercapture':
      return (o = r.pointerId), Fr.set(o, pr(Fr.get(o) || null, e, t, n, i, r)), !0;
  }
  return !1;
}
function yh(e) {
  var t = qn(e.target);
  if (t !== null) {
    var n = ai(t);
    if (n !== null) {
      if (((t = n.tag), t === 13)) {
        if (((t = lh(n)), t !== null)) {
          (e.blockedOn = t),
            xh(e.priority, function () {
              vh(n);
            });
          return;
        }
      } else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
        e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
        return;
      }
    }
  }
  e.blockedOn = null;
}
function Ho(e) {
  if (e.blockedOn !== null) return !1;
  for (var t = e.targetContainers; 0 < t.length; ) {
    var n = yl(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
    if (n === null) {
      n = e.nativeEvent;
      var i = new n.constructor(n.type, n);
      (fl = i), n.target.dispatchEvent(i), (fl = null);
    } else return (t = to(n)), t !== null && kc(t), (e.blockedOn = n), !1;
    t.shift();
  }
  return !0;
}
function ed(e, t, n) {
  Ho(e) && n.delete(t);
}
function Wg() {
  (xl = !1),
    Sn !== null && Ho(Sn) && (Sn = null),
    An !== null && Ho(An) && (An = null),
    wn !== null && Ho(wn) && (wn = null),
    jr.forEach(ed),
    Fr.forEach(ed);
}
function hr(e, t) {
  e.blockedOn === t &&
    ((e.blockedOn = null), xl || ((xl = !0), vt.unstable_scheduleCallback(vt.unstable_NormalPriority, Wg)));
}
function zr(e) {
  function t(r) {
    return hr(r, e);
  }
  if (0 < Eo.length) {
    hr(Eo[0], e);
    for (var n = 1; n < Eo.length; n++) {
      var i = Eo[n];
      i.blockedOn === e && (i.blockedOn = null);
    }
  }
  for (
    Sn !== null && hr(Sn, e), An !== null && hr(An, e), wn !== null && hr(wn, e), jr.forEach(t), Fr.forEach(t), n = 0;
    n < xn.length;
    n++
  )
    (i = xn[n]), i.blockedOn === e && (i.blockedOn = null);
  for (; 0 < xn.length && ((n = xn[0]), n.blockedOn === null); ) yh(n), n.blockedOn === null && xn.shift();
}
var ji = cn.ReactCurrentBatchConfig,
  Zo = !0;
function Kg(e, t, n, i) {
  var r = oe,
    o = ji.transition;
  ji.transition = null;
  try {
    (oe = 1), Sc(e, t, n, i);
  } finally {
    (oe = r), (ji.transition = o);
  }
}
function Jg(e, t, n, i) {
  var r = oe,
    o = ji.transition;
  ji.transition = null;
  try {
    (oe = 4), Sc(e, t, n, i);
  } finally {
    (oe = r), (ji.transition = o);
  }
}
function Sc(e, t, n, i) {
  if (Zo) {
    var r = yl(e, t, n, i);
    if (r === null) Ns(e, t, i, Yo, n), Yu(e, i);
    else if (Qg(r, e, t, n, i)) i.stopPropagation();
    else if ((Yu(e, i), t & 4 && -1 < Vg.indexOf(e))) {
      for (; r !== null; ) {
        var o = to(r);
        if ((o !== null && gh(o), (o = yl(e, t, n, i)), o === null && Ns(e, t, i, Yo, n), o === r)) break;
        r = o;
      }
      r !== null && i.stopPropagation();
    } else Ns(e, t, i, null, n);
  }
}
var Yo = null;
function yl(e, t, n, i) {
  if (((Yo = null), (e = xc(i)), (e = qn(e)), e !== null))
    if (((t = ai(e)), t === null)) e = null;
    else if (((n = t.tag), n === 13)) {
      if (((e = lh(t)), e !== null)) return e;
      e = null;
    } else if (n === 3) {
      if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
      e = null;
    } else t !== e && (e = null);
  return (Yo = e), null;
}
function Eh(e) {
  switch (e) {
    case 'cancel':
    case 'click':
    case 'close':
    case 'contextmenu':
    case 'copy':
    case 'cut':
    case 'auxclick':
    case 'dblclick':
    case 'dragend':
    case 'dragstart':
    case 'drop':
    case 'focusin':
    case 'focusout':
    case 'input':
    case 'invalid':
    case 'keydown':
    case 'keypress':
    case 'keyup':
    case 'mousedown':
    case 'mouseup':
    case 'paste':
    case 'pause':
    case 'play':
    case 'pointercancel':
    case 'pointerdown':
    case 'pointerup':
    case 'ratechange':
    case 'reset':
    case 'resize':
    case 'seeked':
    case 'submit':
    case 'touchcancel':
    case 'touchend':
    case 'touchstart':
    case 'volumechange':
    case 'change':
    case 'selectionchange':
    case 'textInput':
    case 'compositionstart':
    case 'compositionend':
    case 'compositionupdate':
    case 'beforeblur':
    case 'afterblur':
    case 'beforeinput':
    case 'blur':
    case 'fullscreenchange':
    case 'focus':
    case 'hashchange':
    case 'popstate':
    case 'select':
    case 'selectstart':
      return 1;
    case 'drag':
    case 'dragenter':
    case 'dragexit':
    case 'dragleave':
    case 'dragover':
    case 'mousemove':
    case 'mouseout':
    case 'mouseover':
    case 'pointermove':
    case 'pointerout':
    case 'pointerover':
    case 'scroll':
    case 'toggle':
    case 'touchmove':
    case 'wheel':
    case 'mouseenter':
    case 'mouseleave':
    case 'pointerenter':
    case 'pointerleave':
      return 4;
    case 'message':
      switch (Og()) {
        case yc:
          return 1;
        case ph:
          return 4;
        case Jo:
        case jg:
          return 16;
        case hh:
          return 536870912;
        default:
          return 16;
      }
    default:
      return 16;
  }
}
var En = null,
  Ac = null,
  Oo = null;
function kh() {
  if (Oo) return Oo;
  var e,
    t = Ac,
    n = t.length,
    i,
    r = 'value' in En ? En.value : En.textContent,
    o = r.length;
  for (e = 0; e < n && t[e] === r[e]; e++);
  var a = n - e;
  for (i = 1; i <= a && t[n - i] === r[o - i]; i++);
  return (Oo = r.slice(e, 1 < i ? 1 - i : void 0));
}
function jo(e) {
  var t = e.keyCode;
  return (
    'charCode' in e ? ((e = e.charCode), e === 0 && t === 13 && (e = 13)) : (e = t),
    e === 10 && (e = 13),
    32 <= e || e === 13 ? e : 0
  );
}
function ko() {
  return !0;
}
function td() {
  return !1;
}
function xt(e) {
  function t(n, i, r, o, a) {
    (this._reactName = n),
      (this._targetInst = r),
      (this.type = i),
      (this.nativeEvent = o),
      (this.target = a),
      (this.currentTarget = null);
    for (var s in e) e.hasOwnProperty(s) && ((n = e[s]), (this[s] = n ? n(o) : o[s]));
    return (
      (this.isDefaultPrevented = (o.defaultPrevented != null ? o.defaultPrevented : o.returnValue === !1) ? ko : td),
      (this.isPropagationStopped = td),
      this
    );
  }
  return (
    ge(t.prototype, {
      preventDefault: function () {
        this.defaultPrevented = !0;
        var n = this.nativeEvent;
        n &&
          (n.preventDefault ? n.preventDefault() : typeof n.returnValue != 'unknown' && (n.returnValue = !1),
          (this.isDefaultPrevented = ko));
      },
      stopPropagation: function () {
        var n = this.nativeEvent;
        n &&
          (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != 'unknown' && (n.cancelBubble = !0),
          (this.isPropagationStopped = ko));
      },
      persist: function () {},
      isPersistent: ko,
    }),
    t
  );
}
var Xi = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function (e) {
      return e.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0,
  },
  wc = xt(Xi),
  eo = ge({}, Xi, { view: 0, detail: 0 }),
  Xg = xt(eo),
  As,
  ws,
  fr,
  ya = ge({}, eo, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: Mc,
    button: 0,
    buttons: 0,
    relatedTarget: function (e) {
      return e.relatedTarget === void 0
        ? e.fromElement === e.srcElement
          ? e.toElement
          : e.fromElement
        : e.relatedTarget;
    },
    movementX: function (e) {
      return 'movementX' in e
        ? e.movementX
        : (e !== fr &&
            (fr && e.type === 'mousemove'
              ? ((As = e.screenX - fr.screenX), (ws = e.screenY - fr.screenY))
              : (ws = As = 0),
            (fr = e)),
          As);
    },
    movementY: function (e) {
      return 'movementY' in e ? e.movementY : ws;
    },
  }),
  nd = xt(ya),
  Zg = ge({}, ya, { dataTransfer: 0 }),
  Yg = xt(Zg),
  ev = ge({}, eo, { relatedTarget: 0 }),
  Ms = xt(ev),
  tv = ge({}, Xi, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }),
  nv = xt(tv),
  iv = ge({}, Xi, {
    clipboardData: function (e) {
      return 'clipboardData' in e ? e.clipboardData : window.clipboardData;
    },
  }),
  rv = xt(iv),
  ov = ge({}, Xi, { data: 0 }),
  id = xt(ov),
  av = {
    Esc: 'Escape',
    Spacebar: ' ',
    Left: 'ArrowLeft',
    Up: 'ArrowUp',
    Right: 'ArrowRight',
    Down: 'ArrowDown',
    Del: 'Delete',
    Win: 'OS',
    Menu: 'ContextMenu',
    Apps: 'ContextMenu',
    Scroll: 'ScrollLock',
    MozPrintableKey: 'Unidentified',
  },
  sv = {
    8: 'Backspace',
    9: 'Tab',
    12: 'Clear',
    13: 'Enter',
    16: 'Shift',
    17: 'Control',
    18: 'Alt',
    19: 'Pause',
    20: 'CapsLock',
    27: 'Escape',
    32: ' ',
    33: 'PageUp',
    34: 'PageDown',
    35: 'End',
    36: 'Home',
    37: 'ArrowLeft',
    38: 'ArrowUp',
    39: 'ArrowRight',
    40: 'ArrowDown',
    45: 'Insert',
    46: 'Delete',
    112: 'F1',
    113: 'F2',
    114: 'F3',
    115: 'F4',
    116: 'F5',
    117: 'F6',
    118: 'F7',
    119: 'F8',
    120: 'F9',
    121: 'F10',
    122: 'F11',
    123: 'F12',
    144: 'NumLock',
    145: 'ScrollLock',
    224: 'Meta',
  },
  lv = { Alt: 'altKey', Control: 'ctrlKey', Meta: 'metaKey', Shift: 'shiftKey' };
function cv(e) {
  var t = this.nativeEvent;
  return t.getModifierState ? t.getModifierState(e) : (e = lv[e]) ? !!t[e] : !1;
}
function Mc() {
  return cv;
}
var uv = ge({}, eo, {
    key: function (e) {
      if (e.key) {
        var t = av[e.key] || e.key;
        if (t !== 'Unidentified') return t;
      }
      return e.type === 'keypress'
        ? ((e = jo(e)), e === 13 ? 'Enter' : String.fromCharCode(e))
        : e.type === 'keydown' || e.type === 'keyup'
          ? sv[e.keyCode] || 'Unidentified'
          : '';
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: Mc,
    charCode: function (e) {
      return e.type === 'keypress' ? jo(e) : 0;
    },
    keyCode: function (e) {
      return e.type === 'keydown' || e.type === 'keyup' ? e.keyCode : 0;
    },
    which: function (e) {
      return e.type === 'keypress' ? jo(e) : e.type === 'keydown' || e.type === 'keyup' ? e.keyCode : 0;
    },
  }),
  dv = xt(uv),
  pv = ge({}, ya, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0,
  }),
  rd = xt(pv),
  hv = ge({}, eo, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: Mc,
  }),
  fv = xt(hv),
  mv = ge({}, Xi, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
  gv = xt(mv),
  vv = ge({}, ya, {
    deltaX: function (e) {
      return 'deltaX' in e ? e.deltaX : 'wheelDeltaX' in e ? -e.wheelDeltaX : 0;
    },
    deltaY: function (e) {
      return 'deltaY' in e ? e.deltaY : 'wheelDeltaY' in e ? -e.wheelDeltaY : 'wheelDelta' in e ? -e.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0,
  }),
  _v = xt(vv),
  xv = [9, 13, 27, 32],
  Pc = rn && 'CompositionEvent' in window,
  Pr = null;
rn && 'documentMode' in document && (Pr = document.documentMode);
var yv = rn && 'TextEvent' in window && !Pr,
  Sh = rn && (!Pc || (Pr && 8 < Pr && 11 >= Pr)),
  od = String.fromCharCode(32),
  ad = !1;
function Ah(e, t) {
  switch (e) {
    case 'keyup':
      return xv.indexOf(t.keyCode) !== -1;
    case 'keydown':
      return t.keyCode !== 229;
    case 'keypress':
    case 'mousedown':
    case 'focusout':
      return !0;
    default:
      return !1;
  }
}
function wh(e) {
  return (e = e.detail), typeof e == 'object' && 'data' in e ? e.data : null;
}
var Ai = !1;
function Ev(e, t) {
  switch (e) {
    case 'compositionend':
      return wh(t);
    case 'keypress':
      return t.which !== 32 ? null : ((ad = !0), od);
    case 'textInput':
      return (e = t.data), e === od && ad ? null : e;
    default:
      return null;
  }
}
function kv(e, t) {
  if (Ai) return e === 'compositionend' || (!Pc && Ah(e, t)) ? ((e = kh()), (Oo = Ac = En = null), (Ai = !1), e) : null;
  switch (e) {
    case 'paste':
      return null;
    case 'keypress':
      if (!(t.ctrlKey || t.altKey || t.metaKey) || (t.ctrlKey && t.altKey)) {
        if (t.char && 1 < t.char.length) return t.char;
        if (t.which) return String.fromCharCode(t.which);
      }
      return null;
    case 'compositionend':
      return Sh && t.locale !== 'ko' ? null : t.data;
    default:
      return null;
  }
}
var Sv = {
  color: !0,
  date: !0,
  datetime: !0,
  'datetime-local': !0,
  email: !0,
  month: !0,
  number: !0,
  password: !0,
  range: !0,
  search: !0,
  tel: !0,
  text: !0,
  time: !0,
  url: !0,
  week: !0,
};
function sd(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return t === 'input' ? !!Sv[e.type] : t === 'textarea';
}
function Mh(e, t, n, i) {
  ih(i),
    (t = ea(t, 'onChange')),
    0 < t.length && ((n = new wc('onChange', 'change', null, n, i)), e.push({ event: n, listeners: t }));
}
var Tr = null,
  Br = null;
function Av(e) {
  Oh(e, 0);
}
function Ea(e) {
  var t = Pi(e);
  if (Jp(t)) return e;
}
function wv(e, t) {
  if (e === 'change') return t;
}
var Ph = !1;
if (rn) {
  var Ps;
  if (rn) {
    var Ts = 'oninput' in document;
    if (!Ts) {
      var ld = document.createElement('div');
      ld.setAttribute('oninput', 'return;'), (Ts = typeof ld.oninput == 'function');
    }
    Ps = Ts;
  } else Ps = !1;
  Ph = Ps && (!document.documentMode || 9 < document.documentMode);
}
function cd() {
  Tr && (Tr.detachEvent('onpropertychange', Th), (Br = Tr = null));
}
function Th(e) {
  if (e.propertyName === 'value' && Ea(Br)) {
    var t = [];
    Mh(t, Br, e, xc(e)), sh(Av, t);
  }
}
function Mv(e, t, n) {
  e === 'focusin' ? (cd(), (Tr = t), (Br = n), Tr.attachEvent('onpropertychange', Th)) : e === 'focusout' && cd();
}
function Pv(e) {
  if (e === 'selectionchange' || e === 'keyup' || e === 'keydown') return Ea(Br);
}
function Tv(e, t) {
  if (e === 'click') return Ea(t);
}
function Cv(e, t) {
  if (e === 'input' || e === 'change') return Ea(t);
}
function bv(e, t) {
  return (e === t && (e !== 0 || 1 / e === 1 / t)) || (e !== e && t !== t);
}
var Dt = typeof Object.is == 'function' ? Object.is : bv;
function Ur(e, t) {
  if (Dt(e, t)) return !0;
  if (typeof e != 'object' || e === null || typeof t != 'object' || t === null) return !1;
  var n = Object.keys(e),
    i = Object.keys(t);
  if (n.length !== i.length) return !1;
  for (i = 0; i < n.length; i++) {
    var r = n[i];
    if (!nl.call(t, r) || !Dt(e[r], t[r])) return !1;
  }
  return !0;
}
function ud(e) {
  for (; e && e.firstChild; ) e = e.firstChild;
  return e;
}
function dd(e, t) {
  var n = ud(e);
  e = 0;
  for (var i; n; ) {
    if (n.nodeType === 3) {
      if (((i = e + n.textContent.length), e <= t && i >= t)) return { node: n, offset: t - e };
      e = i;
    }
    e: {
      for (; n; ) {
        if (n.nextSibling) {
          n = n.nextSibling;
          break e;
        }
        n = n.parentNode;
      }
      n = void 0;
    }
    n = ud(n);
  }
}
function Ch(e, t) {
  return e && t
    ? e === t
      ? !0
      : e && e.nodeType === 3
        ? !1
        : t && t.nodeType === 3
          ? Ch(e, t.parentNode)
          : 'contains' in e
            ? e.contains(t)
            : e.compareDocumentPosition
              ? !!(e.compareDocumentPosition(t) & 16)
              : !1
    : !1;
}
function bh() {
  for (var e = window, t = Qo(); t instanceof e.HTMLIFrameElement; ) {
    try {
      var n = typeof t.contentWindow.location.href == 'string';
    } catch {
      n = !1;
    }
    if (n) e = t.contentWindow;
    else break;
    t = Qo(e.document);
  }
  return t;
}
function Tc(e) {
  var t = e && e.nodeName && e.nodeName.toLowerCase();
  return (
    t &&
    ((t === 'input' &&
      (e.type === 'text' || e.type === 'search' || e.type === 'tel' || e.type === 'url' || e.type === 'password')) ||
      t === 'textarea' ||
      e.contentEditable === 'true')
  );
}
function Iv(e) {
  var t = bh(),
    n = e.focusedElem,
    i = e.selectionRange;
  if (t !== n && n && n.ownerDocument && Ch(n.ownerDocument.documentElement, n)) {
    if (i !== null && Tc(n)) {
      if (((t = i.start), (e = i.end), e === void 0 && (e = t), 'selectionStart' in n))
        (n.selectionStart = t), (n.selectionEnd = Math.min(e, n.value.length));
      else if (((e = ((t = n.ownerDocument || document) && t.defaultView) || window), e.getSelection)) {
        e = e.getSelection();
        var r = n.textContent.length,
          o = Math.min(i.start, r);
        (i = i.end === void 0 ? o : Math.min(i.end, r)),
          !e.extend && o > i && ((r = i), (i = o), (o = r)),
          (r = dd(n, o));
        var a = dd(n, i);
        r &&
          a &&
          (e.rangeCount !== 1 ||
            e.anchorNode !== r.node ||
            e.anchorOffset !== r.offset ||
            e.focusNode !== a.node ||
            e.focusOffset !== a.offset) &&
          ((t = t.createRange()),
          t.setStart(r.node, r.offset),
          e.removeAllRanges(),
          o > i ? (e.addRange(t), e.extend(a.node, a.offset)) : (t.setEnd(a.node, a.offset), e.addRange(t)));
      }
    }
    for (t = [], e = n; (e = e.parentNode); )
      e.nodeType === 1 && t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
    for (typeof n.focus == 'function' && n.focus(), n = 0; n < t.length; n++)
      (e = t[n]), (e.element.scrollLeft = e.left), (e.element.scrollTop = e.top);
  }
}
var Lv = rn && 'documentMode' in document && 11 >= document.documentMode,
  wi = null,
  El = null,
  Cr = null,
  kl = !1;
function pd(e, t, n) {
  var i = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
  kl ||
    wi == null ||
    wi !== Qo(i) ||
    ((i = wi),
    'selectionStart' in i && Tc(i)
      ? (i = { start: i.selectionStart, end: i.selectionEnd })
      : ((i = ((i.ownerDocument && i.ownerDocument.defaultView) || window).getSelection()),
        (i = {
          anchorNode: i.anchorNode,
          anchorOffset: i.anchorOffset,
          focusNode: i.focusNode,
          focusOffset: i.focusOffset,
        })),
    (Cr && Ur(Cr, i)) ||
      ((Cr = i),
      (i = ea(El, 'onSelect')),
      0 < i.length &&
        ((t = new wc('onSelect', 'select', null, t, n)), e.push({ event: t, listeners: i }), (t.target = wi))));
}
function So(e, t) {
  var n = {};
  return (n[e.toLowerCase()] = t.toLowerCase()), (n['Webkit' + e] = 'webkit' + t), (n['Moz' + e] = 'moz' + t), n;
}
var Mi = {
    animationend: So('Animation', 'AnimationEnd'),
    animationiteration: So('Animation', 'AnimationIteration'),
    animationstart: So('Animation', 'AnimationStart'),
    transitionend: So('Transition', 'TransitionEnd'),
  },
  Cs = {},
  Ih = {};
rn &&
  ((Ih = document.createElement('div').style),
  'AnimationEvent' in window ||
    (delete Mi.animationend.animation, delete Mi.animationiteration.animation, delete Mi.animationstart.animation),
  'TransitionEvent' in window || delete Mi.transitionend.transition);
function ka(e) {
  if (Cs[e]) return Cs[e];
  if (!Mi[e]) return e;
  var t = Mi[e],
    n;
  for (n in t) if (t.hasOwnProperty(n) && n in Ih) return (Cs[e] = t[n]);
  return e;
}
var Lh = ka('animationend'),
  Nh = ka('animationiteration'),
  Rh = ka('animationstart'),
  Dh = ka('transitionend'),
  Hh = new Map(),
  hd =
    'abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel'.split(
      ' ',
    );
function Nn(e, t) {
  Hh.set(e, t), oi(t, [e]);
}
for (var bs = 0; bs < hd.length; bs++) {
  var Is = hd[bs],
    Nv = Is.toLowerCase(),
    Rv = Is[0].toUpperCase() + Is.slice(1);
  Nn(Nv, 'on' + Rv);
}
Nn(Lh, 'onAnimationEnd');
Nn(Nh, 'onAnimationIteration');
Nn(Rh, 'onAnimationStart');
Nn('dblclick', 'onDoubleClick');
Nn('focusin', 'onFocus');
Nn('focusout', 'onBlur');
Nn(Dh, 'onTransitionEnd');
Ui('onMouseEnter', ['mouseout', 'mouseover']);
Ui('onMouseLeave', ['mouseout', 'mouseover']);
Ui('onPointerEnter', ['pointerout', 'pointerover']);
Ui('onPointerLeave', ['pointerout', 'pointerover']);
oi('onChange', 'change click focusin focusout input keydown keyup selectionchange'.split(' '));
oi('onSelect', 'focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange'.split(' '));
oi('onBeforeInput', ['compositionend', 'keypress', 'textInput', 'paste']);
oi('onCompositionEnd', 'compositionend focusout keydown keypress keyup mousedown'.split(' '));
oi('onCompositionStart', 'compositionstart focusout keydown keypress keyup mousedown'.split(' '));
oi('onCompositionUpdate', 'compositionupdate focusout keydown keypress keyup mousedown'.split(' '));
var Sr =
    'abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting'.split(
      ' ',
    ),
  Dv = new Set('cancel close invalid load scroll toggle'.split(' ').concat(Sr));
function fd(e, t, n) {
  var i = e.type || 'unknown-event';
  (e.currentTarget = n), Ng(i, t, void 0, e), (e.currentTarget = null);
}
function Oh(e, t) {
  t = (t & 4) !== 0;
  for (var n = 0; n < e.length; n++) {
    var i = e[n],
      r = i.event;
    i = i.listeners;
    e: {
      var o = void 0;
      if (t)
        for (var a = i.length - 1; 0 <= a; a--) {
          var s = i[a],
            l = s.instance,
            c = s.currentTarget;
          if (((s = s.listener), l !== o && r.isPropagationStopped())) break e;
          fd(r, s, c), (o = l);
        }
      else
        for (a = 0; a < i.length; a++) {
          if (
            ((s = i[a]), (l = s.instance), (c = s.currentTarget), (s = s.listener), l !== o && r.isPropagationStopped())
          )
            break e;
          fd(r, s, c), (o = l);
        }
    }
  }
  if (Ko) throw ((e = vl), (Ko = !1), (vl = null), e);
}
function ce(e, t) {
  var n = t[Pl];
  n === void 0 && (n = t[Pl] = new Set());
  var i = e + '__bubble';
  n.has(i) || (jh(t, e, 2, !1), n.add(i));
}
function Ls(e, t, n) {
  var i = 0;
  t && (i |= 4), jh(n, e, i, t);
}
var Ao = '_reactListening' + Math.random().toString(36).slice(2);
function Gr(e) {
  if (!e[Ao]) {
    (e[Ao] = !0),
      qp.forEach(function (n) {
        n !== 'selectionchange' && (Dv.has(n) || Ls(n, !1, e), Ls(n, !0, e));
      });
    var t = e.nodeType === 9 ? e : e.ownerDocument;
    t === null || t[Ao] || ((t[Ao] = !0), Ls('selectionchange', !1, t));
  }
}
function jh(e, t, n, i) {
  switch (Eh(t)) {
    case 1:
      var r = Kg;
      break;
    case 4:
      r = Jg;
      break;
    default:
      r = Sc;
  }
  (n = r.bind(null, t, n, e)),
    (r = void 0),
    !gl || (t !== 'touchstart' && t !== 'touchmove' && t !== 'wheel') || (r = !0),
    i
      ? r !== void 0
        ? e.addEventListener(t, n, { capture: !0, passive: r })
        : e.addEventListener(t, n, !0)
      : r !== void 0
        ? e.addEventListener(t, n, { passive: r })
        : e.addEventListener(t, n, !1);
}
function Ns(e, t, n, i, r) {
  var o = i;
  if ((t & 1) === 0 && (t & 2) === 0 && i !== null)
    e: for (;;) {
      if (i === null) return;
      var a = i.tag;
      if (a === 3 || a === 4) {
        var s = i.stateNode.containerInfo;
        if (s === r || (s.nodeType === 8 && s.parentNode === r)) break;
        if (a === 4)
          for (a = i.return; a !== null; ) {
            var l = a.tag;
            if (
              (l === 3 || l === 4) &&
              ((l = a.stateNode.containerInfo), l === r || (l.nodeType === 8 && l.parentNode === r))
            )
              return;
            a = a.return;
          }
        for (; s !== null; ) {
          if (((a = qn(s)), a === null)) return;
          if (((l = a.tag), l === 5 || l === 6)) {
            i = o = a;
            continue e;
          }
          s = s.parentNode;
        }
      }
      i = i.return;
    }
  sh(function () {
    var c = o,
      u = xc(n),
      f = [];
    e: {
      var h = Hh.get(e);
      if (h !== void 0) {
        var x = wc,
          y = e;
        switch (e) {
          case 'keypress':
            if (jo(n) === 0) break e;
          case 'keydown':
          case 'keyup':
            x = dv;
            break;
          case 'focusin':
            (y = 'focus'), (x = Ms);
            break;
          case 'focusout':
            (y = 'blur'), (x = Ms);
            break;
          case 'beforeblur':
          case 'afterblur':
            x = Ms;
            break;
          case 'click':
            if (n.button === 2) break e;
          case 'auxclick':
          case 'dblclick':
          case 'mousedown':
          case 'mousemove':
          case 'mouseup':
          case 'mouseout':
          case 'mouseover':
          case 'contextmenu':
            x = nd;
            break;
          case 'drag':
          case 'dragend':
          case 'dragenter':
          case 'dragexit':
          case 'dragleave':
          case 'dragover':
          case 'dragstart':
          case 'drop':
            x = Yg;
            break;
          case 'touchcancel':
          case 'touchend':
          case 'touchmove':
          case 'touchstart':
            x = fv;
            break;
          case Lh:
          case Nh:
          case Rh:
            x = nv;
            break;
          case Dh:
            x = gv;
            break;
          case 'scroll':
            x = Xg;
            break;
          case 'wheel':
            x = _v;
            break;
          case 'copy':
          case 'cut':
          case 'paste':
            x = rv;
            break;
          case 'gotpointercapture':
          case 'lostpointercapture':
          case 'pointercancel':
          case 'pointerdown':
          case 'pointermove':
          case 'pointerout':
          case 'pointerover':
          case 'pointerup':
            x = rd;
        }
        var m = (t & 4) !== 0,
          j = !m && e === 'scroll',
          p = m ? (h !== null ? h + 'Capture' : null) : h;
        m = [];
        for (var d = c, g; d !== null; ) {
          g = d;
          var k = g.stateNode;
          if (
            (g.tag === 5 && k !== null && ((g = k), p !== null && ((k = Or(d, p)), k != null && m.push($r(d, k, g)))),
            j)
          )
            break;
          d = d.return;
        }
        0 < m.length && ((h = new x(h, y, null, n, u)), f.push({ event: h, listeners: m }));
      }
    }
    if ((t & 7) === 0) {
      e: {
        if (
          ((h = e === 'mouseover' || e === 'pointerover'),
          (x = e === 'mouseout' || e === 'pointerout'),
          h && n !== fl && (y = n.relatedTarget || n.fromElement) && (qn(y) || y[on]))
        )
          break e;
        if (
          (x || h) &&
          ((h = u.window === u ? u : (h = u.ownerDocument) ? h.defaultView || h.parentWindow : window),
          x
            ? ((y = n.relatedTarget || n.toElement),
              (x = c),
              (y = y ? qn(y) : null),
              y !== null && ((j = ai(y)), y !== j || (y.tag !== 5 && y.tag !== 6)) && (y = null))
            : ((x = null), (y = c)),
          x !== y)
        ) {
          if (
            ((m = nd),
            (k = 'onMouseLeave'),
            (p = 'onMouseEnter'),
            (d = 'mouse'),
            (e === 'pointerout' || e === 'pointerover') &&
              ((m = rd), (k = 'onPointerLeave'), (p = 'onPointerEnter'), (d = 'pointer')),
            (j = x == null ? h : Pi(x)),
            (g = y == null ? h : Pi(y)),
            (h = new m(k, d + 'leave', x, n, u)),
            (h.target = j),
            (h.relatedTarget = g),
            (k = null),
            qn(u) === c && ((m = new m(p, d + 'enter', y, n, u)), (m.target = g), (m.relatedTarget = j), (k = m)),
            (j = k),
            x && y)
          )
            t: {
              for (m = x, p = y, d = 0, g = m; g; g = yi(g)) d++;
              for (g = 0, k = p; k; k = yi(k)) g++;
              for (; 0 < d - g; ) (m = yi(m)), d--;
              for (; 0 < g - d; ) (p = yi(p)), g--;
              for (; d--; ) {
                if (m === p || (p !== null && m === p.alternate)) break t;
                (m = yi(m)), (p = yi(p));
              }
              m = null;
            }
          else m = null;
          x !== null && md(f, h, x, m, !1), y !== null && j !== null && md(f, j, y, m, !0);
        }
      }
      e: {
        if (
          ((h = c ? Pi(c) : window),
          (x = h.nodeName && h.nodeName.toLowerCase()),
          x === 'select' || (x === 'input' && h.type === 'file'))
        )
          var T = wv;
        else if (sd(h))
          if (Ph) T = Cv;
          else {
            T = Pv;
            var R = Mv;
          }
        else
          (x = h.nodeName) && x.toLowerCase() === 'input' && (h.type === 'checkbox' || h.type === 'radio') && (T = Tv);
        if (T && (T = T(e, c))) {
          Mh(f, T, n, u);
          break e;
        }
        R && R(e, h, c),
          e === 'focusout' && (R = h._wrapperState) && R.controlled && h.type === 'number' && cl(h, 'number', h.value);
      }
      switch (((R = c ? Pi(c) : window), e)) {
        case 'focusin':
          (sd(R) || R.contentEditable === 'true') && ((wi = R), (El = c), (Cr = null));
          break;
        case 'focusout':
          Cr = El = wi = null;
          break;
        case 'mousedown':
          kl = !0;
          break;
        case 'contextmenu':
        case 'mouseup':
        case 'dragend':
          (kl = !1), pd(f, n, u);
          break;
        case 'selectionchange':
          if (Lv) break;
        case 'keydown':
        case 'keyup':
          pd(f, n, u);
      }
      var b;
      if (Pc)
        e: {
          switch (e) {
            case 'compositionstart':
              var z = 'onCompositionStart';
              break e;
            case 'compositionend':
              z = 'onCompositionEnd';
              break e;
            case 'compositionupdate':
              z = 'onCompositionUpdate';
              break e;
          }
          z = void 0;
        }
      else
        Ai ? Ah(e, n) && (z = 'onCompositionEnd') : e === 'keydown' && n.keyCode === 229 && (z = 'onCompositionStart');
      z &&
        (Sh &&
          n.locale !== 'ko' &&
          (Ai || z !== 'onCompositionStart'
            ? z === 'onCompositionEnd' && Ai && (b = kh())
            : ((En = u), (Ac = 'value' in En ? En.value : En.textContent), (Ai = !0))),
        (R = ea(c, z)),
        0 < R.length &&
          ((z = new id(z, e, null, n, u)),
          f.push({ event: z, listeners: R }),
          b ? (z.data = b) : ((b = wh(n)), b !== null && (z.data = b)))),
        (b = yv ? Ev(e, n) : kv(e, n)) &&
          ((c = ea(c, 'onBeforeInput')),
          0 < c.length &&
            ((u = new id('onBeforeInput', 'beforeinput', null, n, u)),
            f.push({ event: u, listeners: c }),
            (u.data = b)));
    }
    Oh(f, t);
  });
}
function $r(e, t, n) {
  return { instance: e, listener: t, currentTarget: n };
}
function ea(e, t) {
  for (var n = t + 'Capture', i = []; e !== null; ) {
    var r = e,
      o = r.stateNode;
    r.tag === 5 &&
      o !== null &&
      ((r = o), (o = Or(e, n)), o != null && i.unshift($r(e, o, r)), (o = Or(e, t)), o != null && i.push($r(e, o, r))),
      (e = e.return);
  }
  return i;
}
function yi(e) {
  if (e === null) return null;
  do e = e.return;
  while (e && e.tag !== 5);
  return e || null;
}
function md(e, t, n, i, r) {
  for (var o = t._reactName, a = []; n !== null && n !== i; ) {
    var s = n,
      l = s.alternate,
      c = s.stateNode;
    if (l !== null && l === i) break;
    s.tag === 5 &&
      c !== null &&
      ((s = c),
      r
        ? ((l = Or(n, o)), l != null && a.unshift($r(n, l, s)))
        : r || ((l = Or(n, o)), l != null && a.push($r(n, l, s)))),
      (n = n.return);
  }
  a.length !== 0 && e.push({ event: t, listeners: a });
}
var Hv = /\r\n?/g,
  Ov = /\u0000|\uFFFD/g;
function gd(e) {
  return (typeof e == 'string' ? e : '' + e)
    .replace(
      Hv,
      `
`,
    )
    .replace(Ov, '');
}
function wo(e, t, n) {
  if (((t = gd(t)), gd(e) !== t && n)) throw Error(w(425));
}
function ta() {}
var Sl = null,
  Al = null;
function wl(e, t) {
  return (
    e === 'textarea' ||
    e === 'noscript' ||
    typeof t.children == 'string' ||
    typeof t.children == 'number' ||
    (typeof t.dangerouslySetInnerHTML == 'object' &&
      t.dangerouslySetInnerHTML !== null &&
      t.dangerouslySetInnerHTML.__html != null)
  );
}
var Ml = typeof setTimeout == 'function' ? setTimeout : void 0,
  jv = typeof clearTimeout == 'function' ? clearTimeout : void 0,
  vd = typeof Promise == 'function' ? Promise : void 0,
  Fv =
    typeof queueMicrotask == 'function'
      ? queueMicrotask
      : typeof vd < 'u'
        ? function (e) {
            return vd.resolve(null).then(e).catch(zv);
          }
        : Ml;
function zv(e) {
  setTimeout(function () {
    throw e;
  });
}
function Rs(e, t) {
  var n = t,
    i = 0;
  do {
    var r = n.nextSibling;
    if ((e.removeChild(n), r && r.nodeType === 8))
      if (((n = r.data), n === '/$')) {
        if (i === 0) {
          e.removeChild(r), zr(t);
          return;
        }
        i--;
      } else (n !== '$' && n !== '$?' && n !== '$!') || i++;
    n = r;
  } while (n);
  zr(t);
}
function Mn(e) {
  for (; e != null; e = e.nextSibling) {
    var t = e.nodeType;
    if (t === 1 || t === 3) break;
    if (t === 8) {
      if (((t = e.data), t === '$' || t === '$!' || t === '$?')) break;
      if (t === '/$') return null;
    }
  }
  return e;
}
function _d(e) {
  e = e.previousSibling;
  for (var t = 0; e; ) {
    if (e.nodeType === 8) {
      var n = e.data;
      if (n === '$' || n === '$!' || n === '$?') {
        if (t === 0) return e;
        t--;
      } else n === '/$' && t++;
    }
    e = e.previousSibling;
  }
  return null;
}
var Zi = Math.random().toString(36).slice(2),
  $t = '__reactFiber$' + Zi,
  qr = '__reactProps$' + Zi,
  on = '__reactContainer$' + Zi,
  Pl = '__reactEvents$' + Zi,
  Bv = '__reactListeners$' + Zi,
  Uv = '__reactHandles$' + Zi;
function qn(e) {
  var t = e[$t];
  if (t) return t;
  for (var n = e.parentNode; n; ) {
    if ((t = n[on] || n[$t])) {
      if (((n = t.alternate), t.child !== null || (n !== null && n.child !== null)))
        for (e = _d(e); e !== null; ) {
          if ((n = e[$t])) return n;
          e = _d(e);
        }
      return t;
    }
    (e = n), (n = e.parentNode);
  }
  return null;
}
function to(e) {
  return (e = e[$t] || e[on]), !e || (e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3) ? null : e;
}
function Pi(e) {
  if (e.tag === 5 || e.tag === 6) return e.stateNode;
  throw Error(w(33));
}
function Sa(e) {
  return e[qr] || null;
}
var Tl = [],
  Ti = -1;
function Rn(e) {
  return { current: e };
}
function de(e) {
  0 > Ti || ((e.current = Tl[Ti]), (Tl[Ti] = null), Ti--);
}
function le(e, t) {
  Ti++, (Tl[Ti] = e.current), (e.current = t);
}
var Ln = {},
  Ke = Rn(Ln),
  lt = Rn(!1),
  Yn = Ln;
function Gi(e, t) {
  var n = e.type.contextTypes;
  if (!n) return Ln;
  var i = e.stateNode;
  if (i && i.__reactInternalMemoizedUnmaskedChildContext === t) return i.__reactInternalMemoizedMaskedChildContext;
  var r = {},
    o;
  for (o in n) r[o] = t[o];
  return (
    i &&
      ((e = e.stateNode),
      (e.__reactInternalMemoizedUnmaskedChildContext = t),
      (e.__reactInternalMemoizedMaskedChildContext = r)),
    r
  );
}
function ct(e) {
  return (e = e.childContextTypes), e != null;
}
function na() {
  de(lt), de(Ke);
}
function xd(e, t, n) {
  if (Ke.current !== Ln) throw Error(w(168));
  le(Ke, t), le(lt, n);
}
function Fh(e, t, n) {
  var i = e.stateNode;
  if (((t = t.childContextTypes), typeof i.getChildContext != 'function')) return n;
  i = i.getChildContext();
  for (var r in i) if (!(r in t)) throw Error(w(108, Mg(e) || 'Unknown', r));
  return ge({}, n, i);
}
function ia(e) {
  return (
    (e = ((e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext) || Ln),
    (Yn = Ke.current),
    le(Ke, e),
    le(lt, lt.current),
    !0
  );
}
function yd(e, t, n) {
  var i = e.stateNode;
  if (!i) throw Error(w(169));
  n ? ((e = Fh(e, t, Yn)), (i.__reactInternalMemoizedMergedChildContext = e), de(lt), de(Ke), le(Ke, e)) : de(lt),
    le(lt, n);
}
var Yt = null,
  Aa = !1,
  Ds = !1;
function zh(e) {
  Yt === null ? (Yt = [e]) : Yt.push(e);
}
function Gv(e) {
  (Aa = !0), zh(e);
}
function Dn() {
  if (!Ds && Yt !== null) {
    Ds = !0;
    var e = 0,
      t = oe;
    try {
      var n = Yt;
      for (oe = 1; e < n.length; e++) {
        var i = n[e];
        do i = i(!0);
        while (i !== null);
      }
      (Yt = null), (Aa = !1);
    } catch (r) {
      throw (Yt !== null && (Yt = Yt.slice(e + 1)), dh(yc, Dn), r);
    } finally {
      (oe = t), (Ds = !1);
    }
  }
  return null;
}
var Ci = [],
  bi = 0,
  ra = null,
  oa = 0,
  kt = [],
  St = 0,
  ei = null,
  en = 1,
  tn = '';
function Un(e, t) {
  (Ci[bi++] = oa), (Ci[bi++] = ra), (ra = e), (oa = t);
}
function Bh(e, t, n) {
  (kt[St++] = en), (kt[St++] = tn), (kt[St++] = ei), (ei = e);
  var i = en;
  e = tn;
  var r = 32 - Nt(i) - 1;
  (i &= ~(1 << r)), (n += 1);
  var o = 32 - Nt(t) + r;
  if (30 < o) {
    var a = r - (r % 5);
    (o = (i & ((1 << a) - 1)).toString(32)),
      (i >>= a),
      (r -= a),
      (en = (1 << (32 - Nt(t) + r)) | (n << r) | i),
      (tn = o + e);
  } else (en = (1 << o) | (n << r) | i), (tn = e);
}
function Cc(e) {
  e.return !== null && (Un(e, 1), Bh(e, 1, 0));
}
function bc(e) {
  for (; e === ra; ) (ra = Ci[--bi]), (Ci[bi] = null), (oa = Ci[--bi]), (Ci[bi] = null);
  for (; e === ei; )
    (ei = kt[--St]), (kt[St] = null), (tn = kt[--St]), (kt[St] = null), (en = kt[--St]), (kt[St] = null);
}
var gt = null,
  mt = null,
  pe = !1,
  Lt = null;
function Uh(e, t) {
  var n = At(5, null, null, 0);
  (n.elementType = 'DELETED'),
    (n.stateNode = t),
    (n.return = e),
    (t = e.deletions),
    t === null ? ((e.deletions = [n]), (e.flags |= 16)) : t.push(n);
}
function Ed(e, t) {
  switch (e.tag) {
    case 5:
      var n = e.type;
      return (
        (t = t.nodeType !== 1 || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t),
        t !== null ? ((e.stateNode = t), (gt = e), (mt = Mn(t.firstChild)), !0) : !1
      );
    case 6:
      return (
        (t = e.pendingProps === '' || t.nodeType !== 3 ? null : t),
        t !== null ? ((e.stateNode = t), (gt = e), (mt = null), !0) : !1
      );
    case 13:
      return (
        (t = t.nodeType !== 8 ? null : t),
        t !== null
          ? ((n = ei !== null ? { id: en, overflow: tn } : null),
            (e.memoizedState = { dehydrated: t, treeContext: n, retryLane: 1073741824 }),
            (n = At(18, null, null, 0)),
            (n.stateNode = t),
            (n.return = e),
            (e.child = n),
            (gt = e),
            (mt = null),
            !0)
          : !1
      );
    default:
      return !1;
  }
}
function Cl(e) {
  return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
}
function bl(e) {
  if (pe) {
    var t = mt;
    if (t) {
      var n = t;
      if (!Ed(e, t)) {
        if (Cl(e)) throw Error(w(418));
        t = Mn(n.nextSibling);
        var i = gt;
        t && Ed(e, t) ? Uh(i, n) : ((e.flags = (e.flags & -4097) | 2), (pe = !1), (gt = e));
      }
    } else {
      if (Cl(e)) throw Error(w(418));
      (e.flags = (e.flags & -4097) | 2), (pe = !1), (gt = e);
    }
  }
}
function kd(e) {
  for (e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13; ) e = e.return;
  gt = e;
}
function Mo(e) {
  if (e !== gt) return !1;
  if (!pe) return kd(e), (pe = !0), !1;
  var t;
  if (
    ((t = e.tag !== 3) &&
      !(t = e.tag !== 5) &&
      ((t = e.type), (t = t !== 'head' && t !== 'body' && !wl(e.type, e.memoizedProps))),
    t && (t = mt))
  ) {
    if (Cl(e)) throw (Gh(), Error(w(418)));
    for (; t; ) Uh(e, t), (t = Mn(t.nextSibling));
  }
  if ((kd(e), e.tag === 13)) {
    if (((e = e.memoizedState), (e = e !== null ? e.dehydrated : null), !e)) throw Error(w(317));
    e: {
      for (e = e.nextSibling, t = 0; e; ) {
        if (e.nodeType === 8) {
          var n = e.data;
          if (n === '/$') {
            if (t === 0) {
              mt = Mn(e.nextSibling);
              break e;
            }
            t--;
          } else (n !== '$' && n !== '$!' && n !== '$?') || t++;
        }
        e = e.nextSibling;
      }
      mt = null;
    }
  } else mt = gt ? Mn(e.stateNode.nextSibling) : null;
  return !0;
}
function Gh() {
  for (var e = mt; e; ) e = Mn(e.nextSibling);
}
function $i() {
  (mt = gt = null), (pe = !1);
}
function Ic(e) {
  Lt === null ? (Lt = [e]) : Lt.push(e);
}
var $v = cn.ReactCurrentBatchConfig;
function bt(e, t) {
  if (e && e.defaultProps) {
    (t = ge({}, t)), (e = e.defaultProps);
    for (var n in e) t[n] === void 0 && (t[n] = e[n]);
    return t;
  }
  return t;
}
var aa = Rn(null),
  sa = null,
  Ii = null,
  Lc = null;
function Nc() {
  Lc = Ii = sa = null;
}
function Rc(e) {
  var t = aa.current;
  de(aa), (e._currentValue = t);
}
function Il(e, t, n) {
  for (; e !== null; ) {
    var i = e.alternate;
    if (
      ((e.childLanes & t) !== t
        ? ((e.childLanes |= t), i !== null && (i.childLanes |= t))
        : i !== null && (i.childLanes & t) !== t && (i.childLanes |= t),
      e === n)
    )
      break;
    e = e.return;
  }
}
function Fi(e, t) {
  (sa = e),
    (Lc = Ii = null),
    (e = e.dependencies),
    e !== null && e.firstContext !== null && ((e.lanes & t) !== 0 && (st = !0), (e.firstContext = null));
}
function Mt(e) {
  var t = e._currentValue;
  if (Lc !== e)
    if (((e = { context: e, memoizedValue: t, next: null }), Ii === null)) {
      if (sa === null) throw Error(w(308));
      (Ii = e), (sa.dependencies = { lanes: 0, firstContext: e });
    } else Ii = Ii.next = e;
  return t;
}
var Vn = null;
function Dc(e) {
  Vn === null ? (Vn = [e]) : Vn.push(e);
}
function $h(e, t, n, i) {
  var r = t.interleaved;
  return r === null ? ((n.next = n), Dc(t)) : ((n.next = r.next), (r.next = n)), (t.interleaved = n), an(e, i);
}
function an(e, t) {
  e.lanes |= t;
  var n = e.alternate;
  for (n !== null && (n.lanes |= t), n = e, e = e.return; e !== null; )
    (e.childLanes |= t), (n = e.alternate), n !== null && (n.childLanes |= t), (n = e), (e = e.return);
  return n.tag === 3 ? n.stateNode : null;
}
var _n = !1;
function Hc(e) {
  e.updateQueue = {
    baseState: e.memoizedState,
    firstBaseUpdate: null,
    lastBaseUpdate: null,
    shared: { pending: null, interleaved: null, lanes: 0 },
    effects: null,
  };
}
function qh(e, t) {
  (e = e.updateQueue),
    t.updateQueue === e &&
      (t.updateQueue = {
        baseState: e.baseState,
        firstBaseUpdate: e.firstBaseUpdate,
        lastBaseUpdate: e.lastBaseUpdate,
        shared: e.shared,
        effects: e.effects,
      });
}
function nn(e, t) {
  return { eventTime: e, lane: t, tag: 0, payload: null, callback: null, next: null };
}
function Pn(e, t, n) {
  var i = e.updateQueue;
  if (i === null) return null;
  if (((i = i.shared), (Y & 2) !== 0)) {
    var r = i.pending;
    return r === null ? (t.next = t) : ((t.next = r.next), (r.next = t)), (i.pending = t), an(e, n);
  }
  return (
    (r = i.interleaved),
    r === null ? ((t.next = t), Dc(i)) : ((t.next = r.next), (r.next = t)),
    (i.interleaved = t),
    an(e, n)
  );
}
function Fo(e, t, n) {
  if (((t = t.updateQueue), t !== null && ((t = t.shared), (n & 4194240) !== 0))) {
    var i = t.lanes;
    (i &= e.pendingLanes), (n |= i), (t.lanes = n), Ec(e, n);
  }
}
function Sd(e, t) {
  var n = e.updateQueue,
    i = e.alternate;
  if (i !== null && ((i = i.updateQueue), n === i)) {
    var r = null,
      o = null;
    if (((n = n.firstBaseUpdate), n !== null)) {
      do {
        var a = {
          eventTime: n.eventTime,
          lane: n.lane,
          tag: n.tag,
          payload: n.payload,
          callback: n.callback,
          next: null,
        };
        o === null ? (r = o = a) : (o = o.next = a), (n = n.next);
      } while (n !== null);
      o === null ? (r = o = t) : (o = o.next = t);
    } else r = o = t;
    (n = { baseState: i.baseState, firstBaseUpdate: r, lastBaseUpdate: o, shared: i.shared, effects: i.effects }),
      (e.updateQueue = n);
    return;
  }
  (e = n.lastBaseUpdate), e === null ? (n.firstBaseUpdate = t) : (e.next = t), (n.lastBaseUpdate = t);
}
function la(e, t, n, i) {
  var r = e.updateQueue;
  _n = !1;
  var o = r.firstBaseUpdate,
    a = r.lastBaseUpdate,
    s = r.shared.pending;
  if (s !== null) {
    r.shared.pending = null;
    var l = s,
      c = l.next;
    (l.next = null), a === null ? (o = c) : (a.next = c), (a = l);
    var u = e.alternate;
    u !== null &&
      ((u = u.updateQueue),
      (s = u.lastBaseUpdate),
      s !== a && (s === null ? (u.firstBaseUpdate = c) : (s.next = c), (u.lastBaseUpdate = l)));
  }
  if (o !== null) {
    var f = r.baseState;
    (a = 0), (u = c = l = null), (s = o);
    do {
      var h = s.lane,
        x = s.eventTime;
      if ((i & h) === h) {
        u !== null &&
          (u = u.next = { eventTime: x, lane: 0, tag: s.tag, payload: s.payload, callback: s.callback, next: null });
        e: {
          var y = e,
            m = s;
          switch (((h = t), (x = n), m.tag)) {
            case 1:
              if (((y = m.payload), typeof y == 'function')) {
                f = y.call(x, f, h);
                break e;
              }
              f = y;
              break e;
            case 3:
              y.flags = (y.flags & -65537) | 128;
            case 0:
              if (((y = m.payload), (h = typeof y == 'function' ? y.call(x, f, h) : y), h == null)) break e;
              f = ge({}, f, h);
              break e;
            case 2:
              _n = !0;
          }
        }
        s.callback !== null &&
          s.lane !== 0 &&
          ((e.flags |= 64), (h = r.effects), h === null ? (r.effects = [s]) : h.push(s));
      } else
        (x = { eventTime: x, lane: h, tag: s.tag, payload: s.payload, callback: s.callback, next: null }),
          u === null ? ((c = u = x), (l = f)) : (u = u.next = x),
          (a |= h);
      if (((s = s.next), s === null)) {
        if (((s = r.shared.pending), s === null)) break;
        (h = s), (s = h.next), (h.next = null), (r.lastBaseUpdate = h), (r.shared.pending = null);
      }
    } while (1);
    if (
      (u === null && (l = f),
      (r.baseState = l),
      (r.firstBaseUpdate = c),
      (r.lastBaseUpdate = u),
      (t = r.shared.interleaved),
      t !== null)
    ) {
      r = t;
      do (a |= r.lane), (r = r.next);
      while (r !== t);
    } else o === null && (r.shared.lanes = 0);
    (ni |= a), (e.lanes = a), (e.memoizedState = f);
  }
}
function Ad(e, t, n) {
  if (((e = t.effects), (t.effects = null), e !== null))
    for (t = 0; t < e.length; t++) {
      var i = e[t],
        r = i.callback;
      if (r !== null) {
        if (((i.callback = null), (i = n), typeof r != 'function')) throw Error(w(191, r));
        r.call(i);
      }
    }
}
var Vh = new $p.Component().refs;
function Ll(e, t, n, i) {
  (t = e.memoizedState),
    (n = n(i, t)),
    (n = n == null ? t : ge({}, t, n)),
    (e.memoizedState = n),
    e.lanes === 0 && (e.updateQueue.baseState = n);
}
var wa = {
  isMounted: function (e) {
    return (e = e._reactInternals) ? ai(e) === e : !1;
  },
  enqueueSetState: function (e, t, n) {
    e = e._reactInternals;
    var i = et(),
      r = Cn(e),
      o = nn(i, r);
    (o.payload = t), n != null && (o.callback = n), (t = Pn(e, o, r)), t !== null && (Rt(t, e, r, i), Fo(t, e, r));
  },
  enqueueReplaceState: function (e, t, n) {
    e = e._reactInternals;
    var i = et(),
      r = Cn(e),
      o = nn(i, r);
    (o.tag = 1),
      (o.payload = t),
      n != null && (o.callback = n),
      (t = Pn(e, o, r)),
      t !== null && (Rt(t, e, r, i), Fo(t, e, r));
  },
  enqueueForceUpdate: function (e, t) {
    e = e._reactInternals;
    var n = et(),
      i = Cn(e),
      r = nn(n, i);
    (r.tag = 2), t != null && (r.callback = t), (t = Pn(e, r, i)), t !== null && (Rt(t, e, i, n), Fo(t, e, i));
  },
};
function wd(e, t, n, i, r, o, a) {
  return (
    (e = e.stateNode),
    typeof e.shouldComponentUpdate == 'function'
      ? e.shouldComponentUpdate(i, o, a)
      : t.prototype && t.prototype.isPureReactComponent
        ? !Ur(n, i) || !Ur(r, o)
        : !0
  );
}
function Qh(e, t, n) {
  var i = !1,
    r = Ln,
    o = t.contextType;
  return (
    typeof o == 'object' && o !== null
      ? (o = Mt(o))
      : ((r = ct(t) ? Yn : Ke.current), (i = t.contextTypes), (o = (i = i != null) ? Gi(e, r) : Ln)),
    (t = new t(n, o)),
    (e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null),
    (t.updater = wa),
    (e.stateNode = t),
    (t._reactInternals = e),
    i &&
      ((e = e.stateNode),
      (e.__reactInternalMemoizedUnmaskedChildContext = r),
      (e.__reactInternalMemoizedMaskedChildContext = o)),
    t
  );
}
function Md(e, t, n, i) {
  (e = t.state),
    typeof t.componentWillReceiveProps == 'function' && t.componentWillReceiveProps(n, i),
    typeof t.UNSAFE_componentWillReceiveProps == 'function' && t.UNSAFE_componentWillReceiveProps(n, i),
    t.state !== e && wa.enqueueReplaceState(t, t.state, null);
}
function Nl(e, t, n, i) {
  var r = e.stateNode;
  (r.props = n), (r.state = e.memoizedState), (r.refs = Vh), Hc(e);
  var o = t.contextType;
  typeof o == 'object' && o !== null ? (r.context = Mt(o)) : ((o = ct(t) ? Yn : Ke.current), (r.context = Gi(e, o))),
    (r.state = e.memoizedState),
    (o = t.getDerivedStateFromProps),
    typeof o == 'function' && (Ll(e, t, o, n), (r.state = e.memoizedState)),
    typeof t.getDerivedStateFromProps == 'function' ||
      typeof r.getSnapshotBeforeUpdate == 'function' ||
      (typeof r.UNSAFE_componentWillMount != 'function' && typeof r.componentWillMount != 'function') ||
      ((t = r.state),
      typeof r.componentWillMount == 'function' && r.componentWillMount(),
      typeof r.UNSAFE_componentWillMount == 'function' && r.UNSAFE_componentWillMount(),
      t !== r.state && wa.enqueueReplaceState(r, r.state, null),
      la(e, n, r, i),
      (r.state = e.memoizedState)),
    typeof r.componentDidMount == 'function' && (e.flags |= 4194308);
}
function mr(e, t, n) {
  if (((e = n.ref), e !== null && typeof e != 'function' && typeof e != 'object')) {
    if (n._owner) {
      if (((n = n._owner), n)) {
        if (n.tag !== 1) throw Error(w(309));
        var i = n.stateNode;
      }
      if (!i) throw Error(w(147, e));
      var r = i,
        o = '' + e;
      return t !== null && t.ref !== null && typeof t.ref == 'function' && t.ref._stringRef === o
        ? t.ref
        : ((t = function (a) {
            var s = r.refs;
            s === Vh && (s = r.refs = {}), a === null ? delete s[o] : (s[o] = a);
          }),
          (t._stringRef = o),
          t);
    }
    if (typeof e != 'string') throw Error(w(284));
    if (!n._owner) throw Error(w(290, e));
  }
  return e;
}
function Po(e, t) {
  throw (
    ((e = Object.prototype.toString.call(t)),
    Error(w(31, e === '[object Object]' ? 'object with keys {' + Object.keys(t).join(', ') + '}' : e)))
  );
}
function Pd(e) {
  var t = e._init;
  return t(e._payload);
}
function Wh(e) {
  function t(p, d) {
    if (e) {
      var g = p.deletions;
      g === null ? ((p.deletions = [d]), (p.flags |= 16)) : g.push(d);
    }
  }
  function n(p, d) {
    if (!e) return null;
    for (; d !== null; ) t(p, d), (d = d.sibling);
    return null;
  }
  function i(p, d) {
    for (p = new Map(); d !== null; ) d.key !== null ? p.set(d.key, d) : p.set(d.index, d), (d = d.sibling);
    return p;
  }
  function r(p, d) {
    return (p = bn(p, d)), (p.index = 0), (p.sibling = null), p;
  }
  function o(p, d, g) {
    return (
      (p.index = g),
      e
        ? ((g = p.alternate), g !== null ? ((g = g.index), g < d ? ((p.flags |= 2), d) : g) : ((p.flags |= 2), d))
        : ((p.flags |= 1048576), d)
    );
  }
  function a(p) {
    return e && p.alternate === null && (p.flags |= 2), p;
  }
  function s(p, d, g, k) {
    return d === null || d.tag !== 6 ? ((d = Us(g, p.mode, k)), (d.return = p), d) : ((d = r(d, g)), (d.return = p), d);
  }
  function l(p, d, g, k) {
    var T = g.type;
    return T === Si
      ? u(p, d, g.props.children, k, g.key)
      : d !== null &&
          (d.elementType === T || (typeof T == 'object' && T !== null && T.$$typeof === vn && Pd(T) === d.type))
        ? ((k = r(d, g.props)), (k.ref = mr(p, d, g)), (k.return = p), k)
        : ((k = qo(g.type, g.key, g.props, null, p.mode, k)), (k.ref = mr(p, d, g)), (k.return = p), k);
  }
  function c(p, d, g, k) {
    return d === null ||
      d.tag !== 4 ||
      d.stateNode.containerInfo !== g.containerInfo ||
      d.stateNode.implementation !== g.implementation
      ? ((d = Gs(g, p.mode, k)), (d.return = p), d)
      : ((d = r(d, g.children || [])), (d.return = p), d);
  }
  function u(p, d, g, k, T) {
    return d === null || d.tag !== 7
      ? ((d = Jn(g, p.mode, k, T)), (d.return = p), d)
      : ((d = r(d, g)), (d.return = p), d);
  }
  function f(p, d, g) {
    if ((typeof d == 'string' && d !== '') || typeof d == 'number')
      return (d = Us('' + d, p.mode, g)), (d.return = p), d;
    if (typeof d == 'object' && d !== null) {
      switch (d.$$typeof) {
        case go:
          return (g = qo(d.type, d.key, d.props, null, p.mode, g)), (g.ref = mr(p, null, d)), (g.return = p), g;
        case ki:
          return (d = Gs(d, p.mode, g)), (d.return = p), d;
        case vn:
          var k = d._init;
          return f(p, k(d._payload), g);
      }
      if (Er(d) || ur(d)) return (d = Jn(d, p.mode, g, null)), (d.return = p), d;
      Po(p, d);
    }
    return null;
  }
  function h(p, d, g, k) {
    var T = d !== null ? d.key : null;
    if ((typeof g == 'string' && g !== '') || typeof g == 'number') return T !== null ? null : s(p, d, '' + g, k);
    if (typeof g == 'object' && g !== null) {
      switch (g.$$typeof) {
        case go:
          return g.key === T ? l(p, d, g, k) : null;
        case ki:
          return g.key === T ? c(p, d, g, k) : null;
        case vn:
          return (T = g._init), h(p, d, T(g._payload), k);
      }
      if (Er(g) || ur(g)) return T !== null ? null : u(p, d, g, k, null);
      Po(p, g);
    }
    return null;
  }
  function x(p, d, g, k, T) {
    if ((typeof k == 'string' && k !== '') || typeof k == 'number') return (p = p.get(g) || null), s(d, p, '' + k, T);
    if (typeof k == 'object' && k !== null) {
      switch (k.$$typeof) {
        case go:
          return (p = p.get(k.key === null ? g : k.key) || null), l(d, p, k, T);
        case ki:
          return (p = p.get(k.key === null ? g : k.key) || null), c(d, p, k, T);
        case vn:
          var R = k._init;
          return x(p, d, g, R(k._payload), T);
      }
      if (Er(k) || ur(k)) return (p = p.get(g) || null), u(d, p, k, T, null);
      Po(d, k);
    }
    return null;
  }
  function y(p, d, g, k) {
    for (var T = null, R = null, b = d, z = (d = 0), te = null; b !== null && z < g.length; z++) {
      b.index > z ? ((te = b), (b = null)) : (te = b.sibling);
      var Q = h(p, b, g[z], k);
      if (Q === null) {
        b === null && (b = te);
        break;
      }
      e && b && Q.alternate === null && t(p, b),
        (d = o(Q, d, z)),
        R === null ? (T = Q) : (R.sibling = Q),
        (R = Q),
        (b = te);
    }
    if (z === g.length) return n(p, b), pe && Un(p, z), T;
    if (b === null) {
      for (; z < g.length; z++)
        (b = f(p, g[z], k)), b !== null && ((d = o(b, d, z)), R === null ? (T = b) : (R.sibling = b), (R = b));
      return pe && Un(p, z), T;
    }
    for (b = i(p, b); z < g.length; z++)
      (te = x(b, p, z, g[z], k)),
        te !== null &&
          (e && te.alternate !== null && b.delete(te.key === null ? z : te.key),
          (d = o(te, d, z)),
          R === null ? (T = te) : (R.sibling = te),
          (R = te));
    return (
      e &&
        b.forEach(function (Te) {
          return t(p, Te);
        }),
      pe && Un(p, z),
      T
    );
  }
  function m(p, d, g, k) {
    var T = ur(g);
    if (typeof T != 'function') throw Error(w(150));
    if (((g = T.call(g)), g == null)) throw Error(w(151));
    for (var R = (T = null), b = d, z = (d = 0), te = null, Q = g.next(); b !== null && !Q.done; z++, Q = g.next()) {
      b.index > z ? ((te = b), (b = null)) : (te = b.sibling);
      var Te = h(p, b, Q.value, k);
      if (Te === null) {
        b === null && (b = te);
        break;
      }
      e && b && Te.alternate === null && t(p, b),
        (d = o(Te, d, z)),
        R === null ? (T = Te) : (R.sibling = Te),
        (R = Te),
        (b = te);
    }
    if (Q.done) return n(p, b), pe && Un(p, z), T;
    if (b === null) {
      for (; !Q.done; z++, Q = g.next())
        (Q = f(p, Q.value, k)), Q !== null && ((d = o(Q, d, z)), R === null ? (T = Q) : (R.sibling = Q), (R = Q));
      return pe && Un(p, z), T;
    }
    for (b = i(p, b); !Q.done; z++, Q = g.next())
      (Q = x(b, p, z, Q.value, k)),
        Q !== null &&
          (e && Q.alternate !== null && b.delete(Q.key === null ? z : Q.key),
          (d = o(Q, d, z)),
          R === null ? (T = Q) : (R.sibling = Q),
          (R = Q));
    return (
      e &&
        b.forEach(function (_e) {
          return t(p, _e);
        }),
      pe && Un(p, z),
      T
    );
  }
  function j(p, d, g, k) {
    if (
      (typeof g == 'object' && g !== null && g.type === Si && g.key === null && (g = g.props.children),
      typeof g == 'object' && g !== null)
    ) {
      switch (g.$$typeof) {
        case go:
          e: {
            for (var T = g.key, R = d; R !== null; ) {
              if (R.key === T) {
                if (((T = g.type), T === Si)) {
                  if (R.tag === 7) {
                    n(p, R.sibling), (d = r(R, g.props.children)), (d.return = p), (p = d);
                    break e;
                  }
                } else if (
                  R.elementType === T ||
                  (typeof T == 'object' && T !== null && T.$$typeof === vn && Pd(T) === R.type)
                ) {
                  n(p, R.sibling), (d = r(R, g.props)), (d.ref = mr(p, R, g)), (d.return = p), (p = d);
                  break e;
                }
                n(p, R);
                break;
              } else t(p, R);
              R = R.sibling;
            }
            g.type === Si
              ? ((d = Jn(g.props.children, p.mode, k, g.key)), (d.return = p), (p = d))
              : ((k = qo(g.type, g.key, g.props, null, p.mode, k)), (k.ref = mr(p, d, g)), (k.return = p), (p = k));
          }
          return a(p);
        case ki:
          e: {
            for (R = g.key; d !== null; ) {
              if (d.key === R)
                if (
                  d.tag === 4 &&
                  d.stateNode.containerInfo === g.containerInfo &&
                  d.stateNode.implementation === g.implementation
                ) {
                  n(p, d.sibling), (d = r(d, g.children || [])), (d.return = p), (p = d);
                  break e;
                } else {
                  n(p, d);
                  break;
                }
              else t(p, d);
              d = d.sibling;
            }
            (d = Gs(g, p.mode, k)), (d.return = p), (p = d);
          }
          return a(p);
        case vn:
          return (R = g._init), j(p, d, R(g._payload), k);
      }
      if (Er(g)) return y(p, d, g, k);
      if (ur(g)) return m(p, d, g, k);
      Po(p, g);
    }
    return (typeof g == 'string' && g !== '') || typeof g == 'number'
      ? ((g = '' + g),
        d !== null && d.tag === 6
          ? (n(p, d.sibling), (d = r(d, g)), (d.return = p), (p = d))
          : (n(p, d), (d = Us(g, p.mode, k)), (d.return = p), (p = d)),
        a(p))
      : n(p, d);
  }
  return j;
}
var qi = Wh(!0),
  Kh = Wh(!1),
  no = {},
  Vt = Rn(no),
  Vr = Rn(no),
  Qr = Rn(no);
function Qn(e) {
  if (e === no) throw Error(w(174));
  return e;
}
function Oc(e, t) {
  switch ((le(Qr, t), le(Vr, e), le(Vt, no), (e = t.nodeType), e)) {
    case 9:
    case 11:
      t = (t = t.documentElement) ? t.namespaceURI : dl(null, '');
      break;
    default:
      (e = e === 8 ? t.parentNode : t), (t = e.namespaceURI || null), (e = e.tagName), (t = dl(t, e));
  }
  de(Vt), le(Vt, t);
}
function Vi() {
  de(Vt), de(Vr), de(Qr);
}
function Jh(e) {
  Qn(Qr.current);
  var t = Qn(Vt.current),
    n = dl(t, e.type);
  t !== n && (le(Vr, e), le(Vt, n));
}
function jc(e) {
  Vr.current === e && (de(Vt), de(Vr));
}
var fe = Rn(0);
function ca(e) {
  for (var t = e; t !== null; ) {
    if (t.tag === 13) {
      var n = t.memoizedState;
      if (n !== null && ((n = n.dehydrated), n === null || n.data === '$?' || n.data === '$!')) return t;
    } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
      if ((t.flags & 128) !== 0) return t;
    } else if (t.child !== null) {
      (t.child.return = t), (t = t.child);
      continue;
    }
    if (t === e) break;
    for (; t.sibling === null; ) {
      if (t.return === null || t.return === e) return null;
      t = t.return;
    }
    (t.sibling.return = t.return), (t = t.sibling);
  }
  return null;
}
var Hs = [];
function Fc() {
  for (var e = 0; e < Hs.length; e++) Hs[e]._workInProgressVersionPrimary = null;
  Hs.length = 0;
}
var zo = cn.ReactCurrentDispatcher,
  Os = cn.ReactCurrentBatchConfig,
  ti = 0,
  me = null,
  Me = null,
  Le = null,
  ua = !1,
  br = !1,
  Wr = 0,
  qv = 0;
function qe() {
  throw Error(w(321));
}
function zc(e, t) {
  if (t === null) return !1;
  for (var n = 0; n < t.length && n < e.length; n++) if (!Dt(e[n], t[n])) return !1;
  return !0;
}
function Bc(e, t, n, i, r, o) {
  if (
    ((ti = o),
    (me = t),
    (t.memoizedState = null),
    (t.updateQueue = null),
    (t.lanes = 0),
    (zo.current = e === null || e.memoizedState === null ? Kv : Jv),
    (e = n(i, r)),
    br)
  ) {
    o = 0;
    do {
      if (((br = !1), (Wr = 0), 25 <= o)) throw Error(w(301));
      (o += 1), (Le = Me = null), (t.updateQueue = null), (zo.current = Xv), (e = n(i, r));
    } while (br);
  }
  if (((zo.current = da), (t = Me !== null && Me.next !== null), (ti = 0), (Le = Me = me = null), (ua = !1), t))
    throw Error(w(300));
  return e;
}
function Uc() {
  var e = Wr !== 0;
  return (Wr = 0), e;
}
function zt() {
  var e = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
  return Le === null ? (me.memoizedState = Le = e) : (Le = Le.next = e), Le;
}
function Pt() {
  if (Me === null) {
    var e = me.alternate;
    e = e !== null ? e.memoizedState : null;
  } else e = Me.next;
  var t = Le === null ? me.memoizedState : Le.next;
  if (t !== null) (Le = t), (Me = e);
  else {
    if (e === null) throw Error(w(310));
    (Me = e),
      (e = {
        memoizedState: Me.memoizedState,
        baseState: Me.baseState,
        baseQueue: Me.baseQueue,
        queue: Me.queue,
        next: null,
      }),
      Le === null ? (me.memoizedState = Le = e) : (Le = Le.next = e);
  }
  return Le;
}
function Kr(e, t) {
  return typeof t == 'function' ? t(e) : t;
}
function js(e) {
  var t = Pt(),
    n = t.queue;
  if (n === null) throw Error(w(311));
  n.lastRenderedReducer = e;
  var i = Me,
    r = i.baseQueue,
    o = n.pending;
  if (o !== null) {
    if (r !== null) {
      var a = r.next;
      (r.next = o.next), (o.next = a);
    }
    (i.baseQueue = r = o), (n.pending = null);
  }
  if (r !== null) {
    (o = r.next), (i = i.baseState);
    var s = (a = null),
      l = null,
      c = o;
    do {
      var u = c.lane;
      if ((ti & u) === u)
        l !== null &&
          (l = l.next =
            { lane: 0, action: c.action, hasEagerState: c.hasEagerState, eagerState: c.eagerState, next: null }),
          (i = c.hasEagerState ? c.eagerState : e(i, c.action));
      else {
        var f = { lane: u, action: c.action, hasEagerState: c.hasEagerState, eagerState: c.eagerState, next: null };
        l === null ? ((s = l = f), (a = i)) : (l = l.next = f), (me.lanes |= u), (ni |= u);
      }
      c = c.next;
    } while (c !== null && c !== o);
    l === null ? (a = i) : (l.next = s),
      Dt(i, t.memoizedState) || (st = !0),
      (t.memoizedState = i),
      (t.baseState = a),
      (t.baseQueue = l),
      (n.lastRenderedState = i);
  }
  if (((e = n.interleaved), e !== null)) {
    r = e;
    do (o = r.lane), (me.lanes |= o), (ni |= o), (r = r.next);
    while (r !== e);
  } else r === null && (n.lanes = 0);
  return [t.memoizedState, n.dispatch];
}
function Fs(e) {
  var t = Pt(),
    n = t.queue;
  if (n === null) throw Error(w(311));
  n.lastRenderedReducer = e;
  var i = n.dispatch,
    r = n.pending,
    o = t.memoizedState;
  if (r !== null) {
    n.pending = null;
    var a = (r = r.next);
    do (o = e(o, a.action)), (a = a.next);
    while (a !== r);
    Dt(o, t.memoizedState) || (st = !0),
      (t.memoizedState = o),
      t.baseQueue === null && (t.baseState = o),
      (n.lastRenderedState = o);
  }
  return [o, i];
}
function Xh() {}
function Zh(e, t) {
  var n = me,
    i = Pt(),
    r = t(),
    o = !Dt(i.memoizedState, r);
  if (
    (o && ((i.memoizedState = r), (st = !0)),
    (i = i.queue),
    Gc(tf.bind(null, n, i, e), [e]),
    i.getSnapshot !== t || o || (Le !== null && Le.memoizedState.tag & 1))
  ) {
    if (((n.flags |= 2048), Jr(9, ef.bind(null, n, i, r, t), void 0, null), Ne === null)) throw Error(w(349));
    (ti & 30) !== 0 || Yh(n, t, r);
  }
  return r;
}
function Yh(e, t, n) {
  (e.flags |= 16384),
    (e = { getSnapshot: t, value: n }),
    (t = me.updateQueue),
    t === null
      ? ((t = { lastEffect: null, stores: null }), (me.updateQueue = t), (t.stores = [e]))
      : ((n = t.stores), n === null ? (t.stores = [e]) : n.push(e));
}
function ef(e, t, n, i) {
  (t.value = n), (t.getSnapshot = i), nf(t) && rf(e);
}
function tf(e, t, n) {
  return n(function () {
    nf(t) && rf(e);
  });
}
function nf(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var n = t();
    return !Dt(e, n);
  } catch {
    return !0;
  }
}
function rf(e) {
  var t = an(e, 1);
  t !== null && Rt(t, e, 1, -1);
}
function Td(e) {
  var t = zt();
  return (
    typeof e == 'function' && (e = e()),
    (t.memoizedState = t.baseState = e),
    (e = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Kr, lastRenderedState: e }),
    (t.queue = e),
    (e = e.dispatch = Wv.bind(null, me, e)),
    [t.memoizedState, e]
  );
}
function Jr(e, t, n, i) {
  return (
    (e = { tag: e, create: t, destroy: n, deps: i, next: null }),
    (t = me.updateQueue),
    t === null
      ? ((t = { lastEffect: null, stores: null }), (me.updateQueue = t), (t.lastEffect = e.next = e))
      : ((n = t.lastEffect),
        n === null ? (t.lastEffect = e.next = e) : ((i = n.next), (n.next = e), (e.next = i), (t.lastEffect = e))),
    e
  );
}
function of() {
  return Pt().memoizedState;
}
function Bo(e, t, n, i) {
  var r = zt();
  (me.flags |= e), (r.memoizedState = Jr(1 | t, n, void 0, i === void 0 ? null : i));
}
function Ma(e, t, n, i) {
  var r = Pt();
  i = i === void 0 ? null : i;
  var o = void 0;
  if (Me !== null) {
    var a = Me.memoizedState;
    if (((o = a.destroy), i !== null && zc(i, a.deps))) {
      r.memoizedState = Jr(t, n, o, i);
      return;
    }
  }
  (me.flags |= e), (r.memoizedState = Jr(1 | t, n, o, i));
}
function Cd(e, t) {
  return Bo(8390656, 8, e, t);
}
function Gc(e, t) {
  return Ma(2048, 8, e, t);
}
function af(e, t) {
  return Ma(4, 2, e, t);
}
function sf(e, t) {
  return Ma(4, 4, e, t);
}
function lf(e, t) {
  if (typeof t == 'function')
    return (
      (e = e()),
      t(e),
      function () {
        t(null);
      }
    );
  if (t != null)
    return (
      (e = e()),
      (t.current = e),
      function () {
        t.current = null;
      }
    );
}
function cf(e, t, n) {
  return (n = n != null ? n.concat([e]) : null), Ma(4, 4, lf.bind(null, t, e), n);
}
function $c() {}
function uf(e, t) {
  var n = Pt();
  t = t === void 0 ? null : t;
  var i = n.memoizedState;
  return i !== null && t !== null && zc(t, i[1]) ? i[0] : ((n.memoizedState = [e, t]), e);
}
function df(e, t) {
  var n = Pt();
  t = t === void 0 ? null : t;
  var i = n.memoizedState;
  return i !== null && t !== null && zc(t, i[1]) ? i[0] : ((e = e()), (n.memoizedState = [e, t]), e);
}
function pf(e, t, n) {
  return (ti & 21) === 0
    ? (e.baseState && ((e.baseState = !1), (st = !0)), (e.memoizedState = n))
    : (Dt(n, t) || ((n = fh()), (me.lanes |= n), (ni |= n), (e.baseState = !0)), t);
}
function Vv(e, t) {
  var n = oe;
  (oe = n !== 0 && 4 > n ? n : 4), e(!0);
  var i = Os.transition;
  Os.transition = {};
  try {
    e(!1), t();
  } finally {
    (oe = n), (Os.transition = i);
  }
}
function hf() {
  return Pt().memoizedState;
}
function Qv(e, t, n) {
  var i = Cn(e);
  if (((n = { lane: i, action: n, hasEagerState: !1, eagerState: null, next: null }), ff(e))) mf(t, n);
  else if (((n = $h(e, t, n, i)), n !== null)) {
    var r = et();
    Rt(n, e, i, r), gf(n, t, i);
  }
}
function Wv(e, t, n) {
  var i = Cn(e),
    r = { lane: i, action: n, hasEagerState: !1, eagerState: null, next: null };
  if (ff(e)) mf(t, r);
  else {
    var o = e.alternate;
    if (e.lanes === 0 && (o === null || o.lanes === 0) && ((o = t.lastRenderedReducer), o !== null))
      try {
        var a = t.lastRenderedState,
          s = o(a, n);
        if (((r.hasEagerState = !0), (r.eagerState = s), Dt(s, a))) {
          var l = t.interleaved;
          l === null ? ((r.next = r), Dc(t)) : ((r.next = l.next), (l.next = r)), (t.interleaved = r);
          return;
        }
      } catch {
      } finally {
      }
    (n = $h(e, t, r, i)), n !== null && ((r = et()), Rt(n, e, i, r), gf(n, t, i));
  }
}
function ff(e) {
  var t = e.alternate;
  return e === me || (t !== null && t === me);
}
function mf(e, t) {
  br = ua = !0;
  var n = e.pending;
  n === null ? (t.next = t) : ((t.next = n.next), (n.next = t)), (e.pending = t);
}
function gf(e, t, n) {
  if ((n & 4194240) !== 0) {
    var i = t.lanes;
    (i &= e.pendingLanes), (n |= i), (t.lanes = n), Ec(e, n);
  }
}
var da = {
    readContext: Mt,
    useCallback: qe,
    useContext: qe,
    useEffect: qe,
    useImperativeHandle: qe,
    useInsertionEffect: qe,
    useLayoutEffect: qe,
    useMemo: qe,
    useReducer: qe,
    useRef: qe,
    useState: qe,
    useDebugValue: qe,
    useDeferredValue: qe,
    useTransition: qe,
    useMutableSource: qe,
    useSyncExternalStore: qe,
    useId: qe,
    unstable_isNewReconciler: !1,
  },
  Kv = {
    readContext: Mt,
    useCallback: function (e, t) {
      return (zt().memoizedState = [e, t === void 0 ? null : t]), e;
    },
    useContext: Mt,
    useEffect: Cd,
    useImperativeHandle: function (e, t, n) {
      return (n = n != null ? n.concat([e]) : null), Bo(4194308, 4, lf.bind(null, t, e), n);
    },
    useLayoutEffect: function (e, t) {
      return Bo(4194308, 4, e, t);
    },
    useInsertionEffect: function (e, t) {
      return Bo(4, 2, e, t);
    },
    useMemo: function (e, t) {
      var n = zt();
      return (t = t === void 0 ? null : t), (e = e()), (n.memoizedState = [e, t]), e;
    },
    useReducer: function (e, t, n) {
      var i = zt();
      return (
        (t = n !== void 0 ? n(t) : t),
        (i.memoizedState = i.baseState = t),
        (e = {
          pending: null,
          interleaved: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: e,
          lastRenderedState: t,
        }),
        (i.queue = e),
        (e = e.dispatch = Qv.bind(null, me, e)),
        [i.memoizedState, e]
      );
    },
    useRef: function (e) {
      var t = zt();
      return (e = { current: e }), (t.memoizedState = e);
    },
    useState: Td,
    useDebugValue: $c,
    useDeferredValue: function (e) {
      return (zt().memoizedState = e);
    },
    useTransition: function () {
      var e = Td(!1),
        t = e[0];
      return (e = Vv.bind(null, e[1])), (zt().memoizedState = e), [t, e];
    },
    useMutableSource: function () {},
    useSyncExternalStore: function (e, t, n) {
      var i = me,
        r = zt();
      if (pe) {
        if (n === void 0) throw Error(w(407));
        n = n();
      } else {
        if (((n = t()), Ne === null)) throw Error(w(349));
        (ti & 30) !== 0 || Yh(i, t, n);
      }
      r.memoizedState = n;
      var o = { value: n, getSnapshot: t };
      return (
        (r.queue = o),
        Cd(tf.bind(null, i, o, e), [e]),
        (i.flags |= 2048),
        Jr(9, ef.bind(null, i, o, n, t), void 0, null),
        n
      );
    },
    useId: function () {
      var e = zt(),
        t = Ne.identifierPrefix;
      if (pe) {
        var n = tn,
          i = en;
        (n = (i & ~(1 << (32 - Nt(i) - 1))).toString(32) + n),
          (t = ':' + t + 'R' + n),
          (n = Wr++),
          0 < n && (t += 'H' + n.toString(32)),
          (t += ':');
      } else (n = qv++), (t = ':' + t + 'r' + n.toString(32) + ':');
      return (e.memoizedState = t);
    },
    unstable_isNewReconciler: !1,
  },
  Jv = {
    readContext: Mt,
    useCallback: uf,
    useContext: Mt,
    useEffect: Gc,
    useImperativeHandle: cf,
    useInsertionEffect: af,
    useLayoutEffect: sf,
    useMemo: df,
    useReducer: js,
    useRef: of,
    useState: function () {
      return js(Kr);
    },
    useDebugValue: $c,
    useDeferredValue: function (e) {
      var t = Pt();
      return pf(t, Me.memoizedState, e);
    },
    useTransition: function () {
      var e = js(Kr)[0],
        t = Pt().memoizedState;
      return [e, t];
    },
    useMutableSource: Xh,
    useSyncExternalStore: Zh,
    useId: hf,
    unstable_isNewReconciler: !1,
  },
  Xv = {
    readContext: Mt,
    useCallback: uf,
    useContext: Mt,
    useEffect: Gc,
    useImperativeHandle: cf,
    useInsertionEffect: af,
    useLayoutEffect: sf,
    useMemo: df,
    useReducer: Fs,
    useRef: of,
    useState: function () {
      return Fs(Kr);
    },
    useDebugValue: $c,
    useDeferredValue: function (e) {
      var t = Pt();
      return Me === null ? (t.memoizedState = e) : pf(t, Me.memoizedState, e);
    },
    useTransition: function () {
      var e = Fs(Kr)[0],
        t = Pt().memoizedState;
      return [e, t];
    },
    useMutableSource: Xh,
    useSyncExternalStore: Zh,
    useId: hf,
    unstable_isNewReconciler: !1,
  };
function Qi(e, t) {
  try {
    var n = '',
      i = t;
    do (n += wg(i)), (i = i.return);
    while (i);
    var r = n;
  } catch (o) {
    r =
      `
Error generating stack: ` +
      o.message +
      `
` +
      o.stack;
  }
  return { value: e, source: t, stack: r, digest: null };
}
function zs(e, t, n) {
  return { value: e, source: null, stack: n != null ? n : null, digest: t != null ? t : null };
}
function Rl(e, t) {
  try {
    console.error(t.value);
  } catch (n) {
    setTimeout(function () {
      throw n;
    });
  }
}
var Zv = typeof WeakMap == 'function' ? WeakMap : Map;
function vf(e, t, n) {
  (n = nn(-1, n)), (n.tag = 3), (n.payload = { element: null });
  var i = t.value;
  return (
    (n.callback = function () {
      ha || ((ha = !0), ($l = i)), Rl(e, t);
    }),
    n
  );
}
function _f(e, t, n) {
  (n = nn(-1, n)), (n.tag = 3);
  var i = e.type.getDerivedStateFromError;
  if (typeof i == 'function') {
    var r = t.value;
    (n.payload = function () {
      return i(r);
    }),
      (n.callback = function () {
        Rl(e, t);
      });
  }
  var o = e.stateNode;
  return (
    o !== null &&
      typeof o.componentDidCatch == 'function' &&
      (n.callback = function () {
        Rl(e, t), typeof i != 'function' && (Tn === null ? (Tn = new Set([this])) : Tn.add(this));
        var a = t.stack;
        this.componentDidCatch(t.value, { componentStack: a !== null ? a : '' });
      }),
    n
  );
}
function bd(e, t, n) {
  var i = e.pingCache;
  if (i === null) {
    i = e.pingCache = new Zv();
    var r = new Set();
    i.set(t, r);
  } else (r = i.get(t)), r === void 0 && ((r = new Set()), i.set(t, r));
  r.has(n) || (r.add(n), (e = p_.bind(null, e, t, n)), t.then(e, e));
}
function Id(e) {
  do {
    var t;
    if (((t = e.tag === 13) && ((t = e.memoizedState), (t = t !== null ? t.dehydrated !== null : !0)), t)) return e;
    e = e.return;
  } while (e !== null);
  return null;
}
function Ld(e, t, n, i, r) {
  return (e.mode & 1) === 0
    ? (e === t
        ? (e.flags |= 65536)
        : ((e.flags |= 128),
          (n.flags |= 131072),
          (n.flags &= -52805),
          n.tag === 1 && (n.alternate === null ? (n.tag = 17) : ((t = nn(-1, 1)), (t.tag = 2), Pn(n, t, 1))),
          (n.lanes |= 1)),
      e)
    : ((e.flags |= 65536), (e.lanes = r), e);
}
var Yv = cn.ReactCurrentOwner,
  st = !1;
function Ye(e, t, n, i) {
  t.child = e === null ? Kh(t, null, n, i) : qi(t, e.child, n, i);
}
function Nd(e, t, n, i, r) {
  n = n.render;
  var o = t.ref;
  return (
    Fi(t, r),
    (i = Bc(e, t, n, i, o, r)),
    (n = Uc()),
    e !== null && !st
      ? ((t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~r), sn(e, t, r))
      : (pe && n && Cc(t), (t.flags |= 1), Ye(e, t, i, r), t.child)
  );
}
function Rd(e, t, n, i, r) {
  if (e === null) {
    var o = n.type;
    return typeof o == 'function' &&
      !Zc(o) &&
      o.defaultProps === void 0 &&
      n.compare === null &&
      n.defaultProps === void 0
      ? ((t.tag = 15), (t.type = o), xf(e, t, o, i, r))
      : ((e = qo(n.type, null, i, t, t.mode, r)), (e.ref = t.ref), (e.return = t), (t.child = e));
  }
  if (((o = e.child), (e.lanes & r) === 0)) {
    var a = o.memoizedProps;
    if (((n = n.compare), (n = n !== null ? n : Ur), n(a, i) && e.ref === t.ref)) return sn(e, t, r);
  }
  return (t.flags |= 1), (e = bn(o, i)), (e.ref = t.ref), (e.return = t), (t.child = e);
}
function xf(e, t, n, i, r) {
  if (e !== null) {
    var o = e.memoizedProps;
    if (Ur(o, i) && e.ref === t.ref)
      if (((st = !1), (t.pendingProps = i = o), (e.lanes & r) !== 0)) (e.flags & 131072) !== 0 && (st = !0);
      else return (t.lanes = e.lanes), sn(e, t, r);
  }
  return Dl(e, t, n, i, r);
}
function yf(e, t, n) {
  var i = t.pendingProps,
    r = i.children,
    o = e !== null ? e.memoizedState : null;
  if (i.mode === 'hidden')
    if ((t.mode & 1) === 0)
      (t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }), le(Ni, ft), (ft |= n);
    else {
      if ((n & 1073741824) === 0)
        return (
          (e = o !== null ? o.baseLanes | n : n),
          (t.lanes = t.childLanes = 1073741824),
          (t.memoizedState = { baseLanes: e, cachePool: null, transitions: null }),
          (t.updateQueue = null),
          le(Ni, ft),
          (ft |= e),
          null
        );
      (t.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }),
        (i = o !== null ? o.baseLanes : n),
        le(Ni, ft),
        (ft |= i);
    }
  else o !== null ? ((i = o.baseLanes | n), (t.memoizedState = null)) : (i = n), le(Ni, ft), (ft |= i);
  return Ye(e, t, r, n), t.child;
}
function Ef(e, t) {
  var n = t.ref;
  ((e === null && n !== null) || (e !== null && e.ref !== n)) && ((t.flags |= 512), (t.flags |= 2097152));
}
function Dl(e, t, n, i, r) {
  var o = ct(n) ? Yn : Ke.current;
  return (
    (o = Gi(t, o)),
    Fi(t, r),
    (n = Bc(e, t, n, i, o, r)),
    (i = Uc()),
    e !== null && !st
      ? ((t.updateQueue = e.updateQueue), (t.flags &= -2053), (e.lanes &= ~r), sn(e, t, r))
      : (pe && i && Cc(t), (t.flags |= 1), Ye(e, t, n, r), t.child)
  );
}
function Dd(e, t, n, i, r) {
  if (ct(n)) {
    var o = !0;
    ia(t);
  } else o = !1;
  if ((Fi(t, r), t.stateNode === null)) Uo(e, t), Qh(t, n, i), Nl(t, n, i, r), (i = !0);
  else if (e === null) {
    var a = t.stateNode,
      s = t.memoizedProps;
    a.props = s;
    var l = a.context,
      c = n.contextType;
    typeof c == 'object' && c !== null ? (c = Mt(c)) : ((c = ct(n) ? Yn : Ke.current), (c = Gi(t, c)));
    var u = n.getDerivedStateFromProps,
      f = typeof u == 'function' || typeof a.getSnapshotBeforeUpdate == 'function';
    f ||
      (typeof a.UNSAFE_componentWillReceiveProps != 'function' && typeof a.componentWillReceiveProps != 'function') ||
      ((s !== i || l !== c) && Md(t, a, i, c)),
      (_n = !1);
    var h = t.memoizedState;
    (a.state = h),
      la(t, i, a, r),
      (l = t.memoizedState),
      s !== i || h !== l || lt.current || _n
        ? (typeof u == 'function' && (Ll(t, n, u, i), (l = t.memoizedState)),
          (s = _n || wd(t, n, s, i, h, l, c))
            ? (f ||
                (typeof a.UNSAFE_componentWillMount != 'function' && typeof a.componentWillMount != 'function') ||
                (typeof a.componentWillMount == 'function' && a.componentWillMount(),
                typeof a.UNSAFE_componentWillMount == 'function' && a.UNSAFE_componentWillMount()),
              typeof a.componentDidMount == 'function' && (t.flags |= 4194308))
            : (typeof a.componentDidMount == 'function' && (t.flags |= 4194308),
              (t.memoizedProps = i),
              (t.memoizedState = l)),
          (a.props = i),
          (a.state = l),
          (a.context = c),
          (i = s))
        : (typeof a.componentDidMount == 'function' && (t.flags |= 4194308), (i = !1));
  } else {
    (a = t.stateNode),
      qh(e, t),
      (s = t.memoizedProps),
      (c = t.type === t.elementType ? s : bt(t.type, s)),
      (a.props = c),
      (f = t.pendingProps),
      (h = a.context),
      (l = n.contextType),
      typeof l == 'object' && l !== null ? (l = Mt(l)) : ((l = ct(n) ? Yn : Ke.current), (l = Gi(t, l)));
    var x = n.getDerivedStateFromProps;
    (u = typeof x == 'function' || typeof a.getSnapshotBeforeUpdate == 'function') ||
      (typeof a.UNSAFE_componentWillReceiveProps != 'function' && typeof a.componentWillReceiveProps != 'function') ||
      ((s !== f || h !== l) && Md(t, a, i, l)),
      (_n = !1),
      (h = t.memoizedState),
      (a.state = h),
      la(t, i, a, r);
    var y = t.memoizedState;
    s !== f || h !== y || lt.current || _n
      ? (typeof x == 'function' && (Ll(t, n, x, i), (y = t.memoizedState)),
        (c = _n || wd(t, n, c, i, h, y, l) || !1)
          ? (u ||
              (typeof a.UNSAFE_componentWillUpdate != 'function' && typeof a.componentWillUpdate != 'function') ||
              (typeof a.componentWillUpdate == 'function' && a.componentWillUpdate(i, y, l),
              typeof a.UNSAFE_componentWillUpdate == 'function' && a.UNSAFE_componentWillUpdate(i, y, l)),
            typeof a.componentDidUpdate == 'function' && (t.flags |= 4),
            typeof a.getSnapshotBeforeUpdate == 'function' && (t.flags |= 1024))
          : (typeof a.componentDidUpdate != 'function' ||
              (s === e.memoizedProps && h === e.memoizedState) ||
              (t.flags |= 4),
            typeof a.getSnapshotBeforeUpdate != 'function' ||
              (s === e.memoizedProps && h === e.memoizedState) ||
              (t.flags |= 1024),
            (t.memoizedProps = i),
            (t.memoizedState = y)),
        (a.props = i),
        (a.state = y),
        (a.context = l),
        (i = c))
      : (typeof a.componentDidUpdate != 'function' ||
          (s === e.memoizedProps && h === e.memoizedState) ||
          (t.flags |= 4),
        typeof a.getSnapshotBeforeUpdate != 'function' ||
          (s === e.memoizedProps && h === e.memoizedState) ||
          (t.flags |= 1024),
        (i = !1));
  }
  return Hl(e, t, n, i, o, r);
}
function Hl(e, t, n, i, r, o) {
  Ef(e, t);
  var a = (t.flags & 128) !== 0;
  if (!i && !a) return r && yd(t, n, !1), sn(e, t, o);
  (i = t.stateNode), (Yv.current = t);
  var s = a && typeof n.getDerivedStateFromError != 'function' ? null : i.render();
  return (
    (t.flags |= 1),
    e !== null && a ? ((t.child = qi(t, e.child, null, o)), (t.child = qi(t, null, s, o))) : Ye(e, t, s, o),
    (t.memoizedState = i.state),
    r && yd(t, n, !0),
    t.child
  );
}
function kf(e) {
  var t = e.stateNode;
  t.pendingContext ? xd(e, t.pendingContext, t.pendingContext !== t.context) : t.context && xd(e, t.context, !1),
    Oc(e, t.containerInfo);
}
function Hd(e, t, n, i, r) {
  return $i(), Ic(r), (t.flags |= 256), Ye(e, t, n, i), t.child;
}
var Ol = { dehydrated: null, treeContext: null, retryLane: 0 };
function jl(e) {
  return { baseLanes: e, cachePool: null, transitions: null };
}
function Sf(e, t, n) {
  var i = t.pendingProps,
    r = fe.current,
    o = !1,
    a = (t.flags & 128) !== 0,
    s;
  if (
    ((s = a) || (s = e !== null && e.memoizedState === null ? !1 : (r & 2) !== 0),
    s ? ((o = !0), (t.flags &= -129)) : (e === null || e.memoizedState !== null) && (r |= 1),
    le(fe, r & 1),
    e === null)
  )
    return (
      bl(t),
      (e = t.memoizedState),
      e !== null && ((e = e.dehydrated), e !== null)
        ? ((t.mode & 1) === 0 ? (t.lanes = 1) : e.data === '$!' ? (t.lanes = 8) : (t.lanes = 1073741824), null)
        : ((a = i.children),
          (e = i.fallback),
          o
            ? ((i = t.mode),
              (o = t.child),
              (a = { mode: 'hidden', children: a }),
              (i & 1) === 0 && o !== null ? ((o.childLanes = 0), (o.pendingProps = a)) : (o = Ca(a, i, 0, null)),
              (e = Jn(e, i, n, null)),
              (o.return = t),
              (e.return = t),
              (o.sibling = e),
              (t.child = o),
              (t.child.memoizedState = jl(n)),
              (t.memoizedState = Ol),
              e)
            : qc(t, a))
    );
  if (((r = e.memoizedState), r !== null && ((s = r.dehydrated), s !== null))) return e_(e, t, a, i, s, r, n);
  if (o) {
    (o = i.fallback), (a = t.mode), (r = e.child), (s = r.sibling);
    var l = { mode: 'hidden', children: i.children };
    return (
      (a & 1) === 0 && t.child !== r
        ? ((i = t.child), (i.childLanes = 0), (i.pendingProps = l), (t.deletions = null))
        : ((i = bn(r, l)), (i.subtreeFlags = r.subtreeFlags & 14680064)),
      s !== null ? (o = bn(s, o)) : ((o = Jn(o, a, n, null)), (o.flags |= 2)),
      (o.return = t),
      (i.return = t),
      (i.sibling = o),
      (t.child = i),
      (i = o),
      (o = t.child),
      (a = e.child.memoizedState),
      (a = a === null ? jl(n) : { baseLanes: a.baseLanes | n, cachePool: null, transitions: a.transitions }),
      (o.memoizedState = a),
      (o.childLanes = e.childLanes & ~n),
      (t.memoizedState = Ol),
      i
    );
  }
  return (
    (o = e.child),
    (e = o.sibling),
    (i = bn(o, { mode: 'visible', children: i.children })),
    (t.mode & 1) === 0 && (i.lanes = n),
    (i.return = t),
    (i.sibling = null),
    e !== null && ((n = t.deletions), n === null ? ((t.deletions = [e]), (t.flags |= 16)) : n.push(e)),
    (t.child = i),
    (t.memoizedState = null),
    i
  );
}
function qc(e, t) {
  return (t = Ca({ mode: 'visible', children: t }, e.mode, 0, null)), (t.return = e), (e.child = t);
}
function To(e, t, n, i) {
  return (
    i !== null && Ic(i),
    qi(t, e.child, null, n),
    (e = qc(t, t.pendingProps.children)),
    (e.flags |= 2),
    (t.memoizedState = null),
    e
  );
}
function e_(e, t, n, i, r, o, a) {
  if (n)
    return t.flags & 256
      ? ((t.flags &= -257), (i = zs(Error(w(422)))), To(e, t, a, i))
      : t.memoizedState !== null
        ? ((t.child = e.child), (t.flags |= 128), null)
        : ((o = i.fallback),
          (r = t.mode),
          (i = Ca({ mode: 'visible', children: i.children }, r, 0, null)),
          (o = Jn(o, r, a, null)),
          (o.flags |= 2),
          (i.return = t),
          (o.return = t),
          (i.sibling = o),
          (t.child = i),
          (t.mode & 1) !== 0 && qi(t, e.child, null, a),
          (t.child.memoizedState = jl(a)),
          (t.memoizedState = Ol),
          o);
  if ((t.mode & 1) === 0) return To(e, t, a, null);
  if (r.data === '$!') {
    if (((i = r.nextSibling && r.nextSibling.dataset), i)) var s = i.dgst;
    return (i = s), (o = Error(w(419))), (i = zs(o, i, void 0)), To(e, t, a, i);
  }
  if (((s = (a & e.childLanes) !== 0), st || s)) {
    if (((i = Ne), i !== null)) {
      switch (a & -a) {
        case 4:
          r = 2;
          break;
        case 16:
          r = 8;
          break;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          r = 32;
          break;
        case 536870912:
          r = 268435456;
          break;
        default:
          r = 0;
      }
      (r = (r & (i.suspendedLanes | a)) !== 0 ? 0 : r),
        r !== 0 && r !== o.retryLane && ((o.retryLane = r), an(e, r), Rt(i, e, r, -1));
    }
    return Xc(), (i = zs(Error(w(421)))), To(e, t, a, i);
  }
  return r.data === '$?'
    ? ((t.flags |= 128), (t.child = e.child), (t = h_.bind(null, e)), (r._reactRetry = t), null)
    : ((e = o.treeContext),
      (mt = Mn(r.nextSibling)),
      (gt = t),
      (pe = !0),
      (Lt = null),
      e !== null && ((kt[St++] = en), (kt[St++] = tn), (kt[St++] = ei), (en = e.id), (tn = e.overflow), (ei = t)),
      (t = qc(t, i.children)),
      (t.flags |= 4096),
      t);
}
function Od(e, t, n) {
  e.lanes |= t;
  var i = e.alternate;
  i !== null && (i.lanes |= t), Il(e.return, t, n);
}
function Bs(e, t, n, i, r) {
  var o = e.memoizedState;
  o === null
    ? (e.memoizedState = { isBackwards: t, rendering: null, renderingStartTime: 0, last: i, tail: n, tailMode: r })
    : ((o.isBackwards = t),
      (o.rendering = null),
      (o.renderingStartTime = 0),
      (o.last = i),
      (o.tail = n),
      (o.tailMode = r));
}
function Af(e, t, n) {
  var i = t.pendingProps,
    r = i.revealOrder,
    o = i.tail;
  if ((Ye(e, t, i.children, n), (i = fe.current), (i & 2) !== 0)) (i = (i & 1) | 2), (t.flags |= 128);
  else {
    if (e !== null && (e.flags & 128) !== 0)
      e: for (e = t.child; e !== null; ) {
        if (e.tag === 13) e.memoizedState !== null && Od(e, n, t);
        else if (e.tag === 19) Od(e, n, t);
        else if (e.child !== null) {
          (e.child.return = e), (e = e.child);
          continue;
        }
        if (e === t) break e;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t) break e;
          e = e.return;
        }
        (e.sibling.return = e.return), (e = e.sibling);
      }
    i &= 1;
  }
  if ((le(fe, i), (t.mode & 1) === 0)) t.memoizedState = null;
  else
    switch (r) {
      case 'forwards':
        for (n = t.child, r = null; n !== null; )
          (e = n.alternate), e !== null && ca(e) === null && (r = n), (n = n.sibling);
        (n = r),
          n === null ? ((r = t.child), (t.child = null)) : ((r = n.sibling), (n.sibling = null)),
          Bs(t, !1, r, n, o);
        break;
      case 'backwards':
        for (n = null, r = t.child, t.child = null; r !== null; ) {
          if (((e = r.alternate), e !== null && ca(e) === null)) {
            t.child = r;
            break;
          }
          (e = r.sibling), (r.sibling = n), (n = r), (r = e);
        }
        Bs(t, !0, n, null, o);
        break;
      case 'together':
        Bs(t, !1, null, null, void 0);
        break;
      default:
        t.memoizedState = null;
    }
  return t.child;
}
function Uo(e, t) {
  (t.mode & 1) === 0 && e !== null && ((e.alternate = null), (t.alternate = null), (t.flags |= 2));
}
function sn(e, t, n) {
  if ((e !== null && (t.dependencies = e.dependencies), (ni |= t.lanes), (n & t.childLanes) === 0)) return null;
  if (e !== null && t.child !== e.child) throw Error(w(153));
  if (t.child !== null) {
    for (e = t.child, n = bn(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null; )
      (e = e.sibling), (n = n.sibling = bn(e, e.pendingProps)), (n.return = t);
    n.sibling = null;
  }
  return t.child;
}
function t_(e, t, n) {
  switch (t.tag) {
    case 3:
      kf(t), $i();
      break;
    case 5:
      Jh(t);
      break;
    case 1:
      ct(t.type) && ia(t);
      break;
    case 4:
      Oc(t, t.stateNode.containerInfo);
      break;
    case 10:
      var i = t.type._context,
        r = t.memoizedProps.value;
      le(aa, i._currentValue), (i._currentValue = r);
      break;
    case 13:
      if (((i = t.memoizedState), i !== null))
        return i.dehydrated !== null
          ? (le(fe, fe.current & 1), (t.flags |= 128), null)
          : (n & t.child.childLanes) !== 0
            ? Sf(e, t, n)
            : (le(fe, fe.current & 1), (e = sn(e, t, n)), e !== null ? e.sibling : null);
      le(fe, fe.current & 1);
      break;
    case 19:
      if (((i = (n & t.childLanes) !== 0), (e.flags & 128) !== 0)) {
        if (i) return Af(e, t, n);
        t.flags |= 128;
      }
      if (
        ((r = t.memoizedState),
        r !== null && ((r.rendering = null), (r.tail = null), (r.lastEffect = null)),
        le(fe, fe.current),
        i)
      )
        break;
      return null;
    case 22:
    case 23:
      return (t.lanes = 0), yf(e, t, n);
  }
  return sn(e, t, n);
}
var wf, Fl, Mf, Pf;
wf = function (e, t) {
  for (var n = t.child; n !== null; ) {
    if (n.tag === 5 || n.tag === 6) e.appendChild(n.stateNode);
    else if (n.tag !== 4 && n.child !== null) {
      (n.child.return = n), (n = n.child);
      continue;
    }
    if (n === t) break;
    for (; n.sibling === null; ) {
      if (n.return === null || n.return === t) return;
      n = n.return;
    }
    (n.sibling.return = n.return), (n = n.sibling);
  }
};
Fl = function () {};
Mf = function (e, t, n, i) {
  var r = e.memoizedProps;
  if (r !== i) {
    (e = t.stateNode), Qn(Vt.current);
    var o = null;
    switch (n) {
      case 'input':
        (r = sl(e, r)), (i = sl(e, i)), (o = []);
        break;
      case 'select':
        (r = ge({}, r, { value: void 0 })), (i = ge({}, i, { value: void 0 })), (o = []);
        break;
      case 'textarea':
        (r = ul(e, r)), (i = ul(e, i)), (o = []);
        break;
      default:
        typeof r.onClick != 'function' && typeof i.onClick == 'function' && (e.onclick = ta);
    }
    pl(n, i);
    var a;
    n = null;
    for (c in r)
      if (!i.hasOwnProperty(c) && r.hasOwnProperty(c) && r[c] != null)
        if (c === 'style') {
          var s = r[c];
          for (a in s) s.hasOwnProperty(a) && (n || (n = {}), (n[a] = ''));
        } else
          c !== 'dangerouslySetInnerHTML' &&
            c !== 'children' &&
            c !== 'suppressContentEditableWarning' &&
            c !== 'suppressHydrationWarning' &&
            c !== 'autoFocus' &&
            (Dr.hasOwnProperty(c) ? o || (o = []) : (o = o || []).push(c, null));
    for (c in i) {
      var l = i[c];
      if (((s = r != null ? r[c] : void 0), i.hasOwnProperty(c) && l !== s && (l != null || s != null)))
        if (c === 'style')
          if (s) {
            for (a in s) !s.hasOwnProperty(a) || (l && l.hasOwnProperty(a)) || (n || (n = {}), (n[a] = ''));
            for (a in l) l.hasOwnProperty(a) && s[a] !== l[a] && (n || (n = {}), (n[a] = l[a]));
          } else n || (o || (o = []), o.push(c, n)), (n = l);
        else
          c === 'dangerouslySetInnerHTML'
            ? ((l = l ? l.__html : void 0),
              (s = s ? s.__html : void 0),
              l != null && s !== l && (o = o || []).push(c, l))
            : c === 'children'
              ? (typeof l != 'string' && typeof l != 'number') || (o = o || []).push(c, '' + l)
              : c !== 'suppressContentEditableWarning' &&
                c !== 'suppressHydrationWarning' &&
                (Dr.hasOwnProperty(c)
                  ? (l != null && c === 'onScroll' && ce('scroll', e), o || s === l || (o = []))
                  : (o = o || []).push(c, l));
    }
    n && (o = o || []).push('style', n);
    var c = o;
    (t.updateQueue = c) && (t.flags |= 4);
  }
};
Pf = function (e, t, n, i) {
  n !== i && (t.flags |= 4);
};
function gr(e, t) {
  if (!pe)
    switch (e.tailMode) {
      case 'hidden':
        t = e.tail;
        for (var n = null; t !== null; ) t.alternate !== null && (n = t), (t = t.sibling);
        n === null ? (e.tail = null) : (n.sibling = null);
        break;
      case 'collapsed':
        n = e.tail;
        for (var i = null; n !== null; ) n.alternate !== null && (i = n), (n = n.sibling);
        i === null ? (t || e.tail === null ? (e.tail = null) : (e.tail.sibling = null)) : (i.sibling = null);
    }
}
function Ve(e) {
  var t = e.alternate !== null && e.alternate.child === e.child,
    n = 0,
    i = 0;
  if (t)
    for (var r = e.child; r !== null; )
      (n |= r.lanes | r.childLanes),
        (i |= r.subtreeFlags & 14680064),
        (i |= r.flags & 14680064),
        (r.return = e),
        (r = r.sibling);
  else
    for (r = e.child; r !== null; )
      (n |= r.lanes | r.childLanes), (i |= r.subtreeFlags), (i |= r.flags), (r.return = e), (r = r.sibling);
  return (e.subtreeFlags |= i), (e.childLanes = n), t;
}
function n_(e, t, n) {
  var i = t.pendingProps;
  switch ((bc(t), t.tag)) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return Ve(t), null;
    case 1:
      return ct(t.type) && na(), Ve(t), null;
    case 3:
      return (
        (i = t.stateNode),
        Vi(),
        de(lt),
        de(Ke),
        Fc(),
        i.pendingContext && ((i.context = i.pendingContext), (i.pendingContext = null)),
        (e === null || e.child === null) &&
          (Mo(t)
            ? (t.flags |= 4)
            : e === null ||
              (e.memoizedState.isDehydrated && (t.flags & 256) === 0) ||
              ((t.flags |= 1024), Lt !== null && (Ql(Lt), (Lt = null)))),
        Fl(e, t),
        Ve(t),
        null
      );
    case 5:
      jc(t);
      var r = Qn(Qr.current);
      if (((n = t.type), e !== null && t.stateNode != null))
        Mf(e, t, n, i, r), e.ref !== t.ref && ((t.flags |= 512), (t.flags |= 2097152));
      else {
        if (!i) {
          if (t.stateNode === null) throw Error(w(166));
          return Ve(t), null;
        }
        if (((e = Qn(Vt.current)), Mo(t))) {
          (i = t.stateNode), (n = t.type);
          var o = t.memoizedProps;
          switch (((i[$t] = t), (i[qr] = o), (e = (t.mode & 1) !== 0), n)) {
            case 'dialog':
              ce('cancel', i), ce('close', i);
              break;
            case 'iframe':
            case 'object':
            case 'embed':
              ce('load', i);
              break;
            case 'video':
            case 'audio':
              for (r = 0; r < Sr.length; r++) ce(Sr[r], i);
              break;
            case 'source':
              ce('error', i);
              break;
            case 'img':
            case 'image':
            case 'link':
              ce('error', i), ce('load', i);
              break;
            case 'details':
              ce('toggle', i);
              break;
            case 'input':
              Vu(i, o), ce('invalid', i);
              break;
            case 'select':
              (i._wrapperState = { wasMultiple: !!o.multiple }), ce('invalid', i);
              break;
            case 'textarea':
              Wu(i, o), ce('invalid', i);
          }
          pl(n, o), (r = null);
          for (var a in o)
            if (o.hasOwnProperty(a)) {
              var s = o[a];
              a === 'children'
                ? typeof s == 'string'
                  ? i.textContent !== s &&
                    (o.suppressHydrationWarning !== !0 && wo(i.textContent, s, e), (r = ['children', s]))
                  : typeof s == 'number' &&
                    i.textContent !== '' + s &&
                    (o.suppressHydrationWarning !== !0 && wo(i.textContent, s, e), (r = ['children', '' + s]))
                : Dr.hasOwnProperty(a) && s != null && a === 'onScroll' && ce('scroll', i);
            }
          switch (n) {
            case 'input':
              vo(i), Qu(i, o, !0);
              break;
            case 'textarea':
              vo(i), Ku(i);
              break;
            case 'select':
            case 'option':
              break;
            default:
              typeof o.onClick == 'function' && (i.onclick = ta);
          }
          (i = r), (t.updateQueue = i), i !== null && (t.flags |= 4);
        } else {
          (a = r.nodeType === 9 ? r : r.ownerDocument),
            e === 'http://www.w3.org/1999/xhtml' && (e = Yp(n)),
            e === 'http://www.w3.org/1999/xhtml'
              ? n === 'script'
                ? ((e = a.createElement('div')), (e.innerHTML = '<script></script>'), (e = e.removeChild(e.firstChild)))
                : typeof i.is == 'string'
                  ? (e = a.createElement(n, { is: i.is }))
                  : ((e = a.createElement(n)),
                    n === 'select' && ((a = e), i.multiple ? (a.multiple = !0) : i.size && (a.size = i.size)))
              : (e = a.createElementNS(e, n)),
            (e[$t] = t),
            (e[qr] = i),
            wf(e, t, !1, !1),
            (t.stateNode = e);
          e: {
            switch (((a = hl(n, i)), n)) {
              case 'dialog':
                ce('cancel', e), ce('close', e), (r = i);
                break;
              case 'iframe':
              case 'object':
              case 'embed':
                ce('load', e), (r = i);
                break;
              case 'video':
              case 'audio':
                for (r = 0; r < Sr.length; r++) ce(Sr[r], e);
                r = i;
                break;
              case 'source':
                ce('error', e), (r = i);
                break;
              case 'img':
              case 'image':
              case 'link':
                ce('error', e), ce('load', e), (r = i);
                break;
              case 'details':
                ce('toggle', e), (r = i);
                break;
              case 'input':
                Vu(e, i), (r = sl(e, i)), ce('invalid', e);
                break;
              case 'option':
                r = i;
                break;
              case 'select':
                (e._wrapperState = { wasMultiple: !!i.multiple }), (r = ge({}, i, { value: void 0 })), ce('invalid', e);
                break;
              case 'textarea':
                Wu(e, i), (r = ul(e, i)), ce('invalid', e);
                break;
              default:
                r = i;
            }
            pl(n, r), (s = r);
            for (o in s)
              if (s.hasOwnProperty(o)) {
                var l = s[o];
                o === 'style'
                  ? nh(e, l)
                  : o === 'dangerouslySetInnerHTML'
                    ? ((l = l ? l.__html : void 0), l != null && eh(e, l))
                    : o === 'children'
                      ? typeof l == 'string'
                        ? (n !== 'textarea' || l !== '') && Hr(e, l)
                        : typeof l == 'number' && Hr(e, '' + l)
                      : o !== 'suppressContentEditableWarning' &&
                        o !== 'suppressHydrationWarning' &&
                        o !== 'autoFocus' &&
                        (Dr.hasOwnProperty(o)
                          ? l != null && o === 'onScroll' && ce('scroll', e)
                          : l != null && mc(e, o, l, a));
              }
            switch (n) {
              case 'input':
                vo(e), Qu(e, i, !1);
                break;
              case 'textarea':
                vo(e), Ku(e);
                break;
              case 'option':
                i.value != null && e.setAttribute('value', '' + In(i.value));
                break;
              case 'select':
                (e.multiple = !!i.multiple),
                  (o = i.value),
                  o != null
                    ? Di(e, !!i.multiple, o, !1)
                    : i.defaultValue != null && Di(e, !!i.multiple, i.defaultValue, !0);
                break;
              default:
                typeof r.onClick == 'function' && (e.onclick = ta);
            }
            switch (n) {
              case 'button':
              case 'input':
              case 'select':
              case 'textarea':
                i = !!i.autoFocus;
                break e;
              case 'img':
                i = !0;
                break e;
              default:
                i = !1;
            }
          }
          i && (t.flags |= 4);
        }
        t.ref !== null && ((t.flags |= 512), (t.flags |= 2097152));
      }
      return Ve(t), null;
    case 6:
      if (e && t.stateNode != null) Pf(e, t, e.memoizedProps, i);
      else {
        if (typeof i != 'string' && t.stateNode === null) throw Error(w(166));
        if (((n = Qn(Qr.current)), Qn(Vt.current), Mo(t))) {
          if (
            ((i = t.stateNode), (n = t.memoizedProps), (i[$t] = t), (o = i.nodeValue !== n) && ((e = gt), e !== null))
          )
            switch (e.tag) {
              case 3:
                wo(i.nodeValue, n, (e.mode & 1) !== 0);
                break;
              case 5:
                e.memoizedProps.suppressHydrationWarning !== !0 && wo(i.nodeValue, n, (e.mode & 1) !== 0);
            }
          o && (t.flags |= 4);
        } else (i = (n.nodeType === 9 ? n : n.ownerDocument).createTextNode(i)), (i[$t] = t), (t.stateNode = i);
      }
      return Ve(t), null;
    case 13:
      if (
        (de(fe), (i = t.memoizedState), e === null || (e.memoizedState !== null && e.memoizedState.dehydrated !== null))
      ) {
        if (pe && mt !== null && (t.mode & 1) !== 0 && (t.flags & 128) === 0) Gh(), $i(), (t.flags |= 98560), (o = !1);
        else if (((o = Mo(t)), i !== null && i.dehydrated !== null)) {
          if (e === null) {
            if (!o) throw Error(w(318));
            if (((o = t.memoizedState), (o = o !== null ? o.dehydrated : null), !o)) throw Error(w(317));
            o[$t] = t;
          } else $i(), (t.flags & 128) === 0 && (t.memoizedState = null), (t.flags |= 4);
          Ve(t), (o = !1);
        } else Lt !== null && (Ql(Lt), (Lt = null)), (o = !0);
        if (!o) return t.flags & 65536 ? t : null;
      }
      return (t.flags & 128) !== 0
        ? ((t.lanes = n), t)
        : ((i = i !== null),
          i !== (e !== null && e.memoizedState !== null) &&
            i &&
            ((t.child.flags |= 8192),
            (t.mode & 1) !== 0 && (e === null || (fe.current & 1) !== 0 ? Pe === 0 && (Pe = 3) : Xc())),
          t.updateQueue !== null && (t.flags |= 4),
          Ve(t),
          null);
    case 4:
      return Vi(), Fl(e, t), e === null && Gr(t.stateNode.containerInfo), Ve(t), null;
    case 10:
      return Rc(t.type._context), Ve(t), null;
    case 17:
      return ct(t.type) && na(), Ve(t), null;
    case 19:
      if ((de(fe), (o = t.memoizedState), o === null)) return Ve(t), null;
      if (((i = (t.flags & 128) !== 0), (a = o.rendering), a === null))
        if (i) gr(o, !1);
        else {
          if (Pe !== 0 || (e !== null && (e.flags & 128) !== 0))
            for (e = t.child; e !== null; ) {
              if (((a = ca(e)), a !== null)) {
                for (
                  t.flags |= 128,
                    gr(o, !1),
                    i = a.updateQueue,
                    i !== null && ((t.updateQueue = i), (t.flags |= 4)),
                    t.subtreeFlags = 0,
                    i = n,
                    n = t.child;
                  n !== null;

                )
                  (o = n),
                    (e = i),
                    (o.flags &= 14680066),
                    (a = o.alternate),
                    a === null
                      ? ((o.childLanes = 0),
                        (o.lanes = e),
                        (o.child = null),
                        (o.subtreeFlags = 0),
                        (o.memoizedProps = null),
                        (o.memoizedState = null),
                        (o.updateQueue = null),
                        (o.dependencies = null),
                        (o.stateNode = null))
                      : ((o.childLanes = a.childLanes),
                        (o.lanes = a.lanes),
                        (o.child = a.child),
                        (o.subtreeFlags = 0),
                        (o.deletions = null),
                        (o.memoizedProps = a.memoizedProps),
                        (o.memoizedState = a.memoizedState),
                        (o.updateQueue = a.updateQueue),
                        (o.type = a.type),
                        (e = a.dependencies),
                        (o.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext })),
                    (n = n.sibling);
                return le(fe, (fe.current & 1) | 2), t.child;
              }
              e = e.sibling;
            }
          o.tail !== null && ye() > Wi && ((t.flags |= 128), (i = !0), gr(o, !1), (t.lanes = 4194304));
        }
      else {
        if (!i)
          if (((e = ca(a)), e !== null)) {
            if (
              ((t.flags |= 128),
              (i = !0),
              (n = e.updateQueue),
              n !== null && ((t.updateQueue = n), (t.flags |= 4)),
              gr(o, !0),
              o.tail === null && o.tailMode === 'hidden' && !a.alternate && !pe)
            )
              return Ve(t), null;
          } else
            2 * ye() - o.renderingStartTime > Wi &&
              n !== 1073741824 &&
              ((t.flags |= 128), (i = !0), gr(o, !1), (t.lanes = 4194304));
        o.isBackwards
          ? ((a.sibling = t.child), (t.child = a))
          : ((n = o.last), n !== null ? (n.sibling = a) : (t.child = a), (o.last = a));
      }
      return o.tail !== null
        ? ((t = o.tail),
          (o.rendering = t),
          (o.tail = t.sibling),
          (o.renderingStartTime = ye()),
          (t.sibling = null),
          (n = fe.current),
          le(fe, i ? (n & 1) | 2 : n & 1),
          t)
        : (Ve(t), null);
    case 22:
    case 23:
      return (
        Jc(),
        (i = t.memoizedState !== null),
        e !== null && (e.memoizedState !== null) !== i && (t.flags |= 8192),
        i && (t.mode & 1) !== 0 ? (ft & 1073741824) !== 0 && (Ve(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : Ve(t),
        null
      );
    case 24:
      return null;
    case 25:
      return null;
  }
  throw Error(w(156, t.tag));
}
function i_(e, t) {
  switch ((bc(t), t.tag)) {
    case 1:
      return ct(t.type) && na(), (e = t.flags), e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null;
    case 3:
      return (
        Vi(),
        de(lt),
        de(Ke),
        Fc(),
        (e = t.flags),
        (e & 65536) !== 0 && (e & 128) === 0 ? ((t.flags = (e & -65537) | 128), t) : null
      );
    case 5:
      return jc(t), null;
    case 13:
      if ((de(fe), (e = t.memoizedState), e !== null && e.dehydrated !== null)) {
        if (t.alternate === null) throw Error(w(340));
        $i();
      }
      return (e = t.flags), e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null;
    case 19:
      return de(fe), null;
    case 4:
      return Vi(), null;
    case 10:
      return Rc(t.type._context), null;
    case 22:
    case 23:
      return Jc(), null;
    case 24:
      return null;
    default:
      return null;
  }
}
var Co = !1,
  We = !1,
  r_ = typeof WeakSet == 'function' ? WeakSet : Set,
  O = null;
function Li(e, t) {
  var n = e.ref;
  if (n !== null)
    if (typeof n == 'function')
      try {
        n(null);
      } catch (i) {
        ve(e, t, i);
      }
    else n.current = null;
}
function zl(e, t, n) {
  try {
    n();
  } catch (i) {
    ve(e, t, i);
  }
}
var jd = !1;
function o_(e, t) {
  if (((Sl = Zo), (e = bh()), Tc(e))) {
    if ('selectionStart' in e) var n = { start: e.selectionStart, end: e.selectionEnd };
    else
      e: {
        n = ((n = e.ownerDocument) && n.defaultView) || window;
        var i = n.getSelection && n.getSelection();
        if (i && i.rangeCount !== 0) {
          n = i.anchorNode;
          var r = i.anchorOffset,
            o = i.focusNode;
          i = i.focusOffset;
          try {
            n.nodeType, o.nodeType;
          } catch {
            n = null;
            break e;
          }
          var a = 0,
            s = -1,
            l = -1,
            c = 0,
            u = 0,
            f = e,
            h = null;
          t: for (;;) {
            for (
              var x;
              f !== n || (r !== 0 && f.nodeType !== 3) || (s = a + r),
                f !== o || (i !== 0 && f.nodeType !== 3) || (l = a + i),
                f.nodeType === 3 && (a += f.nodeValue.length),
                (x = f.firstChild) !== null;

            )
              (h = f), (f = x);
            for (;;) {
              if (f === e) break t;
              if ((h === n && ++c === r && (s = a), h === o && ++u === i && (l = a), (x = f.nextSibling) !== null))
                break;
              (f = h), (h = f.parentNode);
            }
            f = x;
          }
          n = s === -1 || l === -1 ? null : { start: s, end: l };
        } else n = null;
      }
    n = n || { start: 0, end: 0 };
  } else n = null;
  for (Al = { focusedElem: e, selectionRange: n }, Zo = !1, O = t; O !== null; )
    if (((t = O), (e = t.child), (t.subtreeFlags & 1028) !== 0 && e !== null)) (e.return = t), (O = e);
    else
      for (; O !== null; ) {
        t = O;
        try {
          var y = t.alternate;
          if ((t.flags & 1024) !== 0)
            switch (t.tag) {
              case 0:
              case 11:
              case 15:
                break;
              case 1:
                if (y !== null) {
                  var m = y.memoizedProps,
                    j = y.memoizedState,
                    p = t.stateNode,
                    d = p.getSnapshotBeforeUpdate(t.elementType === t.type ? m : bt(t.type, m), j);
                  p.__reactInternalSnapshotBeforeUpdate = d;
                }
                break;
              case 3:
                var g = t.stateNode.containerInfo;
                g.nodeType === 1
                  ? (g.textContent = '')
                  : g.nodeType === 9 && g.documentElement && g.removeChild(g.documentElement);
                break;
              case 5:
              case 6:
              case 4:
              case 17:
                break;
              default:
                throw Error(w(163));
            }
        } catch (k) {
          ve(t, t.return, k);
        }
        if (((e = t.sibling), e !== null)) {
          (e.return = t.return), (O = e);
          break;
        }
        O = t.return;
      }
  return (y = jd), (jd = !1), y;
}
function Ir(e, t, n) {
  var i = t.updateQueue;
  if (((i = i !== null ? i.lastEffect : null), i !== null)) {
    var r = (i = i.next);
    do {
      if ((r.tag & e) === e) {
        var o = r.destroy;
        (r.destroy = void 0), o !== void 0 && zl(t, n, o);
      }
      r = r.next;
    } while (r !== i);
  }
}
function Pa(e, t) {
  if (((t = t.updateQueue), (t = t !== null ? t.lastEffect : null), t !== null)) {
    var n = (t = t.next);
    do {
      if ((n.tag & e) === e) {
        var i = n.create;
        n.destroy = i();
      }
      n = n.next;
    } while (n !== t);
  }
}
function Bl(e) {
  var t = e.ref;
  if (t !== null) {
    var n = e.stateNode;
    switch (e.tag) {
      case 5:
        e = n;
        break;
      default:
        e = n;
    }
    typeof t == 'function' ? t(e) : (t.current = e);
  }
}
function Tf(e) {
  var t = e.alternate;
  t !== null && ((e.alternate = null), Tf(t)),
    (e.child = null),
    (e.deletions = null),
    (e.sibling = null),
    e.tag === 5 &&
      ((t = e.stateNode), t !== null && (delete t[$t], delete t[qr], delete t[Pl], delete t[Bv], delete t[Uv])),
    (e.stateNode = null),
    (e.return = null),
    (e.dependencies = null),
    (e.memoizedProps = null),
    (e.memoizedState = null),
    (e.pendingProps = null),
    (e.stateNode = null),
    (e.updateQueue = null);
}
function Cf(e) {
  return e.tag === 5 || e.tag === 3 || e.tag === 4;
}
function Fd(e) {
  e: for (;;) {
    for (; e.sibling === null; ) {
      if (e.return === null || Cf(e.return)) return null;
      e = e.return;
    }
    for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
      if (e.flags & 2 || e.child === null || e.tag === 4) continue e;
      (e.child.return = e), (e = e.child);
    }
    if (!(e.flags & 2)) return e.stateNode;
  }
}
function Ul(e, t, n) {
  var i = e.tag;
  if (i === 5 || i === 6)
    (e = e.stateNode),
      t
        ? n.nodeType === 8
          ? n.parentNode.insertBefore(e, t)
          : n.insertBefore(e, t)
        : (n.nodeType === 8 ? ((t = n.parentNode), t.insertBefore(e, n)) : ((t = n), t.appendChild(e)),
          (n = n._reactRootContainer),
          n != null || t.onclick !== null || (t.onclick = ta));
  else if (i !== 4 && ((e = e.child), e !== null))
    for (Ul(e, t, n), e = e.sibling; e !== null; ) Ul(e, t, n), (e = e.sibling);
}
function Gl(e, t, n) {
  var i = e.tag;
  if (i === 5 || i === 6) (e = e.stateNode), t ? n.insertBefore(e, t) : n.appendChild(e);
  else if (i !== 4 && ((e = e.child), e !== null))
    for (Gl(e, t, n), e = e.sibling; e !== null; ) Gl(e, t, n), (e = e.sibling);
}
var Oe = null,
  It = !1;
function gn(e, t, n) {
  for (n = n.child; n !== null; ) bf(e, t, n), (n = n.sibling);
}
function bf(e, t, n) {
  if (qt && typeof qt.onCommitFiberUnmount == 'function')
    try {
      qt.onCommitFiberUnmount(xa, n);
    } catch {}
  switch (n.tag) {
    case 5:
      We || Li(n, t);
    case 6:
      var i = Oe,
        r = It;
      (Oe = null),
        gn(e, t, n),
        (Oe = i),
        (It = r),
        Oe !== null &&
          (It
            ? ((e = Oe), (n = n.stateNode), e.nodeType === 8 ? e.parentNode.removeChild(n) : e.removeChild(n))
            : Oe.removeChild(n.stateNode));
      break;
    case 18:
      Oe !== null &&
        (It
          ? ((e = Oe), (n = n.stateNode), e.nodeType === 8 ? Rs(e.parentNode, n) : e.nodeType === 1 && Rs(e, n), zr(e))
          : Rs(Oe, n.stateNode));
      break;
    case 4:
      (i = Oe), (r = It), (Oe = n.stateNode.containerInfo), (It = !0), gn(e, t, n), (Oe = i), (It = r);
      break;
    case 0:
    case 11:
    case 14:
    case 15:
      if (!We && ((i = n.updateQueue), i !== null && ((i = i.lastEffect), i !== null))) {
        r = i = i.next;
        do {
          var o = r,
            a = o.destroy;
          (o = o.tag), a !== void 0 && ((o & 2) !== 0 || (o & 4) !== 0) && zl(n, t, a), (r = r.next);
        } while (r !== i);
      }
      gn(e, t, n);
      break;
    case 1:
      if (!We && (Li(n, t), (i = n.stateNode), typeof i.componentWillUnmount == 'function'))
        try {
          (i.props = n.memoizedProps), (i.state = n.memoizedState), i.componentWillUnmount();
        } catch (s) {
          ve(n, t, s);
        }
      gn(e, t, n);
      break;
    case 21:
      gn(e, t, n);
      break;
    case 22:
      n.mode & 1 ? ((We = (i = We) || n.memoizedState !== null), gn(e, t, n), (We = i)) : gn(e, t, n);
      break;
    default:
      gn(e, t, n);
  }
}
function zd(e) {
  var t = e.updateQueue;
  if (t !== null) {
    e.updateQueue = null;
    var n = e.stateNode;
    n === null && (n = e.stateNode = new r_()),
      t.forEach(function (i) {
        var r = f_.bind(null, e, i);
        n.has(i) || (n.add(i), i.then(r, r));
      });
  }
}
function Ct(e, t) {
  var n = t.deletions;
  if (n !== null)
    for (var i = 0; i < n.length; i++) {
      var r = n[i];
      try {
        var o = e,
          a = t,
          s = a;
        e: for (; s !== null; ) {
          switch (s.tag) {
            case 5:
              (Oe = s.stateNode), (It = !1);
              break e;
            case 3:
              (Oe = s.stateNode.containerInfo), (It = !0);
              break e;
            case 4:
              (Oe = s.stateNode.containerInfo), (It = !0);
              break e;
          }
          s = s.return;
        }
        if (Oe === null) throw Error(w(160));
        bf(o, a, r), (Oe = null), (It = !1);
        var l = r.alternate;
        l !== null && (l.return = null), (r.return = null);
      } catch (c) {
        ve(r, t, c);
      }
    }
  if (t.subtreeFlags & 12854) for (t = t.child; t !== null; ) If(t, e), (t = t.sibling);
}
function If(e, t) {
  var n = e.alternate,
    i = e.flags;
  switch (e.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      if ((Ct(t, e), Ft(e), i & 4)) {
        try {
          Ir(3, e, e.return), Pa(3, e);
        } catch (m) {
          ve(e, e.return, m);
        }
        try {
          Ir(5, e, e.return);
        } catch (m) {
          ve(e, e.return, m);
        }
      }
      break;
    case 1:
      Ct(t, e), Ft(e), i & 512 && n !== null && Li(n, n.return);
      break;
    case 5:
      if ((Ct(t, e), Ft(e), i & 512 && n !== null && Li(n, n.return), e.flags & 32)) {
        var r = e.stateNode;
        try {
          Hr(r, '');
        } catch (m) {
          ve(e, e.return, m);
        }
      }
      if (i & 4 && ((r = e.stateNode), r != null)) {
        var o = e.memoizedProps,
          a = n !== null ? n.memoizedProps : o,
          s = e.type,
          l = e.updateQueue;
        if (((e.updateQueue = null), l !== null))
          try {
            s === 'input' && o.type === 'radio' && o.name != null && Xp(r, o), hl(s, a);
            var c = hl(s, o);
            for (a = 0; a < l.length; a += 2) {
              var u = l[a],
                f = l[a + 1];
              u === 'style'
                ? nh(r, f)
                : u === 'dangerouslySetInnerHTML'
                  ? eh(r, f)
                  : u === 'children'
                    ? Hr(r, f)
                    : mc(r, u, f, c);
            }
            switch (s) {
              case 'input':
                ll(r, o);
                break;
              case 'textarea':
                Zp(r, o);
                break;
              case 'select':
                var h = r._wrapperState.wasMultiple;
                r._wrapperState.wasMultiple = !!o.multiple;
                var x = o.value;
                x != null
                  ? Di(r, !!o.multiple, x, !1)
                  : h !== !!o.multiple &&
                    (o.defaultValue != null
                      ? Di(r, !!o.multiple, o.defaultValue, !0)
                      : Di(r, !!o.multiple, o.multiple ? [] : '', !1));
            }
            r[qr] = o;
          } catch (m) {
            ve(e, e.return, m);
          }
      }
      break;
    case 6:
      if ((Ct(t, e), Ft(e), i & 4)) {
        if (e.stateNode === null) throw Error(w(162));
        (r = e.stateNode), (o = e.memoizedProps);
        try {
          r.nodeValue = o;
        } catch (m) {
          ve(e, e.return, m);
        }
      }
      break;
    case 3:
      if ((Ct(t, e), Ft(e), i & 4 && n !== null && n.memoizedState.isDehydrated))
        try {
          zr(t.containerInfo);
        } catch (m) {
          ve(e, e.return, m);
        }
      break;
    case 4:
      Ct(t, e), Ft(e);
      break;
    case 13:
      Ct(t, e),
        Ft(e),
        (r = e.child),
        r.flags & 8192 &&
          ((o = r.memoizedState !== null),
          (r.stateNode.isHidden = o),
          !o || (r.alternate !== null && r.alternate.memoizedState !== null) || (Wc = ye())),
        i & 4 && zd(e);
      break;
    case 22:
      if (
        ((u = n !== null && n.memoizedState !== null),
        e.mode & 1 ? ((We = (c = We) || u), Ct(t, e), (We = c)) : Ct(t, e),
        Ft(e),
        i & 8192)
      ) {
        if (((c = e.memoizedState !== null), (e.stateNode.isHidden = c) && !u && (e.mode & 1) !== 0))
          for (O = e, u = e.child; u !== null; ) {
            for (f = O = u; O !== null; ) {
              switch (((h = O), (x = h.child), h.tag)) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Ir(4, h, h.return);
                  break;
                case 1:
                  Li(h, h.return);
                  var y = h.stateNode;
                  if (typeof y.componentWillUnmount == 'function') {
                    (i = h), (n = h.return);
                    try {
                      (t = i), (y.props = t.memoizedProps), (y.state = t.memoizedState), y.componentWillUnmount();
                    } catch (m) {
                      ve(i, n, m);
                    }
                  }
                  break;
                case 5:
                  Li(h, h.return);
                  break;
                case 22:
                  if (h.memoizedState !== null) {
                    Ud(f);
                    continue;
                  }
              }
              x !== null ? ((x.return = h), (O = x)) : Ud(f);
            }
            u = u.sibling;
          }
        e: for (u = null, f = e; ; ) {
          if (f.tag === 5) {
            if (u === null) {
              u = f;
              try {
                (r = f.stateNode),
                  c
                    ? ((o = r.style),
                      typeof o.setProperty == 'function'
                        ? o.setProperty('display', 'none', 'important')
                        : (o.display = 'none'))
                    : ((s = f.stateNode),
                      (l = f.memoizedProps.style),
                      (a = l != null && l.hasOwnProperty('display') ? l.display : null),
                      (s.style.display = th('display', a)));
              } catch (m) {
                ve(e, e.return, m);
              }
            }
          } else if (f.tag === 6) {
            if (u === null)
              try {
                f.stateNode.nodeValue = c ? '' : f.memoizedProps;
              } catch (m) {
                ve(e, e.return, m);
              }
          } else if (((f.tag !== 22 && f.tag !== 23) || f.memoizedState === null || f === e) && f.child !== null) {
            (f.child.return = f), (f = f.child);
            continue;
          }
          if (f === e) break e;
          for (; f.sibling === null; ) {
            if (f.return === null || f.return === e) break e;
            u === f && (u = null), (f = f.return);
          }
          u === f && (u = null), (f.sibling.return = f.return), (f = f.sibling);
        }
      }
      break;
    case 19:
      Ct(t, e), Ft(e), i & 4 && zd(e);
      break;
    case 21:
      break;
    default:
      Ct(t, e), Ft(e);
  }
}
function Ft(e) {
  var t = e.flags;
  if (t & 2) {
    try {
      e: {
        for (var n = e.return; n !== null; ) {
          if (Cf(n)) {
            var i = n;
            break e;
          }
          n = n.return;
        }
        throw Error(w(160));
      }
      switch (i.tag) {
        case 5:
          var r = i.stateNode;
          i.flags & 32 && (Hr(r, ''), (i.flags &= -33));
          var o = Fd(e);
          Gl(e, o, r);
          break;
        case 3:
        case 4:
          var a = i.stateNode.containerInfo,
            s = Fd(e);
          Ul(e, s, a);
          break;
        default:
          throw Error(w(161));
      }
    } catch (l) {
      ve(e, e.return, l);
    }
    e.flags &= -3;
  }
  t & 4096 && (e.flags &= -4097);
}
function a_(e, t, n) {
  (O = e), Lf(e);
}
function Lf(e, t, n) {
  for (var i = (e.mode & 1) !== 0; O !== null; ) {
    var r = O,
      o = r.child;
    if (r.tag === 22 && i) {
      var a = r.memoizedState !== null || Co;
      if (!a) {
        var s = r.alternate,
          l = (s !== null && s.memoizedState !== null) || We;
        s = Co;
        var c = We;
        if (((Co = a), (We = l) && !c))
          for (O = r; O !== null; )
            (a = O),
              (l = a.child),
              a.tag === 22 && a.memoizedState !== null ? Gd(r) : l !== null ? ((l.return = a), (O = l)) : Gd(r);
        for (; o !== null; ) (O = o), Lf(o), (o = o.sibling);
        (O = r), (Co = s), (We = c);
      }
      Bd(e);
    } else (r.subtreeFlags & 8772) !== 0 && o !== null ? ((o.return = r), (O = o)) : Bd(e);
  }
}
function Bd(e) {
  for (; O !== null; ) {
    var t = O;
    if ((t.flags & 8772) !== 0) {
      var n = t.alternate;
      try {
        if ((t.flags & 8772) !== 0)
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              We || Pa(5, t);
              break;
            case 1:
              var i = t.stateNode;
              if (t.flags & 4 && !We)
                if (n === null) i.componentDidMount();
                else {
                  var r = t.elementType === t.type ? n.memoizedProps : bt(t.type, n.memoizedProps);
                  i.componentDidUpdate(r, n.memoizedState, i.__reactInternalSnapshotBeforeUpdate);
                }
              var o = t.updateQueue;
              o !== null && Ad(t, o, i);
              break;
            case 3:
              var a = t.updateQueue;
              if (a !== null) {
                if (((n = null), t.child !== null))
                  switch (t.child.tag) {
                    case 5:
                      n = t.child.stateNode;
                      break;
                    case 1:
                      n = t.child.stateNode;
                  }
                Ad(t, a, n);
              }
              break;
            case 5:
              var s = t.stateNode;
              if (n === null && t.flags & 4) {
                n = s;
                var l = t.memoizedProps;
                switch (t.type) {
                  case 'button':
                  case 'input':
                  case 'select':
                  case 'textarea':
                    l.autoFocus && n.focus();
                    break;
                  case 'img':
                    l.src && (n.src = l.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (t.memoizedState === null) {
                var c = t.alternate;
                if (c !== null) {
                  var u = c.memoizedState;
                  if (u !== null) {
                    var f = u.dehydrated;
                    f !== null && zr(f);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(w(163));
          }
        We || (t.flags & 512 && Bl(t));
      } catch (h) {
        ve(t, t.return, h);
      }
    }
    if (t === e) {
      O = null;
      break;
    }
    if (((n = t.sibling), n !== null)) {
      (n.return = t.return), (O = n);
      break;
    }
    O = t.return;
  }
}
function Ud(e) {
  for (; O !== null; ) {
    var t = O;
    if (t === e) {
      O = null;
      break;
    }
    var n = t.sibling;
    if (n !== null) {
      (n.return = t.return), (O = n);
      break;
    }
    O = t.return;
  }
}
function Gd(e) {
  for (; O !== null; ) {
    var t = O;
    try {
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          var n = t.return;
          try {
            Pa(4, t);
          } catch (l) {
            ve(t, n, l);
          }
          break;
        case 1:
          var i = t.stateNode;
          if (typeof i.componentDidMount == 'function') {
            var r = t.return;
            try {
              i.componentDidMount();
            } catch (l) {
              ve(t, r, l);
            }
          }
          var o = t.return;
          try {
            Bl(t);
          } catch (l) {
            ve(t, o, l);
          }
          break;
        case 5:
          var a = t.return;
          try {
            Bl(t);
          } catch (l) {
            ve(t, a, l);
          }
      }
    } catch (l) {
      ve(t, t.return, l);
    }
    if (t === e) {
      O = null;
      break;
    }
    var s = t.sibling;
    if (s !== null) {
      (s.return = t.return), (O = s);
      break;
    }
    O = t.return;
  }
}
var s_ = Math.ceil,
  pa = cn.ReactCurrentDispatcher,
  Vc = cn.ReactCurrentOwner,
  wt = cn.ReactCurrentBatchConfig,
  Y = 0,
  Ne = null,
  Se = null,
  je = 0,
  ft = 0,
  Ni = Rn(0),
  Pe = 0,
  Xr = null,
  ni = 0,
  Ta = 0,
  Qc = 0,
  Lr = null,
  at = null,
  Wc = 0,
  Wi = 1 / 0,
  Zt = null,
  ha = !1,
  $l = null,
  Tn = null,
  bo = !1,
  kn = null,
  fa = 0,
  Nr = 0,
  ql = null,
  Go = -1,
  $o = 0;
function et() {
  return (Y & 6) !== 0 ? ye() : Go !== -1 ? Go : (Go = ye());
}
function Cn(e) {
  return (e.mode & 1) === 0
    ? 1
    : (Y & 2) !== 0 && je !== 0
      ? je & -je
      : $v.transition !== null
        ? ($o === 0 && ($o = fh()), $o)
        : ((e = oe), e !== 0 || ((e = window.event), (e = e === void 0 ? 16 : Eh(e.type))), e);
}
function Rt(e, t, n, i) {
  if (50 < Nr) throw ((Nr = 0), (ql = null), Error(w(185)));
  Yr(e, n, i),
    ((Y & 2) === 0 || e !== Ne) &&
      (e === Ne && ((Y & 2) === 0 && (Ta |= n), Pe === 4 && yn(e, je)),
      ut(e, i),
      n === 1 && Y === 0 && (t.mode & 1) === 0 && ((Wi = ye() + 500), Aa && Dn()));
}
function ut(e, t) {
  var n = e.callbackNode;
  $g(e, t);
  var i = Xo(e, e === Ne ? je : 0);
  if (i === 0) n !== null && Zu(n), (e.callbackNode = null), (e.callbackPriority = 0);
  else if (((t = i & -i), e.callbackPriority !== t)) {
    if ((n != null && Zu(n), t === 1))
      e.tag === 0 ? Gv($d.bind(null, e)) : zh($d.bind(null, e)),
        Fv(function () {
          (Y & 6) === 0 && Dn();
        }),
        (n = null);
    else {
      switch (mh(i)) {
        case 1:
          n = yc;
          break;
        case 4:
          n = ph;
          break;
        case 16:
          n = Jo;
          break;
        case 536870912:
          n = hh;
          break;
        default:
          n = Jo;
      }
      n = zf(n, Nf.bind(null, e));
    }
    (e.callbackPriority = t), (e.callbackNode = n);
  }
}
function Nf(e, t) {
  if (((Go = -1), ($o = 0), (Y & 6) !== 0)) throw Error(w(327));
  var n = e.callbackNode;
  if (zi() && e.callbackNode !== n) return null;
  var i = Xo(e, e === Ne ? je : 0);
  if (i === 0) return null;
  if ((i & 30) !== 0 || (i & e.expiredLanes) !== 0 || t) t = ma(e, i);
  else {
    t = i;
    var r = Y;
    Y |= 2;
    var o = Df();
    (Ne !== e || je !== t) && ((Zt = null), (Wi = ye() + 500), Kn(e, t));
    do
      try {
        u_();
        break;
      } catch (s) {
        Rf(e, s);
      }
    while (1);
    Nc(), (pa.current = o), (Y = r), Se !== null ? (t = 0) : ((Ne = null), (je = 0), (t = Pe));
  }
  if (t !== 0) {
    if ((t === 2 && ((r = _l(e)), r !== 0 && ((i = r), (t = Vl(e, r)))), t === 1))
      throw ((n = Xr), Kn(e, 0), yn(e, i), ut(e, ye()), n);
    if (t === 6) yn(e, i);
    else {
      if (
        ((r = e.current.alternate),
        (i & 30) === 0 &&
          !l_(r) &&
          ((t = ma(e, i)), t === 2 && ((o = _l(e)), o !== 0 && ((i = o), (t = Vl(e, o)))), t === 1))
      )
        throw ((n = Xr), Kn(e, 0), yn(e, i), ut(e, ye()), n);
      switch (((e.finishedWork = r), (e.finishedLanes = i), t)) {
        case 0:
        case 1:
          throw Error(w(345));
        case 2:
          Gn(e, at, Zt);
          break;
        case 3:
          if ((yn(e, i), (i & 130023424) === i && ((t = Wc + 500 - ye()), 10 < t))) {
            if (Xo(e, 0) !== 0) break;
            if (((r = e.suspendedLanes), (r & i) !== i)) {
              et(), (e.pingedLanes |= e.suspendedLanes & r);
              break;
            }
            e.timeoutHandle = Ml(Gn.bind(null, e, at, Zt), t);
            break;
          }
          Gn(e, at, Zt);
          break;
        case 4:
          if ((yn(e, i), (i & 4194240) === i)) break;
          for (t = e.eventTimes, r = -1; 0 < i; ) {
            var a = 31 - Nt(i);
            (o = 1 << a), (a = t[a]), a > r && (r = a), (i &= ~o);
          }
          if (
            ((i = r),
            (i = ye() - i),
            (i =
              (120 > i
                ? 120
                : 480 > i
                  ? 480
                  : 1080 > i
                    ? 1080
                    : 1920 > i
                      ? 1920
                      : 3e3 > i
                        ? 3e3
                        : 4320 > i
                          ? 4320
                          : 1960 * s_(i / 1960)) - i),
            10 < i)
          ) {
            e.timeoutHandle = Ml(Gn.bind(null, e, at, Zt), i);
            break;
          }
          Gn(e, at, Zt);
          break;
        case 5:
          Gn(e, at, Zt);
          break;
        default:
          throw Error(w(329));
      }
    }
  }
  return ut(e, ye()), e.callbackNode === n ? Nf.bind(null, e) : null;
}
function Vl(e, t) {
  var n = Lr;
  return (
    e.current.memoizedState.isDehydrated && (Kn(e, t).flags |= 256),
    (e = ma(e, t)),
    e !== 2 && ((t = at), (at = n), t !== null && Ql(t)),
    e
  );
}
function Ql(e) {
  at === null ? (at = e) : at.push.apply(at, e);
}
function l_(e) {
  for (var t = e; ; ) {
    if (t.flags & 16384) {
      var n = t.updateQueue;
      if (n !== null && ((n = n.stores), n !== null))
        for (var i = 0; i < n.length; i++) {
          var r = n[i],
            o = r.getSnapshot;
          r = r.value;
          try {
            if (!Dt(o(), r)) return !1;
          } catch {
            return !1;
          }
        }
    }
    if (((n = t.child), t.subtreeFlags & 16384 && n !== null)) (n.return = t), (t = n);
    else {
      if (t === e) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === e) return !0;
        t = t.return;
      }
      (t.sibling.return = t.return), (t = t.sibling);
    }
  }
  return !0;
}
function yn(e, t) {
  for (t &= ~Qc, t &= ~Ta, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t; ) {
    var n = 31 - Nt(t),
      i = 1 << n;
    (e[n] = -1), (t &= ~i);
  }
}
function $d(e) {
  if ((Y & 6) !== 0) throw Error(w(327));
  zi();
  var t = Xo(e, 0);
  if ((t & 1) === 0) return ut(e, ye()), null;
  var n = ma(e, t);
  if (e.tag !== 0 && n === 2) {
    var i = _l(e);
    i !== 0 && ((t = i), (n = Vl(e, i)));
  }
  if (n === 1) throw ((n = Xr), Kn(e, 0), yn(e, t), ut(e, ye()), n);
  if (n === 6) throw Error(w(345));
  return (e.finishedWork = e.current.alternate), (e.finishedLanes = t), Gn(e, at, Zt), ut(e, ye()), null;
}
function Kc(e, t) {
  var n = Y;
  Y |= 1;
  try {
    return e(t);
  } finally {
    (Y = n), Y === 0 && ((Wi = ye() + 500), Aa && Dn());
  }
}
function ii(e) {
  kn !== null && kn.tag === 0 && (Y & 6) === 0 && zi();
  var t = Y;
  Y |= 1;
  var n = wt.transition,
    i = oe;
  try {
    if (((wt.transition = null), (oe = 1), e)) return e();
  } finally {
    (oe = i), (wt.transition = n), (Y = t), (Y & 6) === 0 && Dn();
  }
}
function Jc() {
  (ft = Ni.current), de(Ni);
}
function Kn(e, t) {
  (e.finishedWork = null), (e.finishedLanes = 0);
  var n = e.timeoutHandle;
  if ((n !== -1 && ((e.timeoutHandle = -1), jv(n)), Se !== null))
    for (n = Se.return; n !== null; ) {
      var i = n;
      switch ((bc(i), i.tag)) {
        case 1:
          (i = i.type.childContextTypes), i != null && na();
          break;
        case 3:
          Vi(), de(lt), de(Ke), Fc();
          break;
        case 5:
          jc(i);
          break;
        case 4:
          Vi();
          break;
        case 13:
          de(fe);
          break;
        case 19:
          de(fe);
          break;
        case 10:
          Rc(i.type._context);
          break;
        case 22:
        case 23:
          Jc();
      }
      n = n.return;
    }
  if (
    ((Ne = e),
    (Se = e = bn(e.current, null)),
    (je = ft = t),
    (Pe = 0),
    (Xr = null),
    (Qc = Ta = ni = 0),
    (at = Lr = null),
    Vn !== null)
  ) {
    for (t = 0; t < Vn.length; t++)
      if (((n = Vn[t]), (i = n.interleaved), i !== null)) {
        n.interleaved = null;
        var r = i.next,
          o = n.pending;
        if (o !== null) {
          var a = o.next;
          (o.next = r), (i.next = a);
        }
        n.pending = i;
      }
    Vn = null;
  }
  return e;
}
function Rf(e, t) {
  do {
    var n = Se;
    try {
      if ((Nc(), (zo.current = da), ua)) {
        for (var i = me.memoizedState; i !== null; ) {
          var r = i.queue;
          r !== null && (r.pending = null), (i = i.next);
        }
        ua = !1;
      }
      if (
        ((ti = 0), (Le = Me = me = null), (br = !1), (Wr = 0), (Vc.current = null), n === null || n.return === null)
      ) {
        (Pe = 1), (Xr = t), (Se = null);
        break;
      }
      e: {
        var o = e,
          a = n.return,
          s = n,
          l = t;
        if (((t = je), (s.flags |= 32768), l !== null && typeof l == 'object' && typeof l.then == 'function')) {
          var c = l,
            u = s,
            f = u.tag;
          if ((u.mode & 1) === 0 && (f === 0 || f === 11 || f === 15)) {
            var h = u.alternate;
            h
              ? ((u.updateQueue = h.updateQueue), (u.memoizedState = h.memoizedState), (u.lanes = h.lanes))
              : ((u.updateQueue = null), (u.memoizedState = null));
          }
          var x = Id(a);
          if (x !== null) {
            (x.flags &= -257), Ld(x, a, s, o, t), x.mode & 1 && bd(o, c, t), (t = x), (l = c);
            var y = t.updateQueue;
            if (y === null) {
              var m = new Set();
              m.add(l), (t.updateQueue = m);
            } else y.add(l);
            break e;
          } else {
            if ((t & 1) === 0) {
              bd(o, c, t), Xc();
              break e;
            }
            l = Error(w(426));
          }
        } else if (pe && s.mode & 1) {
          var j = Id(a);
          if (j !== null) {
            (j.flags & 65536) === 0 && (j.flags |= 256), Ld(j, a, s, o, t), Ic(Qi(l, s));
            break e;
          }
        }
        (o = l = Qi(l, s)), Pe !== 4 && (Pe = 2), Lr === null ? (Lr = [o]) : Lr.push(o), (o = a);
        do {
          switch (o.tag) {
            case 3:
              (o.flags |= 65536), (t &= -t), (o.lanes |= t);
              var p = vf(o, l, t);
              Sd(o, p);
              break e;
            case 1:
              s = l;
              var d = o.type,
                g = o.stateNode;
              if (
                (o.flags & 128) === 0 &&
                (typeof d.getDerivedStateFromError == 'function' ||
                  (g !== null && typeof g.componentDidCatch == 'function' && (Tn === null || !Tn.has(g))))
              ) {
                (o.flags |= 65536), (t &= -t), (o.lanes |= t);
                var k = _f(o, s, t);
                Sd(o, k);
                break e;
              }
          }
          o = o.return;
        } while (o !== null);
      }
      Of(n);
    } catch (T) {
      (t = T), Se === n && n !== null && (Se = n = n.return);
      continue;
    }
    break;
  } while (1);
}
function Df() {
  var e = pa.current;
  return (pa.current = da), e === null ? da : e;
}
function Xc() {
  (Pe === 0 || Pe === 3 || Pe === 2) && (Pe = 4),
    Ne === null || ((ni & 268435455) === 0 && (Ta & 268435455) === 0) || yn(Ne, je);
}
function ma(e, t) {
  var n = Y;
  Y |= 2;
  var i = Df();
  (Ne !== e || je !== t) && ((Zt = null), Kn(e, t));
  do
    try {
      c_();
      break;
    } catch (r) {
      Rf(e, r);
    }
  while (1);
  if ((Nc(), (Y = n), (pa.current = i), Se !== null)) throw Error(w(261));
  return (Ne = null), (je = 0), Pe;
}
function c_() {
  for (; Se !== null; ) Hf(Se);
}
function u_() {
  for (; Se !== null && !Dg(); ) Hf(Se);
}
function Hf(e) {
  var t = Ff(e.alternate, e, ft);
  (e.memoizedProps = e.pendingProps), t === null ? Of(e) : (Se = t), (Vc.current = null);
}
function Of(e) {
  var t = e;
  do {
    var n = t.alternate;
    if (((e = t.return), (t.flags & 32768) === 0)) {
      if (((n = n_(n, t, ft)), n !== null)) {
        Se = n;
        return;
      }
    } else {
      if (((n = i_(n, t)), n !== null)) {
        (n.flags &= 32767), (Se = n);
        return;
      }
      if (e !== null) (e.flags |= 32768), (e.subtreeFlags = 0), (e.deletions = null);
      else {
        (Pe = 6), (Se = null);
        return;
      }
    }
    if (((t = t.sibling), t !== null)) {
      Se = t;
      return;
    }
    Se = t = e;
  } while (t !== null);
  Pe === 0 && (Pe = 5);
}
function Gn(e, t, n) {
  var i = oe,
    r = wt.transition;
  try {
    (wt.transition = null), (oe = 1), d_(e, t, n, i);
  } finally {
    (wt.transition = r), (oe = i);
  }
  return null;
}
function d_(e, t, n, i) {
  do zi();
  while (kn !== null);
  if ((Y & 6) !== 0) throw Error(w(327));
  n = e.finishedWork;
  var r = e.finishedLanes;
  if (n === null) return null;
  if (((e.finishedWork = null), (e.finishedLanes = 0), n === e.current)) throw Error(w(177));
  (e.callbackNode = null), (e.callbackPriority = 0);
  var o = n.lanes | n.childLanes;
  if (
    (qg(e, o),
    e === Ne && ((Se = Ne = null), (je = 0)),
    ((n.subtreeFlags & 2064) === 0 && (n.flags & 2064) === 0) ||
      bo ||
      ((bo = !0),
      zf(Jo, function () {
        return zi(), null;
      })),
    (o = (n.flags & 15990) !== 0),
    (n.subtreeFlags & 15990) !== 0 || o)
  ) {
    (o = wt.transition), (wt.transition = null);
    var a = oe;
    oe = 1;
    var s = Y;
    (Y |= 4),
      (Vc.current = null),
      o_(e, n),
      If(n, e),
      Iv(Al),
      (Zo = !!Sl),
      (Al = Sl = null),
      (e.current = n),
      a_(n),
      Hg(),
      (Y = s),
      (oe = a),
      (wt.transition = o);
  } else e.current = n;
  if (
    (bo && ((bo = !1), (kn = e), (fa = r)),
    (o = e.pendingLanes),
    o === 0 && (Tn = null),
    Fg(n.stateNode),
    ut(e, ye()),
    t !== null)
  )
    for (i = e.onRecoverableError, n = 0; n < t.length; n++)
      (r = t[n]), i(r.value, { componentStack: r.stack, digest: r.digest });
  if (ha) throw ((ha = !1), (e = $l), ($l = null), e);
  return (
    (fa & 1) !== 0 && e.tag !== 0 && zi(),
    (o = e.pendingLanes),
    (o & 1) !== 0 ? (e === ql ? Nr++ : ((Nr = 0), (ql = e))) : (Nr = 0),
    Dn(),
    null
  );
}
function zi() {
  if (kn !== null) {
    var e = mh(fa),
      t = wt.transition,
      n = oe;
    try {
      if (((wt.transition = null), (oe = 16 > e ? 16 : e), kn === null)) var i = !1;
      else {
        if (((e = kn), (kn = null), (fa = 0), (Y & 6) !== 0)) throw Error(w(331));
        var r = Y;
        for (Y |= 4, O = e.current; O !== null; ) {
          var o = O,
            a = o.child;
          if ((O.flags & 16) !== 0) {
            var s = o.deletions;
            if (s !== null) {
              for (var l = 0; l < s.length; l++) {
                var c = s[l];
                for (O = c; O !== null; ) {
                  var u = O;
                  switch (u.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Ir(8, u, o);
                  }
                  var f = u.child;
                  if (f !== null) (f.return = u), (O = f);
                  else
                    for (; O !== null; ) {
                      u = O;
                      var h = u.sibling,
                        x = u.return;
                      if ((Tf(u), u === c)) {
                        O = null;
                        break;
                      }
                      if (h !== null) {
                        (h.return = x), (O = h);
                        break;
                      }
                      O = x;
                    }
                }
              }
              var y = o.alternate;
              if (y !== null) {
                var m = y.child;
                if (m !== null) {
                  y.child = null;
                  do {
                    var j = m.sibling;
                    (m.sibling = null), (m = j);
                  } while (m !== null);
                }
              }
              O = o;
            }
          }
          if ((o.subtreeFlags & 2064) !== 0 && a !== null) (a.return = o), (O = a);
          else
            e: for (; O !== null; ) {
              if (((o = O), (o.flags & 2048) !== 0))
                switch (o.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Ir(9, o, o.return);
                }
              var p = o.sibling;
              if (p !== null) {
                (p.return = o.return), (O = p);
                break e;
              }
              O = o.return;
            }
        }
        var d = e.current;
        for (O = d; O !== null; ) {
          a = O;
          var g = a.child;
          if ((a.subtreeFlags & 2064) !== 0 && g !== null) (g.return = a), (O = g);
          else
            e: for (a = d; O !== null; ) {
              if (((s = O), (s.flags & 2048) !== 0))
                try {
                  switch (s.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Pa(9, s);
                  }
                } catch (T) {
                  ve(s, s.return, T);
                }
              if (s === a) {
                O = null;
                break e;
              }
              var k = s.sibling;
              if (k !== null) {
                (k.return = s.return), (O = k);
                break e;
              }
              O = s.return;
            }
        }
        if (((Y = r), Dn(), qt && typeof qt.onPostCommitFiberRoot == 'function'))
          try {
            qt.onPostCommitFiberRoot(xa, e);
          } catch {}
        i = !0;
      }
      return i;
    } finally {
      (oe = n), (wt.transition = t);
    }
  }
  return !1;
}
function qd(e, t, n) {
  (t = Qi(n, t)), (t = vf(e, t, 1)), (e = Pn(e, t, 1)), (t = et()), e !== null && (Yr(e, 1, t), ut(e, t));
}
function ve(e, t, n) {
  if (e.tag === 3) qd(e, e, n);
  else
    for (; t !== null; ) {
      if (t.tag === 3) {
        qd(t, e, n);
        break;
      } else if (t.tag === 1) {
        var i = t.stateNode;
        if (
          typeof t.type.getDerivedStateFromError == 'function' ||
          (typeof i.componentDidCatch == 'function' && (Tn === null || !Tn.has(i)))
        ) {
          (e = Qi(n, e)), (e = _f(t, e, 1)), (t = Pn(t, e, 1)), (e = et()), t !== null && (Yr(t, 1, e), ut(t, e));
          break;
        }
      }
      t = t.return;
    }
}
function p_(e, t, n) {
  var i = e.pingCache;
  i !== null && i.delete(t),
    (t = et()),
    (e.pingedLanes |= e.suspendedLanes & n),
    Ne === e &&
      (je & n) === n &&
      (Pe === 4 || (Pe === 3 && (je & 130023424) === je && 500 > ye() - Wc) ? Kn(e, 0) : (Qc |= n)),
    ut(e, t);
}
function jf(e, t) {
  t === 0 && ((e.mode & 1) === 0 ? (t = 1) : ((t = yo), (yo <<= 1), (yo & 130023424) === 0 && (yo = 4194304)));
  var n = et();
  (e = an(e, t)), e !== null && (Yr(e, t, n), ut(e, n));
}
function h_(e) {
  var t = e.memoizedState,
    n = 0;
  t !== null && (n = t.retryLane), jf(e, n);
}
function f_(e, t) {
  var n = 0;
  switch (e.tag) {
    case 13:
      var i = e.stateNode,
        r = e.memoizedState;
      r !== null && (n = r.retryLane);
      break;
    case 19:
      i = e.stateNode;
      break;
    default:
      throw Error(w(314));
  }
  i !== null && i.delete(t), jf(e, n);
}
var Ff;
Ff = function (e, t, n) {
  if (e !== null)
    if (e.memoizedProps !== t.pendingProps || lt.current) st = !0;
    else {
      if ((e.lanes & n) === 0 && (t.flags & 128) === 0) return (st = !1), t_(e, t, n);
      st = (e.flags & 131072) !== 0;
    }
  else (st = !1), pe && (t.flags & 1048576) !== 0 && Bh(t, oa, t.index);
  switch (((t.lanes = 0), t.tag)) {
    case 2:
      var i = t.type;
      Uo(e, t), (e = t.pendingProps);
      var r = Gi(t, Ke.current);
      Fi(t, n), (r = Bc(null, t, i, e, r, n));
      var o = Uc();
      return (
        (t.flags |= 1),
        typeof r == 'object' && r !== null && typeof r.render == 'function' && r.$$typeof === void 0
          ? ((t.tag = 1),
            (t.memoizedState = null),
            (t.updateQueue = null),
            ct(i) ? ((o = !0), ia(t)) : (o = !1),
            (t.memoizedState = r.state !== null && r.state !== void 0 ? r.state : null),
            Hc(t),
            (r.updater = wa),
            (t.stateNode = r),
            (r._reactInternals = t),
            Nl(t, i, e, n),
            (t = Hl(null, t, i, !0, o, n)))
          : ((t.tag = 0), pe && o && Cc(t), Ye(null, t, r, n), (t = t.child)),
        t
      );
    case 16:
      i = t.elementType;
      e: {
        switch (
          (Uo(e, t),
          (e = t.pendingProps),
          (r = i._init),
          (i = r(i._payload)),
          (t.type = i),
          (r = t.tag = g_(i)),
          (e = bt(i, e)),
          r)
        ) {
          case 0:
            t = Dl(null, t, i, e, n);
            break e;
          case 1:
            t = Dd(null, t, i, e, n);
            break e;
          case 11:
            t = Nd(null, t, i, e, n);
            break e;
          case 14:
            t = Rd(null, t, i, bt(i.type, e), n);
            break e;
        }
        throw Error(w(306, i, ''));
      }
      return t;
    case 0:
      return (i = t.type), (r = t.pendingProps), (r = t.elementType === i ? r : bt(i, r)), Dl(e, t, i, r, n);
    case 1:
      return (i = t.type), (r = t.pendingProps), (r = t.elementType === i ? r : bt(i, r)), Dd(e, t, i, r, n);
    case 3:
      e: {
        if ((kf(t), e === null)) throw Error(w(387));
        (i = t.pendingProps), (o = t.memoizedState), (r = o.element), qh(e, t), la(t, i, null, n);
        var a = t.memoizedState;
        if (((i = a.element), o.isDehydrated))
          if (
            ((o = {
              element: i,
              isDehydrated: !1,
              cache: a.cache,
              pendingSuspenseBoundaries: a.pendingSuspenseBoundaries,
              transitions: a.transitions,
            }),
            (t.updateQueue.baseState = o),
            (t.memoizedState = o),
            t.flags & 256)
          ) {
            (r = Qi(Error(w(423)), t)), (t = Hd(e, t, i, n, r));
            break e;
          } else if (i !== r) {
            (r = Qi(Error(w(424)), t)), (t = Hd(e, t, i, n, r));
            break e;
          } else
            for (
              mt = Mn(t.stateNode.containerInfo.firstChild),
                gt = t,
                pe = !0,
                Lt = null,
                n = Kh(t, null, i, n),
                t.child = n;
              n;

            )
              (n.flags = (n.flags & -3) | 4096), (n = n.sibling);
        else {
          if (($i(), i === r)) {
            t = sn(e, t, n);
            break e;
          }
          Ye(e, t, i, n);
        }
        t = t.child;
      }
      return t;
    case 5:
      return (
        Jh(t),
        e === null && bl(t),
        (i = t.type),
        (r = t.pendingProps),
        (o = e !== null ? e.memoizedProps : null),
        (a = r.children),
        wl(i, r) ? (a = null) : o !== null && wl(i, o) && (t.flags |= 32),
        Ef(e, t),
        Ye(e, t, a, n),
        t.child
      );
    case 6:
      return e === null && bl(t), null;
    case 13:
      return Sf(e, t, n);
    case 4:
      return (
        Oc(t, t.stateNode.containerInfo),
        (i = t.pendingProps),
        e === null ? (t.child = qi(t, null, i, n)) : Ye(e, t, i, n),
        t.child
      );
    case 11:
      return (i = t.type), (r = t.pendingProps), (r = t.elementType === i ? r : bt(i, r)), Nd(e, t, i, r, n);
    case 7:
      return Ye(e, t, t.pendingProps, n), t.child;
    case 8:
      return Ye(e, t, t.pendingProps.children, n), t.child;
    case 12:
      return Ye(e, t, t.pendingProps.children, n), t.child;
    case 10:
      e: {
        if (
          ((i = t.type._context),
          (r = t.pendingProps),
          (o = t.memoizedProps),
          (a = r.value),
          le(aa, i._currentValue),
          (i._currentValue = a),
          o !== null)
        )
          if (Dt(o.value, a)) {
            if (o.children === r.children && !lt.current) {
              t = sn(e, t, n);
              break e;
            }
          } else
            for (o = t.child, o !== null && (o.return = t); o !== null; ) {
              var s = o.dependencies;
              if (s !== null) {
                a = o.child;
                for (var l = s.firstContext; l !== null; ) {
                  if (l.context === i) {
                    if (o.tag === 1) {
                      (l = nn(-1, n & -n)), (l.tag = 2);
                      var c = o.updateQueue;
                      if (c !== null) {
                        c = c.shared;
                        var u = c.pending;
                        u === null ? (l.next = l) : ((l.next = u.next), (u.next = l)), (c.pending = l);
                      }
                    }
                    (o.lanes |= n), (l = o.alternate), l !== null && (l.lanes |= n), Il(o.return, n, t), (s.lanes |= n);
                    break;
                  }
                  l = l.next;
                }
              } else if (o.tag === 10) a = o.type === t.type ? null : o.child;
              else if (o.tag === 18) {
                if (((a = o.return), a === null)) throw Error(w(341));
                (a.lanes |= n), (s = a.alternate), s !== null && (s.lanes |= n), Il(a, n, t), (a = o.sibling);
              } else a = o.child;
              if (a !== null) a.return = o;
              else
                for (a = o; a !== null; ) {
                  if (a === t) {
                    a = null;
                    break;
                  }
                  if (((o = a.sibling), o !== null)) {
                    (o.return = a.return), (a = o);
                    break;
                  }
                  a = a.return;
                }
              o = a;
            }
        Ye(e, t, r.children, n), (t = t.child);
      }
      return t;
    case 9:
      return (
        (r = t.type),
        (i = t.pendingProps.children),
        Fi(t, n),
        (r = Mt(r)),
        (i = i(r)),
        (t.flags |= 1),
        Ye(e, t, i, n),
        t.child
      );
    case 14:
      return (i = t.type), (r = bt(i, t.pendingProps)), (r = bt(i.type, r)), Rd(e, t, i, r, n);
    case 15:
      return xf(e, t, t.type, t.pendingProps, n);
    case 17:
      return (
        (i = t.type),
        (r = t.pendingProps),
        (r = t.elementType === i ? r : bt(i, r)),
        Uo(e, t),
        (t.tag = 1),
        ct(i) ? ((e = !0), ia(t)) : (e = !1),
        Fi(t, n),
        Qh(t, i, r),
        Nl(t, i, r, n),
        Hl(null, t, i, !0, e, n)
      );
    case 19:
      return Af(e, t, n);
    case 22:
      return yf(e, t, n);
  }
  throw Error(w(156, t.tag));
};
function zf(e, t) {
  return dh(e, t);
}
function m_(e, t, n, i) {
  (this.tag = e),
    (this.key = n),
    (this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null),
    (this.index = 0),
    (this.ref = null),
    (this.pendingProps = t),
    (this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null),
    (this.mode = i),
    (this.subtreeFlags = this.flags = 0),
    (this.deletions = null),
    (this.childLanes = this.lanes = 0),
    (this.alternate = null);
}
function At(e, t, n, i) {
  return new m_(e, t, n, i);
}
function Zc(e) {
  return (e = e.prototype), !(!e || !e.isReactComponent);
}
function g_(e) {
  if (typeof e == 'function') return Zc(e) ? 1 : 0;
  if (e != null) {
    if (((e = e.$$typeof), e === vc)) return 11;
    if (e === _c) return 14;
  }
  return 2;
}
function bn(e, t) {
  var n = e.alternate;
  return (
    n === null
      ? ((n = At(e.tag, t, e.key, e.mode)),
        (n.elementType = e.elementType),
        (n.type = e.type),
        (n.stateNode = e.stateNode),
        (n.alternate = e),
        (e.alternate = n))
      : ((n.pendingProps = t), (n.type = e.type), (n.flags = 0), (n.subtreeFlags = 0), (n.deletions = null)),
    (n.flags = e.flags & 14680064),
    (n.childLanes = e.childLanes),
    (n.lanes = e.lanes),
    (n.child = e.child),
    (n.memoizedProps = e.memoizedProps),
    (n.memoizedState = e.memoizedState),
    (n.updateQueue = e.updateQueue),
    (t = e.dependencies),
    (n.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }),
    (n.sibling = e.sibling),
    (n.index = e.index),
    (n.ref = e.ref),
    n
  );
}
function qo(e, t, n, i, r, o) {
  var a = 2;
  if (((i = e), typeof e == 'function')) Zc(e) && (a = 1);
  else if (typeof e == 'string') a = 5;
  else
    e: switch (e) {
      case Si:
        return Jn(n.children, r, o, t);
      case gc:
        (a = 8), (r |= 8);
        break;
      case il:
        return (e = At(12, n, t, r | 2)), (e.elementType = il), (e.lanes = o), e;
      case rl:
        return (e = At(13, n, t, r)), (e.elementType = rl), (e.lanes = o), e;
      case ol:
        return (e = At(19, n, t, r)), (e.elementType = ol), (e.lanes = o), e;
      case Wp:
        return Ca(n, r, o, t);
      default:
        if (typeof e == 'object' && e !== null)
          switch (e.$$typeof) {
            case Vp:
              a = 10;
              break e;
            case Qp:
              a = 9;
              break e;
            case vc:
              a = 11;
              break e;
            case _c:
              a = 14;
              break e;
            case vn:
              (a = 16), (i = null);
              break e;
          }
        throw Error(w(130, e == null ? e : typeof e, ''));
    }
  return (t = At(a, n, t, r)), (t.elementType = e), (t.type = i), (t.lanes = o), t;
}
function Jn(e, t, n, i) {
  return (e = At(7, e, i, t)), (e.lanes = n), e;
}
function Ca(e, t, n, i) {
  return (e = At(22, e, i, t)), (e.elementType = Wp), (e.lanes = n), (e.stateNode = { isHidden: !1 }), e;
}
function Us(e, t, n) {
  return (e = At(6, e, null, t)), (e.lanes = n), e;
}
function Gs(e, t, n) {
  return (
    (t = At(4, e.children !== null ? e.children : [], e.key, t)),
    (t.lanes = n),
    (t.stateNode = { containerInfo: e.containerInfo, pendingChildren: null, implementation: e.implementation }),
    t
  );
}
function v_(e, t, n, i, r) {
  (this.tag = t),
    (this.containerInfo = e),
    (this.finishedWork = this.pingCache = this.current = this.pendingChildren = null),
    (this.timeoutHandle = -1),
    (this.callbackNode = this.pendingContext = this.context = null),
    (this.callbackPriority = 0),
    (this.eventTimes = Ss(0)),
    (this.expirationTimes = Ss(-1)),
    (this.entangledLanes =
      this.finishedLanes =
      this.mutableReadLanes =
      this.expiredLanes =
      this.pingedLanes =
      this.suspendedLanes =
      this.pendingLanes =
        0),
    (this.entanglements = Ss(0)),
    (this.identifierPrefix = i),
    (this.onRecoverableError = r),
    (this.mutableSourceEagerHydrationData = null);
}
function Yc(e, t, n, i, r, o, a, s, l) {
  return (
    (e = new v_(e, t, n, s, l)),
    t === 1 ? ((t = 1), o === !0 && (t |= 8)) : (t = 0),
    (o = At(3, null, null, t)),
    (e.current = o),
    (o.stateNode = e),
    (o.memoizedState = {
      element: i,
      isDehydrated: n,
      cache: null,
      transitions: null,
      pendingSuspenseBoundaries: null,
    }),
    Hc(o),
    e
  );
}
function __(e, t, n) {
  var i = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return { $$typeof: ki, key: i == null ? null : '' + i, children: e, containerInfo: t, implementation: n };
}
function Bf(e) {
  if (!e) return Ln;
  e = e._reactInternals;
  e: {
    if (ai(e) !== e || e.tag !== 1) throw Error(w(170));
    var t = e;
    do {
      switch (t.tag) {
        case 3:
          t = t.stateNode.context;
          break e;
        case 1:
          if (ct(t.type)) {
            t = t.stateNode.__reactInternalMemoizedMergedChildContext;
            break e;
          }
      }
      t = t.return;
    } while (t !== null);
    throw Error(w(171));
  }
  if (e.tag === 1) {
    var n = e.type;
    if (ct(n)) return Fh(e, n, t);
  }
  return t;
}
function Uf(e, t, n, i, r, o, a, s, l) {
  return (
    (e = Yc(n, i, !0, e, r, o, a, s, l)),
    (e.context = Bf(null)),
    (n = e.current),
    (i = et()),
    (r = Cn(n)),
    (o = nn(i, r)),
    (o.callback = t != null ? t : null),
    Pn(n, o, r),
    (e.current.lanes = r),
    Yr(e, r, i),
    ut(e, i),
    e
  );
}
function ba(e, t, n, i) {
  var r = t.current,
    o = et(),
    a = Cn(r);
  return (
    (n = Bf(n)),
    t.context === null ? (t.context = n) : (t.pendingContext = n),
    (t = nn(o, a)),
    (t.payload = { element: e }),
    (i = i === void 0 ? null : i),
    i !== null && (t.callback = i),
    (e = Pn(r, t, a)),
    e !== null && (Rt(e, r, a, o), Fo(e, r, a)),
    a
  );
}
function ga(e) {
  if (((e = e.current), !e.child)) return null;
  switch (e.child.tag) {
    case 5:
      return e.child.stateNode;
    default:
      return e.child.stateNode;
  }
}
function Vd(e, t) {
  if (((e = e.memoizedState), e !== null && e.dehydrated !== null)) {
    var n = e.retryLane;
    e.retryLane = n !== 0 && n < t ? n : t;
  }
}
function eu(e, t) {
  Vd(e, t), (e = e.alternate) && Vd(e, t);
}
function x_() {
  return null;
}
var Gf =
  typeof reportError == 'function'
    ? reportError
    : function (e) {
        console.error(e);
      };
function tu(e) {
  this._internalRoot = e;
}
Ia.prototype.render = tu.prototype.render = function (e) {
  var t = this._internalRoot;
  if (t === null) throw Error(w(409));
  ba(e, t, null, null);
};
Ia.prototype.unmount = tu.prototype.unmount = function () {
  var e = this._internalRoot;
  if (e !== null) {
    this._internalRoot = null;
    var t = e.containerInfo;
    ii(function () {
      ba(null, e, null, null);
    }),
      (t[on] = null);
  }
};
function Ia(e) {
  this._internalRoot = e;
}
Ia.prototype.unstable_scheduleHydration = function (e) {
  if (e) {
    var t = _h();
    e = { blockedOn: null, target: e, priority: t };
    for (var n = 0; n < xn.length && t !== 0 && t < xn[n].priority; n++);
    xn.splice(n, 0, e), n === 0 && yh(e);
  }
};
function nu(e) {
  return !(!e || (e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11));
}
function La(e) {
  return !(
    !e ||
    (e.nodeType !== 1 &&
      e.nodeType !== 9 &&
      e.nodeType !== 11 &&
      (e.nodeType !== 8 || e.nodeValue !== ' react-mount-point-unstable '))
  );
}
function Qd() {}
function y_(e, t, n, i, r) {
  if (r) {
    if (typeof i == 'function') {
      var o = i;
      i = function () {
        var c = ga(a);
        o.call(c);
      };
    }
    var a = Uf(t, i, e, 0, null, !1, !1, '', Qd);
    return (e._reactRootContainer = a), (e[on] = a.current), Gr(e.nodeType === 8 ? e.parentNode : e), ii(), a;
  }
  for (; (r = e.lastChild); ) e.removeChild(r);
  if (typeof i == 'function') {
    var s = i;
    i = function () {
      var c = ga(l);
      s.call(c);
    };
  }
  var l = Yc(e, 0, !1, null, null, !1, !1, '', Qd);
  return (
    (e._reactRootContainer = l),
    (e[on] = l.current),
    Gr(e.nodeType === 8 ? e.parentNode : e),
    ii(function () {
      ba(t, l, n, i);
    }),
    l
  );
}
function Na(e, t, n, i, r) {
  var o = n._reactRootContainer;
  if (o) {
    var a = o;
    if (typeof r == 'function') {
      var s = r;
      r = function () {
        var l = ga(a);
        s.call(l);
      };
    }
    ba(t, a, e, r);
  } else a = y_(n, t, e, r, i);
  return ga(a);
}
gh = function (e) {
  switch (e.tag) {
    case 3:
      var t = e.stateNode;
      if (t.current.memoizedState.isDehydrated) {
        var n = kr(t.pendingLanes);
        n !== 0 && (Ec(t, n | 1), ut(t, ye()), (Y & 6) === 0 && ((Wi = ye() + 500), Dn()));
      }
      break;
    case 13:
      ii(function () {
        var i = an(e, 1);
        if (i !== null) {
          var r = et();
          Rt(i, e, 1, r);
        }
      }),
        eu(e, 1);
  }
};
kc = function (e) {
  if (e.tag === 13) {
    var t = an(e, 134217728);
    if (t !== null) {
      var n = et();
      Rt(t, e, 134217728, n);
    }
    eu(e, 134217728);
  }
};
vh = function (e) {
  if (e.tag === 13) {
    var t = Cn(e),
      n = an(e, t);
    if (n !== null) {
      var i = et();
      Rt(n, e, t, i);
    }
    eu(e, t);
  }
};
_h = function () {
  return oe;
};
xh = function (e, t) {
  var n = oe;
  try {
    return (oe = e), t();
  } finally {
    oe = n;
  }
};
ml = function (e, t, n) {
  switch (t) {
    case 'input':
      if ((ll(e, n), (t = n.name), n.type === 'radio' && t != null)) {
        for (n = e; n.parentNode; ) n = n.parentNode;
        for (
          n = n.querySelectorAll('input[name=' + JSON.stringify('' + t) + '][type="radio"]'), t = 0;
          t < n.length;
          t++
        ) {
          var i = n[t];
          if (i !== e && i.form === e.form) {
            var r = Sa(i);
            if (!r) throw Error(w(90));
            Jp(i), ll(i, r);
          }
        }
      }
      break;
    case 'textarea':
      Zp(e, n);
      break;
    case 'select':
      (t = n.value), t != null && Di(e, !!n.multiple, t, !1);
  }
};
oh = Kc;
ah = ii;
var E_ = { usingClientEntryPoint: !1, Events: [to, Pi, Sa, ih, rh, Kc] },
  vr = { findFiberByHostInstance: qn, bundleType: 0, version: '18.2.0', rendererPackageName: 'react-dom' },
  k_ = {
    bundleType: vr.bundleType,
    version: vr.version,
    rendererPackageName: vr.rendererPackageName,
    rendererConfig: vr.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: cn.ReactCurrentDispatcher,
    findHostInstanceByFiber: function (e) {
      return (e = ch(e)), e === null ? null : e.stateNode;
    },
    findFiberByHostInstance: vr.findFiberByHostInstance || x_,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: '18.2.0-next-9e3b772b8-20220608',
  };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u') {
  var Io = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!Io.isDisabled && Io.supportsFiber)
    try {
      (xa = Io.inject(k_)), (qt = Io);
    } catch {}
}
_t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = E_;
_t.createPortal = function (e, t) {
  var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!nu(t)) throw Error(w(200));
  return __(e, t, null, n);
};
_t.createRoot = function (e, t) {
  if (!nu(e)) throw Error(w(299));
  var n = !1,
    i = '',
    r = Gf;
  return (
    t != null &&
      (t.unstable_strictMode === !0 && (n = !0),
      t.identifierPrefix !== void 0 && (i = t.identifierPrefix),
      t.onRecoverableError !== void 0 && (r = t.onRecoverableError)),
    (t = Yc(e, 1, !1, null, null, n, !1, i, r)),
    (e[on] = t.current),
    Gr(e.nodeType === 8 ? e.parentNode : e),
    new tu(t)
  );
};
_t.findDOMNode = function (e) {
  if (e == null) return null;
  if (e.nodeType === 1) return e;
  var t = e._reactInternals;
  if (t === void 0)
    throw typeof e.render == 'function' ? Error(w(188)) : ((e = Object.keys(e).join(',')), Error(w(268, e)));
  return (e = ch(t)), (e = e === null ? null : e.stateNode), e;
};
_t.flushSync = function (e) {
  return ii(e);
};
_t.hydrate = function (e, t, n) {
  if (!La(t)) throw Error(w(200));
  return Na(null, e, t, !0, n);
};
_t.hydrateRoot = function (e, t, n) {
  if (!nu(e)) throw Error(w(405));
  var i = (n != null && n.hydratedSources) || null,
    r = !1,
    o = '',
    a = Gf;
  if (
    (n != null &&
      (n.unstable_strictMode === !0 && (r = !0),
      n.identifierPrefix !== void 0 && (o = n.identifierPrefix),
      n.onRecoverableError !== void 0 && (a = n.onRecoverableError)),
    (t = Uf(t, null, e, 1, n != null ? n : null, r, !1, o, a)),
    (e[on] = t.current),
    Gr(e),
    i)
  )
    for (e = 0; e < i.length; e++)
      (n = i[e]),
        (r = n._getVersion),
        (r = r(n._source)),
        t.mutableSourceEagerHydrationData == null
          ? (t.mutableSourceEagerHydrationData = [n, r])
          : t.mutableSourceEagerHydrationData.push(n, r);
  return new Ia(t);
};
_t.render = function (e, t, n) {
  if (!La(t)) throw Error(w(200));
  return Na(null, e, t, !1, n);
};
_t.unmountComponentAtNode = function (e) {
  if (!La(e)) throw Error(w(40));
  return e._reactRootContainer
    ? (ii(function () {
        Na(null, null, e, !1, function () {
          (e._reactRootContainer = null), (e[on] = null);
        });
      }),
      !0)
    : !1;
};
_t.unstable_batchedUpdates = Kc;
_t.unstable_renderSubtreeIntoContainer = function (e, t, n, i) {
  if (!La(n)) throw Error(w(200));
  if (e == null || e._reactInternals === void 0) throw Error(w(38));
  return Na(e, t, n, !1, i);
};
_t.version = '18.2.0-next-9e3b772b8-20220608';
(function (e) {
  function t() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > 'u' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != 'function'))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t);
      } catch (n) {
        console.error(n);
      }
  }
  t(), (e.exports = _t);
})(Bp);
var $f,
  Wd = Bp.exports;
($f = Wd.createRoot), Wd.hydrateRoot;
/**
 * @remix-run/router v1.0.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function ke() {
  return (
    (ke = Object.assign
      ? Object.assign.bind()
      : function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
          return e;
        }),
    ke.apply(this, arguments)
  );
}
var we;
(function (e) {
  (e.Pop = 'POP'), (e.Push = 'PUSH'), (e.Replace = 'REPLACE');
})(we || (we = {}));
const Kd = 'popstate';
function S_(e) {
  e === void 0 && (e = {});
  function t(i, r) {
    var o, a;
    let { pathname: s, search: l, hash: c } = i.location;
    return Xn(
      '',
      { pathname: s, search: l, hash: c },
      ((o = r.state) == null ? void 0 : o.usr) || null,
      ((a = r.state) == null ? void 0 : a.key) || 'default',
    );
  }
  function n(i, r) {
    return typeof r == 'string' ? r : Wl(r);
  }
  return w_(t, n, null, e);
}
function A_() {
  return Math.random().toString(36).substr(2, 8);
}
function Jd(e) {
  return { usr: e.state, key: e.key };
}
function Xn(e, t, n, i) {
  return (
    n === void 0 && (n = null),
    ke({ pathname: typeof e == 'string' ? e : e.pathname, search: '', hash: '' }, typeof t == 'string' ? ln(t) : t, {
      state: n,
      key: (t == null ? void 0 : t.key) || i || A_(),
    })
  );
}
function Wl(e) {
  let { pathname: t = '/', search: n = '', hash: i = '' } = e;
  return (
    n && n !== '?' && (t += n.charAt(0) === '?' ? n : '?' + n),
    i && i !== '#' && (t += i.charAt(0) === '#' ? i : '#' + i),
    t
  );
}
function ln(e) {
  let t = {};
  if (e) {
    let n = e.indexOf('#');
    n >= 0 && ((t.hash = e.substr(n)), (e = e.substr(0, n)));
    let i = e.indexOf('?');
    i >= 0 && ((t.search = e.substr(i)), (e = e.substr(0, i))), e && (t.pathname = e);
  }
  return t;
}
function w_(e, t, n, i) {
  i === void 0 && (i = {});
  let { window: r = document.defaultView, v5Compat: o = !1 } = i,
    a = r.history,
    s = we.Pop,
    l = null;
  function c() {
    (s = we.Pop), l && l({ action: s, location: h.location });
  }
  function u(x, y) {
    s = we.Push;
    let m = Xn(h.location, x, y);
    n == null || n(m, x);
    let j = Jd(m),
      p = h.createHref(m);
    try {
      a.pushState(j, '', p);
    } catch {
      r.location.assign(p);
    }
    o && l && l({ action: s, location: m });
  }
  function f(x, y) {
    s = we.Replace;
    let m = Xn(h.location, x, y);
    n == null || n(m, x);
    let j = Jd(m),
      p = h.createHref(m);
    a.replaceState(j, '', p), o && l && l({ action: s, location: m });
  }
  let h = {
    get action() {
      return s;
    },
    get location() {
      return e(r, a);
    },
    listen(x) {
      if (l) throw new Error('A history only accepts one active listener');
      return (
        r.addEventListener(Kd, c),
        (l = x),
        () => {
          r.removeEventListener(Kd, c), (l = null);
        }
      );
    },
    createHref(x) {
      return t(r, x);
    },
    push: u,
    replace: f,
    go(x) {
      return a.go(x);
    },
  };
  return h;
}
var Qe;
(function (e) {
  (e.data = 'data'), (e.deferred = 'deferred'), (e.redirect = 'redirect'), (e.error = 'error');
})(Qe || (Qe = {}));
function qf(e, t, n) {
  return (
    t === void 0 && (t = []),
    n === void 0 && (n = new Set()),
    e.map((i, r) => {
      let o = [...t, r],
        a = typeof i.id == 'string' ? i.id : o.join('-');
      return (
        re(
          !n.has(a),
          'Found a route id collision on id "' + a + `".  Route id's must be globally unique within Data Router usages`,
        ),
        n.add(a),
        ke({}, i, { id: a, children: i.children ? qf(i.children, o, n) : void 0 })
      );
    })
  );
}
function Ar(e, t, n) {
  n === void 0 && (n = '/');
  let i = typeof t == 'string' ? ln(t) : t,
    r = Qf(i.pathname || '/', n);
  if (r == null) return null;
  let o = Vf(e);
  M_(o);
  let a = null;
  for (let s = 0; a == null && s < o.length; ++s) a = D_(o[s], r);
  return a;
}
function Vf(e, t, n, i) {
  return (
    t === void 0 && (t = []),
    n === void 0 && (n = []),
    i === void 0 && (i = ''),
    e.forEach((r, o) => {
      let a = { relativePath: r.path || '', caseSensitive: r.caseSensitive === !0, childrenIndex: o, route: r };
      a.relativePath.startsWith('/') &&
        (re(
          a.relativePath.startsWith(i),
          'Absolute route path "' +
            a.relativePath +
            '" nested under path ' +
            ('"' + i + '" is not valid. An absolute child route path ') +
            'must start with the combined path of all its parent routes.',
        ),
        (a.relativePath = a.relativePath.slice(i.length)));
      let s = Zn([i, a.relativePath]),
        l = n.concat(a);
      r.children &&
        r.children.length > 0 &&
        (re(
          r.index !== !0,
          'Index routes must not have child routes. Please remove ' + ('all child routes from route path "' + s + '".'),
        ),
        Vf(r.children, t, l, s)),
        !(r.path == null && !r.index) && t.push({ path: s, score: N_(s, r.index), routesMeta: l });
    }),
    t
  );
}
function M_(e) {
  e.sort((t, n) =>
    t.score !== n.score
      ? n.score - t.score
      : R_(
          t.routesMeta.map((i) => i.childrenIndex),
          n.routesMeta.map((i) => i.childrenIndex),
        ),
  );
}
const P_ = /^:\w+$/,
  T_ = 3,
  C_ = 2,
  b_ = 1,
  I_ = 10,
  L_ = -2,
  Xd = (e) => e === '*';
function N_(e, t) {
  let n = e.split('/'),
    i = n.length;
  return (
    n.some(Xd) && (i += L_),
    t && (i += C_),
    n.filter((r) => !Xd(r)).reduce((r, o) => r + (P_.test(o) ? T_ : o === '' ? b_ : I_), i)
  );
}
function R_(e, t) {
  return e.length === t.length && e.slice(0, -1).every((i, r) => i === t[r]) ? e[e.length - 1] - t[t.length - 1] : 0;
}
function D_(e, t) {
  let { routesMeta: n } = e,
    i = {},
    r = '/',
    o = [];
  for (let a = 0; a < n.length; ++a) {
    let s = n[a],
      l = a === n.length - 1,
      c = r === '/' ? t : t.slice(r.length) || '/',
      u = H_({ path: s.relativePath, caseSensitive: s.caseSensitive, end: l }, c);
    if (!u) return null;
    Object.assign(i, u.params);
    let f = s.route;
    o.push({ params: i, pathname: Zn([r, u.pathname]), pathnameBase: U_(Zn([r, u.pathnameBase])), route: f }),
      u.pathnameBase !== '/' && (r = Zn([r, u.pathnameBase]));
  }
  return o;
}
function H_(e, t) {
  typeof e == 'string' && (e = { path: e, caseSensitive: !1, end: !0 });
  let [n, i] = O_(e.path, e.caseSensitive, e.end),
    r = t.match(n);
  if (!r) return null;
  let o = r[0],
    a = o.replace(/(.)\/+$/, '$1'),
    s = r.slice(1);
  return {
    params: i.reduce((c, u, f) => {
      if (u === '*') {
        let h = s[f] || '';
        a = o.slice(0, o.length - h.length).replace(/(.)\/+$/, '$1');
      }
      return (c[u] = j_(s[f] || '', u)), c;
    }, {}),
    pathname: o,
    pathnameBase: a,
    pattern: e,
  };
}
function O_(e, t, n) {
  t === void 0 && (t = !1),
    n === void 0 && (n = !0),
    Wf(
      e === '*' || !e.endsWith('*') || e.endsWith('/*'),
      'Route path "' +
        e +
        '" will be treated as if it were ' +
        ('"' + e.replace(/\*$/, '/*') + '" because the `*` character must ') +
        'always follow a `/` in the pattern. To get rid of this warning, ' +
        ('please change the route path to "' + e.replace(/\*$/, '/*') + '".'),
    );
  let i = [],
    r =
      '^' +
      e
        .replace(/\/*\*?$/, '')
        .replace(/^\/*/, '/')
        .replace(/[\\.*+^$?{}|()[\]]/g, '\\$&')
        .replace(/:(\w+)/g, (a, s) => (i.push(s), '([^\\/]+)'));
  return (
    e.endsWith('*')
      ? (i.push('*'), (r += e === '*' || e === '/*' ? '(.*)$' : '(?:\\/(.+)|\\/*)$'))
      : (r += n ? '\\/*$' : '(?:(?=[@.~-]|%[0-9A-F]{2})|\\b|\\/|$)'),
    [new RegExp(r, t ? void 0 : 'i'), i]
  );
}
function j_(e, t) {
  try {
    return decodeURIComponent(e);
  } catch (n) {
    return (
      Wf(
        !1,
        'The value for the URL param "' +
          t +
          '" will not be decoded because' +
          (' the string "' + e + '" is a malformed URL segment. This is probably') +
          (' due to a bad percent encoding (' + n + ').'),
      ),
      e
    );
  }
}
function Qf(e, t) {
  if (t === '/') return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase())) return null;
  let n = t.endsWith('/') ? t.length - 1 : t.length,
    i = e.charAt(n);
  return i && i !== '/' ? null : e.slice(n) || '/';
}
function re(e, t) {
  if (e === !1 || e === null || typeof e > 'u') throw new Error(t);
}
function Wf(e, t) {
  if (!e) {
    typeof console < 'u' && console.warn(t);
    try {
      throw new Error(t);
    } catch {}
  }
}
function F_(e, t) {
  t === void 0 && (t = '/');
  let { pathname: n, search: i = '', hash: r = '' } = typeof e == 'string' ? ln(e) : e;
  return { pathname: n ? (n.startsWith('/') ? n : z_(n, t)) : t, search: G_(i), hash: $_(r) };
}
function z_(e, t) {
  let n = t.replace(/\/+$/, '').split('/');
  return (
    e.split('/').forEach((r) => {
      r === '..' ? n.length > 1 && n.pop() : r !== '.' && n.push(r);
    }),
    n.length > 1 ? n.join('/') : '/'
  );
}
function B_(e, t, n, i) {
  i === void 0 && (i = !1);
  let r = typeof e == 'string' ? ln(e) : ke({}, e),
    o = e === '' || r.pathname === '',
    a = o ? '/' : r.pathname,
    s;
  if (i || a == null) s = n;
  else {
    let f = t.length - 1;
    if (a.startsWith('..')) {
      let h = a.split('/');
      for (; h[0] === '..'; ) h.shift(), (f -= 1);
      r.pathname = h.join('/');
    }
    s = f >= 0 ? t[f] : '/';
  }
  let l = F_(r, s),
    c = a && a !== '/' && a.endsWith('/'),
    u = (o || a === '.') && n.endsWith('/');
  return !l.pathname.endsWith('/') && (c || u) && (l.pathname += '/'), l;
}
const Zn = (e) => e.join('/').replace(/\/\/+/g, '/'),
  U_ = (e) => e.replace(/\/+$/, '').replace(/^\/*/, '/'),
  G_ = (e) => (!e || e === '?' ? '' : e.startsWith('?') ? e : '?' + e),
  $_ = (e) => (!e || e === '#' ? '' : e.startsWith('#') ? e : '#' + e);
class Zd extends Error {}
class q_ {
  constructor(t) {
    (this.pendingKeys = new Set()),
      (this.subscriber = void 0),
      re(t && typeof t == 'object' && !Array.isArray(t), 'defer() only accepts plain objects');
    let n;
    (this.abortPromise = new Promise((r, o) => (n = o))), (this.controller = new AbortController());
    let i = () => n(new Zd('Deferred data aborted'));
    (this.unlistenAbortSignal = () => this.controller.signal.removeEventListener('abort', i)),
      this.controller.signal.addEventListener('abort', i),
      (this.data = Object.entries(t).reduce((r, o) => {
        let [a, s] = o;
        return Object.assign(r, { [a]: this.trackPromise(a, s) });
      }, {}));
  }
  trackPromise(t, n) {
    if (!(n instanceof Promise)) return n;
    this.pendingKeys.add(t);
    let i = Promise.race([n, this.abortPromise]).then(
      (r) => this.onSettle(i, t, null, r),
      (r) => this.onSettle(i, t, r),
    );
    return i.catch(() => {}), Object.defineProperty(i, '_tracked', { get: () => !0 }), i;
  }
  onSettle(t, n, i, r) {
    var o;
    if (this.controller.signal.aborted && i instanceof Zd)
      return this.unlistenAbortSignal(), Object.defineProperty(t, '_error', { get: () => i }), Promise.reject(i);
    if ((this.pendingKeys.delete(n), this.done && this.unlistenAbortSignal(), i)) {
      var a;
      return (
        Object.defineProperty(t, '_error', { get: () => i }),
        (a = this.subscriber) == null || a.call(this, !1),
        Promise.reject(i)
      );
    }
    return Object.defineProperty(t, '_data', { get: () => r }), (o = this.subscriber) == null || o.call(this, !1), r;
  }
  subscribe(t) {
    this.subscriber = t;
  }
  cancel() {
    var t;
    this.controller.abort(),
      this.pendingKeys.forEach((n, i) => this.pendingKeys.delete(i)),
      (t = this.subscriber) == null || t.call(this, !0);
  }
  async resolveData(t) {
    let n = !1;
    if (!this.done) {
      let i = () => this.cancel();
      t.addEventListener('abort', i),
        (n = await new Promise((r) => {
          this.subscribe((o) => {
            t.removeEventListener('abort', i), (o || this.done) && r(o);
          });
        }));
    }
    return n;
  }
  get done() {
    return this.pendingKeys.size === 0;
  }
  get unwrappedData() {
    return (
      re(this.data !== null && this.done, 'Can only unwrap data on initialized and settled deferreds'),
      Object.entries(this.data).reduce((t, n) => {
        let [i, r] = n;
        return Object.assign(t, { [i]: Q_(r) });
      }, {})
    );
  }
}
function V_(e) {
  return e instanceof Promise && e._tracked === !0;
}
function Q_(e) {
  if (!V_(e)) return e;
  if (e._error) throw e._error;
  return e._data;
}
class Yi {
  constructor(t, n, i) {
    (this.status = t), (this.statusText = n || ''), (this.data = i);
  }
}
function Kf(e) {
  return e instanceof Yi;
}
const $s = {
    state: 'idle',
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
  },
  W_ = { state: 'idle', data: void 0, formMethod: void 0, formAction: void 0, formEncType: void 0, formData: void 0 };
function K_(e) {
  var t, n, i;
  re(e.routes.length > 0, 'You must provide a non-empty routes array to createRouter');
  let r = qf(e.routes),
    o = null,
    a = new Set(),
    s = null,
    l = null,
    c = null,
    u = !1,
    f = Ar(r, e.history.location, e.basename),
    h = null;
  if (f == null) {
    let { matches: S, route: M, error: L } = ip(r);
    (f = S), (h = { [M.id]: L });
  }
  let x = !f.some((S) => S.route.loader) || e.hydrationData != null,
    y,
    m = {
      historyAction: e.history.action,
      location: e.history.location,
      matches: f,
      initialized: x,
      navigation: $s,
      restoreScrollPosition: null,
      preventScrollReset: !1,
      revalidation: 'idle',
      loaderData: ((t = e.hydrationData) == null ? void 0 : t.loaderData) || {},
      actionData: ((n = e.hydrationData) == null ? void 0 : n.actionData) || null,
      errors: ((i = e.hydrationData) == null ? void 0 : i.errors) || h,
      fetchers: new Map(),
    },
    j = we.Pop,
    p = !1,
    d,
    g = !1,
    k = !1,
    T = [],
    R = [],
    b = new Map(),
    z = 0,
    te = -1,
    Q = new Map(),
    Te = new Set(),
    _e = new Map(),
    Xe = new Map();
  function li() {
    return (
      (o = e.history.listen((S) => {
        let { action: M, location: L } = S;
        return Z(M, L);
      })),
      m.initialized || Z(we.Pop, m.location),
      y
    );
  }
  function Ae() {
    var S;
    o && o(), a.clear(), (S = d) == null || S.abort(), m.fetchers.forEach((M, L) => pn(L));
  }
  function Wt(S) {
    return a.add(S), () => a.delete(S);
  }
  function ie(S) {
    (m = ke({}, m, S)), a.forEach((M) => M(m));
  }
  function N(S, M) {
    let L = m.actionData != null && m.navigation.formMethod != null && m.navigation.state === 'loading',
      V = M.loaderData ? { loaderData: Vs(m.loaderData, M.loaderData, M.matches || []) } : {};
    ie(
      ke({}, L ? {} : { actionData: null }, M, V, {
        historyAction: j,
        location: S,
        initialized: !0,
        navigation: $s,
        revalidation: 'idle',
        restoreScrollPosition: m.navigation.formData ? !1 : lo(S, M.matches || m.matches),
        preventScrollReset: p,
      }),
    ),
      g ||
        j === we.Pop ||
        (j === we.Push ? e.history.push(S, S.state) : j === we.Replace && e.history.replace(S, S.state)),
      (j = we.Pop),
      (p = !1),
      (g = !1),
      (k = !1),
      (T = []),
      (R = []);
  }
  async function C(S, M) {
    if (typeof S == 'number') {
      e.history.go(S);
      return;
    }
    let { path: L, submission: V, error: E } = Yd(S, M),
      A = Xn(m.location, L, M == null ? void 0 : M.state),
      I = (M == null ? void 0 : M.replace) === !0 || V != null ? we.Replace : we.Push,
      D = M && 'preventScrollReset' in M ? M.preventScrollReset === !0 : void 0;
    return await Z(I, A, {
      submission: V,
      pendingError: E,
      preventScrollReset: D,
      replace: M == null ? void 0 : M.replace,
    });
  }
  function q() {
    if ((jn(), ie({ revalidation: 'loading' }), m.navigation.state !== 'submitting')) {
      if (m.navigation.state === 'idle') {
        Z(m.historyAction, m.location, { startUninterruptedRevalidation: !0 });
        return;
      }
      Z(j || m.historyAction, m.navigation.location, { overrideNavigation: m.navigation });
    }
  }
  async function Z(S, M, L) {
    var V;
    (V = d) == null || V.abort(),
      (d = null),
      (j = S),
      (g = (L == null ? void 0 : L.startUninterruptedRevalidation) === !0),
      Ya(m.location, m.matches),
      (p = (L == null ? void 0 : L.preventScrollReset) === !0);
    let E = L == null ? void 0 : L.overrideNavigation,
      A = Ar(r, M, e.basename);
    if (!A) {
      let { matches: Ce, route: rt, error: Kt } = ip(r);
      ir(), N(M, { matches: Ce, loaderData: {}, errors: { [rt.id]: Kt } });
      return;
    }
    if (Y_(m.location, M)) {
      N(M, { matches: A });
      return;
    }
    d = new AbortController();
    let I = xr(M, d.signal, L == null ? void 0 : L.submission),
      D,
      $;
    if (L != null && L.pendingError) $ = { [Ri(A).route.id]: L.pendingError };
    else if (L != null && L.submission) {
      let Ce = await he(I, M, L.submission, A, { replace: L.replace });
      if (Ce.shortCircuited) return;
      (D = Ce.pendingActionData),
        ($ = Ce.pendingActionError),
        (E = ke({ state: 'loading', location: M }, L.submission));
    }
    let {
      shortCircuited: ee,
      loaderData: se,
      errors: ze,
    } = await Ht(I, M, A, E, L == null ? void 0 : L.submission, L == null ? void 0 : L.replace, D, $);
    ee || ((d = null), N(M, { matches: A, loaderData: se, errors: ze }));
  }
  async function he(S, M, L, V, E) {
    jn();
    let A = ke({ state: 'submitting', location: M }, L);
    ie({ navigation: A });
    let I,
      D = lp(V, M);
    if (!D.route.action) I = rp(M);
    else if (((I = await _r('action', S, D)), S.signal.aborted)) return { shortCircuited: !0 };
    if (Bi(I)) {
      let $ = ke({ state: 'loading', location: Xn(m.location, I.location) }, L);
      return await dn(I, $, E == null ? void 0 : E.replace), { shortCircuited: !0 };
    }
    if (Rr(I)) {
      let $ = Ri(V, D.route.id);
      return (
        (E == null ? void 0 : E.replace) !== !0 && (j = we.Push), { pendingActionError: { [$.route.id]: I.error } }
      );
    }
    if (Wn(I)) throw new Error('defer() is not supported in actions');
    return { pendingActionData: { [D.route.id]: I.data } };
  }
  async function Ht(S, M, L, V, E, A, I, D) {
    let $ = V;
    $ ||
      ($ = {
        state: 'loading',
        location: M,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
      });
    let [ee, se] = ep(m, L, E, M, k, T, R, I, D, _e);
    if (
      (ir(
        (xe) =>
          !(L != null && L.some((Be) => Be.route.id === xe)) ||
          (ee == null ? void 0 : ee.some((Be) => Be.route.id === xe)),
      ),
      ee.length === 0 && se.length === 0)
    )
      return (
        N(M, { matches: L, loaderData: Vs(m.loaderData, {}, L), errors: D || null, actionData: I || null }),
        { shortCircuited: !0 }
      );
    g ||
      (se.forEach((xe) => {
        var Be;
        let [Ot] = xe,
          pi = {
            state: 'loading',
            data: (Be = m.fetchers.get(Ot)) == null ? void 0 : Be.data,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
          };
        m.fetchers.set(Ot, pi);
      }),
      ie(
        ke(
          { navigation: $, actionData: I || m.actionData || null },
          se.length > 0 ? { fetchers: new Map(m.fetchers) } : {},
        ),
      )),
      (te = ++z),
      se.forEach((xe) => {
        let [Be] = xe;
        return b.set(Be, d);
      });
    let { results: ze, loaderResults: Ce, fetcherResults: rt } = await nr(m.matches, ee, se, S);
    if (S.signal.aborted) return { shortCircuited: !0 };
    se.forEach((xe) => {
      let [Be] = xe;
      return b.delete(Be);
    });
    let Kt = op(ze);
    if (Kt) {
      let xe = qs(m, Kt);
      return await dn(Kt, xe, A), { shortCircuited: !0 };
    }
    let { loaderData: di, errors: hn } = np(m, L, ee, Ce, D, se, rt, Xe);
    Xe.forEach((xe, Be) => {
      xe.subscribe((Ot) => {
        (Ot || xe.done) && Xe.delete(Be);
      });
    }),
      Xa();
    let fn = so(te);
    return ke({ loaderData: di, errors: hn }, fn || se.length > 0 ? { fetchers: new Map(m.fetchers) } : {});
  }
  function it(S) {
    return m.fetchers.get(S) || W_;
  }
  function On(S, M, L, V) {
    if (typeof AbortController > 'u')
      throw new Error(
        "router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.",
      );
    b.has(S) && ui(S);
    let E = Ar(r, L, e.basename);
    if (!E) {
      ci(S, M, new Yi(404, 'Not Found', null));
      return;
    }
    let { path: A, submission: I } = Yd(L, V),
      D = lp(E, A);
    if (I) {
      pt(S, M, A, D, I);
      return;
    }
    _e.set(S, [A, D]), un(S, M, A, D);
  }
  async function pt(S, M, L, V, E) {
    var A;
    if ((jn(), _e.delete(S), !V.route.action)) {
      let { error: Ue } = rp(L);
      ci(S, M, Ue);
      return;
    }
    let I = ke({ state: 'submitting' }, E, { data: ((A = m.fetchers.get(S)) == null ? void 0 : A.data) || void 0 });
    m.fetchers.set(S, I), ie({ fetchers: new Map(m.fetchers) });
    let D = new AbortController(),
      $ = xr(L, D.signal, E);
    b.set(S, D);
    let ee = await _r('action', $, V);
    if ($.signal.aborted) {
      b.get(S) === D && b.delete(S);
      return;
    }
    if (Bi(ee)) {
      b.delete(S), Te.add(S);
      let Ue = ke({ state: 'loading' }, E, { data: void 0 });
      m.fetchers.set(S, Ue), ie({ fetchers: new Map(m.fetchers) });
      let Et = ke({ state: 'loading', location: Xn(m.location, ee.location) }, E);
      await dn(ee, Et);
      return;
    }
    if (Rr(ee)) {
      ci(S, M, ee.error);
      return;
    }
    Wn(ee) && re(!1, 'defer() is not supported in actions');
    let se = m.navigation.location || m.location,
      ze = xr(se, D.signal),
      Ce = m.navigation.state !== 'idle' ? Ar(r, m.navigation.location, e.basename) : m.matches;
    re(Ce, "Didn't find any matches after fetcher action");
    let rt = ++z;
    Q.set(S, rt);
    let Kt = ke({ state: 'loading', data: ee.data }, E);
    m.fetchers.set(S, Kt);
    let [di, hn] = ep(m, Ce, E, se, k, T, R, { [V.route.id]: ee.data }, void 0, _e);
    hn
      .filter((Ue) => {
        let [Et] = Ue;
        return Et !== S;
      })
      .forEach((Ue) => {
        var Et;
        let [ar] = Ue,
          es = {
            state: 'loading',
            data: (Et = m.fetchers.get(ar)) == null ? void 0 : Et.data,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
          };
        m.fetchers.set(ar, es), b.set(ar, D);
      }),
      ie({ fetchers: new Map(m.fetchers) });
    let { results: fn, loaderResults: xe, fetcherResults: Be } = await nr(m.matches, di, hn, ze);
    if (D.signal.aborted) return;
    Q.delete(S),
      b.delete(S),
      hn.forEach((Ue) => {
        let [Et] = Ue;
        return b.delete(Et);
      });
    let Ot = op(fn);
    if (Ot) {
      let Ue = qs(m, Ot);
      await dn(Ot, Ue);
      return;
    }
    let { loaderData: pi, errors: hi } = np(m, m.matches, di, xe, void 0, hn, Be, Xe),
      rr = {
        state: 'idle',
        data: ee.data,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
      };
    m.fetchers.set(S, rr);
    let ht = so(rt);
    if (m.navigation.state === 'loading' && rt > te) {
      var or;
      re(j, 'Expected pending action'),
        (or = d) == null || or.abort(),
        N(m.navigation.location, { matches: Ce, loaderData: pi, errors: hi, fetchers: new Map(m.fetchers) });
    } else
      ie(ke({ errors: hi, loaderData: Vs(m.loaderData, pi, Ce) }, ht ? { fetchers: new Map(m.fetchers) } : {})),
        (k = !1);
  }
  async function un(S, M, L, V) {
    var E;
    let A = {
      state: 'loading',
      formMethod: void 0,
      formAction: void 0,
      formEncType: void 0,
      formData: void 0,
      data: ((E = m.fetchers.get(S)) == null ? void 0 : E.data) || void 0,
    };
    m.fetchers.set(S, A), ie({ fetchers: new Map(m.fetchers) });
    let I = new AbortController(),
      D = xr(L, I.signal);
    b.set(S, I);
    let $ = await _r('loader', D, V);
    if ((Wn($) && ($ = (await Zf($, D.signal, !0)) || $), b.get(S) === I && b.delete(S), D.signal.aborted)) return;
    if (Bi($)) {
      let se = qs(m, $);
      await dn($, se);
      return;
    }
    if (Rr($)) {
      let se = Ri(m.matches, M);
      m.fetchers.delete(S), ie({ fetchers: new Map(m.fetchers), errors: { [se.route.id]: $.error } });
      return;
    }
    re(!Wn($), 'Unhandled fetcher deferred data');
    let ee = {
      state: 'idle',
      data: $.data,
      formMethod: void 0,
      formAction: void 0,
      formEncType: void 0,
      formData: void 0,
    };
    m.fetchers.set(S, ee), ie({ fetchers: new Map(m.fetchers) });
  }
  async function dn(S, M, L) {
    S.revalidate && (k = !0), re(M.location, 'Expected a location on the redirect navigation'), (d = null);
    let V = L === !0 ? we.Replace : we.Push;
    await Z(V, M.location, { overrideNavigation: M });
  }
  async function nr(S, M, L, V) {
    let E = await Promise.all([
        ...M.map((D) => _r('loader', V, D)),
        ...L.map((D) => {
          let [, $, ee] = D;
          return _r('loader', xr($, V.signal), ee);
        }),
      ]),
      A = E.slice(0, M.length),
      I = E.slice(M.length);
    return (
      await Promise.all([
        ap(S, M, A, V.signal, !1, m.loaderData),
        ap(
          S,
          L.map((D) => {
            let [, , $] = D;
            return $;
          }),
          I,
          V.signal,
          !0,
        ),
      ]),
      { results: E, loaderResults: A, fetcherResults: I }
    );
  }
  function jn() {
    (k = !0),
      T.push(...ir()),
      _e.forEach((S, M) => {
        b.has(M) && (R.push(M), ui(M));
      });
  }
  function ci(S, M, L) {
    let V = Ri(m.matches, M);
    pn(S), ie({ errors: { [V.route.id]: L }, fetchers: new Map(m.fetchers) });
  }
  function pn(S) {
    b.has(S) && ui(S), _e.delete(S), Q.delete(S), Te.delete(S), m.fetchers.delete(S);
  }
  function ui(S) {
    let M = b.get(S);
    re(M, 'Expected fetch controller: ' + S), M.abort(), b.delete(S);
  }
  function ao(S) {
    for (let M of S) {
      let V = {
        state: 'idle',
        data: it(M).data,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
      };
      m.fetchers.set(M, V);
    }
  }
  function Xa() {
    let S = [];
    for (let M of Te) {
      let L = m.fetchers.get(M);
      re(L, 'Expected fetcher: ' + M), L.state === 'loading' && (Te.delete(M), S.push(M));
    }
    ao(S);
  }
  function so(S) {
    let M = [];
    for (let [L, V] of Q)
      if (V < S) {
        let E = m.fetchers.get(L);
        re(E, 'Expected fetcher: ' + L), E.state === 'loading' && (ui(L), Q.delete(L), M.push(L));
      }
    return ao(M), M.length > 0;
  }
  function ir(S) {
    let M = [];
    return (
      Xe.forEach((L, V) => {
        (!S || S(V)) && (L.cancel(), M.push(V), Xe.delete(V));
      }),
      M
    );
  }
  function Za(S, M, L) {
    if (((s = S), (c = M), (l = L || ((V) => V.key)), !u && m.navigation === $s)) {
      u = !0;
      let V = lo(m.location, m.matches);
      V != null && ie({ restoreScrollPosition: V });
    }
    return () => {
      (s = null), (c = null), (l = null);
    };
  }
  function Ya(S, M) {
    if (s && l && c) {
      let L = M.map((E) => sp(E, m.loaderData)),
        V = l(S, L) || S.key;
      s[V] = c();
    }
  }
  function lo(S, M) {
    if (s && l && c) {
      let L = M.map((A) => sp(A, m.loaderData)),
        V = l(S, L) || S.key,
        E = s[V];
      if (typeof E == 'number') return E;
    }
    return null;
  }
  return (
    (y = {
      get basename() {
        return e.basename;
      },
      get state() {
        return m;
      },
      get routes() {
        return r;
      },
      initialize: li,
      subscribe: Wt,
      enableScrollRestoration: Za,
      navigate: C,
      fetch: On,
      revalidate: q,
      createHref: Ra,
      getFetcher: it,
      deleteFetcher: pn,
      dispose: Ae,
      _internalFetchControllers: b,
      _internalActiveDeferreds: Xe,
    }),
    y
  );
}
function Yd(e, t) {
  let n = typeof e == 'string' ? e : Wl(e);
  if (!t || (!('formMethod' in t) && !('formData' in t))) return { path: n };
  if (t.formMethod != null && t.formMethod !== 'get')
    return {
      path: n,
      submission: {
        formMethod: t.formMethod,
        formAction: Ra(ln(n)),
        formEncType: (t == null ? void 0 : t.formEncType) || 'application/x-www-form-urlencoded',
        formData: t.formData,
      },
    };
  if (!t.formData) return { path: n };
  let i = ln(n);
  try {
    let r = Xf(t.formData);
    i.search = '?' + r;
  } catch {
    return { path: n, error: new Yi(400, 'Bad Request', 'Cannot submit binary form data using GET') };
  }
  return { path: Wl(i) };
}
function qs(e, t) {
  let { formMethod: n, formAction: i, formEncType: r, formData: o } = e.navigation;
  return {
    state: 'loading',
    location: Xn(e.location, t.location),
    formMethod: n || void 0,
    formAction: i || void 0,
    formEncType: r || void 0,
    formData: o || void 0,
  };
}
function J_(e, t) {
  let n = e;
  if (t) {
    let i = e.findIndex((r) => r.route.id === t);
    i >= 0 && (n = e.slice(0, i));
  }
  return n;
}
function ep(e, t, n, i, r, o, a, s, l, c) {
  let u = l ? Object.values(l)[0] : s ? Object.values(s)[0] : null,
    f = l ? Object.keys(l)[0] : void 0,
    x = J_(t, f).filter(
      (m, j) =>
        m.route.loader != null &&
        (X_(e.loaderData, e.matches[j], m) ||
          o.some((p) => p === m.route.id) ||
          tp(e.location, e.matches[j], n, i, m, r, u)),
    ),
    y = [];
  return (
    c == null ||
      c.forEach((m, j) => {
        let [p, d] = m;
        a.includes(j) ? y.push([j, p, d]) : r && tp(p, d, n, p, d, r, u) && y.push([j, p, d]);
      }),
    [x, y]
  );
}
function X_(e, t, n) {
  let i = !t || n.route.id !== t.route.id,
    r = e[n.route.id] === void 0;
  return i || r;
}
function Jf(e, t) {
  var n;
  return (
    e.pathname !== t.pathname ||
    (((n = e.route.path) == null ? void 0 : n.endsWith('*')) && e.params['*'] !== t.params['*'])
  );
}
function tp(e, t, n, i, r, o, a) {
  let s = Kl(e),
    l = t.params,
    c = Kl(i),
    u = r.params,
    f = Jf(t, r) || s.toString() === c.toString() || s.search !== c.search || o;
  if (r.route.shouldRevalidate) {
    let h = r.route.shouldRevalidate(
      ke({ currentUrl: s, currentParams: l, nextUrl: c, nextParams: u }, n, {
        actionResult: a,
        defaultShouldRevalidate: f,
      }),
    );
    if (typeof h == 'boolean') return h;
  }
  return f;
}
async function _r(e, t, n, i, r) {
  i === void 0 && (i = !1), r === void 0 && (r = !1);
  let o,
    a,
    s,
    l = new Promise((f, h) => (s = h)),
    c = () => s();
  t.signal.addEventListener('abort', c);
  try {
    let f = n.route[e];
    re(f, 'Could not find the ' + e + ' to run on the "' + n.route.id + '" route'),
      (a = await Promise.race([f({ request: t, params: n.params }), l]));
  } catch (f) {
    (o = Qe.error), (a = f);
  } finally {
    t.signal.removeEventListener('abort', c);
  }
  if (a instanceof Response) {
    var u;
    let f = a.status,
      h = a.headers.get('Location');
    if (r) throw a;
    if (f >= 300 && f <= 399 && h != null) {
      if (i) throw a;
      return { type: Qe.redirect, status: f, location: h, revalidate: a.headers.get('X-Remix-Revalidate') !== null };
    }
    let x;
    return (
      (u = a.headers.get('Content-Type')) != null && u.startsWith('application/json')
        ? (x = await a.json())
        : (x = await a.text()),
      o === Qe.error
        ? { type: o, error: new Yi(f, a.statusText, x), headers: a.headers }
        : { type: Qe.data, data: x, statusCode: a.status, headers: a.headers }
    );
  }
  return o === Qe.error
    ? { type: o, error: a }
    : a instanceof q_
      ? { type: Qe.deferred, deferredData: a }
      : { type: Qe.data, data: a };
}
function xr(e, t, n) {
  let i = Kl(e).toString(),
    r = { signal: t };
  if (n) {
    let { formMethod: o, formEncType: a, formData: s } = n;
    (r.method = o.toUpperCase()), (r.body = a === 'application/x-www-form-urlencoded' ? Xf(s) : s);
  }
  return new Request(i, r);
}
function Xf(e) {
  let t = new URLSearchParams();
  for (let [n, i] of e.entries())
    re(
      typeof i == 'string',
      'File inputs are not supported with encType "application/x-www-form-urlencoded", please use "multipart/form-data" instead.',
    ),
      t.append(n, i);
  return t;
}
function Z_(e, t, n, i, r) {
  let o = {},
    a = null,
    s,
    l = !1,
    c = {};
  return (
    n.forEach((u, f) => {
      let h = t[f].route.id;
      if ((re(!Bi(u), 'Cannot handle redirect results in processLoaderData'), Rr(u))) {
        let x = Ri(e, h),
          y = u.error;
        i && ((y = Object.values(i)[0]), (i = void 0)),
          (a = Object.assign(a || {}, { [x.route.id]: y })),
          l || ((l = !0), (s = Kf(u.error) ? u.error.status : 500)),
          u.headers && (c[h] = u.headers);
      } else
        Wn(u)
          ? (r == null || r.set(h, u.deferredData), (o[h] = u.deferredData.data))
          : ((o[h] = u.data), u.statusCode !== 200 && !l && (s = u.statusCode), u.headers && (c[h] = u.headers));
    }),
    i && (a = i),
    { loaderData: o, errors: a, statusCode: s || 200, loaderHeaders: c }
  );
}
function np(e, t, n, i, r, o, a, s) {
  let { loaderData: l, errors: c } = Z_(t, n, i, r, s);
  for (let f = 0; f < o.length; f++) {
    let [h, , x] = o[f];
    re(a !== void 0 && a[f] !== void 0, 'Did not find corresponding fetcher result');
    let y = a[f];
    if (Rr(y)) {
      var u;
      let m = Ri(e.matches, x.route.id);
      ((u = c) != null && u[m.route.id]) || (c = ke({}, c, { [m.route.id]: y.error })), e.fetchers.delete(h);
    } else {
      if (Bi(y)) throw new Error('Unhandled fetcher revalidation redirect');
      if (Wn(y)) throw new Error('Unhandled fetcher deferred data');
      {
        let m = {
          state: 'idle',
          data: y.data,
          formMethod: void 0,
          formAction: void 0,
          formEncType: void 0,
          formData: void 0,
        };
        e.fetchers.set(h, m);
      }
    }
  }
  return { loaderData: l, errors: c };
}
function Vs(e, t, n) {
  let i = ke({}, t);
  return (
    n.forEach((r) => {
      let o = r.route.id;
      t[o] === void 0 && e[o] !== void 0 && (i[o] = e[o]);
    }),
    i
  );
}
function Ri(e, t) {
  return (
    (t ? e.slice(0, e.findIndex((i) => i.route.id === t) + 1) : [...e])
      .reverse()
      .find((i) => i.route.hasErrorBoundary === !0) || e[0]
  );
}
function ip(e) {
  let t = e.find((n) => n.index || n.path === '' || n.path === '/') || { id: '__shim-404-route__' };
  return {
    matches: [{ params: {}, pathname: '', pathnameBase: '', route: t }],
    route: t,
    error: new Yi(404, 'Not Found', null),
  };
}
function rp(e) {
  let t = typeof e == 'string' ? e : Ra(e);
  return (
    console.warn(
      "You're trying to submit to a route that does not have an action.  To fix this, please add an `action` function to the route for " +
        ('[' + t + ']'),
    ),
    { type: Qe.error, error: new Yi(405, 'Method Not Allowed', 'No action found for [' + t + ']') }
  );
}
function op(e) {
  for (let t = e.length - 1; t >= 0; t--) {
    let n = e[t];
    if (Bi(n)) return n;
  }
}
function Ra(e) {
  return (e.pathname || '') + (e.search || '');
}
function Y_(e, t) {
  return e.pathname === t.pathname && e.search === t.search && e.hash !== t.hash;
}
function Wn(e) {
  return e.type === Qe.deferred;
}
function Rr(e) {
  return e.type === Qe.error;
}
function Bi(e) {
  return (e == null ? void 0 : e.type) === Qe.redirect;
}
async function ap(e, t, n, i, r, o) {
  for (let a = 0; a < n.length; a++) {
    let s = n[a],
      l = t[a],
      c = e.find((f) => f.route.id === l.route.id),
      u = c != null && !Jf(c, l) && (o == null ? void 0 : o[l.route.id]) !== void 0;
    Wn(s) &&
      (r || u) &&
      (await Zf(s, i, r).then((f) => {
        f && (n[a] = f || n[a]);
      }));
  }
}
async function Zf(e, t, n) {
  if ((n === void 0 && (n = !1), !(await e.deferredData.resolveData(t)))) {
    if (n)
      try {
        return { type: Qe.data, data: e.deferredData.unwrappedData };
      } catch (r) {
        return { type: Qe.error, error: r };
      }
    return { type: Qe.data, data: e.deferredData.data };
  }
}
function e0(e) {
  return new URLSearchParams(e).getAll('index').some((t) => t === '');
}
function sp(e, t) {
  let { route: n, pathname: i, params: r } = e;
  return { id: n.id, pathname: i, params: r, data: t[n.id], handle: n.handle };
}
function lp(e, t) {
  let n = typeof t == 'string' ? ln(t).search : t.search;
  return e[e.length - 1].route.index && !e0(n || '') ? e.slice(-2)[0] : e.slice(-1)[0];
}
function Kl(e) {
  let t = typeof window < 'u' && typeof window.location < 'u' ? window.location.origin : 'unknown://unknown',
    n = typeof e == 'string' ? e : Ra(e);
  return new URL(n, t);
}
var Da = { exports: {} },
  Ha = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var t0 = B.exports,
  n0 = Symbol.for('react.element'),
  i0 = Symbol.for('react.fragment'),
  r0 = Object.prototype.hasOwnProperty,
  o0 = t0.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
  a0 = { key: !0, ref: !0, __self: !0, __source: !0 };
function Yf(e, t, n) {
  var i,
    r = {},
    o = null,
    a = null;
  n !== void 0 && (o = '' + n), t.key !== void 0 && (o = '' + t.key), t.ref !== void 0 && (a = t.ref);
  for (i in t) r0.call(t, i) && !a0.hasOwnProperty(i) && (r[i] = t[i]);
  if (e && e.defaultProps) for (i in ((t = e.defaultProps), t)) r[i] === void 0 && (r[i] = t[i]);
  return { $$typeof: n0, type: e, key: o, ref: a, props: r, _owner: o0.current };
}
Ha.Fragment = i0;
Ha.jsx = Yf;
Ha.jsxs = Yf;
(function (e) {
  e.exports = Ha;
})(Da);
const ri = Da.exports.Fragment,
  _ = Da.exports.jsx,
  W = Da.exports.jsxs;
/**
 * React Router v6.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function va() {
  return (
    (va = Object.assign
      ? Object.assign.bind()
      : function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
          }
          return e;
        }),
    va.apply(this, arguments)
  );
}
function s0(e, t) {
  return (e === t && (e !== 0 || 1 / e === 1 / t)) || (e !== e && t !== t);
}
const l0 = typeof Object.is == 'function' ? Object.is : s0,
  { useState: c0, useEffect: u0, useLayoutEffect: d0, useDebugValue: p0 } = tl;
function h0(e, t, n) {
  const i = t(),
    [{ inst: r }, o] = c0({ inst: { value: i, getSnapshot: t } });
  return (
    d0(() => {
      (r.value = i), (r.getSnapshot = t), Qs(r) && o({ inst: r });
    }, [e, i, t]),
    u0(
      () => (
        Qs(r) && o({ inst: r }),
        e(() => {
          Qs(r) && o({ inst: r });
        })
      ),
      [e],
    ),
    p0(i),
    i
  );
}
function Qs(e) {
  const t = e.getSnapshot,
    n = e.value;
  try {
    const i = t();
    return !l0(n, i);
  } catch {
    return !0;
  }
}
function f0(e, t, n) {
  return t();
}
const m0 = typeof window < 'u' && typeof window.document < 'u' && typeof window.document.createElement < 'u',
  g0 = !m0,
  v0 = g0 ? f0 : h0,
  _0 = 'useSyncExternalStore' in tl ? ((e) => e.useSyncExternalStore)(tl) : v0,
  x0 = B.exports.createContext(null),
  em = B.exports.createContext(null),
  iu = B.exports.createContext(null),
  tm = B.exports.createContext(null),
  Oa = B.exports.createContext(null),
  io = B.exports.createContext({ outlet: null, matches: [] }),
  nm = B.exports.createContext(null);
function ja() {
  return B.exports.useContext(Oa) != null;
}
function im() {
  return ja() || re(!1), B.exports.useContext(Oa).location;
}
function y0(e) {
  return e.filter((t, n) => n === 0 || (!t.route.index && t.pathnameBase !== e[n - 1].pathnameBase));
}
function E0() {
  ja() || re(!1);
  let { basename: e, navigator: t } = B.exports.useContext(tm),
    { matches: n } = B.exports.useContext(io),
    { pathname: i } = im(),
    r = JSON.stringify(y0(n).map((s) => s.pathnameBase)),
    o = B.exports.useRef(!1);
  return (
    B.exports.useEffect(() => {
      o.current = !0;
    }),
    B.exports.useCallback(
      function (s, l) {
        if ((l === void 0 && (l = {}), !o.current)) return;
        if (typeof s == 'number') {
          t.go(s);
          return;
        }
        let c = B_(s, JSON.parse(r), i, l.relative === 'path');
        e !== '/' && (c.pathname = c.pathname === '/' ? e : Zn([e, c.pathname])),
          (l.replace ? t.replace : t.push)(c, l.state, l);
      },
      [e, t, r, i],
    )
  );
}
function k0() {
  let { matches: e } = B.exports.useContext(io),
    t = e[e.length - 1];
  return t ? t.params : {};
}
function S0(e, t) {
  ja() || re(!1);
  let n = B.exports.useContext(iu),
    { matches: i } = B.exports.useContext(io),
    r = i[i.length - 1],
    o = r ? r.params : {};
  r && r.pathname;
  let a = r ? r.pathnameBase : '/';
  r && r.route;
  let s = im(),
    l;
  if (t) {
    var c;
    let y = typeof t == 'string' ? ln(t) : t;
    a === '/' || ((c = y.pathname) == null ? void 0 : c.startsWith(a)) || re(!1), (l = y);
  } else l = s;
  let u = l.pathname || '/',
    f = a === '/' ? u : u.slice(a.length) || '/',
    h = Ar(e, { pathname: f }),
    x = P0(
      h &&
        h.map((y) =>
          Object.assign({}, y, {
            params: Object.assign({}, o, y.params),
            pathname: Zn([a, y.pathname]),
            pathnameBase: y.pathnameBase === '/' ? a : Zn([a, y.pathnameBase]),
          }),
        ),
      i,
      n || void 0,
    );
  return t
    ? _(Oa.Provider, {
        value: {
          location: va({ pathname: '/', search: '', hash: '', state: null, key: 'default' }, l),
          navigationType: we.Pop,
        },
        children: x,
      })
    : x;
}
function A0() {
  let e = C0(),
    t = Kf(e) ? e.status + ' ' + e.statusText : e instanceof Error ? e.message : JSON.stringify(e),
    n = e instanceof Error ? e.stack : null,
    i = 'rgba(200,200,200, 0.5)',
    r = { padding: '0.5rem', backgroundColor: i },
    o = { padding: '2px 4px', backgroundColor: i };
  return W(ri, {
    children: [
      _('h2', { children: 'Unhandled Thrown Error!' }),
      _('h3', { style: { fontStyle: 'italic' }, children: t }),
      n ? _('pre', { style: r, children: n }) : null,
      _('p', { children: '\u{1F4BF} Hey developer \u{1F44B}' }),
      W('p', {
        children: [
          'You can provide a way better UX than this when your app throws errors by providing your own\xA0',
          _('code', { style: o, children: 'errorElement' }),
          ' props on\xA0',
          _('code', { style: o, children: '<Route>' }),
        ],
      }),
    ],
  });
}
class w0 extends B.exports.Component {
  constructor(t) {
    super(t), (this.state = { location: t.location, error: t.error });
  }
  static getDerivedStateFromError(t) {
    return { error: t };
  }
  static getDerivedStateFromProps(t, n) {
    return n.location !== t.location
      ? { error: t.error, location: t.location }
      : { error: t.error || n.error, location: n.location };
  }
  componentDidCatch(t, n) {
    console.error('React Router caught the following error during render', t, n);
  }
  render() {
    return this.state.error
      ? _(nm.Provider, { value: this.state.error, children: this.props.component })
      : this.props.children;
  }
}
function M0(e) {
  let { routeContext: t, match: n, children: i } = e,
    r = B.exports.useContext(x0);
  return (
    r && n.route.errorElement && (r._deepestRenderedBoundaryId = n.route.id), _(io.Provider, { value: t, children: i })
  );
}
function P0(e, t, n) {
  if ((t === void 0 && (t = []), e == null))
    if (n != null && n.errors) e = n.matches;
    else return null;
  let i = e,
    r = n == null ? void 0 : n.errors;
  if (r != null) {
    let o = i.findIndex((a) => a.route.id && (r == null ? void 0 : r[a.route.id]));
    o >= 0 || re(!1), (i = i.slice(0, Math.min(i.length, o + 1)));
  }
  return i.reduceRight((o, a, s) => {
    let l = a.route.id ? (r == null ? void 0 : r[a.route.id]) : null,
      c = n ? a.route.errorElement || _(A0, {}) : null,
      u = () =>
        _(M0, {
          match: a,
          routeContext: { outlet: o, matches: t.concat(i.slice(0, s + 1)) },
          children: l ? c : a.route.element !== void 0 ? a.route.element : o,
        });
    return n && (a.route.errorElement || s === 0)
      ? _(w0, { location: n.location, component: c, error: l, children: u() })
      : u();
  }, null);
}
var Jl;
(function (e) {
  (e.UseLoaderData = 'useLoaderData'),
    (e.UseActionData = 'useActionData'),
    (e.UseRouteError = 'useRouteError'),
    (e.UseNavigation = 'useNavigation'),
    (e.UseRouteLoaderData = 'useRouteLoaderData'),
    (e.UseMatches = 'useMatches'),
    (e.UseRevalidator = 'useRevalidator');
})(Jl || (Jl = {}));
function T0(e) {
  let t = B.exports.useContext(iu);
  return t || re(!1), t;
}
function C0() {
  var e;
  let t = B.exports.useContext(nm),
    n = T0(Jl.UseRouteError),
    i = B.exports.useContext(io),
    r = i.matches[i.matches.length - 1];
  return t || (i || re(!1), r.route.id || re(!1), (e = n.errors) == null ? void 0 : e[r.route.id]);
}
function b0(e) {
  let { fallbackElement: t, router: n } = e,
    i = _0(
      n.subscribe,
      () => n.state,
      () => n.state,
    ),
    r = B.exports.useMemo(
      () => ({
        createHref: n.createHref,
        go: (a) => n.navigate(a),
        push: (a, s, l) => n.navigate(a, { state: s, preventScrollReset: l == null ? void 0 : l.preventScrollReset }),
        replace: (a, s, l) =>
          n.navigate(a, { replace: !0, state: s, preventScrollReset: l == null ? void 0 : l.preventScrollReset }),
      }),
      [n],
    ),
    o = n.basename || '/';
  return _(em.Provider, {
    value: { router: n, navigator: r, static: !1, basename: o },
    children: _(iu.Provider, {
      value: i,
      children: _(L0, {
        basename: n.basename,
        location: n.state.location,
        navigationType: n.state.historyAction,
        navigator: r,
        children: n.state.initialized ? _(N0, {}) : t,
      }),
    }),
  });
}
function I0(e) {
  re(!1);
}
function L0(e) {
  let {
    basename: t = '/',
    children: n = null,
    location: i,
    navigationType: r = we.Pop,
    navigator: o,
    static: a = !1,
  } = e;
  ja() && re(!1);
  let s = t.replace(/^\/*/, '/'),
    l = B.exports.useMemo(() => ({ basename: s, navigator: o, static: a }), [s, o, a]);
  typeof i == 'string' && (i = ln(i));
  let { pathname: c = '/', search: u = '', hash: f = '', state: h = null, key: x = 'default' } = i,
    y = B.exports.useMemo(() => {
      let m = Qf(c, s);
      return m == null ? null : { pathname: m, search: u, hash: f, state: h, key: x };
    }, [s, c, u, f, h, x]);
  return y == null
    ? null
    : _(tm.Provider, {
        value: l,
        children: _(Oa.Provider, { children: n, value: { location: y, navigationType: r } }),
      });
}
function N0(e) {
  let { children: t, location: n } = e,
    i = B.exports.useContext(em),
    r = i && !t ? i.router.routes : Xl(t);
  return S0(r, n);
}
var cp;
(function (e) {
  (e[(e.pending = 0)] = 'pending'), (e[(e.success = 1)] = 'success'), (e[(e.error = 2)] = 'error');
})(cp || (cp = {}));
new Promise(() => {});
function Xl(e, t) {
  t === void 0 && (t = []);
  let n = [];
  return (
    B.exports.Children.forEach(e, (i, r) => {
      if (!B.exports.isValidElement(i)) return;
      if (i.type === B.exports.Fragment) {
        n.push.apply(n, Xl(i.props.children, t));
        return;
      }
      i.type !== I0 && re(!1);
      let o = [...t, r],
        a = {
          id: i.props.id || o.join('-'),
          caseSensitive: i.props.caseSensitive,
          element: i.props.element,
          index: i.props.index,
          path: i.props.path,
          loader: i.props.loader,
          action: i.props.action,
          errorElement: i.props.errorElement,
          hasErrorBoundary: i.props.errorElement != null,
          shouldRevalidate: i.props.shouldRevalidate,
          handle: i.props.handle,
        };
      i.props.children && (a.children = Xl(i.props.children, o)), n.push(a);
    }),
    n
  );
}
function rm(e) {
  return e.map((t) => {
    let n = va({}, t);
    return (
      n.hasErrorBoundary == null && (n.hasErrorBoundary = n.errorElement != null),
      n.children && (n.children = rm(n.children)),
      n
    );
  });
}
/**
 * React Router DOM v6.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function R0(e, t) {
  var n;
  return K_({
    basename: t == null ? void 0 : t.basename,
    history: S_({ window: t == null ? void 0 : t.window }),
    hydrationData:
      (t == null ? void 0 : t.hydrationData) || ((n = window) == null ? void 0 : n.__staticRouterHydrationData),
    routes: rm(e),
  }).initialize();
}
var Zl = function (e, t) {
  return (
    (Zl =
      Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array &&
        function (n, i) {
          n.__proto__ = i;
        }) ||
      function (n, i) {
        for (var r in i) Object.prototype.hasOwnProperty.call(i, r) && (n[r] = i[r]);
      }),
    Zl(e, t)
  );
};
function Tt(e, t) {
  if (typeof t != 'function' && t !== null)
    throw new TypeError('Class extends value ' + String(t) + ' is not a constructor or null');
  Zl(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : ((n.prototype = t.prototype), new n());
}
var F = function () {
  return (
    (F =
      Object.assign ||
      function (t) {
        for (var n, i = 1, r = arguments.length; i < r; i++) {
          n = arguments[i];
          for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
        }
        return t;
      }),
    F.apply(this, arguments)
  );
};
function ru(e, t) {
  var n = {};
  for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == 'function')
    for (var r = 0, i = Object.getOwnPropertySymbols(e); r < i.length; r++)
      t.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[r]) && (n[i[r]] = e[i[r]]);
  return n;
}
function Gt(e, t, n) {
  if (n || arguments.length === 2)
    for (var i = 0, r = t.length, o; i < r; i++)
      (o || !(i in t)) && (o || (o = Array.prototype.slice.call(t, 0, i)), (o[i] = t[i]));
  return e.concat(o || Array.prototype.slice.call(t));
}
var om = { exports: {} },
  ae = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var Re = typeof Symbol == 'function' && Symbol.for,
  ou = Re ? Symbol.for('react.element') : 60103,
  au = Re ? Symbol.for('react.portal') : 60106,
  Fa = Re ? Symbol.for('react.fragment') : 60107,
  za = Re ? Symbol.for('react.strict_mode') : 60108,
  Ba = Re ? Symbol.for('react.profiler') : 60114,
  Ua = Re ? Symbol.for('react.provider') : 60109,
  Ga = Re ? Symbol.for('react.context') : 60110,
  su = Re ? Symbol.for('react.async_mode') : 60111,
  $a = Re ? Symbol.for('react.concurrent_mode') : 60111,
  qa = Re ? Symbol.for('react.forward_ref') : 60112,
  Va = Re ? Symbol.for('react.suspense') : 60113,
  D0 = Re ? Symbol.for('react.suspense_list') : 60120,
  Qa = Re ? Symbol.for('react.memo') : 60115,
  Wa = Re ? Symbol.for('react.lazy') : 60116,
  H0 = Re ? Symbol.for('react.block') : 60121,
  O0 = Re ? Symbol.for('react.fundamental') : 60117,
  j0 = Re ? Symbol.for('react.responder') : 60118,
  F0 = Re ? Symbol.for('react.scope') : 60119;
function yt(e) {
  if (typeof e == 'object' && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case ou:
        switch (((e = e.type), e)) {
          case su:
          case $a:
          case Fa:
          case Ba:
          case za:
          case Va:
            return e;
          default:
            switch (((e = e && e.$$typeof), e)) {
              case Ga:
              case qa:
              case Wa:
              case Qa:
              case Ua:
                return e;
              default:
                return t;
            }
        }
      case au:
        return t;
    }
  }
}
function am(e) {
  return yt(e) === $a;
}
ae.AsyncMode = su;
ae.ConcurrentMode = $a;
ae.ContextConsumer = Ga;
ae.ContextProvider = Ua;
ae.Element = ou;
ae.ForwardRef = qa;
ae.Fragment = Fa;
ae.Lazy = Wa;
ae.Memo = Qa;
ae.Portal = au;
ae.Profiler = Ba;
ae.StrictMode = za;
ae.Suspense = Va;
ae.isAsyncMode = function (e) {
  return am(e) || yt(e) === su;
};
ae.isConcurrentMode = am;
ae.isContextConsumer = function (e) {
  return yt(e) === Ga;
};
ae.isContextProvider = function (e) {
  return yt(e) === Ua;
};
ae.isElement = function (e) {
  return typeof e == 'object' && e !== null && e.$$typeof === ou;
};
ae.isForwardRef = function (e) {
  return yt(e) === qa;
};
ae.isFragment = function (e) {
  return yt(e) === Fa;
};
ae.isLazy = function (e) {
  return yt(e) === Wa;
};
ae.isMemo = function (e) {
  return yt(e) === Qa;
};
ae.isPortal = function (e) {
  return yt(e) === au;
};
ae.isProfiler = function (e) {
  return yt(e) === Ba;
};
ae.isStrictMode = function (e) {
  return yt(e) === za;
};
ae.isSuspense = function (e) {
  return yt(e) === Va;
};
ae.isValidElementType = function (e) {
  return (
    typeof e == 'string' ||
    typeof e == 'function' ||
    e === Fa ||
    e === $a ||
    e === Ba ||
    e === za ||
    e === Va ||
    e === D0 ||
    (typeof e == 'object' &&
      e !== null &&
      (e.$$typeof === Wa ||
        e.$$typeof === Qa ||
        e.$$typeof === Ua ||
        e.$$typeof === Ga ||
        e.$$typeof === qa ||
        e.$$typeof === O0 ||
        e.$$typeof === j0 ||
        e.$$typeof === F0 ||
        e.$$typeof === H0))
  );
};
ae.typeOf = yt;
(function (e) {
  e.exports = ae;
})(om);
var lu = om.exports,
  z0 = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0,
  },
  B0 = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 },
  U0 = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 },
  sm = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 },
  cu = {};
cu[lu.ForwardRef] = U0;
cu[lu.Memo] = sm;
function up(e) {
  return lu.isMemo(e) ? sm : cu[e.$$typeof] || z0;
}
var G0 = Object.defineProperty,
  $0 = Object.getOwnPropertyNames,
  dp = Object.getOwnPropertySymbols,
  q0 = Object.getOwnPropertyDescriptor,
  V0 = Object.getPrototypeOf,
  pp = Object.prototype;
function lm(e, t, n) {
  if (typeof t != 'string') {
    if (pp) {
      var i = V0(t);
      i && i !== pp && lm(e, i, n);
    }
    var r = $0(t);
    dp && (r = r.concat(dp(t)));
    for (var o = up(e), a = up(t), s = 0; s < r.length; ++s) {
      var l = r[s];
      if (!B0[l] && !(n && n[l]) && !(a && a[l]) && !(o && o[l])) {
        var c = q0(t, l);
        try {
          G0(e, l, c);
        } catch {}
      }
    }
  }
  return e;
}
var Q0 = lm;
const hp = Q0;
function cm(e, t, n) {
  if ((n === void 0 && (n = Error), !e)) throw new n(t);
}
var J;
(function (e) {
  (e[(e.EXPECT_ARGUMENT_CLOSING_BRACE = 1)] = 'EXPECT_ARGUMENT_CLOSING_BRACE'),
    (e[(e.EMPTY_ARGUMENT = 2)] = 'EMPTY_ARGUMENT'),
    (e[(e.MALFORMED_ARGUMENT = 3)] = 'MALFORMED_ARGUMENT'),
    (e[(e.EXPECT_ARGUMENT_TYPE = 4)] = 'EXPECT_ARGUMENT_TYPE'),
    (e[(e.INVALID_ARGUMENT_TYPE = 5)] = 'INVALID_ARGUMENT_TYPE'),
    (e[(e.EXPECT_ARGUMENT_STYLE = 6)] = 'EXPECT_ARGUMENT_STYLE'),
    (e[(e.INVALID_NUMBER_SKELETON = 7)] = 'INVALID_NUMBER_SKELETON'),
    (e[(e.INVALID_DATE_TIME_SKELETON = 8)] = 'INVALID_DATE_TIME_SKELETON'),
    (e[(e.EXPECT_NUMBER_SKELETON = 9)] = 'EXPECT_NUMBER_SKELETON'),
    (e[(e.EXPECT_DATE_TIME_SKELETON = 10)] = 'EXPECT_DATE_TIME_SKELETON'),
    (e[(e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11)] = 'UNCLOSED_QUOTE_IN_ARGUMENT_STYLE'),
    (e[(e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12)] = 'EXPECT_SELECT_ARGUMENT_OPTIONS'),
    (e[(e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13)] = 'EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE'),
    (e[(e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14)] = 'INVALID_PLURAL_ARGUMENT_OFFSET_VALUE'),
    (e[(e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15)] = 'EXPECT_SELECT_ARGUMENT_SELECTOR'),
    (e[(e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16)] = 'EXPECT_PLURAL_ARGUMENT_SELECTOR'),
    (e[(e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17)] = 'EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT'),
    (e[(e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18)] = 'EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT'),
    (e[(e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19)] = 'INVALID_PLURAL_ARGUMENT_SELECTOR'),
    (e[(e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20)] = 'DUPLICATE_PLURAL_ARGUMENT_SELECTOR'),
    (e[(e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21)] = 'DUPLICATE_SELECT_ARGUMENT_SELECTOR'),
    (e[(e.MISSING_OTHER_CLAUSE = 22)] = 'MISSING_OTHER_CLAUSE'),
    (e[(e.INVALID_TAG = 23)] = 'INVALID_TAG'),
    (e[(e.INVALID_TAG_NAME = 25)] = 'INVALID_TAG_NAME'),
    (e[(e.UNMATCHED_CLOSING_TAG = 26)] = 'UNMATCHED_CLOSING_TAG'),
    (e[(e.UNCLOSED_TAG = 27)] = 'UNCLOSED_TAG');
})(J || (J = {}));
var ue;
(function (e) {
  (e[(e.literal = 0)] = 'literal'),
    (e[(e.argument = 1)] = 'argument'),
    (e[(e.number = 2)] = 'number'),
    (e[(e.date = 3)] = 'date'),
    (e[(e.time = 4)] = 'time'),
    (e[(e.select = 5)] = 'select'),
    (e[(e.plural = 6)] = 'plural'),
    (e[(e.pound = 7)] = 'pound'),
    (e[(e.tag = 8)] = 'tag');
})(ue || (ue = {}));
var Ki;
(function (e) {
  (e[(e.number = 0)] = 'number'), (e[(e.dateTime = 1)] = 'dateTime');
})(Ki || (Ki = {}));
function fp(e) {
  return e.type === ue.literal;
}
function W0(e) {
  return e.type === ue.argument;
}
function um(e) {
  return e.type === ue.number;
}
function dm(e) {
  return e.type === ue.date;
}
function pm(e) {
  return e.type === ue.time;
}
function hm(e) {
  return e.type === ue.select;
}
function fm(e) {
  return e.type === ue.plural;
}
function K0(e) {
  return e.type === ue.pound;
}
function mm(e) {
  return e.type === ue.tag;
}
function gm(e) {
  return !!(e && typeof e == 'object' && e.type === Ki.number);
}
function Yl(e) {
  return !!(e && typeof e == 'object' && e.type === Ki.dateTime);
}
var vm = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/,
  J0 =
    /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function X0(e) {
  var t = {};
  return (
    e.replace(J0, function (n) {
      var i = n.length;
      switch (n[0]) {
        case 'G':
          t.era = i === 4 ? 'long' : i === 5 ? 'narrow' : 'short';
          break;
        case 'y':
          t.year = i === 2 ? '2-digit' : 'numeric';
          break;
        case 'Y':
        case 'u':
        case 'U':
        case 'r':
          throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
        case 'q':
        case 'Q':
          throw new RangeError('`q/Q` (quarter) patterns are not supported');
        case 'M':
        case 'L':
          t.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][i - 1];
          break;
        case 'w':
        case 'W':
          throw new RangeError('`w/W` (week) patterns are not supported');
        case 'd':
          t.day = ['numeric', '2-digit'][i - 1];
          break;
        case 'D':
        case 'F':
        case 'g':
          throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
        case 'E':
          t.weekday = i === 4 ? 'short' : i === 5 ? 'narrow' : 'short';
          break;
        case 'e':
          if (i < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
          t.weekday = ['short', 'long', 'narrow', 'short'][i - 4];
          break;
        case 'c':
          if (i < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
          t.weekday = ['short', 'long', 'narrow', 'short'][i - 4];
          break;
        case 'a':
          t.hour12 = !0;
          break;
        case 'b':
        case 'B':
          throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
        case 'h':
          (t.hourCycle = 'h12'), (t.hour = ['numeric', '2-digit'][i - 1]);
          break;
        case 'H':
          (t.hourCycle = 'h23'), (t.hour = ['numeric', '2-digit'][i - 1]);
          break;
        case 'K':
          (t.hourCycle = 'h11'), (t.hour = ['numeric', '2-digit'][i - 1]);
          break;
        case 'k':
          (t.hourCycle = 'h24'), (t.hour = ['numeric', '2-digit'][i - 1]);
          break;
        case 'j':
        case 'J':
        case 'C':
          throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
        case 'm':
          t.minute = ['numeric', '2-digit'][i - 1];
          break;
        case 's':
          t.second = ['numeric', '2-digit'][i - 1];
          break;
        case 'S':
        case 'A':
          throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
        case 'z':
          t.timeZoneName = i < 4 ? 'short' : 'long';
          break;
        case 'Z':
        case 'O':
        case 'v':
        case 'V':
        case 'X':
        case 'x':
          throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
      }
      return '';
    }),
    t
  );
}
var Z0 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function Y0(e) {
  if (e.length === 0) throw new Error('Number skeleton cannot be empty');
  for (
    var t = e.split(Z0).filter(function (h) {
        return h.length > 0;
      }),
      n = [],
      i = 0,
      r = t;
    i < r.length;
    i++
  ) {
    var o = r[i],
      a = o.split('/');
    if (a.length === 0) throw new Error('Invalid number skeleton');
    for (var s = a[0], l = a.slice(1), c = 0, u = l; c < u.length; c++) {
      var f = u[c];
      if (f.length === 0) throw new Error('Invalid number skeleton');
    }
    n.push({ stem: s, options: l });
  }
  return n;
}
function ex(e) {
  return e.replace(/^(.*?)-/, '');
}
var mp = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g,
  _m = /^(@+)?(\+|#+)?[rs]?$/g,
  tx = /(\*)(0+)|(#+)(0+)|(0+)/g,
  xm = /^(0+)$/;
function gp(e) {
  var t = {};
  return (
    e[e.length - 1] === 'r'
      ? (t.roundingPriority = 'morePrecision')
      : e[e.length - 1] === 's' && (t.roundingPriority = 'lessPrecision'),
    e.replace(_m, function (n, i, r) {
      return (
        typeof r != 'string'
          ? ((t.minimumSignificantDigits = i.length), (t.maximumSignificantDigits = i.length))
          : r === '+'
            ? (t.minimumSignificantDigits = i.length)
            : i[0] === '#'
              ? (t.maximumSignificantDigits = i.length)
              : ((t.minimumSignificantDigits = i.length),
                (t.maximumSignificantDigits = i.length + (typeof r == 'string' ? r.length : 0))),
        ''
      );
    }),
    t
  );
}
function ym(e) {
  switch (e) {
    case 'sign-auto':
      return { signDisplay: 'auto' };
    case 'sign-accounting':
    case '()':
      return { currencySign: 'accounting' };
    case 'sign-always':
    case '+!':
      return { signDisplay: 'always' };
    case 'sign-accounting-always':
    case '()!':
      return { signDisplay: 'always', currencySign: 'accounting' };
    case 'sign-except-zero':
    case '+?':
      return { signDisplay: 'exceptZero' };
    case 'sign-accounting-except-zero':
    case '()?':
      return { signDisplay: 'exceptZero', currencySign: 'accounting' };
    case 'sign-never':
    case '+_':
      return { signDisplay: 'never' };
  }
}
function nx(e) {
  var t;
  if (
    (e[0] === 'E' && e[1] === 'E'
      ? ((t = { notation: 'engineering' }), (e = e.slice(2)))
      : e[0] === 'E' && ((t = { notation: 'scientific' }), (e = e.slice(1))),
    t)
  ) {
    var n = e.slice(0, 2);
    if (
      (n === '+!'
        ? ((t.signDisplay = 'always'), (e = e.slice(2)))
        : n === '+?' && ((t.signDisplay = 'exceptZero'), (e = e.slice(2))),
      !xm.test(e))
    )
      throw new Error('Malformed concise eng/scientific notation');
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function vp(e) {
  var t = {},
    n = ym(e);
  return n || t;
}
function ix(e) {
  for (var t = {}, n = 0, i = e; n < i.length; n++) {
    var r = i[n];
    switch (r.stem) {
      case 'percent':
      case '%':
        t.style = 'percent';
        continue;
      case '%x100':
        (t.style = 'percent'), (t.scale = 100);
        continue;
      case 'currency':
        (t.style = 'currency'), (t.currency = r.options[0]);
        continue;
      case 'group-off':
      case ',_':
        t.useGrouping = !1;
        continue;
      case 'precision-integer':
      case '.':
        t.maximumFractionDigits = 0;
        continue;
      case 'measure-unit':
      case 'unit':
        (t.style = 'unit'), (t.unit = ex(r.options[0]));
        continue;
      case 'compact-short':
      case 'K':
        (t.notation = 'compact'), (t.compactDisplay = 'short');
        continue;
      case 'compact-long':
      case 'KK':
        (t.notation = 'compact'), (t.compactDisplay = 'long');
        continue;
      case 'scientific':
        t = F(
          F(F({}, t), { notation: 'scientific' }),
          r.options.reduce(function (l, c) {
            return F(F({}, l), vp(c));
          }, {}),
        );
        continue;
      case 'engineering':
        t = F(
          F(F({}, t), { notation: 'engineering' }),
          r.options.reduce(function (l, c) {
            return F(F({}, l), vp(c));
          }, {}),
        );
        continue;
      case 'notation-simple':
        t.notation = 'standard';
        continue;
      case 'unit-width-narrow':
        (t.currencyDisplay = 'narrowSymbol'), (t.unitDisplay = 'narrow');
        continue;
      case 'unit-width-short':
        (t.currencyDisplay = 'code'), (t.unitDisplay = 'short');
        continue;
      case 'unit-width-full-name':
        (t.currencyDisplay = 'name'), (t.unitDisplay = 'long');
        continue;
      case 'unit-width-iso-code':
        t.currencyDisplay = 'symbol';
        continue;
      case 'scale':
        t.scale = parseFloat(r.options[0]);
        continue;
      case 'integer-width':
        if (r.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
        r.options[0].replace(tx, function (l, c, u, f, h, x) {
          if (c) t.minimumIntegerDigits = u.length;
          else {
            if (f && h) throw new Error('We currently do not support maximum integer digits');
            if (x) throw new Error('We currently do not support exact integer digits');
          }
          return '';
        });
        continue;
    }
    if (xm.test(r.stem)) {
      t.minimumIntegerDigits = r.stem.length;
      continue;
    }
    if (mp.test(r.stem)) {
      if (r.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
      r.stem.replace(mp, function (l, c, u, f, h, x) {
        return (
          u === '*'
            ? (t.minimumFractionDigits = c.length)
            : f && f[0] === '#'
              ? (t.maximumFractionDigits = f.length)
              : h && x
                ? ((t.minimumFractionDigits = h.length), (t.maximumFractionDigits = h.length + x.length))
                : ((t.minimumFractionDigits = c.length), (t.maximumFractionDigits = c.length)),
          ''
        );
      });
      var o = r.options[0];
      o === 'w' ? (t = F(F({}, t), { trailingZeroDisplay: 'stripIfInteger' })) : o && (t = F(F({}, t), gp(o)));
      continue;
    }
    if (_m.test(r.stem)) {
      t = F(F({}, t), gp(r.stem));
      continue;
    }
    var a = ym(r.stem);
    a && (t = F(F({}, t), a));
    var s = nx(r.stem);
    s && (t = F(F({}, t), s));
  }
  return t;
}
var Lo = {
  AX: ['H'],
  BQ: ['H'],
  CP: ['H'],
  CZ: ['H'],
  DK: ['H'],
  FI: ['H'],
  ID: ['H'],
  IS: ['H'],
  ML: ['H'],
  NE: ['H'],
  RU: ['H'],
  SE: ['H'],
  SJ: ['H'],
  SK: ['H'],
  AS: ['h', 'H'],
  BT: ['h', 'H'],
  DJ: ['h', 'H'],
  ER: ['h', 'H'],
  GH: ['h', 'H'],
  IN: ['h', 'H'],
  LS: ['h', 'H'],
  PG: ['h', 'H'],
  PW: ['h', 'H'],
  SO: ['h', 'H'],
  TO: ['h', 'H'],
  VU: ['h', 'H'],
  WS: ['h', 'H'],
  '001': ['H', 'h'],
  AL: ['h', 'H', 'hB'],
  TD: ['h', 'H', 'hB'],
  'ca-ES': ['H', 'h', 'hB'],
  CF: ['H', 'h', 'hB'],
  CM: ['H', 'h', 'hB'],
  'fr-CA': ['H', 'h', 'hB'],
  'gl-ES': ['H', 'h', 'hB'],
  'it-CH': ['H', 'h', 'hB'],
  'it-IT': ['H', 'h', 'hB'],
  LU: ['H', 'h', 'hB'],
  NP: ['H', 'h', 'hB'],
  PF: ['H', 'h', 'hB'],
  SC: ['H', 'h', 'hB'],
  SM: ['H', 'h', 'hB'],
  SN: ['H', 'h', 'hB'],
  TF: ['H', 'h', 'hB'],
  VA: ['H', 'h', 'hB'],
  CY: ['h', 'H', 'hb', 'hB'],
  GR: ['h', 'H', 'hb', 'hB'],
  CO: ['h', 'H', 'hB', 'hb'],
  DO: ['h', 'H', 'hB', 'hb'],
  KP: ['h', 'H', 'hB', 'hb'],
  KR: ['h', 'H', 'hB', 'hb'],
  NA: ['h', 'H', 'hB', 'hb'],
  PA: ['h', 'H', 'hB', 'hb'],
  PR: ['h', 'H', 'hB', 'hb'],
  VE: ['h', 'H', 'hB', 'hb'],
  AC: ['H', 'h', 'hb', 'hB'],
  AI: ['H', 'h', 'hb', 'hB'],
  BW: ['H', 'h', 'hb', 'hB'],
  BZ: ['H', 'h', 'hb', 'hB'],
  CC: ['H', 'h', 'hb', 'hB'],
  CK: ['H', 'h', 'hb', 'hB'],
  CX: ['H', 'h', 'hb', 'hB'],
  DG: ['H', 'h', 'hb', 'hB'],
  FK: ['H', 'h', 'hb', 'hB'],
  GB: ['H', 'h', 'hb', 'hB'],
  GG: ['H', 'h', 'hb', 'hB'],
  GI: ['H', 'h', 'hb', 'hB'],
  IE: ['H', 'h', 'hb', 'hB'],
  IM: ['H', 'h', 'hb', 'hB'],
  IO: ['H', 'h', 'hb', 'hB'],
  JE: ['H', 'h', 'hb', 'hB'],
  LT: ['H', 'h', 'hb', 'hB'],
  MK: ['H', 'h', 'hb', 'hB'],
  MN: ['H', 'h', 'hb', 'hB'],
  MS: ['H', 'h', 'hb', 'hB'],
  NF: ['H', 'h', 'hb', 'hB'],
  NG: ['H', 'h', 'hb', 'hB'],
  NR: ['H', 'h', 'hb', 'hB'],
  NU: ['H', 'h', 'hb', 'hB'],
  PN: ['H', 'h', 'hb', 'hB'],
  SH: ['H', 'h', 'hb', 'hB'],
  SX: ['H', 'h', 'hb', 'hB'],
  TA: ['H', 'h', 'hb', 'hB'],
  ZA: ['H', 'h', 'hb', 'hB'],
  'af-ZA': ['H', 'h', 'hB', 'hb'],
  AR: ['H', 'h', 'hB', 'hb'],
  CL: ['H', 'h', 'hB', 'hb'],
  CR: ['H', 'h', 'hB', 'hb'],
  CU: ['H', 'h', 'hB', 'hb'],
  EA: ['H', 'h', 'hB', 'hb'],
  'es-BO': ['H', 'h', 'hB', 'hb'],
  'es-BR': ['H', 'h', 'hB', 'hb'],
  'es-EC': ['H', 'h', 'hB', 'hb'],
  'es-ES': ['H', 'h', 'hB', 'hb'],
  'es-GQ': ['H', 'h', 'hB', 'hb'],
  'es-PE': ['H', 'h', 'hB', 'hb'],
  GT: ['H', 'h', 'hB', 'hb'],
  HN: ['H', 'h', 'hB', 'hb'],
  IC: ['H', 'h', 'hB', 'hb'],
  KG: ['H', 'h', 'hB', 'hb'],
  KM: ['H', 'h', 'hB', 'hb'],
  LK: ['H', 'h', 'hB', 'hb'],
  MA: ['H', 'h', 'hB', 'hb'],
  MX: ['H', 'h', 'hB', 'hb'],
  NI: ['H', 'h', 'hB', 'hb'],
  PY: ['H', 'h', 'hB', 'hb'],
  SV: ['H', 'h', 'hB', 'hb'],
  UY: ['H', 'h', 'hB', 'hb'],
  JP: ['H', 'h', 'K'],
  AD: ['H', 'hB'],
  AM: ['H', 'hB'],
  AO: ['H', 'hB'],
  AT: ['H', 'hB'],
  AW: ['H', 'hB'],
  BE: ['H', 'hB'],
  BF: ['H', 'hB'],
  BJ: ['H', 'hB'],
  BL: ['H', 'hB'],
  BR: ['H', 'hB'],
  CG: ['H', 'hB'],
  CI: ['H', 'hB'],
  CV: ['H', 'hB'],
  DE: ['H', 'hB'],
  EE: ['H', 'hB'],
  FR: ['H', 'hB'],
  GA: ['H', 'hB'],
  GF: ['H', 'hB'],
  GN: ['H', 'hB'],
  GP: ['H', 'hB'],
  GW: ['H', 'hB'],
  HR: ['H', 'hB'],
  IL: ['H', 'hB'],
  IT: ['H', 'hB'],
  KZ: ['H', 'hB'],
  MC: ['H', 'hB'],
  MD: ['H', 'hB'],
  MF: ['H', 'hB'],
  MQ: ['H', 'hB'],
  MZ: ['H', 'hB'],
  NC: ['H', 'hB'],
  NL: ['H', 'hB'],
  PM: ['H', 'hB'],
  PT: ['H', 'hB'],
  RE: ['H', 'hB'],
  RO: ['H', 'hB'],
  SI: ['H', 'hB'],
  SR: ['H', 'hB'],
  ST: ['H', 'hB'],
  TG: ['H', 'hB'],
  TR: ['H', 'hB'],
  WF: ['H', 'hB'],
  YT: ['H', 'hB'],
  BD: ['h', 'hB', 'H'],
  PK: ['h', 'hB', 'H'],
  AZ: ['H', 'hB', 'h'],
  BA: ['H', 'hB', 'h'],
  BG: ['H', 'hB', 'h'],
  CH: ['H', 'hB', 'h'],
  GE: ['H', 'hB', 'h'],
  LI: ['H', 'hB', 'h'],
  ME: ['H', 'hB', 'h'],
  RS: ['H', 'hB', 'h'],
  UA: ['H', 'hB', 'h'],
  UZ: ['H', 'hB', 'h'],
  XK: ['H', 'hB', 'h'],
  AG: ['h', 'hb', 'H', 'hB'],
  AU: ['h', 'hb', 'H', 'hB'],
  BB: ['h', 'hb', 'H', 'hB'],
  BM: ['h', 'hb', 'H', 'hB'],
  BS: ['h', 'hb', 'H', 'hB'],
  CA: ['h', 'hb', 'H', 'hB'],
  DM: ['h', 'hb', 'H', 'hB'],
  'en-001': ['h', 'hb', 'H', 'hB'],
  FJ: ['h', 'hb', 'H', 'hB'],
  FM: ['h', 'hb', 'H', 'hB'],
  GD: ['h', 'hb', 'H', 'hB'],
  GM: ['h', 'hb', 'H', 'hB'],
  GU: ['h', 'hb', 'H', 'hB'],
  GY: ['h', 'hb', 'H', 'hB'],
  JM: ['h', 'hb', 'H', 'hB'],
  KI: ['h', 'hb', 'H', 'hB'],
  KN: ['h', 'hb', 'H', 'hB'],
  KY: ['h', 'hb', 'H', 'hB'],
  LC: ['h', 'hb', 'H', 'hB'],
  LR: ['h', 'hb', 'H', 'hB'],
  MH: ['h', 'hb', 'H', 'hB'],
  MP: ['h', 'hb', 'H', 'hB'],
  MW: ['h', 'hb', 'H', 'hB'],
  NZ: ['h', 'hb', 'H', 'hB'],
  SB: ['h', 'hb', 'H', 'hB'],
  SG: ['h', 'hb', 'H', 'hB'],
  SL: ['h', 'hb', 'H', 'hB'],
  SS: ['h', 'hb', 'H', 'hB'],
  SZ: ['h', 'hb', 'H', 'hB'],
  TC: ['h', 'hb', 'H', 'hB'],
  TT: ['h', 'hb', 'H', 'hB'],
  UM: ['h', 'hb', 'H', 'hB'],
  US: ['h', 'hb', 'H', 'hB'],
  VC: ['h', 'hb', 'H', 'hB'],
  VG: ['h', 'hb', 'H', 'hB'],
  VI: ['h', 'hb', 'H', 'hB'],
  ZM: ['h', 'hb', 'H', 'hB'],
  BO: ['H', 'hB', 'h', 'hb'],
  EC: ['H', 'hB', 'h', 'hb'],
  ES: ['H', 'hB', 'h', 'hb'],
  GQ: ['H', 'hB', 'h', 'hb'],
  PE: ['H', 'hB', 'h', 'hb'],
  AE: ['h', 'hB', 'hb', 'H'],
  'ar-001': ['h', 'hB', 'hb', 'H'],
  BH: ['h', 'hB', 'hb', 'H'],
  DZ: ['h', 'hB', 'hb', 'H'],
  EG: ['h', 'hB', 'hb', 'H'],
  EH: ['h', 'hB', 'hb', 'H'],
  HK: ['h', 'hB', 'hb', 'H'],
  IQ: ['h', 'hB', 'hb', 'H'],
  JO: ['h', 'hB', 'hb', 'H'],
  KW: ['h', 'hB', 'hb', 'H'],
  LB: ['h', 'hB', 'hb', 'H'],
  LY: ['h', 'hB', 'hb', 'H'],
  MO: ['h', 'hB', 'hb', 'H'],
  MR: ['h', 'hB', 'hb', 'H'],
  OM: ['h', 'hB', 'hb', 'H'],
  PH: ['h', 'hB', 'hb', 'H'],
  PS: ['h', 'hB', 'hb', 'H'],
  QA: ['h', 'hB', 'hb', 'H'],
  SA: ['h', 'hB', 'hb', 'H'],
  SD: ['h', 'hB', 'hb', 'H'],
  SY: ['h', 'hB', 'hb', 'H'],
  TN: ['h', 'hB', 'hb', 'H'],
  YE: ['h', 'hB', 'hb', 'H'],
  AF: ['H', 'hb', 'hB', 'h'],
  LA: ['H', 'hb', 'hB', 'h'],
  CN: ['H', 'hB', 'hb', 'h'],
  LV: ['H', 'hB', 'hb', 'h'],
  TL: ['H', 'hB', 'hb', 'h'],
  'zu-ZA': ['H', 'hB', 'hb', 'h'],
  CD: ['hB', 'H'],
  IR: ['hB', 'H'],
  'hi-IN': ['hB', 'h', 'H'],
  'kn-IN': ['hB', 'h', 'H'],
  'ml-IN': ['hB', 'h', 'H'],
  'te-IN': ['hB', 'h', 'H'],
  KH: ['hB', 'h', 'H', 'hb'],
  'ta-IN': ['hB', 'h', 'hb', 'H'],
  BN: ['hb', 'hB', 'h', 'H'],
  MY: ['hb', 'hB', 'h', 'H'],
  ET: ['hB', 'hb', 'h', 'H'],
  'gu-IN': ['hB', 'hb', 'h', 'H'],
  'mr-IN': ['hB', 'hb', 'h', 'H'],
  'pa-IN': ['hB', 'hb', 'h', 'H'],
  TW: ['hB', 'hb', 'h', 'H'],
  KE: ['hB', 'hb', 'H', 'h'],
  MM: ['hB', 'hb', 'H', 'h'],
  TZ: ['hB', 'hb', 'H', 'h'],
  UG: ['hB', 'hb', 'H', 'h'],
};
function rx(e, t) {
  for (var n = '', i = 0; i < e.length; i++) {
    var r = e.charAt(i);
    if (r === 'j') {
      for (var o = 0; i + 1 < e.length && e.charAt(i + 1) === r; ) o++, i++;
      var a = 1 + (o & 1),
        s = o < 2 ? 1 : 3 + (o >> 1),
        l = 'a',
        c = ox(t);
      for ((c == 'H' || c == 'k') && (s = 0); s-- > 0; ) n += l;
      for (; a-- > 0; ) n = c + n;
    } else r === 'J' ? (n += 'H') : (n += r);
  }
  return n;
}
function ox(e) {
  var t = e.hourCycle;
  if ((t === void 0 && e.hourCycles && e.hourCycles.length && (t = e.hourCycles[0]), t))
    switch (t) {
      case 'h24':
        return 'k';
      case 'h23':
        return 'H';
      case 'h12':
        return 'h';
      case 'h11':
        return 'K';
      default:
        throw new Error('Invalid hourCycle');
    }
  var n = e.language,
    i;
  n !== 'root' && (i = e.maximize().region);
  var r = Lo[i || ''] || Lo[n || ''] || Lo[''.concat(n, '-001')] || Lo['001'];
  return r[0];
}
var Ws,
  ax = new RegExp('^'.concat(vm.source, '*')),
  sx = new RegExp(''.concat(vm.source, '*$'));
function X(e, t) {
  return { start: e, end: t };
}
var lx = !!String.prototype.startsWith,
  cx = !!String.fromCodePoint,
  ux = !!Object.fromEntries,
  dx = !!String.prototype.codePointAt,
  px = !!String.prototype.trimStart,
  hx = !!String.prototype.trimEnd,
  fx = !!Number.isSafeInteger,
  mx = fx
    ? Number.isSafeInteger
    : function (e) {
        return typeof e == 'number' && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
      },
  ec = !0;
try {
  var gx = km('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
  ec = ((Ws = gx.exec('a')) === null || Ws === void 0 ? void 0 : Ws[0]) === 'a';
} catch {
  ec = !1;
}
var _p = lx
    ? function (t, n, i) {
        return t.startsWith(n, i);
      }
    : function (t, n, i) {
        return t.slice(i, i + n.length) === n;
      },
  tc = cx
    ? String.fromCodePoint
    : function () {
        for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
        for (var i = '', r = t.length, o = 0, a; r > o; ) {
          if (((a = t[o++]), a > 1114111)) throw RangeError(a + ' is not a valid code point');
          i +=
            a < 65536 ? String.fromCharCode(a) : String.fromCharCode(((a -= 65536) >> 10) + 55296, (a % 1024) + 56320);
        }
        return i;
      },
  xp = ux
    ? Object.fromEntries
    : function (t) {
        for (var n = {}, i = 0, r = t; i < r.length; i++) {
          var o = r[i],
            a = o[0],
            s = o[1];
          n[a] = s;
        }
        return n;
      },
  Em = dx
    ? function (t, n) {
        return t.codePointAt(n);
      }
    : function (t, n) {
        var i = t.length;
        if (!(n < 0 || n >= i)) {
          var r = t.charCodeAt(n),
            o;
          return r < 55296 || r > 56319 || n + 1 === i || (o = t.charCodeAt(n + 1)) < 56320 || o > 57343
            ? r
            : ((r - 55296) << 10) + (o - 56320) + 65536;
        }
      },
  vx = px
    ? function (t) {
        return t.trimStart();
      }
    : function (t) {
        return t.replace(ax, '');
      },
  _x = hx
    ? function (t) {
        return t.trimEnd();
      }
    : function (t) {
        return t.replace(sx, '');
      };
function km(e, t) {
  return new RegExp(e, t);
}
var nc;
if (ec) {
  var yp = km('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
  nc = function (t, n) {
    var i;
    yp.lastIndex = n;
    var r = yp.exec(t);
    return (i = r[1]) !== null && i !== void 0 ? i : '';
  };
} else
  nc = function (t, n) {
    for (var i = []; ; ) {
      var r = Em(t, n);
      if (r === void 0 || Sm(r) || kx(r)) break;
      i.push(r), (n += r >= 65536 ? 2 : 1);
    }
    return tc.apply(void 0, i);
  };
var xx = (function () {
  function e(t, n) {
    n === void 0 && (n = {}),
      (this.message = t),
      (this.position = { offset: 0, line: 1, column: 1 }),
      (this.ignoreTag = !!n.ignoreTag),
      (this.locale = n.locale),
      (this.requiresOtherClause = !!n.requiresOtherClause),
      (this.shouldParseSkeletons = !!n.shouldParseSkeletons);
  }
  return (
    (e.prototype.parse = function () {
      if (this.offset() !== 0) throw Error('parser can only be used once');
      return this.parseMessage(0, '', !1);
    }),
    (e.prototype.parseMessage = function (t, n, i) {
      for (var r = []; !this.isEOF(); ) {
        var o = this.char();
        if (o === 123) {
          var a = this.parseArgument(t, i);
          if (a.err) return a;
          r.push(a.val);
        } else {
          if (o === 125 && t > 0) break;
          if (o === 35 && (n === 'plural' || n === 'selectordinal')) {
            var s = this.clonePosition();
            this.bump(), r.push({ type: ue.pound, location: X(s, this.clonePosition()) });
          } else if (o === 60 && !this.ignoreTag && this.peek() === 47) {
            if (i) break;
            return this.error(J.UNMATCHED_CLOSING_TAG, X(this.clonePosition(), this.clonePosition()));
          } else if (o === 60 && !this.ignoreTag && ic(this.peek() || 0)) {
            var a = this.parseTag(t, n);
            if (a.err) return a;
            r.push(a.val);
          } else {
            var a = this.parseLiteral(t, n);
            if (a.err) return a;
            r.push(a.val);
          }
        }
      }
      return { val: r, err: null };
    }),
    (e.prototype.parseTag = function (t, n) {
      var i = this.clonePosition();
      this.bump();
      var r = this.parseTagName();
      if ((this.bumpSpace(), this.bumpIf('/>')))
        return {
          val: { type: ue.literal, value: '<'.concat(r, '/>'), location: X(i, this.clonePosition()) },
          err: null,
        };
      if (this.bumpIf('>')) {
        var o = this.parseMessage(t + 1, n, !0);
        if (o.err) return o;
        var a = o.val,
          s = this.clonePosition();
        if (this.bumpIf('</')) {
          if (this.isEOF() || !ic(this.char())) return this.error(J.INVALID_TAG, X(s, this.clonePosition()));
          var l = this.clonePosition(),
            c = this.parseTagName();
          return r !== c
            ? this.error(J.UNMATCHED_CLOSING_TAG, X(l, this.clonePosition()))
            : (this.bumpSpace(),
              this.bumpIf('>')
                ? { val: { type: ue.tag, value: r, children: a, location: X(i, this.clonePosition()) }, err: null }
                : this.error(J.INVALID_TAG, X(s, this.clonePosition())));
        } else return this.error(J.UNCLOSED_TAG, X(i, this.clonePosition()));
      } else return this.error(J.INVALID_TAG, X(i, this.clonePosition()));
    }),
    (e.prototype.parseTagName = function () {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && Ex(this.char()); ) this.bump();
      return this.message.slice(t, this.offset());
    }),
    (e.prototype.parseLiteral = function (t, n) {
      for (var i = this.clonePosition(), r = ''; ; ) {
        var o = this.tryParseQuote(n);
        if (o) {
          r += o;
          continue;
        }
        var a = this.tryParseUnquoted(t, n);
        if (a) {
          r += a;
          continue;
        }
        var s = this.tryParseLeftAngleBracket();
        if (s) {
          r += s;
          continue;
        }
        break;
      }
      var l = X(i, this.clonePosition());
      return { val: { type: ue.literal, value: r, location: l }, err: null };
    }),
    (e.prototype.tryParseLeftAngleBracket = function () {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || !yx(this.peek() || 0))
        ? (this.bump(), '<')
        : null;
    }),
    (e.prototype.tryParseQuote = function (t) {
      if (this.isEOF() || this.char() !== 39) return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === 'plural' || t === 'selectordinal') break;
          return null;
        default:
          return null;
      }
      this.bump();
      var n = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var i = this.char();
        if (i === 39)
          if (this.peek() === 39) n.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else n.push(i);
        this.bump();
      }
      return tc.apply(void 0, n);
    }),
    (e.prototype.tryParseUnquoted = function (t, n) {
      if (this.isEOF()) return null;
      var i = this.char();
      return i === 60 || i === 123 || (i === 35 && (n === 'plural' || n === 'selectordinal')) || (i === 125 && t > 0)
        ? null
        : (this.bump(), tc(i));
    }),
    (e.prototype.parseArgument = function (t, n) {
      var i = this.clonePosition();
      if ((this.bump(), this.bumpSpace(), this.isEOF()))
        return this.error(J.EXPECT_ARGUMENT_CLOSING_BRACE, X(i, this.clonePosition()));
      if (this.char() === 125) return this.bump(), this.error(J.EMPTY_ARGUMENT, X(i, this.clonePosition()));
      var r = this.parseIdentifierIfPossible().value;
      if (!r) return this.error(J.MALFORMED_ARGUMENT, X(i, this.clonePosition()));
      if ((this.bumpSpace(), this.isEOF()))
        return this.error(J.EXPECT_ARGUMENT_CLOSING_BRACE, X(i, this.clonePosition()));
      switch (this.char()) {
        case 125:
          return this.bump(), { val: { type: ue.argument, value: r, location: X(i, this.clonePosition()) }, err: null };
        case 44:
          return (
            this.bump(),
            this.bumpSpace(),
            this.isEOF()
              ? this.error(J.EXPECT_ARGUMENT_CLOSING_BRACE, X(i, this.clonePosition()))
              : this.parseArgumentOptions(t, n, r, i)
          );
        default:
          return this.error(J.MALFORMED_ARGUMENT, X(i, this.clonePosition()));
      }
    }),
    (e.prototype.parseIdentifierIfPossible = function () {
      var t = this.clonePosition(),
        n = this.offset(),
        i = nc(this.message, n),
        r = n + i.length;
      this.bumpTo(r);
      var o = this.clonePosition(),
        a = X(t, o);
      return { value: i, location: a };
    }),
    (e.prototype.parseArgumentOptions = function (t, n, i, r) {
      var o,
        a = this.clonePosition(),
        s = this.parseIdentifierIfPossible().value,
        l = this.clonePosition();
      switch (s) {
        case '':
          return this.error(J.EXPECT_ARGUMENT_TYPE, X(a, l));
        case 'number':
        case 'date':
        case 'time': {
          this.bumpSpace();
          var c = null;
          if (this.bumpIf(',')) {
            this.bumpSpace();
            var u = this.clonePosition(),
              f = this.parseSimpleArgStyleIfPossible();
            if (f.err) return f;
            var h = _x(f.val);
            if (h.length === 0)
              return this.error(J.EXPECT_ARGUMENT_STYLE, X(this.clonePosition(), this.clonePosition()));
            var x = X(u, this.clonePosition());
            c = { style: h, styleLocation: x };
          }
          var y = this.tryParseArgumentClose(r);
          if (y.err) return y;
          var m = X(r, this.clonePosition());
          if (c && _p(c == null ? void 0 : c.style, '::', 0)) {
            var j = vx(c.style.slice(2));
            if (s === 'number') {
              var f = this.parseNumberSkeletonFromString(j, c.styleLocation);
              return f.err ? f : { val: { type: ue.number, value: i, location: m, style: f.val }, err: null };
            } else {
              if (j.length === 0) return this.error(J.EXPECT_DATE_TIME_SKELETON, m);
              var p = j;
              this.locale && (p = rx(j, this.locale));
              var h = {
                  type: Ki.dateTime,
                  pattern: p,
                  location: c.styleLocation,
                  parsedOptions: this.shouldParseSkeletons ? X0(p) : {},
                },
                d = s === 'date' ? ue.date : ue.time;
              return { val: { type: d, value: i, location: m, style: h }, err: null };
            }
          }
          return {
            val: {
              type: s === 'number' ? ue.number : s === 'date' ? ue.date : ue.time,
              value: i,
              location: m,
              style: (o = c == null ? void 0 : c.style) !== null && o !== void 0 ? o : null,
            },
            err: null,
          };
        }
        case 'plural':
        case 'selectordinal':
        case 'select': {
          var g = this.clonePosition();
          if ((this.bumpSpace(), !this.bumpIf(',')))
            return this.error(J.EXPECT_SELECT_ARGUMENT_OPTIONS, X(g, F({}, g)));
          this.bumpSpace();
          var k = this.parseIdentifierIfPossible(),
            T = 0;
          if (s !== 'select' && k.value === 'offset') {
            if (!this.bumpIf(':'))
              return this.error(J.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, X(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var f = this.tryParseDecimalInteger(
              J.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE,
              J.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE,
            );
            if (f.err) return f;
            this.bumpSpace(), (k = this.parseIdentifierIfPossible()), (T = f.val);
          }
          var R = this.tryParsePluralOrSelectOptions(t, s, n, k);
          if (R.err) return R;
          var y = this.tryParseArgumentClose(r);
          if (y.err) return y;
          var b = X(r, this.clonePosition());
          return s === 'select'
            ? { val: { type: ue.select, value: i, options: xp(R.val), location: b }, err: null }
            : {
                val: {
                  type: ue.plural,
                  value: i,
                  options: xp(R.val),
                  offset: T,
                  pluralType: s === 'plural' ? 'cardinal' : 'ordinal',
                  location: b,
                },
                err: null,
              };
        }
        default:
          return this.error(J.INVALID_ARGUMENT_TYPE, X(a, l));
      }
    }),
    (e.prototype.tryParseArgumentClose = function (t) {
      return this.isEOF() || this.char() !== 125
        ? this.error(J.EXPECT_ARGUMENT_CLOSING_BRACE, X(t, this.clonePosition()))
        : (this.bump(), { val: !0, err: null });
    }),
    (e.prototype.parseSimpleArgStyleIfPossible = function () {
      for (var t = 0, n = this.clonePosition(); !this.isEOF(); ) {
        var i = this.char();
        switch (i) {
          case 39: {
            this.bump();
            var r = this.clonePosition();
            if (!this.bumpUntil("'")) return this.error(J.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, X(r, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            (t += 1), this.bump();
            break;
          }
          case 125: {
            if (t > 0) t -= 1;
            else return { val: this.message.slice(n.offset, this.offset()), err: null };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return { val: this.message.slice(n.offset, this.offset()), err: null };
    }),
    (e.prototype.parseNumberSkeletonFromString = function (t, n) {
      var i = [];
      try {
        i = Y0(t);
      } catch {
        return this.error(J.INVALID_NUMBER_SKELETON, n);
      }
      return {
        val: { type: Ki.number, tokens: i, location: n, parsedOptions: this.shouldParseSkeletons ? ix(i) : {} },
        err: null,
      };
    }),
    (e.prototype.tryParsePluralOrSelectOptions = function (t, n, i, r) {
      for (var o, a = !1, s = [], l = new Set(), c = r.value, u = r.location; ; ) {
        if (c.length === 0) {
          var f = this.clonePosition();
          if (n !== 'select' && this.bumpIf('=')) {
            var h = this.tryParseDecimalInteger(J.EXPECT_PLURAL_ARGUMENT_SELECTOR, J.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (h.err) return h;
            (u = X(f, this.clonePosition())), (c = this.message.slice(f.offset, this.offset()));
          } else break;
        }
        if (l.has(c))
          return this.error(
            n === 'select' ? J.DUPLICATE_SELECT_ARGUMENT_SELECTOR : J.DUPLICATE_PLURAL_ARGUMENT_SELECTOR,
            u,
          );
        c === 'other' && (a = !0), this.bumpSpace();
        var x = this.clonePosition();
        if (!this.bumpIf('{'))
          return this.error(
            n === 'select' ? J.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : J.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT,
            X(this.clonePosition(), this.clonePosition()),
          );
        var y = this.parseMessage(t + 1, n, i);
        if (y.err) return y;
        var m = this.tryParseArgumentClose(x);
        if (m.err) return m;
        s.push([c, { value: y.val, location: X(x, this.clonePosition()) }]),
          l.add(c),
          this.bumpSpace(),
          (o = this.parseIdentifierIfPossible()),
          (c = o.value),
          (u = o.location);
      }
      return s.length === 0
        ? this.error(
            n === 'select' ? J.EXPECT_SELECT_ARGUMENT_SELECTOR : J.EXPECT_PLURAL_ARGUMENT_SELECTOR,
            X(this.clonePosition(), this.clonePosition()),
          )
        : this.requiresOtherClause && !a
          ? this.error(J.MISSING_OTHER_CLAUSE, X(this.clonePosition(), this.clonePosition()))
          : { val: s, err: null };
    }),
    (e.prototype.tryParseDecimalInteger = function (t, n) {
      var i = 1,
        r = this.clonePosition();
      this.bumpIf('+') || (this.bumpIf('-') && (i = -1));
      for (var o = !1, a = 0; !this.isEOF(); ) {
        var s = this.char();
        if (s >= 48 && s <= 57) (o = !0), (a = a * 10 + (s - 48)), this.bump();
        else break;
      }
      var l = X(r, this.clonePosition());
      return o ? ((a *= i), mx(a) ? { val: a, err: null } : this.error(n, l)) : this.error(t, l);
    }),
    (e.prototype.offset = function () {
      return this.position.offset;
    }),
    (e.prototype.isEOF = function () {
      return this.offset() === this.message.length;
    }),
    (e.prototype.clonePosition = function () {
      return { offset: this.position.offset, line: this.position.line, column: this.position.column };
    }),
    (e.prototype.char = function () {
      var t = this.position.offset;
      if (t >= this.message.length) throw Error('out of bound');
      var n = Em(this.message, t);
      if (n === void 0) throw Error('Offset '.concat(t, ' is at invalid UTF-16 code unit boundary'));
      return n;
    }),
    (e.prototype.error = function (t, n) {
      return { val: null, err: { kind: t, message: this.message, location: n } };
    }),
    (e.prototype.bump = function () {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10
          ? ((this.position.line += 1), (this.position.column = 1), (this.position.offset += 1))
          : ((this.position.column += 1), (this.position.offset += t < 65536 ? 1 : 2));
      }
    }),
    (e.prototype.bumpIf = function (t) {
      if (_p(this.message, t, this.offset())) {
        for (var n = 0; n < t.length; n++) this.bump();
        return !0;
      }
      return !1;
    }),
    (e.prototype.bumpUntil = function (t) {
      var n = this.offset(),
        i = this.message.indexOf(t, n);
      return i >= 0 ? (this.bumpTo(i), !0) : (this.bumpTo(this.message.length), !1);
    }),
    (e.prototype.bumpTo = function (t) {
      if (this.offset() > t)
        throw Error(
          'targetOffset '.concat(t, ' must be greater than or equal to the current offset ').concat(this.offset()),
        );
      for (t = Math.min(t, this.message.length); ; ) {
        var n = this.offset();
        if (n === t) break;
        if (n > t) throw Error('targetOffset '.concat(t, ' is at invalid UTF-16 code unit boundary'));
        if ((this.bump(), this.isEOF())) break;
      }
    }),
    (e.prototype.bumpSpace = function () {
      for (; !this.isEOF() && Sm(this.char()); ) this.bump();
    }),
    (e.prototype.peek = function () {
      if (this.isEOF()) return null;
      var t = this.char(),
        n = this.offset(),
        i = this.message.charCodeAt(n + (t >= 65536 ? 2 : 1));
      return i != null ? i : null;
    }),
    e
  );
})();
function ic(e) {
  return (e >= 97 && e <= 122) || (e >= 65 && e <= 90);
}
function yx(e) {
  return ic(e) || e === 47;
}
function Ex(e) {
  return (
    e === 45 ||
    e === 46 ||
    (e >= 48 && e <= 57) ||
    e === 95 ||
    (e >= 97 && e <= 122) ||
    (e >= 65 && e <= 90) ||
    e == 183 ||
    (e >= 192 && e <= 214) ||
    (e >= 216 && e <= 246) ||
    (e >= 248 && e <= 893) ||
    (e >= 895 && e <= 8191) ||
    (e >= 8204 && e <= 8205) ||
    (e >= 8255 && e <= 8256) ||
    (e >= 8304 && e <= 8591) ||
    (e >= 11264 && e <= 12271) ||
    (e >= 12289 && e <= 55295) ||
    (e >= 63744 && e <= 64975) ||
    (e >= 65008 && e <= 65533) ||
    (e >= 65536 && e <= 983039)
  );
}
function Sm(e) {
  return (e >= 9 && e <= 13) || e === 32 || e === 133 || (e >= 8206 && e <= 8207) || e === 8232 || e === 8233;
}
function kx(e) {
  return (
    (e >= 33 && e <= 35) ||
    e === 36 ||
    (e >= 37 && e <= 39) ||
    e === 40 ||
    e === 41 ||
    e === 42 ||
    e === 43 ||
    e === 44 ||
    e === 45 ||
    (e >= 46 && e <= 47) ||
    (e >= 58 && e <= 59) ||
    (e >= 60 && e <= 62) ||
    (e >= 63 && e <= 64) ||
    e === 91 ||
    e === 92 ||
    e === 93 ||
    e === 94 ||
    e === 96 ||
    e === 123 ||
    e === 124 ||
    e === 125 ||
    e === 126 ||
    e === 161 ||
    (e >= 162 && e <= 165) ||
    e === 166 ||
    e === 167 ||
    e === 169 ||
    e === 171 ||
    e === 172 ||
    e === 174 ||
    e === 176 ||
    e === 177 ||
    e === 182 ||
    e === 187 ||
    e === 191 ||
    e === 215 ||
    e === 247 ||
    (e >= 8208 && e <= 8213) ||
    (e >= 8214 && e <= 8215) ||
    e === 8216 ||
    e === 8217 ||
    e === 8218 ||
    (e >= 8219 && e <= 8220) ||
    e === 8221 ||
    e === 8222 ||
    e === 8223 ||
    (e >= 8224 && e <= 8231) ||
    (e >= 8240 && e <= 8248) ||
    e === 8249 ||
    e === 8250 ||
    (e >= 8251 && e <= 8254) ||
    (e >= 8257 && e <= 8259) ||
    e === 8260 ||
    e === 8261 ||
    e === 8262 ||
    (e >= 8263 && e <= 8273) ||
    e === 8274 ||
    e === 8275 ||
    (e >= 8277 && e <= 8286) ||
    (e >= 8592 && e <= 8596) ||
    (e >= 8597 && e <= 8601) ||
    (e >= 8602 && e <= 8603) ||
    (e >= 8604 && e <= 8607) ||
    e === 8608 ||
    (e >= 8609 && e <= 8610) ||
    e === 8611 ||
    (e >= 8612 && e <= 8613) ||
    e === 8614 ||
    (e >= 8615 && e <= 8621) ||
    e === 8622 ||
    (e >= 8623 && e <= 8653) ||
    (e >= 8654 && e <= 8655) ||
    (e >= 8656 && e <= 8657) ||
    e === 8658 ||
    e === 8659 ||
    e === 8660 ||
    (e >= 8661 && e <= 8691) ||
    (e >= 8692 && e <= 8959) ||
    (e >= 8960 && e <= 8967) ||
    e === 8968 ||
    e === 8969 ||
    e === 8970 ||
    e === 8971 ||
    (e >= 8972 && e <= 8991) ||
    (e >= 8992 && e <= 8993) ||
    (e >= 8994 && e <= 9e3) ||
    e === 9001 ||
    e === 9002 ||
    (e >= 9003 && e <= 9083) ||
    e === 9084 ||
    (e >= 9085 && e <= 9114) ||
    (e >= 9115 && e <= 9139) ||
    (e >= 9140 && e <= 9179) ||
    (e >= 9180 && e <= 9185) ||
    (e >= 9186 && e <= 9254) ||
    (e >= 9255 && e <= 9279) ||
    (e >= 9280 && e <= 9290) ||
    (e >= 9291 && e <= 9311) ||
    (e >= 9472 && e <= 9654) ||
    e === 9655 ||
    (e >= 9656 && e <= 9664) ||
    e === 9665 ||
    (e >= 9666 && e <= 9719) ||
    (e >= 9720 && e <= 9727) ||
    (e >= 9728 && e <= 9838) ||
    e === 9839 ||
    (e >= 9840 && e <= 10087) ||
    e === 10088 ||
    e === 10089 ||
    e === 10090 ||
    e === 10091 ||
    e === 10092 ||
    e === 10093 ||
    e === 10094 ||
    e === 10095 ||
    e === 10096 ||
    e === 10097 ||
    e === 10098 ||
    e === 10099 ||
    e === 10100 ||
    e === 10101 ||
    (e >= 10132 && e <= 10175) ||
    (e >= 10176 && e <= 10180) ||
    e === 10181 ||
    e === 10182 ||
    (e >= 10183 && e <= 10213) ||
    e === 10214 ||
    e === 10215 ||
    e === 10216 ||
    e === 10217 ||
    e === 10218 ||
    e === 10219 ||
    e === 10220 ||
    e === 10221 ||
    e === 10222 ||
    e === 10223 ||
    (e >= 10224 && e <= 10239) ||
    (e >= 10240 && e <= 10495) ||
    (e >= 10496 && e <= 10626) ||
    e === 10627 ||
    e === 10628 ||
    e === 10629 ||
    e === 10630 ||
    e === 10631 ||
    e === 10632 ||
    e === 10633 ||
    e === 10634 ||
    e === 10635 ||
    e === 10636 ||
    e === 10637 ||
    e === 10638 ||
    e === 10639 ||
    e === 10640 ||
    e === 10641 ||
    e === 10642 ||
    e === 10643 ||
    e === 10644 ||
    e === 10645 ||
    e === 10646 ||
    e === 10647 ||
    e === 10648 ||
    (e >= 10649 && e <= 10711) ||
    e === 10712 ||
    e === 10713 ||
    e === 10714 ||
    e === 10715 ||
    (e >= 10716 && e <= 10747) ||
    e === 10748 ||
    e === 10749 ||
    (e >= 10750 && e <= 11007) ||
    (e >= 11008 && e <= 11055) ||
    (e >= 11056 && e <= 11076) ||
    (e >= 11077 && e <= 11078) ||
    (e >= 11079 && e <= 11084) ||
    (e >= 11085 && e <= 11123) ||
    (e >= 11124 && e <= 11125) ||
    (e >= 11126 && e <= 11157) ||
    e === 11158 ||
    (e >= 11159 && e <= 11263) ||
    (e >= 11776 && e <= 11777) ||
    e === 11778 ||
    e === 11779 ||
    e === 11780 ||
    e === 11781 ||
    (e >= 11782 && e <= 11784) ||
    e === 11785 ||
    e === 11786 ||
    e === 11787 ||
    e === 11788 ||
    e === 11789 ||
    (e >= 11790 && e <= 11798) ||
    e === 11799 ||
    (e >= 11800 && e <= 11801) ||
    e === 11802 ||
    e === 11803 ||
    e === 11804 ||
    e === 11805 ||
    (e >= 11806 && e <= 11807) ||
    e === 11808 ||
    e === 11809 ||
    e === 11810 ||
    e === 11811 ||
    e === 11812 ||
    e === 11813 ||
    e === 11814 ||
    e === 11815 ||
    e === 11816 ||
    e === 11817 ||
    (e >= 11818 && e <= 11822) ||
    e === 11823 ||
    (e >= 11824 && e <= 11833) ||
    (e >= 11834 && e <= 11835) ||
    (e >= 11836 && e <= 11839) ||
    e === 11840 ||
    e === 11841 ||
    e === 11842 ||
    (e >= 11843 && e <= 11855) ||
    (e >= 11856 && e <= 11857) ||
    e === 11858 ||
    (e >= 11859 && e <= 11903) ||
    (e >= 12289 && e <= 12291) ||
    e === 12296 ||
    e === 12297 ||
    e === 12298 ||
    e === 12299 ||
    e === 12300 ||
    e === 12301 ||
    e === 12302 ||
    e === 12303 ||
    e === 12304 ||
    e === 12305 ||
    (e >= 12306 && e <= 12307) ||
    e === 12308 ||
    e === 12309 ||
    e === 12310 ||
    e === 12311 ||
    e === 12312 ||
    e === 12313 ||
    e === 12314 ||
    e === 12315 ||
    e === 12316 ||
    e === 12317 ||
    (e >= 12318 && e <= 12319) ||
    e === 12320 ||
    e === 12336 ||
    e === 64830 ||
    e === 64831 ||
    (e >= 65093 && e <= 65094)
  );
}
function rc(e) {
  e.forEach(function (t) {
    if ((delete t.location, hm(t) || fm(t)))
      for (var n in t.options) delete t.options[n].location, rc(t.options[n].value);
    else
      (um(t) && gm(t.style)) || ((dm(t) || pm(t)) && Yl(t.style)) ? delete t.style.location : mm(t) && rc(t.children);
  });
}
function Sx(e, t) {
  t === void 0 && (t = {}), (t = F({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t));
  var n = new xx(e, t).parse();
  if (n.err) {
    var i = SyntaxError(J[n.err.kind]);
    throw ((i.location = n.err.location), (i.originalMessage = n.err.message), i);
  }
  return (t != null && t.captureLocation) || rc(n.val), n.val;
}
function Bt(e, t) {
  var n = t && t.cache ? t.cache : Cx,
    i = t && t.serializer ? t.serializer : Tx,
    r = t && t.strategy ? t.strategy : wx;
  return r(e, { cache: n, serializer: i });
}
function Ax(e) {
  return e == null || typeof e == 'number' || typeof e == 'boolean';
}
function Am(e, t, n, i) {
  var r = Ax(i) ? i : n(i),
    o = t.get(r);
  return typeof o > 'u' && ((o = e.call(this, i)), t.set(r, o)), o;
}
function wm(e, t, n) {
  var i = Array.prototype.slice.call(arguments, 3),
    r = n(i),
    o = t.get(r);
  return typeof o > 'u' && ((o = e.apply(this, i)), t.set(r, o)), o;
}
function uu(e, t, n, i, r) {
  return n.bind(t, e, i, r);
}
function wx(e, t) {
  var n = e.length === 1 ? Am : wm;
  return uu(e, this, n, t.cache.create(), t.serializer);
}
function Mx(e, t) {
  return uu(e, this, wm, t.cache.create(), t.serializer);
}
function Px(e, t) {
  return uu(e, this, Am, t.cache.create(), t.serializer);
}
var Tx = function () {
  return JSON.stringify(arguments);
};
function du() {
  this.cache = Object.create(null);
}
du.prototype.get = function (e) {
  return this.cache[e];
};
du.prototype.set = function (e, t) {
  this.cache[e] = t;
};
var Cx = {
    create: function () {
      return new du();
    },
  },
  Ut = { variadic: Mx, monadic: Px },
  Qt;
(function (e) {
  (e.MISSING_VALUE = 'MISSING_VALUE'), (e.INVALID_VALUE = 'INVALID_VALUE'), (e.MISSING_INTL_API = 'MISSING_INTL_API');
})(Qt || (Qt = {}));
var Hn = (function (e) {
    Tt(t, e);
    function t(n, i, r) {
      var o = e.call(this, n) || this;
      return (o.code = i), (o.originalMessage = r), o;
    }
    return (
      (t.prototype.toString = function () {
        return '[formatjs Error: '.concat(this.code, '] ').concat(this.message);
      }),
      t
    );
  })(Error),
  Ep = (function (e) {
    Tt(t, e);
    function t(n, i, r, o) {
      return (
        e.call(
          this,
          'Invalid values for "'
            .concat(n, '": "')
            .concat(i, '". Options are "')
            .concat(Object.keys(r).join('", "'), '"'),
          Qt.INVALID_VALUE,
          o,
        ) || this
      );
    }
    return t;
  })(Hn),
  bx = (function (e) {
    Tt(t, e);
    function t(n, i, r) {
      return e.call(this, 'Value for "'.concat(n, '" must be of type ').concat(i), Qt.INVALID_VALUE, r) || this;
    }
    return t;
  })(Hn),
  Ix = (function (e) {
    Tt(t, e);
    function t(n, i) {
      return (
        e.call(
          this,
          'The intl string context variable "'.concat(n, '" was not provided to the string "').concat(i, '"'),
          Qt.MISSING_VALUE,
          i,
        ) || this
      );
    }
    return t;
  })(Hn),
  Ze;
(function (e) {
  (e[(e.literal = 0)] = 'literal'), (e[(e.object = 1)] = 'object');
})(Ze || (Ze = {}));
function Lx(e) {
  return e.length < 2
    ? e
    : e.reduce(function (t, n) {
        var i = t[t.length - 1];
        return !i || i.type !== Ze.literal || n.type !== Ze.literal ? t.push(n) : (i.value += n.value), t;
      }, []);
}
function Mm(e) {
  return typeof e == 'function';
}
function Vo(e, t, n, i, r, o, a) {
  if (e.length === 1 && fp(e[0])) return [{ type: Ze.literal, value: e[0].value }];
  for (var s = [], l = 0, c = e; l < c.length; l++) {
    var u = c[l];
    if (fp(u)) {
      s.push({ type: Ze.literal, value: u.value });
      continue;
    }
    if (K0(u)) {
      typeof o == 'number' && s.push({ type: Ze.literal, value: n.getNumberFormat(t).format(o) });
      continue;
    }
    var f = u.value;
    if (!(r && f in r)) throw new Ix(f, a);
    var h = r[f];
    if (W0(u)) {
      (!h || typeof h == 'string' || typeof h == 'number') &&
        (h = typeof h == 'string' || typeof h == 'number' ? String(h) : ''),
        s.push({ type: typeof h == 'string' ? Ze.literal : Ze.object, value: h });
      continue;
    }
    if (dm(u)) {
      var x = typeof u.style == 'string' ? i.date[u.style] : Yl(u.style) ? u.style.parsedOptions : void 0;
      s.push({ type: Ze.literal, value: n.getDateTimeFormat(t, x).format(h) });
      continue;
    }
    if (pm(u)) {
      var x = typeof u.style == 'string' ? i.time[u.style] : Yl(u.style) ? u.style.parsedOptions : i.time.medium;
      s.push({ type: Ze.literal, value: n.getDateTimeFormat(t, x).format(h) });
      continue;
    }
    if (um(u)) {
      var x = typeof u.style == 'string' ? i.number[u.style] : gm(u.style) ? u.style.parsedOptions : void 0;
      x && x.scale && (h = h * (x.scale || 1)), s.push({ type: Ze.literal, value: n.getNumberFormat(t, x).format(h) });
      continue;
    }
    if (mm(u)) {
      var y = u.children,
        m = u.value,
        j = r[m];
      if (!Mm(j)) throw new bx(m, 'function', a);
      var p = Vo(y, t, n, i, r, o),
        d = j(
          p.map(function (T) {
            return T.value;
          }),
        );
      Array.isArray(d) || (d = [d]),
        s.push.apply(
          s,
          d.map(function (T) {
            return { type: typeof T == 'string' ? Ze.literal : Ze.object, value: T };
          }),
        );
    }
    if (hm(u)) {
      var g = u.options[h] || u.options.other;
      if (!g) throw new Ep(u.value, h, Object.keys(u.options), a);
      s.push.apply(s, Vo(g.value, t, n, i, r));
      continue;
    }
    if (fm(u)) {
      var g = u.options['='.concat(h)];
      if (!g) {
        if (!Intl.PluralRules)
          throw new Hn(
            `Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`,
            Qt.MISSING_INTL_API,
            a,
          );
        var k = n.getPluralRules(t, { type: u.pluralType }).select(h - (u.offset || 0));
        g = u.options[k] || u.options.other;
      }
      if (!g) throw new Ep(u.value, h, Object.keys(u.options), a);
      s.push.apply(s, Vo(g.value, t, n, i, r, h - (u.offset || 0)));
      continue;
    }
  }
  return Lx(s);
}
function Nx(e, t) {
  return t
    ? F(
        F(F({}, e || {}), t || {}),
        Object.keys(e).reduce(function (n, i) {
          return (n[i] = F(F({}, e[i]), t[i] || {})), n;
        }, {}),
      )
    : e;
}
function Rx(e, t) {
  return t
    ? Object.keys(e).reduce(
        function (n, i) {
          return (n[i] = Nx(e[i], t[i])), n;
        },
        F({}, e),
      )
    : e;
}
function Ks(e) {
  return {
    create: function () {
      return {
        get: function (t) {
          return e[t];
        },
        set: function (t, n) {
          e[t] = n;
        },
      };
    },
  };
}
function Dx(e) {
  return (
    e === void 0 && (e = { number: {}, dateTime: {}, pluralRules: {} }),
    {
      getNumberFormat: Bt(
        function () {
          for (var t, n = [], i = 0; i < arguments.length; i++) n[i] = arguments[i];
          return new ((t = Intl.NumberFormat).bind.apply(t, Gt([void 0], n, !1)))();
        },
        { cache: Ks(e.number), strategy: Ut.variadic },
      ),
      getDateTimeFormat: Bt(
        function () {
          for (var t, n = [], i = 0; i < arguments.length; i++) n[i] = arguments[i];
          return new ((t = Intl.DateTimeFormat).bind.apply(t, Gt([void 0], n, !1)))();
        },
        { cache: Ks(e.dateTime), strategy: Ut.variadic },
      ),
      getPluralRules: Bt(
        function () {
          for (var t, n = [], i = 0; i < arguments.length; i++) n[i] = arguments[i];
          return new ((t = Intl.PluralRules).bind.apply(t, Gt([void 0], n, !1)))();
        },
        { cache: Ks(e.pluralRules), strategy: Ut.variadic },
      ),
    }
  );
}
var Pm = (function () {
    function e(t, n, i, r) {
      n === void 0 && (n = e.defaultLocale);
      var o = this;
      if (
        ((this.formatterCache = { number: {}, dateTime: {}, pluralRules: {} }),
        (this.format = function (a) {
          var s = o.formatToParts(a);
          if (s.length === 1) return s[0].value;
          var l = s.reduce(function (c, u) {
            return (
              !c.length || u.type !== Ze.literal || typeof c[c.length - 1] != 'string'
                ? c.push(u.value)
                : (c[c.length - 1] += u.value),
              c
            );
          }, []);
          return l.length <= 1 ? l[0] || '' : l;
        }),
        (this.formatToParts = function (a) {
          return Vo(o.ast, o.locales, o.formatters, o.formats, a, void 0, o.message);
        }),
        (this.resolvedOptions = function () {
          var a;
          return {
            locale:
              ((a = o.resolvedLocale) === null || a === void 0 ? void 0 : a.toString()) ||
              Intl.NumberFormat.supportedLocalesOf(o.locales)[0],
          };
        }),
        (this.getAst = function () {
          return o.ast;
        }),
        (this.locales = n),
        (this.resolvedLocale = e.resolveLocale(n)),
        typeof t == 'string')
      ) {
        if (((this.message = t), !e.__parse))
          throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
        this.ast = e.__parse(t, { ignoreTag: r == null ? void 0 : r.ignoreTag, locale: this.resolvedLocale });
      } else this.ast = t;
      if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
      (this.formats = Rx(e.formats, i)), (this.formatters = (r && r.formatters) || Dx(this.formatterCache));
    }
    return (
      Object.defineProperty(e, 'defaultLocale', {
        get: function () {
          return (
            e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale),
            e.memoizedDefaultLocale
          );
        },
        enumerable: !1,
        configurable: !0,
      }),
      (e.memoizedDefaultLocale = null),
      (e.resolveLocale = function (t) {
        if (!(typeof Intl.Locale > 'u')) {
          var n = Intl.NumberFormat.supportedLocalesOf(t);
          return n.length > 0 ? new Intl.Locale(n[0]) : new Intl.Locale(typeof t == 'string' ? t : t[0]);
        }
      }),
      (e.__parse = Sx),
      (e.formats = {
        number: {
          integer: { maximumFractionDigits: 0 },
          currency: { style: 'currency' },
          percent: { style: 'percent' },
        },
        date: {
          short: { month: 'numeric', day: 'numeric', year: '2-digit' },
          medium: { month: 'short', day: 'numeric', year: 'numeric' },
          long: { month: 'long', day: 'numeric', year: 'numeric' },
          full: { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' },
        },
        time: {
          short: { hour: 'numeric', minute: 'numeric' },
          medium: { hour: 'numeric', minute: 'numeric', second: 'numeric' },
          long: { hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' },
          full: { hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' },
        },
      }),
      e
    );
  })(),
  Je;
(function (e) {
  (e.FORMAT_ERROR = 'FORMAT_ERROR'),
    (e.UNSUPPORTED_FORMATTER = 'UNSUPPORTED_FORMATTER'),
    (e.INVALID_CONFIG = 'INVALID_CONFIG'),
    (e.MISSING_DATA = 'MISSING_DATA'),
    (e.MISSING_TRANSLATION = 'MISSING_TRANSLATION');
})(Je || (Je = {}));
var dt = (function (e) {
    Tt(t, e);
    function t(n, i, r) {
      var o = this,
        a = r ? (r instanceof Error ? r : new Error(String(r))) : void 0;
      return (
        (o =
          e.call(
            this,
            '[@formatjs/intl Error '
              .concat(n, '] ')
              .concat(
                i,
                `
`,
              )
              .concat(
                a
                  ? `
`
                      .concat(
                        a.message,
                        `
`,
                      )
                      .concat(a.stack)
                  : '',
              ),
          ) || this),
        (o.code = n),
        typeof Error.captureStackTrace == 'function' && Error.captureStackTrace(o, t),
        o
      );
    }
    return t;
  })(Error),
  Hx = (function (e) {
    Tt(t, e);
    function t(n, i) {
      return e.call(this, Je.UNSUPPORTED_FORMATTER, n, i) || this;
    }
    return t;
  })(dt),
  Ox = (function (e) {
    Tt(t, e);
    function t(n, i) {
      return e.call(this, Je.INVALID_CONFIG, n, i) || this;
    }
    return t;
  })(dt),
  kp = (function (e) {
    Tt(t, e);
    function t(n, i) {
      return e.call(this, Je.MISSING_DATA, n, i) || this;
    }
    return t;
  })(dt),
  pu = (function (e) {
    Tt(t, e);
    function t(n, i, r) {
      return (
        e.call(
          this,
          Je.FORMAT_ERROR,
          ''
            .concat(
              n,
              `
Locale: `,
            )
            .concat(
              i,
              `
`,
            ),
          r,
        ) || this
      );
    }
    return t;
  })(dt),
  Js = (function (e) {
    Tt(t, e);
    function t(n, i, r, o) {
      var a =
        e.call(
          this,
          ''
            .concat(
              n,
              `
MessageID: `,
            )
            .concat(
              r == null ? void 0 : r.id,
              `
Default Message: `,
            )
            .concat(
              r == null ? void 0 : r.defaultMessage,
              `
Description: `,
            )
            .concat(
              r == null ? void 0 : r.description,
              `
`,
            ),
          i,
          o,
        ) || this;
      return (a.descriptor = r), a;
    }
    return t;
  })(pu),
  jx = (function (e) {
    Tt(t, e);
    function t(n, i) {
      var r =
        e.call(
          this,
          Je.MISSING_TRANSLATION,
          'Missing message: "'
            .concat(n.id, '" for locale "')
            .concat(i, '", using ')
            .concat(
              n.defaultMessage
                ? 'default message ('.concat(
                    typeof n.defaultMessage == 'string'
                      ? n.defaultMessage
                      : n.defaultMessage
                          .map(function (o) {
                            var a;
                            return (a = o.value) !== null && a !== void 0 ? a : JSON.stringify(o);
                          })
                          .join(),
                    ')',
                  )
                : 'id',
              ' as fallback.',
            ),
        ) || this;
      return (r.descriptor = n), r;
    }
    return t;
  })(dt);
function si(e, t, n) {
  return (
    n === void 0 && (n = {}),
    t.reduce(function (i, r) {
      return r in e ? (i[r] = e[r]) : r in n && (i[r] = n[r]), i;
    }, {})
  );
}
var Fx = function (e) {},
  zx = function (e) {},
  Tm = {
    formats: {},
    messages: {},
    timeZone: void 0,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: !0,
    onError: Fx,
    onWarn: zx,
  };
function Cm() {
  return { dateTime: {}, number: {}, message: {}, relativeTime: {}, pluralRules: {}, list: {}, displayNames: {} };
}
function zn(e) {
  return {
    create: function () {
      return {
        get: function (t) {
          return e[t];
        },
        set: function (t, n) {
          e[t] = n;
        },
      };
    },
  };
}
function Bx(e) {
  e === void 0 && (e = Cm());
  var t = Intl.RelativeTimeFormat,
    n = Intl.ListFormat,
    i = Intl.DisplayNames,
    r = Bt(
      function () {
        for (var s, l = [], c = 0; c < arguments.length; c++) l[c] = arguments[c];
        return new ((s = Intl.DateTimeFormat).bind.apply(s, Gt([void 0], l, !1)))();
      },
      { cache: zn(e.dateTime), strategy: Ut.variadic },
    ),
    o = Bt(
      function () {
        for (var s, l = [], c = 0; c < arguments.length; c++) l[c] = arguments[c];
        return new ((s = Intl.NumberFormat).bind.apply(s, Gt([void 0], l, !1)))();
      },
      { cache: zn(e.number), strategy: Ut.variadic },
    ),
    a = Bt(
      function () {
        for (var s, l = [], c = 0; c < arguments.length; c++) l[c] = arguments[c];
        return new ((s = Intl.PluralRules).bind.apply(s, Gt([void 0], l, !1)))();
      },
      { cache: zn(e.pluralRules), strategy: Ut.variadic },
    );
  return {
    getDateTimeFormat: r,
    getNumberFormat: o,
    getMessageFormat: Bt(
      function (s, l, c, u) {
        return new Pm(
          s,
          l,
          c,
          F({ formatters: { getNumberFormat: o, getDateTimeFormat: r, getPluralRules: a } }, u || {}),
        );
      },
      { cache: zn(e.message), strategy: Ut.variadic },
    ),
    getRelativeTimeFormat: Bt(
      function () {
        for (var s = [], l = 0; l < arguments.length; l++) s[l] = arguments[l];
        return new (t.bind.apply(t, Gt([void 0], s, !1)))();
      },
      { cache: zn(e.relativeTime), strategy: Ut.variadic },
    ),
    getPluralRules: a,
    getListFormat: Bt(
      function () {
        for (var s = [], l = 0; l < arguments.length; l++) s[l] = arguments[l];
        return new (n.bind.apply(n, Gt([void 0], s, !1)))();
      },
      { cache: zn(e.list), strategy: Ut.variadic },
    ),
    getDisplayNames: Bt(
      function () {
        for (var s = [], l = 0; l < arguments.length; l++) s[l] = arguments[l];
        return new (i.bind.apply(i, Gt([void 0], s, !1)))();
      },
      { cache: zn(e.displayNames), strategy: Ut.variadic },
    ),
  };
}
function hu(e, t, n, i) {
  var r = e && e[t],
    o;
  if ((r && (o = r[n]), o)) return o;
  i(new Hx('No '.concat(t, ' format named: ').concat(n)));
}
function No(e, t) {
  return Object.keys(e).reduce(function (n, i) {
    return (n[i] = F({ timeZone: t }, e[i])), n;
  }, {});
}
function Sp(e, t) {
  var n = Object.keys(F(F({}, e), t));
  return n.reduce(function (i, r) {
    return (i[r] = F(F({}, e[r] || {}), t[r] || {})), i;
  }, {});
}
function Ap(e, t) {
  if (!t) return e;
  var n = Pm.formats;
  return F(F(F({}, n), e), {
    date: Sp(No(n.date, t), No(e.date || {}, t)),
    time: Sp(No(n.time, t), No(e.time || {}, t)),
  });
}
var oc = function (e, t, n, i, r) {
    var o = e.locale,
      a = e.formats,
      s = e.messages,
      l = e.defaultLocale,
      c = e.defaultFormats,
      u = e.fallbackOnEmptyString,
      f = e.onError,
      h = e.timeZone,
      x = e.defaultRichTextElements;
    n === void 0 && (n = { id: '' });
    var y = n.id,
      m = n.defaultMessage;
    cm(
      !!y,
      '[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue',
    );
    var j = String(y),
      p = s && Object.prototype.hasOwnProperty.call(s, j) && s[j];
    if (Array.isArray(p) && p.length === 1 && p[0].type === ue.literal) return p[0].value;
    if (!i && p && typeof p == 'string' && !x) return p.replace(/'\{(.*?)\}'/gi, '{$1}');
    if (((i = F(F({}, x), i || {})), (a = Ap(a, h)), (c = Ap(c, h)), !p)) {
      if (u === !1 && p === '') return p;
      if (((!m || (o && o.toLowerCase() !== l.toLowerCase())) && f(new jx(n, o)), m))
        try {
          var d = t.getMessageFormat(m, l, c, r);
          return d.format(i);
        } catch (g) {
          return (
            f(
              new Js(
                'Error formatting default message for: "'.concat(j, '", rendering default message verbatim'),
                o,
                n,
                g,
              ),
            ),
            typeof m == 'string' ? m : j
          );
        }
      return j;
    }
    try {
      var d = t.getMessageFormat(p, o, a, F({ formatters: t }, r || {}));
      return d.format(i);
    } catch (g) {
      f(
        new Js(
          'Error formatting message: "'.concat(j, '", using ').concat(m ? 'default message' : 'id', ' as fallback.'),
          o,
          n,
          g,
        ),
      );
    }
    if (m)
      try {
        var d = t.getMessageFormat(m, l, c, r);
        return d.format(i);
      } catch (g) {
        f(new Js('Error formatting the default message for: "'.concat(j, '", rendering message verbatim'), o, n, g));
      }
    return typeof p == 'string' ? p : typeof m == 'string' ? m : j;
  },
  bm = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    'numberingSystem',
    'fractionalSecondDigits',
  ];
function Ka(e, t, n, i) {
  var r = e.locale,
    o = e.formats,
    a = e.onError,
    s = e.timeZone;
  i === void 0 && (i = {});
  var l = i.format,
    c = F(F({}, s && { timeZone: s }), l && hu(o, t, l, a)),
    u = si(i, bm, c);
  return (
    t === 'time' &&
      !u.hour &&
      !u.minute &&
      !u.second &&
      !u.timeStyle &&
      !u.dateStyle &&
      (u = F(F({}, u), { hour: 'numeric', minute: 'numeric' })),
    n(r, u)
  );
}
function Ux(e, t) {
  for (var n = [], i = 2; i < arguments.length; i++) n[i - 2] = arguments[i];
  var r = n[0],
    o = n[1],
    a = o === void 0 ? {} : o,
    s = typeof r == 'string' ? new Date(r || 0) : r;
  try {
    return Ka(e, 'date', t, a).format(s);
  } catch (l) {
    e.onError(new dt(Je.FORMAT_ERROR, 'Error formatting date.', l));
  }
  return String(s);
}
function Gx(e, t) {
  for (var n = [], i = 2; i < arguments.length; i++) n[i - 2] = arguments[i];
  var r = n[0],
    o = n[1],
    a = o === void 0 ? {} : o,
    s = typeof r == 'string' ? new Date(r || 0) : r;
  try {
    return Ka(e, 'time', t, a).format(s);
  } catch (l) {
    e.onError(new dt(Je.FORMAT_ERROR, 'Error formatting time.', l));
  }
  return String(s);
}
function $x(e, t) {
  for (var n = [], i = 2; i < arguments.length; i++) n[i - 2] = arguments[i];
  var r = n[0],
    o = n[1],
    a = n[2],
    s = a === void 0 ? {} : a,
    l = e.timeZone,
    c = e.locale,
    u = e.onError,
    f = si(s, bm, l ? { timeZone: l } : {});
  try {
    return t(c, f).formatRange(r, o);
  } catch (h) {
    u(new dt(Je.FORMAT_ERROR, 'Error formatting date time range.', h));
  }
  return String(r);
}
function qx(e, t) {
  for (var n = [], i = 2; i < arguments.length; i++) n[i - 2] = arguments[i];
  var r = n[0],
    o = n[1],
    a = o === void 0 ? {} : o,
    s = typeof r == 'string' ? new Date(r || 0) : r;
  try {
    return Ka(e, 'date', t, a).formatToParts(s);
  } catch (l) {
    e.onError(new dt(Je.FORMAT_ERROR, 'Error formatting date.', l));
  }
  return [];
}
function Vx(e, t) {
  for (var n = [], i = 2; i < arguments.length; i++) n[i - 2] = arguments[i];
  var r = n[0],
    o = n[1],
    a = o === void 0 ? {} : o,
    s = typeof r == 'string' ? new Date(r || 0) : r;
  try {
    return Ka(e, 'time', t, a).formatToParts(s);
  } catch (l) {
    e.onError(new dt(Je.FORMAT_ERROR, 'Error formatting time.', l));
  }
  return [];
}
var Qx = ['style', 'type', 'fallback'];
function Wx(e, t, n, i) {
  var r = e.locale,
    o = e.onError,
    a = Intl.DisplayNames;
  a ||
    o(
      new Hn(
        `Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`,
        Qt.MISSING_INTL_API,
      ),
    );
  var s = si(i, Qx);
  try {
    return t(r, s).of(n);
  } catch (l) {
    o(new dt(Je.FORMAT_ERROR, 'Error formatting display name.', l));
  }
}
var Kx = ['type', 'style'],
  wp = Date.now();
function Jx(e) {
  return ''.concat(wp, '_').concat(e, '_').concat(wp);
}
function Xx(e, t, n, i) {
  i === void 0 && (i = {});
  var r = Im(e, t, n, i).reduce(function (o, a) {
    var s = a.value;
    return (
      typeof s != 'string' ? o.push(s) : typeof o[o.length - 1] == 'string' ? (o[o.length - 1] += s) : o.push(s), o
    );
  }, []);
  return r.length === 1 ? r[0] : r.length === 0 ? '' : r;
}
function Im(e, t, n, i) {
  var r = e.locale,
    o = e.onError;
  i === void 0 && (i = {});
  var a = Intl.ListFormat;
  a ||
    o(
      new Hn(
        `Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`,
        Qt.MISSING_INTL_API,
      ),
    );
  var s = si(i, Kx);
  try {
    var l = {},
      c = n.map(function (u, f) {
        if (typeof u == 'object') {
          var h = Jx(f);
          return (l[h] = u), h;
        }
        return String(u);
      });
    return t(r, s)
      .formatToParts(c)
      .map(function (u) {
        return u.type === 'literal' ? u : F(F({}, u), { value: l[u.value] || u.value });
      });
  } catch (u) {
    o(new dt(Je.FORMAT_ERROR, 'Error formatting list.', u));
  }
  return n;
}
var Zx = ['type'];
function Yx(e, t, n, i) {
  var r = e.locale,
    o = e.onError;
  i === void 0 && (i = {}),
    Intl.PluralRules ||
      o(
        new Hn(
          `Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`,
          Qt.MISSING_INTL_API,
        ),
      );
  var a = si(i, Zx);
  try {
    return t(r, a).select(n);
  } catch (s) {
    o(new pu('Error formatting plural.', r, s));
  }
  return 'other';
}
var ey = ['numeric', 'style'];
function ty(e, t, n) {
  var i = e.locale,
    r = e.formats,
    o = e.onError;
  n === void 0 && (n = {});
  var a = n.format,
    s = (!!a && hu(r, 'relative', a, o)) || {},
    l = si(n, ey, s);
  return t(i, l);
}
function ny(e, t, n, i, r) {
  r === void 0 && (r = {}), i || (i = 'second');
  var o = Intl.RelativeTimeFormat;
  o ||
    e.onError(
      new Hn(
        `Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`,
        Qt.MISSING_INTL_API,
      ),
    );
  try {
    return ty(e, t, r).format(n, i);
  } catch (a) {
    e.onError(new pu('Error formatting relative time.', e.locale, a));
  }
  return String(n);
}
var iy = [
  'style',
  'currency',
  'currencyDisplay',
  'unit',
  'unitDisplay',
  'useGrouping',
  'minimumIntegerDigits',
  'minimumFractionDigits',
  'maximumFractionDigits',
  'minimumSignificantDigits',
  'maximumSignificantDigits',
  'compactDisplay',
  'currencyDisplay',
  'currencySign',
  'notation',
  'signDisplay',
  'unit',
  'unitDisplay',
  'numberingSystem',
];
function Lm(e, t, n) {
  var i = e.locale,
    r = e.formats,
    o = e.onError;
  n === void 0 && (n = {});
  var a = n.format,
    s = (a && hu(r, 'number', a, o)) || {},
    l = si(n, iy, s);
  return t(i, l);
}
function ry(e, t, n, i) {
  i === void 0 && (i = {});
  try {
    return Lm(e, t, i).format(n);
  } catch (r) {
    e.onError(new dt(Je.FORMAT_ERROR, 'Error formatting number.', r));
  }
  return String(n);
}
function oy(e, t, n, i) {
  i === void 0 && (i = {});
  try {
    return Lm(e, t, i).formatToParts(n);
  } catch (r) {
    e.onError(new dt(Je.FORMAT_ERROR, 'Error formatting number.', r));
  }
  return [];
}
function ay(e) {
  var t = e ? e[Object.keys(e)[0]] : void 0;
  return typeof t == 'string';
}
function sy(e) {
  e.onWarn &&
    e.defaultRichTextElements &&
    ay(e.messages || {}) &&
    e.onWarn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.io/docs/getting-started/message-distribution`);
}
function ly(e, t) {
  var n = Bx(t),
    i = F(F({}, Tm), e),
    r = i.locale,
    o = i.defaultLocale,
    a = i.onError;
  return (
    r
      ? !Intl.NumberFormat.supportedLocalesOf(r).length && a
        ? a(
            new kp(
              'Missing locale data for locale: "'
                .concat(r, '" in Intl.NumberFormat. Using default locale: "')
                .concat(
                  o,
                  '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details',
                ),
            ),
          )
        : !Intl.DateTimeFormat.supportedLocalesOf(r).length &&
          a &&
          a(
            new kp(
              'Missing locale data for locale: "'
                .concat(r, '" in Intl.DateTimeFormat. Using default locale: "')
                .concat(
                  o,
                  '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details',
                ),
            ),
          )
      : (a &&
          a(
            new Ox(
              '"locale" was not configured, using "'.concat(
                o,
                '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details',
              ),
            ),
          ),
        (i.locale = i.defaultLocale || 'en')),
    sy(i),
    F(F({}, i), {
      formatters: n,
      formatNumber: ry.bind(null, i, n.getNumberFormat),
      formatNumberToParts: oy.bind(null, i, n.getNumberFormat),
      formatRelativeTime: ny.bind(null, i, n.getRelativeTimeFormat),
      formatDate: Ux.bind(null, i, n.getDateTimeFormat),
      formatDateToParts: qx.bind(null, i, n.getDateTimeFormat),
      formatTime: Gx.bind(null, i, n.getDateTimeFormat),
      formatDateTimeRange: $x.bind(null, i, n.getDateTimeFormat),
      formatTimeToParts: Vx.bind(null, i, n.getDateTimeFormat),
      formatPlural: Yx.bind(null, i, n.getPluralRules),
      formatMessage: oc.bind(null, i, n),
      $t: oc.bind(null, i, n),
      formatList: Xx.bind(null, i, n.getListFormat),
      formatListToParts: Im.bind(null, i, n.getListFormat),
      formatDisplayName: Wx.bind(null, i, n.getDisplayNames),
    })
  );
}
function fu(e) {
  cm(e, '[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.');
}
var Nm = F(F({}, Tm), { textComponent: B.exports.Fragment });
function cy(e) {
  return function (t) {
    return e(B.exports.Children.toArray(t));
  };
}
function uy(e, t) {
  if (e === t) return !0;
  if (!e || !t) return !1;
  var n = Object.keys(e),
    i = Object.keys(t),
    r = n.length;
  if (i.length !== r) return !1;
  for (var o = 0; o < r; o++) {
    var a = n[o];
    if (e[a] !== t[a] || !Object.prototype.hasOwnProperty.call(t, a)) return !1;
  }
  return !0;
}
function dy(e) {
  return e.displayName || e.name || 'Component';
}
var mu = B.exports.createContext(null),
  py = mu.Consumer,
  hy = mu.Provider,
  fy = hy,
  my = mu;
function er(e, t) {
  var n = t || {},
    i = n.intlPropName,
    r = i === void 0 ? 'intl' : i,
    o = n.forwardRef,
    a = o === void 0 ? !1 : o,
    s = n.enforceContext,
    l = s === void 0 ? !0 : s,
    c = function (u) {
      return _(py, {
        children: function (f) {
          var h;
          l && fu(f);
          var x = ((h = {}), (h[r] = f), h);
          return _(e, { ...F({}, u, x, { ref: a ? u.forwardedRef : null }) });
        },
      });
    };
  return (
    (c.displayName = 'injectIntl('.concat(dy(e), ')')),
    (c.WrappedComponent = e),
    hp(
      a
        ? B.exports.forwardRef(function (u, f) {
            return _(c, { ...F({}, u, { forwardedRef: f }) });
          })
        : c,
      e,
    )
  );
}
function Rm() {
  var e = B.exports.useContext(my);
  return fu(e), e;
}
var ac;
(function (e) {
  (e.formatDate = 'FormattedDate'),
    (e.formatTime = 'FormattedTime'),
    (e.formatNumber = 'FormattedNumber'),
    (e.formatList = 'FormattedList'),
    (e.formatDisplayName = 'FormattedDisplayName');
})(ac || (ac = {}));
var sc;
(function (e) {
  (e.formatDate = 'FormattedDateParts'),
    (e.formatTime = 'FormattedTimeParts'),
    (e.formatNumber = 'FormattedNumberParts'),
    (e.formatList = 'FormattedListParts');
})(sc || (sc = {}));
function Dm(e) {
  var t = function (n) {
    var i = Rm(),
      r = n.value,
      o = n.children,
      a = ru(n, ['value', 'children']),
      s = typeof r == 'string' ? new Date(r || 0) : r,
      l = e === 'formatDate' ? i.formatDateToParts(s, a) : i.formatTimeToParts(s, a);
    return o(l);
  };
  return (t.displayName = sc[e]), t;
}
function ro(e) {
  var t = function (n) {
    var i = Rm(),
      r = n.value,
      o = n.children,
      a = ru(n, ['value', 'children']),
      s = i[e](r, a);
    if (typeof o == 'function') return o(s);
    var l = i.textComponent || B.exports.Fragment;
    return _(l, { children: s });
  };
  return (t.displayName = ac[e]), t;
}
function Xs(e) {
  return {
    locale: e.locale,
    timeZone: e.timeZone,
    fallbackOnEmptyString: e.fallbackOnEmptyString,
    formats: e.formats,
    textComponent: e.textComponent,
    messages: e.messages,
    defaultLocale: e.defaultLocale,
    defaultFormats: e.defaultFormats,
    onError: e.onError,
    onWarn: e.onWarn,
    wrapRichTextChunksInFragment: e.wrapRichTextChunksInFragment,
    defaultRichTextElements: e.defaultRichTextElements,
  };
}
function Hm(e) {
  return (
    e &&
    Object.keys(e).reduce(function (t, n) {
      var i = e[n];
      return (t[n] = Mm(i) ? cy(i) : i), t;
    }, {})
  );
}
var Mp = function (e, t, n, i) {
    for (var r = [], o = 4; o < arguments.length; o++) r[o - 4] = arguments[o];
    var a = Hm(i),
      s = oc.apply(void 0, Gt([e, t, n, a], r, !1));
    return Array.isArray(s) ? B.exports.Children.toArray(s) : s;
  },
  Pp = function (e, t) {
    var n = e.defaultRichTextElements,
      i = ru(e, ['defaultRichTextElements']),
      r = Hm(n),
      o = ly(F(F(F({}, Nm), i), { defaultRichTextElements: r }), t),
      a = {
        locale: o.locale,
        timeZone: o.timeZone,
        fallbackOnEmptyString: o.fallbackOnEmptyString,
        formats: o.formats,
        defaultLocale: o.defaultLocale,
        defaultFormats: o.defaultFormats,
        messages: o.messages,
        onError: o.onError,
        defaultRichTextElements: r,
      };
    return F(F({}, o), { formatMessage: Mp.bind(null, a, o.formatters), $t: Mp.bind(null, a, o.formatters) });
  },
  gy = (function (e) {
    Tt(t, e);
    function t() {
      var n = (e !== null && e.apply(this, arguments)) || this;
      return (
        (n.cache = Cm()), (n.state = { cache: n.cache, intl: Pp(Xs(n.props), n.cache), prevConfig: Xs(n.props) }), n
      );
    }
    return (
      (t.getDerivedStateFromProps = function (n, i) {
        var r = i.prevConfig,
          o = i.cache,
          a = Xs(n);
        return uy(r, a) ? null : { intl: Pp(a, o), prevConfig: a };
      }),
      (t.prototype.render = function () {
        return fu(this.state.intl), _(fy, { value: this.state.intl, children: this.props.children });
      }),
      (t.displayName = 'IntlProvider'),
      (t.defaultProps = Nm),
      t
    );
  })(B.exports.PureComponent);
const vy = gy;
ro('formatDate');
ro('formatTime');
ro('formatNumber');
ro('formatList');
ro('formatDisplayName');
Dm('formatDate');
Dm('formatTime');
async function _y(e) {
  const t = document.getElementById('microsite-header');
  if (t.innerText.trim() === '') {
    let n = await fetch(`/assets/views/header.html?lang=${e}`);
    t.innerHTML = await n.text();
  }
}
async function xy(e) {
  if (document.getElementById('microsite-footer').innerText.trim() === '') {
    let n = await fetch(`/assets/views/footer.html?lang=${e}`);
    document.getElementById('microsite-footer').innerHTML = await n.text();
  }
}
async function yy() {}
const Ey = {
    title: { id: 'nav.title', defaultMessage: 'AEM Headless CMS developer portal' },
    home: { id: 'nav.home', defaultMessage: 'Home', description: 'Navigation label' },
    codePlayground: { id: 'nav.codePlayground', defaultMessage: 'Code playground', description: 'Navigation label' },
  },
  ky = { nav: Ey },
  Sy = {
    title: { id: 'error.title', defaultMessage: 'Oops! An error occurred.' },
    text: { id: 'error.text', defaultMessage: 'Sorry! Something went wrong. Please try again later.' },
  },
  Ay = {
    title: {
      id: 'page.title',
      defaultMessage: 'AEM Headless CMS Developer Resources and Documentation | Adobe Experience Manager',
    },
    description: {
      id: 'page.description',
      defaultMessage:
        'Visit the AEM Headless CMS developer resources and documentation. Learn how to build next generation apps using headless CMS technologies in Experience Manager as a Cloud Service.',
    },
  },
  wy = '/static-assets/hero__video-placeholder.c304e282.png',
  My = {
    product: {
      id: 'app.hero.solution',
      defaultMessage: 'Adobe Experience Manager Headless',
      description: 'Adobe product name',
    },
    title: { id: 'app.hero.title', defaultMessage: 'Start building with AEM Headless CMS' },
    text: {
      id: 'app.hero.text',
      defaultMessage:
        'Everything you need to learn about AEM headless CMS to build and ship better applications and faster experiences.',
    },
    cta: { id: 'app.hero.cta', defaultMessage: 'Watch how it works', description: 'Button label' },
    video: '339031',
    placeholderImage: wy,
  },
  Py = {
    title: { id: 'what_is_headless.title', defaultMessage: 'What is AEM Headless CMS?' },
    text: {
      id: 'what_is_headless.text',
      defaultMessage:
        "AEM Headless CMS gives developers the freedom to do what they do best: build faster and deliver exceptional experiences using the languages, frameworks, and tools they're already familiar with.",
    },
  },
  Ty = '/static-assets/journey.8369aa1a.png',
  Cy = {
    image: Ty,
    title: { id: 'new_developers.title', defaultMessage: 'FOR DEVELOPERS { emphasis } TO AEM HEADLESS CMS' },
    title_emphasis: { id: 'new_developers.title.emphasis', defaultMessage: 'NEW' },
    text: {
      id: 'new_developers.text',
      defaultMessage:
        'Read this { guideLink }  to learn about headless CMS features of AEM and how to leverage them in a headless development project.',
    },
    text_guide_link: { id: 'new_developers.text.guide_link', defaultMessage: 'guide' },
    links: [
      {
        id: 'new_to_aem_headless.links.0',
        defaultMessage: 'Read the guide ',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/headless/journeys/developer/overview.html',
      },
    ],
  },
  by = '/static-assets/5-steps.bf43c494.png',
  Iy = {
    image: by,
    title: { id: 'experienced_developers.title', defaultMessage: 'FOR { emphasis } AEM HEADLESS CMS DEVELOPERS' },
    title_emphasis: { id: 'experienced_developers.title.emphasis', defaultMessage: 'EXPERIENCED' },
    text: {
      id: 'experienced_developers.text1',
      defaultMessage:
        'Go through { fiveSteps} for creating, managing, and delivering experiences using AEM. { break } Already done? Head over to our { advancedDocumentation }.',
    },
    text_5_steps: { id: 'new_developers.text.5_steps', defaultMessage: '5 steps' },
    text_advanced_documentation: {
      id: 'new_developers.text.advanced_documentation',
      defaultMessage: 'advanced documentation',
    },
    links: [],
  },
  Ly = { title: { id: 'section_example_apps.title', defaultMessage: 'Example AEM Headless CMS apps' } },
  Ny = '/static-assets/android.4c9b7e9f.webp',
  Ry = {
    image: Ny,
    title: { id: 'example_apps_android.title', defaultMessage: 'Android' },
    text: {
      id: 'example_apps_android.text',
      defaultMessage: 'An example Java Android app that consumes content from AEM Headless APIs.',
    },
    links: [
      {
        id: 'example_apps_android.links.0',
        defaultMessage: 'View the app',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/example-apps/android-app.html',
      },
    ],
  },
  Dy = '/static-assets/ios.00440c07.webp',
  Hy = {
    image: Dy,
    title: { id: 'example_apps_ios.title', defaultMessage: 'iOS' },
    text: {
      id: 'example_apps_ios.text',
      defaultMessage: 'An example SwiftUI iOS app that consumes content from AEM Headless APIs.',
    },
    links: [
      {
        id: 'example_apps_ios.links.0',
        defaultMessage: 'View the app',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/example-apps/ios-swiftui-app.html',
      },
    ],
  },
  Oy = '/static-assets/next-js.042d4a9d.webp',
  jy = {
    image: Oy,
    title: { id: 'example_apps_next_js.title', defaultMessage: 'Next.js' },
    text: {
      id: 'example_apps_next_js.text',
      defaultMessage: 'An example Next.js application that consumes content from AEM Headless APIs.',
    },
    links: [
      {
        id: 'example_apps_next_js.links.0',
        defaultMessage: 'View the app',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/example-apps/next-js.html',
      },
    ],
  },
  Fy = '/static-assets/node-js.f489114c.webp',
  zy = {
    image: Fy,
    title: { id: 'example_apps_node-js.title', defaultMessage: 'Node.js' },
    text: {
      id: 'example_apps_node-js.text',
      defaultMessage: 'An example command-line Node.js application that consumes content from AEM Headless APIs.',
    },
    links: [
      {
        id: 'example_apps_node-js.links.0',
        defaultMessage: 'View the app',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/example-apps/server-to-server-app.html',
      },
    ],
  },
  By = '/static-assets/react.bca24be6.webp',
  Uy = {
    image: By,
    title: { id: 'example_apps_react.title', defaultMessage: 'React' },
    text: {
      id: 'example_apps_react.text',
      defaultMessage: 'An example React application that consumes content from AEM Headless APIs.',
    },
    links: [
      {
        id: 'example_apps_react.links.0',
        defaultMessage: 'View the app',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/example-apps/react-app.html',
      },
    ],
  },
  Gy = '/static-assets/web-component.d0252110.webp',
  $y = {
    image: Gy,
    title: { id: 'example_apps_web-component.title', defaultMessage: 'Web Component/JS' },
    text: {
      id: 'example_apps_web-component.text',
      defaultMessage: 'An example pure JavaScript Web Component that consumes content from AEM Headless APIs.',
    },
    links: [
      {
        id: 'example_apps_web-component.links.0',
        defaultMessage: 'View the app',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/example-apps/web-component.html',
      },
    ],
  },
  qy = { android: Ry, ios: Hy, next_js: jy, node_js: zy, react: Uy, web_component: $y },
  Vy = {
    title: { id: 'section_spa_editor.title', defaultMessage: 'Explore the AEM SPA Editor' },
    text: {
      id: 'section_spa_editor.text',
      defaultMessage:
        'The AEM SPA Editor provides a framework to develop React or Angular apps that can be updated in-context by marketers using the AEM authoring UI.',
    },
  },
  Qy = '/static-assets/spa-editor.0cbf214d.png',
  Wy = {
    image: Qy,
    title: { id: 'spa_editor.title', defaultMessage: 'Manage a SPA in AEM' },
    text: {
      id: 'spa_editor.text',
      defaultMessage:
        'The AEM SPA Editor can be used to create a SPA whose components, routing, and views can be completely managed in AEM. The SPA Editor supports the React framework.',
    },
    links: [
      {
        id: 'spa_editor.links.0',
        defaultMessage: 'Start the React tutorial',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/spa-editor/react/overview.html',
      },
    ],
  },
  Ky = {
    image: 'https://cdn.experienceleague.adobe.com/thumb/333181.jpg',
    title: { id: 'spa_editor_remote_spa.title', defaultMessage: 'Author a remote SPA' },
    text: {
      id: 'spa_editor_remote_spa.text',
      defaultMessage:
        "AEM's Remote SPA capabilities enables marketers to update targeted regions of a remotely hosted SPA.",
    },
    links: [
      {
        id: 'spa_editor_remote_spa.links.0',
        defaultMessage: 'Start the tutorial',
        link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/spa-editor/remote-spa/overview.html',
      },
    ],
  },
  Jy = {
    title: { id: 'section_developer_resources.title', defaultMessage: 'Advanced documentation' },
    slug: 'advanced-documentation',
  },
  Xy = {
    title: { id: 'technical_docs.tools.title', defaultMessage: 'Tools' },
    text: { id: 'technical_docs.tools.text', defaultMessage: "Explore AEM's headless developer tools." },
    lists: [
      {
        title: { id: 'technical_docs.tools.section.graphiql', defaultMessage: 'GraphiQL' },
        links: [
          {
            id: 'technical_docs.tools.section.graphiql.links.0',
            defaultMessage: 'GraphiQL IDE',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/headless/graphql-api/graphiql-ide.html',
          },
          {
            id: 'technical_docs.tools.section.graphiql.links.1',
            defaultMessage: 'AEM 6.5 GraphiQL installation guide',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/install-graphiql-aem-6-5.html',
          },
        ],
      },
    ],
  },
  Zy = {
    title: { id: 'technical_docs.sdks.title', defaultMessage: 'SDKs' },
    text: {
      id: 'technical_docs.sdks.text',
      defaultMessage: 'Use AEM Headless SDKs to interact with AEM Headless APIs.',
    },
    lists: [
      {
        title: { id: 'technical_docs.sdks.section.javascript', defaultMessage: 'JavaScript' },
        links: [
          {
            id: 'technical_docs.sdks.section.javascript.links.0',
            defaultMessage: 'Client-side JS SDK',
            link: 'https://github.com/adobe/aem-headless-client-js',
          },
          {
            id: 'technical_docs.sdks.section.javascript.links.1',
            defaultMessage: 'Server-side JS SDK',
            link: 'https://github.com/adobe/aem-headless-client-nodejs',
          },
          {
            id: 'technical_docs.sdks.section.javascript.links.2',
            defaultMessage: 'jwt-auth npm module',
            link: 'https://www.npmjs.com/package/@adobe/jwt-auth',
          },
        ],
      },
      {
        title: { id: 'technical_docs.sdks.section.java', defaultMessage: 'Java' },
        links: [
          {
            id: 'technical_docs.sdks.section.java.links.0',
            defaultMessage: 'Java SDK',
            link: 'https://github.com/adobe/aem-headless-client-java',
          },
        ],
      },
    ],
  },
  Yy = {
    title: { id: 'technical_docs.apis.title', defaultMessage: 'APIs' },
    text: {
      id: 'technical_docs.apis.text',
      defaultMessage: "Learn about AEM's GraphQL APIs and how to construct queries and HTTP requests.",
    },
    lists: [
      {
        title: { id: 'technical_docs.apis.section.graphqlapis', defaultMessage: 'GraphQL APIs' },
        links: [
          {
            id: 'technical_docs.apis.section.graphqlapis.links.0',
            defaultMessage: 'GraphQL API',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/headless/graphql-api/content-fragments.html',
          },
          {
            id: 'technical_docs.apis.section.graphqlapis.links.1',
            defaultMessage: 'Sample GraphQL queries',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/headless/graphql-api/sample-queries.html',
          },
        ],
      },
      {
        title: { id: 'technical_docs.apis.section.relatedhttpapis', defaultMessage: 'Related HTTP APIs' },
        links: [
          {
            id: 'technical_docs.apis.section.relatedhttpapis.links.0',
            defaultMessage: 'AEM Assets HTTP API',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/assets/admin/mac-api-assets.html',
          },
        ],
      },
      {
        title: { id: 'technical_docs.apis.section.formsapis', defaultMessage: 'AEM Forms HTTP APIs' },
        links: [
          {
            id: 'technical_docs.apis.section.formsapis.links.0',
            defaultMessage: 'AEM Forms API (OpenAPI)',
            link: 'https://opensource.adobe.com/aem-forms-af-runtime/api/',
          },
        ],
      },
    ],
  },
  eE = {
    title: { id: 'technical_docs.documentation.title', defaultMessage: 'Additional documentation' },
    text: {
      id: 'technical_docs.documentation.text',
      defaultMessage:
        "View Adobe Experience Manager as a Cloud Services documentation for the complete description of AEM's capabilities and configurations.",
    },
    lists: [
      {
        title: { id: 'technical_docs.documentation.section.contentfragments', defaultMessage: 'Content Fragments' },
        links: [
          {
            id: 'technical_docs.documentation.section.contentfragments.links.0',
            defaultMessage: 'Enabling Contents Fragments',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/assets/content-fragments/content-fragments-configuration-browser.html',
          },
          {
            id: 'technical_docs.documentation.section.contentfragments.links.1',
            defaultMessage: 'Content Fragment Models',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/assets/content-fragments/content-fragments-models.html',
          },
          {
            id: 'technical_docs.documentation.section.contentfragments.links.2',
            defaultMessage: 'Managing Content Fragments',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/assets/content-fragments/content-fragments-managing.html',
          },
          {
            id: 'technical_docs.documentation.section.contentfragments.links.3',
            defaultMessage: 'Variations',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/assets/content-fragments/content-fragments-variations.html',
          },
          {
            id: 'technical_docs.documentation.section.contentfragments.links.4',
            defaultMessage: 'Associated content',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/assets/content-fragments/content-fragments-assoc-content.html',
          },
          {
            id: 'technical_docs.documentation.section.contentfragments.links.5',
            defaultMessage: 'Metadata',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/assets/content-fragments/content-fragments-metadata.html',
          },
          {
            id: 'technical_docs.documentation.section.contentfragments.links.6',
            defaultMessage: 'Markdown',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/assets/content-fragments/content-fragments-markdown.html',
          },
          {
            id: 'technical_docs.documentation.section.contentfragments.links.7',
            defaultMessage: 'Structure tree',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/assets/content-fragments/content-fragments-structure-tree.html',
          },
          {
            id: 'technical_docs.documentation.section.contentfragments.links.8',
            defaultMessage: 'JSON preview',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/assets/content-fragments/content-fragments-json-preview.html',
          },
        ],
      },
      {
        title: {
          id: 'technical_docs.documentation.section.graphqlaemendpoint',
          defaultMessage: 'GraphQL AEM endpoint',
        },
        links: [
          {
            id: 'technical_docs.documentation.section.graphqlaemendpoint.links.0',
            defaultMessage: 'Enabling a GraphQL endpoint',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/headless/graphql-api/graphql-endpoint.html#enabling-graphql-endpoint',
          },
          {
            id: 'technical_docs.documentation.section.graphqlaemendpoint.links.1',
            defaultMessage: 'Publishing a GraphQL endpoint',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/headless/graphql-api/graphql-endpoint.html#publishing-graphql-endpoint',
          },
          {
            id: 'technical_docs.documentation.section.graphqlaemendpoint.links.2',
            defaultMessage: 'Persisted queries',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/headless/graphql-api/graphiql-ide.html#creating-new-query',
          },
          {
            id: 'technical_docs.documentation.section.graphqlaemendpoint.links.3',
            defaultMessage: 'Publish Persisted queries',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/headless/graphql-api/graphiql-ide.html#publishing-persisted-queries',
          },
        ],
      },
      {
        title: { id: 'technical_docs.documentation.section.forms', defaultMessage: 'AEM Forms' },
        links: [
          {
            id: 'technical_docs.documentation.section.forms.links.0',
            defaultMessage: 'Headless Adaptive Forms',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-headless-adaptive-forms/using/overview.html',
          },
        ],
      },
    ],
  },
  tE = {
    title: { id: 'technical_docs.how-to.title', defaultMessage: 'How-to guides' },
    text: {
      id: 'technical_docs.how-to.text',
      defaultMessage: 'Learn how to approach different use cases with AEM Headless.',
    },
    lists: [
      {
        title: { id: 'technical_docs.how-to.section.content', defaultMessage: 'Content' },
        links: [
          {
            id: 'technical_docs.how-to.section.content.links.1',
            defaultMessage: 'Images',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/graphql/how-to/images.html',
          },
          {
            id: 'technical_docs.how-to.section.content.links.3',
            defaultMessage: 'Large result sets',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/large-result-sets.html',
          },
          {
            id: 'technical_docs.how-to.section.content.links.2',
            defaultMessage: 'Localized Content',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/graphql/how-to/localized-content.html',
          },
          {
            id: 'technical_docs.how-to.section.content.links.4',
            defaultMessage: 'Preview',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/preview.html',
          },
          {
            id: 'technical_docs.how-to.section.content.links.0',
            defaultMessage: 'Rich Text',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/graphql/how-to/rich-text.html',
          },
        ],
      },
      {
        title: { id: 'technical_docs.how-to.section.development', defaultMessage: 'Development' },
        links: [
          {
            id: 'technical_docs.how-to.section.development.links.0',
            defaultMessage: 'AEM Headless SDK',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/aem-headless-sdk.html',
          },
          {
            id: 'technical_docs.how-to.section.development.links.1',
            defaultMessage: 'Install GraphiQL IDE on AEM 6.5',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/how-to/install-graphiql-aem-6-5.html',
          },
        ],
      },
      {
        title: { id: 'technical_docs.how-to.section.deployment', defaultMessage: 'Deployment' },
        links: [
          {
            id: 'technical_docs.how-to.section.deployment.links.2',
            defaultMessage: 'Mobile',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/deployments/mobile.html',
          },
          {
            id: 'technical_docs.how-to.section.deployment.links.3',
            defaultMessage: 'Server-to-server',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/deployments/server-to-server.html',
          },
          {
            id: 'technical_docs.how-to.section.deployment.links.0',
            defaultMessage: 'Single-page app',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/deployments/spa.html',
          },
          {
            id: 'technical_docs.how-to.section.deployment.links.1',
            defaultMessage: 'Web component',
            link: 'https://experienceleague.adobe.com/docs/experience-manager-learn/getting-started-with-aem-headless/deployments/web-component.html',
          },
        ],
      },
    ],
  },
  nE = { title: { id: 'section_get_involved.title', defaultMessage: 'Get involved!' } },
  iE = '/static-assets/book.5ff13042.png',
  rE = {
    icon: iE,
    title: { id: 'get_involved_blog.title', defaultMessage: 'Adobe Tech Blog' },
    text: { id: 'get_involved_blog.text', defaultMessage: 'Read the latest on our tech blog.' },
    links: [
      {
        id: 'get_involved_blog.links.0',
        defaultMessage: 'Read the blog',
        description: 'CTA button label',
        link: 'https://blog.developer.adobe.com/search?q=headless',
      },
    ],
  },
  oE = '/static-assets/dicussion.5d531cb9.png',
  aE = {
    icon: oE,
    title: { id: 'get_involved_community.title', defaultMessage: 'Experience League Communities' },
    text: {
      id: 'get_involved_community.text',
      defaultMessage: 'Join our community and get answers to your questions.',
    },
    links: [
      {
        id: 'get_involved_community.links.0',
        defaultMessage: 'Join the conversation',
        description: 'CTA button label',
        link: 'https://experienceleaguecommunities.adobe.com/t5/adobe-experience-manager/ct-p/experience-manager-headless-community',
      },
    ],
  },
  sE = {
    page: Ay,
    hero: My,
    what_is_headless: Py,
    new_developers: Cy,
    experienced_developers: Iy,
    section_developer_resources: Jy,
    technical_docs: [Zy, Yy, Xy, tE, eE],
    section_example_apps: Ly,
    example_apps: qy,
    section_get_involved: nE,
    get_involved_blog: rE,
    get_involved_community: aE,
    section_spa_editor: Vy,
    spa_editor: Wy,
    spa_editor_remote_spa: Ky,
  },
  lE = {
    title: { id: 'code_index.title', defaultMessage: 'Code playground' },
    text: {
      id: 'code_index.text',
      defaultMessage: 'Test drive AEM Headless CMS in seconds using example JavaScript apps!',
    },
    button_run_the_code: { id: 'code_index.button.run_the_code', defaultMessage: 'Run the code' },
    code: {
      'basic-react-app': {
        articleId: 'basic-react-app',
        codeId: 'wknd-react-app-lz5elr',
        type: 'codesandbox',
        tags: ['React'],
      },
      'basic-nextjs-app': {
        articleId: 'basic-nextjs-app',
        codeId: 'wknd-next-js-app-u8x5f8',
        type: 'codesandbox',
        tags: ['Next.js'],
      },
      'filtering-sveltekit-app': {
        articleId: 'filtering-sveltekit-app',
        codeId: 'wknd-sveltekit-bsj8m2',
        type: 'codesandbox',
        tags: ['Svelte', 'SvelteKit'],
      },
      'filtering-react-app': { articleId: 'filtering-react-app', codeId: 'XWqLbPZ', type: 'codepen', tags: ['React'] },
      'filtering-vue-app': { articleId: 'filtering-vue-app', codeId: 'XWYrwpb', type: 'codepen', tags: ['Vue'] },
      'filtering-angular-app': {
        articleId: 'filtering-angular-app',
        codeId: 'zYVVvmg',
        type: 'codepen',
        tags: ['Angular'],
      },
      'filtering-preact-app': {
        articleId: 'filtering-preact-app',
        codeId: 'MWXKdwp',
        type: 'codepen',
        tags: ['Preact'],
      },
      'filtering-express-pug-app': {
        articleId: 'filtering-express-pug-app',
        codeId: 'wknd-nodejs-pugjs-7syir4',
        type: 'codesandbox',
        tags: ['Express', 'Pug'],
      },
      'filtering-jquery-handlebars': {
        articleId: 'filtering-jquery-handlebars',
        codeId: 'ZEoNgOg',
        type: 'codepen',
        tags: ['jQuery', 'Handlebars'],
      },
    },
  },
  cE = {
    button_back: { id: 'code_by_id.button.back', defaultMessage: 'Back to code playground' },
    button_enter_widescreen: { id: 'code_by_id.button.enter_widescreen', defaultMessage: 'Enter widescreen mode' },
    button_exit_widescreen: { id: 'code_by_id.button.exit_widescreen', defaultMessage: 'Exit widescreen mode' },
  },
  oo = { common: ky, error: Sy, home: sE, code_index: lE, code_by_id: cE };
const uE = ({ handleClose: e, contentType: t, iFrameSrc: n, isActive: i }) => {
  let r = 'modal ' + t;
  return (
    (r = i ? r + ' is-active' : r),
    W('div', {
      className: r,
      children: [
        _('div', { className: 'modal-background' }),
        _('div', {
          className: 'modal-content has-text-centered',
          children: W('div', {
            className: 'modal-content-wrapper',
            children: [
              dE(n, i),
              _('button', {
                className: 'modal-close is-large',
                'aria-label': 'close',
                'data-track': 'Close overview video modal',
                onClick: e,
              }),
            ],
          }),
        }),
      ],
    })
  );
};
function dE(e, t) {
  return t
    ? _('iframe', {
        className: 'modal-iframe',
        title: 'iFrame Video',
        src: e,
        frameBorder: '0',
        webkitallowfullscreen: 'true',
        mozallowfullscreen: 'true',
        allowFullScreen: !0,
        scrolling: 'no',
        allow: 'autoplay',
      })
    : null;
}
function pE(e) {
  const [t, n] = B.exports.useState(!1);
  return _('section', {
    className: 'hero',
    children: _('div', {
      className: 'hero__inner',
      children: W('div', {
        className: 'hero__content',
        children: [
          W('div', {
            className: 'hero__content--text',
            children: [
              _('h1', { className: 'title is-size-7 is-uppercase has-text-whitest', children: e.product }),
              _('h2', {
                className: 'subtitle is-size-36 is-size-34-touch is-margin-bottom-small has-text-whitest is-extra-bold',
                children: e.title,
              }),
              _('p', { className: 'is-size-18 has-text-whitest is-margin-bottom-big', children: e.text }),
              W('button', {
                className:
                  'hero__content--cta spectrum-Button spectrum-Button--primary spectrum-Button--sizeM is-margin-bottom-big',
                'data-track': 'Open overview video modal',
                onClick: () => n(!0),
                children: [
                  _('figure', {
                    className: 'spectrum-Icon spectrum-Icon--sizeM',
                    children: _('img', { src: '/static-assets/play.svg', loading: 'lazy', alt: e.cta }),
                  }),
                  _('span', { className: 'spectrum-Button-label', children: e.ctaLabel }),
                ],
              }),
            ],
          }),
          W('div', {
            className: 'hero__content--videoplaceholder',
            'data-track': 'Open overview video modal',
            onClick: () => n(!0),
            children: [
              _('div', {
                className: 'mpc-playbutton',
                children: _('button', {
                  'aria-label': 'play',
                  className: 'mpc-large-play mpc-player__large-play',
                  children: _('div', {
                    className: 'mpc-large-play__circle',
                    children: W('svg', {
                      xmlns: 'http://www.w3.org/2000/svg',
                      width: '24',
                      height: '24',
                      viewBox: '0 0 24 24',
                      className: 'mpc-large-play__icon',
                      children: [
                        _('path', { d: 'M8 5v14l11-7z' }),
                        ' ',
                        _('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
                      ],
                    }),
                  }),
                }),
              }),
              _('img', { className: 'hero__videoplaceholder', src: e.videoPlaceholder, alt: 'video placeholder' }),
            ],
          }),
          _(uE, {
            isActive: t,
            contentType: 'video',
            iFrameSrc: `https://video.tv.adobe.com/v/${e.videoId}/?quality=12&learn=on&autoplay=true`,
            handleClose: () => n(!1),
          }),
        ],
      }),
    }),
  });
}
const tr = pc.createContext('en'),
  hE = tr.Provider;
function _a({ to: e, children: t, ...n }) {
  const i = E0(),
    r = B.exports.useContext(tr);
  return _('span', {
    style: { cursor: 'pointer' },
    onClick: (a) => {
      a.preventDefault(), i({ pathname: `${e}`, search: '?lang=' + (r || 'en') });
    },
    ...n,
    children: t,
  });
}
function fE(e) {
  const { formatMessage: t } = e.intl,
    n = oo,
    i = t(n.common.nav.title),
    r = t(n.common.nav.home),
    o = t(n.common.nav.codePlayground);
  return _('div', {
    className: 'nav',
    children: W('div', {
      className: 'nav-wrapper',
      children: [
        _('div', { className: 'nav__title', children: i }),
        W('ul', {
          className: 'nav__menu',
          children: [
            _('li', {
              className: 'nav__menu-item',
              children: _(_a, { className: 'nav-link', to: '/index.html', children: r }),
            }),
            _('li', {
              className: 'nav__menu-item',
              children: _(_a, { className: 'nav-link', to: '/developer/code.html', children: o }),
            }),
          ],
        }),
      ],
    }),
  });
}
const Ja = er(fE);
function Om(e) {
  return _('div', { className: 'cards', children: e.children });
}
const mE = function (e) {
    return e.indexOf('//') === 0 || e.indexOf('http://') === 0 || e.indexOf('https://') === 0
      ? new URL(e)
      : new URL(e, 'https://experienceleague.adobe.com');
  },
  gE = function (e) {
    return ['experienceleague.adobe.com'].includes(e.host);
  },
  jm = function (e, t) {
    let n = mE(e);
    return gE(n) && t && (n.searchParams.set('lang', t), (e = n.toString())), e;
  },
  Fm = function (e, t) {
    return e && t;
  };
function vE(e) {
  const t = B.exports.useContext(tr);
  return Fm(e.text, e.link)
    ? _('a', {
        href: jm(e.link, t),
        'data-track': `${e.analyticsName}`,
        rel: 'noreferrer',
        target: '_blank',
        children: e.text,
      })
    : null;
}
function zm({ text: e, link: t, analyticsName: n, style: i, size: r, route: o }) {
  const a = B.exports.useContext(tr);
  function s(c, u, f, h, x) {
    return _('a', {
      href: jm(u, a),
      'data-track': f,
      rel: 'noreferrer',
      target: '_blank',
      className: `spectrum-Button spectrum-Button--${h || 'primary'} spectrum-Button--size${x || 'M'}`,
      children: _('span', { className: 'spectrum-Button-label', children: c }),
    });
  }
  function l(c, u, f, h, x) {
    return _(_a, {
      to: u,
      'data-track': f,
      className: `spectrum-Button spectrum-Button--${h || 'primary'} spectrum-Button--size${x || 'M'}`,
      children: _('span', { className: 'spectrum-Button-label', children: c }),
    });
  }
  return Fm(e, t) ? (o ? l(e, t, n, i, r) : s(e, t, n, i, r)) : null;
}
function _E({ tags: e }) {
  return _('div', {
    className: 'code-tags is-margin-top-big is-margin-bottom-big buttons',
    children: e.map((t) => _('span', { className: 'button is-small', children: t }, t)),
  });
}
function Ei(e) {
  return W('div', {
    className: 'card',
    style: { flexGrow: `${e.grow ? e.grow : 1}` },
    children: [
      _('img', { className: 'card__image', src: e.image, alt: e.title }),
      W('div', {
        className: 'card__content',
        children: [
          _('h4', {
            className: 'card__title is-size-4 is-margin-bottom-big has-text-blackest is-extra-bold',
            children: e.title,
          }),
          e.tags && _(_E, { tags: e.tags }),
          _('p', { className: 'card__text is-size-10 is-margin-bottom-big', children: e.text }),
          e.links &&
            _('div', {
              className: 'card__cta',
              children: e.links.map((t, n) =>
                _(zm, { text: t.text, link: t.link, route: t.route, analyticsName: `${e.title} - ${t.text}` }, n),
              ),
            }),
        ],
      }),
    ],
  });
}
function xE(e) {
  const [t, n] = B.exports.useState(e.tabs[0].title);
  function i(r) {
    return t === r.title || !1;
  }
  return W('div', {
    className: 'accordion',
    children: [
      _('div', { className: 'accordion__background' }),
      _('ul', {
        className: 'accordion__menu',
        children: e.tabs.map((r, o) =>
          _(
            'li',
            {
              className: `accordion__menu-item ${i(r) ? 'accordion__menu-item--active' : ''}`,
              onClick: () => n(r.title),
              children: r.title,
            },
            o,
          ),
        ),
      }),
      e.tabs.map((r, o) =>
        W(
          'section',
          {
            className: `accordion__item ${i(r) ? 'accordion__item--active' : ''}`,
            children: [
              _('div', {
                className: `accordion__item-title ${i(r) ? 'accordion__item-title--active' : ''}`,
                onClick: () => n(r.title),
                children: r.title,
              }),
              i(r) &&
                W(
                  'div',
                  {
                    className: 'accordion__content accordion__content--active',
                    children: [
                      _('h4', { className: 'accordion__title', children: r.title }),
                      r.text && _('p', { children: r.text }),
                      _('div', {
                        className: 'accordion__lists',
                        children: r.lists.map((a, s) =>
                          W(
                            'dl',
                            {
                              children: [
                                _('dt', { children: a.title }),
                                a.links.map((l, c) =>
                                  _(
                                    'dd',
                                    {
                                      children: _(vE, {
                                        text: l.text,
                                        link: l.link,
                                        analyticsName: `Developer resources - ${l.text}`,
                                      }),
                                    },
                                    c,
                                  ),
                                ),
                              ],
                            },
                            s,
                          ),
                        ),
                      }),
                    ],
                  },
                  r.title,
                ),
            ],
          },
          o,
        ),
      ),
    ],
  });
}
function yE(e) {
  return W('div', {
    className: 'text-block text-block--center',
    children: [
      _('h2', {
        className: 'is-size-36 is-size-34-touch is-margin-bottom-big has-text-blackest is-extra-bold',
        children: e.title,
      }),
      _('p', { className: 'is-size-5 has-text-whitest is-margin-bottom-big ', children: e.text }),
    ],
  });
}
function EE(e) {
  return _('h3', { className: 'has-text-weight-bold is-margin-bottom-big has-text-blackest', children: e.text });
}
function $n(e) {
  return W('section', {
    id: e.id,
    children: [
      e.title && _(EE, { text: e.title }),
      e.text && _('p', { children: e.text }),
      (e.title || e.text) && e.children && _('div', { className: 'section__spacer' }),
      e.children && _('div', { className: 'section__row', children: e.children }),
    ],
  });
}
$n.Gap = ({ children: e }) => _('div', { className: 'section__gap' });
$n.RowBreak = ({ children: e }) => _('div', { className: 'section__row-break' });
function Tp(e) {
  var t;
  return W('div', {
    className: 'box',
    style: { flexGrow: `${e.grow ? e.grow : 1}` },
    children: [
      _('img', { className: 'box__icon', src: e.icon, alt: e.title }),
      W('div', {
        className: 'box__content',
        children: [
          _('h3', { className: 'is-size-4 has-text-blackest is-extra-bold', children: e.title }),
          _('p', { className: 'box__text is-size-10 has-text-whitest', children: e.text }),
          ((t = e.links) == null ? void 0 : t.length) &&
            e.links.map((n, i) => _(zm, { text: n.text, link: n.link, analyticsName: `${e.title} - ${n.text}` }, i)),
        ],
      }),
    ],
  });
}
class kE {
  constructor(t) {
    vs(this, 'formatMessage');
    this.formatMessage = t;
  }
  links(t) {
    return t.map((n) => ({ text: this.formatMessage(n), link: n.link }));
  }
  tabs(t) {
    return t.map((n) => ({
      title: this.formatMessage(n.title),
      text: this.formatMessage(n.text),
      lists: n.lists.map((i) => ({ title: this.formatMessage(i.title), links: this.links(i.links) })),
    }));
  }
  nav(t) {
    return t.map((n) => ({
      title: this.formatMessage(n.title),
      icon: n.icon,
      link: n.link,
      text: this.formatMessage(n.text),
      links: n.links.map((i) => ({ title: this.formatMessage(i), link: i.link })),
    }));
  }
  list(t) {
    return t.map((n) => this.formatMessage(n));
  }
}
function Cp(e) {
  return W('div', {
    className: 'welcome-box',
    style: { flexGrow: `${e.grow ? e.grow : 1}` },
    children: [
      _('h4', {
        className: 'welcome__title is-size-5 is-margin-bottom-big has-text-blackest is-bold',
        children: e.title,
      }),
      W('div', {
        className: 'welcome-box__content',
        children: [
          _('p', { className: 'welcome__text is-size-10 is-margin-bottom-big', children: e.text }),
          _('img', { className: 'welcome-box__image', src: e.image, alt: e.title }),
        ],
      }),
    ],
  });
}
function SE(e) {
  Object.keys(e).forEach((t) => {
    var o;
    const n = t,
      i = e[t],
      r = (o = document.head) == null ? void 0 : o.querySelector('meta[name="' + n + '"]');
    if (r) r.setAttribute('content', i), (r.dataset.microsite = !0);
    else {
      const a = document.createElement('meta');
      (a.name = n), (a.content = i), (a.dataset.microsite = !0), document.head.appendChild(a);
    }
  });
}
function gu(e, t, n) {
  (e.title = t + ' | Adobe Experience Manager'), e.querySelector('meta[name="description"]').setAttribute('content', n);
}
const G = oo;
function AE(e) {
  const { formatMessage: t } = e.intl,
    n = new kE(t);
  return (
    B.exports.useState(e.intl.locale),
    SE({
      role: 'Developer',
      level: 'Beginner, Intermediate, Advanced',
      'doc-type': 'Microsite',
      'feature-set': 'Experience Manager Sites, Experience Manager',
      solution: 'Experience Manager',
      'solution-title': 'Adobe Experience Manager',
      'sub-product': 'Experience Manager Sites',
      version: 'Cloud Service',
    }),
    gu(document, t(G.home.page.title), t(G.home.page.description)),
    W(ri, {
      children: [
        _(pE, {
          product: t(G.home.hero.product),
          title: t(G.home.hero.title),
          text: t(G.home.hero.text),
          ctaLabel: t(G.home.hero.cta),
          videoPlaceholder: G.home.hero.placeholderImage,
          videoId: G.home.hero.video,
        }),
        _(Ja, {}),
        _('div', {
          className: 'app__content--centered',
          children: W($n, {
            children: [
              _(yE, { title: t(G.home.what_is_headless.title), text: t(G.home.what_is_headless.text) }),
              _($n.RowBreak, {}),
              _(Cp, {
                image: G.home.new_developers.image,
                title: t(G.home.new_developers.title, {
                  emphasis: _('strong', { children: t(G.home.new_developers.title_emphasis) }),
                }),
                text: t(G.home.new_developers.text, {
                  guideLink: _('a', {
                    target: '_blank',
                    rel: 'noreferrer',
                    href: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/headless/journeys/developer/overview.html',
                    children: t(G.home.new_developers.text_guide_link),
                  }),
                }),
              }),
              _(Cp, {
                image: G.home.experienced_developers.image,
                title: t(G.home.experienced_developers.title, {
                  emphasis: _('strong', { children: t(G.home.experienced_developers.title_emphasis) }),
                }),
                text: t(G.home.experienced_developers.text, {
                  fiveSteps: _('a', {
                    target: '_blank',
                    rel: 'noreferrer',
                    href: 'https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/headless/setup/introduction.html',
                    children: t(G.home.experienced_developers.text_5_steps),
                  }),
                  advancedDocumentation: _('a', {
                    href: '#advanced-documentation',
                    children: t(G.home.experienced_developers.text_advanced_documentation),
                  }),
                  break: W(ri, { children: [_('br', {}), _('br', {})] }),
                }),
              }),
            ],
          }),
        }),
        W('div', {
          className: 'app__content--centered',
          children: [
            _($n, {
              id: G.home.section_developer_resources.slug,
              title: t(G.home.section_developer_resources.title),
              children: _(xE, { tabs: n.tabs(G.home.technical_docs) }),
            }),
            W($n, {
              title: t(G.home.section_get_involved.title),
              children: [
                _(Tp, {
                  icon: G.home.get_involved_blog.icon,
                  title: t(G.home.get_involved_blog.title),
                  text: t(G.home.get_involved_blog.text),
                  links: n.links(G.home.get_involved_blog.links),
                }),
                _(Tp, {
                  icon: G.home.get_involved_community.icon,
                  title: t(G.home.get_involved_community.title),
                  text: t(G.home.get_involved_community.text),
                  links: n.links(G.home.get_involved_community.links),
                }),
              ],
            }),
            _($n, {
              title: t(G.home.section_example_apps.title),
              children: W(Om, {
                children: [
                  _(Ei, {
                    image: G.home.example_apps.react.image,
                    title: t(G.home.example_apps.react.title),
                    text: t(G.home.example_apps.react.text),
                    links: n.links(G.home.example_apps.react.links),
                  }),
                  _(Ei, {
                    image: G.home.example_apps.ios.image,
                    title: t(G.home.example_apps.ios.title),
                    text: t(G.home.example_apps.ios.text),
                    links: n.links(G.home.example_apps.ios.links),
                  }),
                  _(Ei, {
                    image: G.home.example_apps.android.image,
                    title: t(G.home.example_apps.android.title),
                    text: t(G.home.example_apps.android.text),
                    links: n.links(G.home.example_apps.android.links),
                  }),
                  _(Ei, {
                    image: G.home.example_apps.web_component.image,
                    title: t(G.home.example_apps.web_component.title),
                    text: t(G.home.example_apps.web_component.text),
                    links: n.links(G.home.example_apps.web_component.links),
                  }),
                  _(Ei, {
                    image: G.home.example_apps.node_js.image,
                    title: t(G.home.example_apps.node_js.title),
                    text: t(G.home.example_apps.node_js.text),
                    links: n.links(G.home.example_apps.node_js.links),
                  }),
                ],
              }),
            }),
          ],
        }),
      ],
    })
  );
}
const wE = er(AE);
function vu(e) {
  return _('div', { className: 'hero-stripe', children: _('div', { className: 'hero-stripe__inner' }) });
}
function Bm(e) {
  const t = B.exports.useContext(tr),
    [n, i] = B.exports.useState(null),
    [r, o] = B.exports.useState(null);
  return (
    B.exports.useEffect(() => {
      async function a() {
        const l = await (
          await fetch(
            window.AEM_CDN +
              '/' +
              (t || 'en') +
              '/docs/experience-manager-learn/getting-started-with-aem-headless/code-samples/' +
              e,
          )
        ).text();
        i(ME(l));
      }
      a();
    }, [e, t]),
    { article: n, errors: r }
  );
}
function ME(e) {
  const n = new DOMParser().parseFromString(e, 'text/html'),
    i = n.querySelector('h1');
  i && i.classList.add('is-extra-bold', 'is-size-36', 'is-size-34-touch', 'has-text-blackest');
  const r = n.querySelector('meta[name="description"]'),
    o = r ? r.getAttribute('content') : '',
    a = n.querySelector('meta[name="thumbnail"]'),
    s = a ? a.getAttribute('content') : '',
    l = n.querySelector('.article-metadata-createdby'),
    c = n.querySelector('.target-insertion');
  let u = '';
  if (l && c) {
    const f = n.createRange();
    f.setStartAfter(l), f.setEndBefore(c);
    const h = f.cloneContents();
    let x = document.createElement('div');
    x.appendChild(h), (x = PE(x)), (u = x.innerHTML);
  }
  return i && (u = i.outerHTML + u), { title: i ? i.textContent : '', description: o, body: u, thumbnail: s };
}
function PE(e) {
  return (
    console.log(e),
    [...e.querySelectorAll('.list')].forEach((t) => {
      const n = t.querySelector('ul,ol');
      t.insertAdjacentElement('beforebegin', n), t.remove();
    }),
    e
  );
}
const Bn = oo;
function TE(e) {
  const { formatMessage: t } = e.intl;
  B.exports.useContext(tr);
  const [n, i] = B.exports.useState(!1);
  return (
    n || (gu(document, t(Bn.code_index.title), t(Bn.code_index.text)), CE(), i(!0)),
    W(ri, {
      children: [
        _(vu, {}),
        _(Ja, {}),
        W('div', {
          className: 'app__content--centered',
          children: [
            _('h1', {
              className: 'is-extra-bold is-size-36 is-size-34-touch has-text-blackest',
              children: t(Bn.code_index.title),
            }),
            _('p', {
              className: 'is-size-18 has-text-weight-normal has-text-blackest',
              children: t(Bn.code_index.text),
            }),
            _('br', {}),
            _('br', {}),
            _(Om, {
              children: Object.keys(Bn.code_index.code).map((r, o) => {
                let a = Bn.code_index.code[r],
                  s = Bm(a.articleId).article;
                if (s)
                  return _(
                    Ei,
                    {
                      image: `https://cdn.experienceleague.adobe.com/thumb/${s.thumbnail}`,
                      title: s.title,
                      text: s.description,
                      tags: a.tags,
                      links: [
                        { text: t(Bn.code_index.button_run_the_code), link: `/developer/code/${r}.html`, route: !0 },
                      ],
                    },
                    o,
                  );
              }),
            }),
          ],
        }),
      ],
    })
  );
}
function CE() {
  (window.adobeDataLayer = window.adobeDataLayer || []),
    window.adobeDataLayer.push({
      event: 'page loaded',
      user: window.adobeDataLayer.getState().user || {},
      web: {
        webPageDetails: {
          pageViews: { value: 1 },
          pageTitle: 'AEM Headless developer resources - Code playground',
          name: 'xl:microsite:landing:experience-manager:headless:code-playground',
          pageType: 'webpage',
          URL: 'https://experienceleague.adobe.com/developer/code.html',
          domain: 'experienceleague.adobe.com',
          server: void 0,
          siteSection: 'microsite',
          siteSubSection1: 'microsite',
          siteSubSection2: ' ',
          siteSubSection3: ' ',
        },
      },
    });
}
const bE = er(TE);
var Zs = { exports: {} };
/*! @license DOMPurify 2.4.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.0/LICENSE */ var bp;
function Ip() {
  return (
    bp ||
      ((bp = 1),
      (function (e, t) {
        (function (n, i) {
          e.exports = i();
        })(rg, function () {
          function n(E) {
            return (
              (n =
                typeof Symbol == 'function' && typeof Symbol.iterator == 'symbol'
                  ? function (A) {
                      return typeof A;
                    }
                  : function (A) {
                      return A && typeof Symbol == 'function' && A.constructor === Symbol && A !== Symbol.prototype
                        ? 'symbol'
                        : typeof A;
                    }),
              n(E)
            );
          }
          function i(E, A) {
            return (
              (i =
                Object.setPrototypeOf ||
                function (D, $) {
                  return (D.__proto__ = $), D;
                }),
              i(E, A)
            );
          }
          function r() {
            if (typeof Reflect > 'u' || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == 'function') return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch {
              return !1;
            }
          }
          function o(E, A, I) {
            return (
              r()
                ? (o = Reflect.construct)
                : (o = function ($, ee, se) {
                    var ze = [null];
                    ze.push.apply(ze, ee);
                    var Ce = Function.bind.apply($, ze),
                      rt = new Ce();
                    return se && i(rt, se.prototype), rt;
                  }),
              o.apply(null, arguments)
            );
          }
          function a(E) {
            return s(E) || l(E) || c(E) || f();
          }
          function s(E) {
            if (Array.isArray(E)) return u(E);
          }
          function l(E) {
            if ((typeof Symbol < 'u' && E[Symbol.iterator] != null) || E['@@iterator'] != null) return Array.from(E);
          }
          function c(E, A) {
            if (E) {
              if (typeof E == 'string') return u(E, A);
              var I = Object.prototype.toString.call(E).slice(8, -1);
              if ((I === 'Object' && E.constructor && (I = E.constructor.name), I === 'Map' || I === 'Set'))
                return Array.from(E);
              if (I === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(I)) return u(E, A);
            }
          }
          function u(E, A) {
            (A == null || A > E.length) && (A = E.length);
            for (var I = 0, D = new Array(A); I < A; I++) D[I] = E[I];
            return D;
          }
          function f() {
            throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          var h = Object.hasOwnProperty,
            x = Object.setPrototypeOf,
            y = Object.isFrozen,
            m = Object.getPrototypeOf,
            j = Object.getOwnPropertyDescriptor,
            p = Object.freeze,
            d = Object.seal,
            g = Object.create,
            k = typeof Reflect < 'u' && Reflect,
            T = k.apply,
            R = k.construct;
          T ||
            (T = function (A, I, D) {
              return A.apply(I, D);
            }),
            p ||
              (p = function (A) {
                return A;
              }),
            d ||
              (d = function (A) {
                return A;
              }),
            R ||
              (R = function (A, I) {
                return o(A, a(I));
              });
          var b = ie(Array.prototype.forEach),
            z = ie(Array.prototype.pop),
            te = ie(Array.prototype.push),
            Q = ie(String.prototype.toLowerCase),
            Te = ie(String.prototype.match),
            _e = ie(String.prototype.replace),
            Xe = ie(String.prototype.indexOf),
            li = ie(String.prototype.trim),
            Ae = ie(RegExp.prototype.test),
            Wt = N(TypeError);
          function ie(E) {
            return function (A) {
              for (var I = arguments.length, D = new Array(I > 1 ? I - 1 : 0), $ = 1; $ < I; $++)
                D[$ - 1] = arguments[$];
              return T(E, A, D);
            };
          }
          function N(E) {
            return function () {
              for (var A = arguments.length, I = new Array(A), D = 0; D < A; D++) I[D] = arguments[D];
              return R(E, I);
            };
          }
          function C(E, A, I) {
            (I = I || Q), x && x(E, null);
            for (var D = A.length; D--; ) {
              var $ = A[D];
              if (typeof $ == 'string') {
                var ee = I($);
                ee !== $ && (y(A) || (A[D] = ee), ($ = ee));
              }
              E[$] = !0;
            }
            return E;
          }
          function q(E) {
            var A = g(null),
              I;
            for (I in E) T(h, E, [I]) && (A[I] = E[I]);
            return A;
          }
          function Z(E, A) {
            for (; E !== null; ) {
              var I = j(E, A);
              if (I) {
                if (I.get) return ie(I.get);
                if (typeof I.value == 'function') return ie(I.value);
              }
              E = m(E);
            }
            function D($) {
              return console.warn('fallback value for', $), null;
            }
            return D;
          }
          var he = p([
              'a',
              'abbr',
              'acronym',
              'address',
              'area',
              'article',
              'aside',
              'audio',
              'b',
              'bdi',
              'bdo',
              'big',
              'blink',
              'blockquote',
              'body',
              'br',
              'button',
              'canvas',
              'caption',
              'center',
              'cite',
              'code',
              'col',
              'colgroup',
              'content',
              'data',
              'datalist',
              'dd',
              'decorator',
              'del',
              'details',
              'dfn',
              'dialog',
              'dir',
              'div',
              'dl',
              'dt',
              'element',
              'em',
              'fieldset',
              'figcaption',
              'figure',
              'font',
              'footer',
              'form',
              'h1',
              'h2',
              'h3',
              'h4',
              'h5',
              'h6',
              'head',
              'header',
              'hgroup',
              'hr',
              'html',
              'i',
              'img',
              'input',
              'ins',
              'kbd',
              'label',
              'legend',
              'li',
              'main',
              'map',
              'mark',
              'marquee',
              'menu',
              'menuitem',
              'meter',
              'nav',
              'nobr',
              'ol',
              'optgroup',
              'option',
              'output',
              'p',
              'picture',
              'pre',
              'progress',
              'q',
              'rp',
              'rt',
              'ruby',
              's',
              'samp',
              'section',
              'select',
              'shadow',
              'small',
              'source',
              'spacer',
              'span',
              'strike',
              'strong',
              'style',
              'sub',
              'summary',
              'sup',
              'table',
              'tbody',
              'td',
              'template',
              'textarea',
              'tfoot',
              'th',
              'thead',
              'time',
              'tr',
              'track',
              'tt',
              'u',
              'ul',
              'var',
              'video',
              'wbr',
            ]),
            Ht = p([
              'svg',
              'a',
              'altglyph',
              'altglyphdef',
              'altglyphitem',
              'animatecolor',
              'animatemotion',
              'animatetransform',
              'circle',
              'clippath',
              'defs',
              'desc',
              'ellipse',
              'filter',
              'font',
              'g',
              'glyph',
              'glyphref',
              'hkern',
              'image',
              'line',
              'lineargradient',
              'marker',
              'mask',
              'metadata',
              'mpath',
              'path',
              'pattern',
              'polygon',
              'polyline',
              'radialgradient',
              'rect',
              'stop',
              'style',
              'switch',
              'symbol',
              'text',
              'textpath',
              'title',
              'tref',
              'tspan',
              'view',
              'vkern',
            ]),
            it = p([
              'feBlend',
              'feColorMatrix',
              'feComponentTransfer',
              'feComposite',
              'feConvolveMatrix',
              'feDiffuseLighting',
              'feDisplacementMap',
              'feDistantLight',
              'feFlood',
              'feFuncA',
              'feFuncB',
              'feFuncG',
              'feFuncR',
              'feGaussianBlur',
              'feImage',
              'feMerge',
              'feMergeNode',
              'feMorphology',
              'feOffset',
              'fePointLight',
              'feSpecularLighting',
              'feSpotLight',
              'feTile',
              'feTurbulence',
            ]),
            On = p([
              'animate',
              'color-profile',
              'cursor',
              'discard',
              'fedropshadow',
              'font-face',
              'font-face-format',
              'font-face-name',
              'font-face-src',
              'font-face-uri',
              'foreignobject',
              'hatch',
              'hatchpath',
              'mesh',
              'meshgradient',
              'meshpatch',
              'meshrow',
              'missing-glyph',
              'script',
              'set',
              'solidcolor',
              'unknown',
              'use',
            ]),
            pt = p([
              'math',
              'menclose',
              'merror',
              'mfenced',
              'mfrac',
              'mglyph',
              'mi',
              'mlabeledtr',
              'mmultiscripts',
              'mn',
              'mo',
              'mover',
              'mpadded',
              'mphantom',
              'mroot',
              'mrow',
              'ms',
              'mspace',
              'msqrt',
              'mstyle',
              'msub',
              'msup',
              'msubsup',
              'mtable',
              'mtd',
              'mtext',
              'mtr',
              'munder',
              'munderover',
            ]),
            un = p([
              'maction',
              'maligngroup',
              'malignmark',
              'mlongdiv',
              'mscarries',
              'mscarry',
              'msgroup',
              'mstack',
              'msline',
              'msrow',
              'semantics',
              'annotation',
              'annotation-xml',
              'mprescripts',
              'none',
            ]),
            dn = p(['#text']),
            nr = p([
              'accept',
              'action',
              'align',
              'alt',
              'autocapitalize',
              'autocomplete',
              'autopictureinpicture',
              'autoplay',
              'background',
              'bgcolor',
              'border',
              'capture',
              'cellpadding',
              'cellspacing',
              'checked',
              'cite',
              'class',
              'clear',
              'color',
              'cols',
              'colspan',
              'controls',
              'controlslist',
              'coords',
              'crossorigin',
              'datetime',
              'decoding',
              'default',
              'dir',
              'disabled',
              'disablepictureinpicture',
              'disableremoteplayback',
              'download',
              'draggable',
              'enctype',
              'enterkeyhint',
              'face',
              'for',
              'headers',
              'height',
              'hidden',
              'high',
              'href',
              'hreflang',
              'id',
              'inputmode',
              'integrity',
              'ismap',
              'kind',
              'label',
              'lang',
              'list',
              'loading',
              'loop',
              'low',
              'max',
              'maxlength',
              'media',
              'method',
              'min',
              'minlength',
              'multiple',
              'muted',
              'name',
              'nonce',
              'noshade',
              'novalidate',
              'nowrap',
              'open',
              'optimum',
              'pattern',
              'placeholder',
              'playsinline',
              'poster',
              'preload',
              'pubdate',
              'radiogroup',
              'readonly',
              'rel',
              'required',
              'rev',
              'reversed',
              'role',
              'rows',
              'rowspan',
              'spellcheck',
              'scope',
              'selected',
              'shape',
              'size',
              'sizes',
              'span',
              'srclang',
              'start',
              'src',
              'srcset',
              'step',
              'style',
              'summary',
              'tabindex',
              'title',
              'translate',
              'type',
              'usemap',
              'valign',
              'value',
              'width',
              'xmlns',
              'slot',
            ]),
            jn = p([
              'accent-height',
              'accumulate',
              'additive',
              'alignment-baseline',
              'ascent',
              'attributename',
              'attributetype',
              'azimuth',
              'basefrequency',
              'baseline-shift',
              'begin',
              'bias',
              'by',
              'class',
              'clip',
              'clippathunits',
              'clip-path',
              'clip-rule',
              'color',
              'color-interpolation',
              'color-interpolation-filters',
              'color-profile',
              'color-rendering',
              'cx',
              'cy',
              'd',
              'dx',
              'dy',
              'diffuseconstant',
              'direction',
              'display',
              'divisor',
              'dur',
              'edgemode',
              'elevation',
              'end',
              'fill',
              'fill-opacity',
              'fill-rule',
              'filter',
              'filterunits',
              'flood-color',
              'flood-opacity',
              'font-family',
              'font-size',
              'font-size-adjust',
              'font-stretch',
              'font-style',
              'font-variant',
              'font-weight',
              'fx',
              'fy',
              'g1',
              'g2',
              'glyph-name',
              'glyphref',
              'gradientunits',
              'gradienttransform',
              'height',
              'href',
              'id',
              'image-rendering',
              'in',
              'in2',
              'k',
              'k1',
              'k2',
              'k3',
              'k4',
              'kerning',
              'keypoints',
              'keysplines',
              'keytimes',
              'lang',
              'lengthadjust',
              'letter-spacing',
              'kernelmatrix',
              'kernelunitlength',
              'lighting-color',
              'local',
              'marker-end',
              'marker-mid',
              'marker-start',
              'markerheight',
              'markerunits',
              'markerwidth',
              'maskcontentunits',
              'maskunits',
              'max',
              'mask',
              'media',
              'method',
              'mode',
              'min',
              'name',
              'numoctaves',
              'offset',
              'operator',
              'opacity',
              'order',
              'orient',
              'orientation',
              'origin',
              'overflow',
              'paint-order',
              'path',
              'pathlength',
              'patterncontentunits',
              'patterntransform',
              'patternunits',
              'points',
              'preservealpha',
              'preserveaspectratio',
              'primitiveunits',
              'r',
              'rx',
              'ry',
              'radius',
              'refx',
              'refy',
              'repeatcount',
              'repeatdur',
              'restart',
              'result',
              'rotate',
              'scale',
              'seed',
              'shape-rendering',
              'specularconstant',
              'specularexponent',
              'spreadmethod',
              'startoffset',
              'stddeviation',
              'stitchtiles',
              'stop-color',
              'stop-opacity',
              'stroke-dasharray',
              'stroke-dashoffset',
              'stroke-linecap',
              'stroke-linejoin',
              'stroke-miterlimit',
              'stroke-opacity',
              'stroke',
              'stroke-width',
              'style',
              'surfacescale',
              'systemlanguage',
              'tabindex',
              'targetx',
              'targety',
              'transform',
              'transform-origin',
              'text-anchor',
              'text-decoration',
              'text-rendering',
              'textlength',
              'type',
              'u1',
              'u2',
              'unicode',
              'values',
              'viewbox',
              'visibility',
              'version',
              'vert-adv-y',
              'vert-origin-x',
              'vert-origin-y',
              'width',
              'word-spacing',
              'wrap',
              'writing-mode',
              'xchannelselector',
              'ychannelselector',
              'x',
              'x1',
              'x2',
              'xmlns',
              'y',
              'y1',
              'y2',
              'z',
              'zoomandpan',
            ]),
            ci = p([
              'accent',
              'accentunder',
              'align',
              'bevelled',
              'close',
              'columnsalign',
              'columnlines',
              'columnspan',
              'denomalign',
              'depth',
              'dir',
              'display',
              'displaystyle',
              'encoding',
              'fence',
              'frame',
              'height',
              'href',
              'id',
              'largeop',
              'length',
              'linethickness',
              'lspace',
              'lquote',
              'mathbackground',
              'mathcolor',
              'mathsize',
              'mathvariant',
              'maxsize',
              'minsize',
              'movablelimits',
              'notation',
              'numalign',
              'open',
              'rowalign',
              'rowlines',
              'rowspacing',
              'rowspan',
              'rspace',
              'rquote',
              'scriptlevel',
              'scriptminsize',
              'scriptsizemultiplier',
              'selection',
              'separator',
              'separators',
              'stretchy',
              'subscriptshift',
              'supscriptshift',
              'symmetric',
              'voffset',
              'width',
              'xmlns',
            ]),
            pn = p(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']),
            ui = d(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
            ao = d(/<%[\w\W]*|[\w\W]*%>/gm),
            Xa = d(/^data-[\-\w.\u00B7-\uFFFF]/),
            so = d(/^aria-[\-\w]+$/),
            ir = d(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),
            Za = d(/^(?:\w+script|data):/i),
            Ya = d(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
            lo = d(/^html$/i),
            S = function () {
              return typeof window > 'u' ? null : window;
            },
            M = function (A, I) {
              if (n(A) !== 'object' || typeof A.createPolicy != 'function') return null;
              var D = null,
                $ = 'data-tt-policy-suffix';
              I.currentScript && I.currentScript.hasAttribute($) && (D = I.currentScript.getAttribute($));
              var ee = 'dompurify' + (D ? '#' + D : '');
              try {
                return A.createPolicy(ee, {
                  createHTML: function (ze) {
                    return ze;
                  },
                  createScriptURL: function (ze) {
                    return ze;
                  },
                });
              } catch {
                return console.warn('TrustedTypes policy ' + ee + ' could not be created.'), null;
              }
            };
          function L() {
            var E = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : S(),
              A = function (v) {
                return L(v);
              };
            if (((A.version = '2.4.0'), (A.removed = []), !E || !E.document || E.document.nodeType !== 9))
              return (A.isSupported = !1), A;
            var I = E.document,
              D = E.document,
              $ = E.DocumentFragment,
              ee = E.HTMLTemplateElement,
              se = E.Node,
              ze = E.Element,
              Ce = E.NodeFilter,
              rt = E.NamedNodeMap,
              Kt = rt === void 0 ? E.NamedNodeMap || E.MozNamedAttrMap : rt,
              di = E.HTMLFormElement,
              hn = E.DOMParser,
              fn = E.trustedTypes,
              xe = ze.prototype,
              Be = Z(xe, 'cloneNode'),
              Ot = Z(xe, 'nextSibling'),
              pi = Z(xe, 'childNodes'),
              hi = Z(xe, 'parentNode');
            if (typeof ee == 'function') {
              var rr = D.createElement('template');
              rr.content && rr.content.ownerDocument && (D = rr.content.ownerDocument);
            }
            var ht = M(fn, I),
              or = ht ? ht.createHTML('') : '',
              Ue = D,
              Et = Ue.implementation,
              ar = Ue.createNodeIterator,
              es = Ue.createDocumentFragment,
              Um = Ue.getElementsByTagName,
              Gm = I.importNode,
              _u = {};
            try {
              _u = q(D).documentMode ? D.documentMode : {};
            } catch {}
            var jt = {};
            A.isSupported = typeof hi == 'function' && Et && typeof Et.createHTMLDocument < 'u' && _u !== 9;
            var ts = ui,
              ns = ao,
              $m = Xa,
              qm = so,
              Vm = Za,
              xu = Ya,
              is = ir,
              be = null,
              yu = C({}, [].concat(a(he), a(Ht), a(it), a(pt), a(dn))),
              De = null,
              Eu = C({}, [].concat(a(nr), a(jn), a(ci), a(pn))),
              Ee = Object.seal(
                Object.create(null, {
                  tagNameCheck: { writable: !0, configurable: !1, enumerable: !0, value: null },
                  attributeNameCheck: { writable: !0, configurable: !1, enumerable: !0, value: null },
                  allowCustomizedBuiltInElements: { writable: !0, configurable: !1, enumerable: !0, value: !1 },
                }),
              ),
              sr = null,
              rs = null,
              ku = !0,
              os = !0,
              Su = !1,
              fi = !1,
              Fn = !1,
              as = !1,
              ss = !1,
              mi = !1,
              co = !1,
              uo = !1,
              Au = !0,
              wu = !1,
              Qm = 'user-content-',
              ls = !0,
              lr = !1,
              gi = {},
              vi = null,
              Mu = C({}, [
                'annotation-xml',
                'audio',
                'colgroup',
                'desc',
                'foreignobject',
                'head',
                'iframe',
                'math',
                'mi',
                'mn',
                'mo',
                'ms',
                'mtext',
                'noembed',
                'noframes',
                'noscript',
                'plaintext',
                'script',
                'style',
                'svg',
                'template',
                'thead',
                'title',
                'video',
                'xmp',
              ]),
              Pu = null,
              Tu = C({}, ['audio', 'video', 'img', 'source', 'image', 'track']),
              cs = null,
              Cu = C({}, [
                'alt',
                'class',
                'for',
                'id',
                'label',
                'name',
                'pattern',
                'placeholder',
                'role',
                'summary',
                'title',
                'value',
                'style',
                'xmlns',
              ]),
              us = 'http://www.w3.org/1998/Math/MathML',
              ds = 'http://www.w3.org/2000/svg',
              mn = 'http://www.w3.org/1999/xhtml',
              po = mn,
              ps = !1,
              _i,
              Wm = ['application/xhtml+xml', 'text/html'],
              Km = 'text/html',
              Ie,
              xi = null,
              Jm = D.createElement('form'),
              bu = function (v) {
                return v instanceof RegExp || v instanceof Function;
              },
              hs = function (v) {
                (xi && xi === v) ||
                  ((!v || n(v) !== 'object') && (v = {}),
                  (v = q(v)),
                  (_i = Wm.indexOf(v.PARSER_MEDIA_TYPE) === -1 ? (_i = Km) : (_i = v.PARSER_MEDIA_TYPE)),
                  (Ie =
                    _i === 'application/xhtml+xml'
                      ? function (P) {
                          return P;
                        }
                      : Q),
                  (be = 'ALLOWED_TAGS' in v ? C({}, v.ALLOWED_TAGS, Ie) : yu),
                  (De = 'ALLOWED_ATTR' in v ? C({}, v.ALLOWED_ATTR, Ie) : Eu),
                  (cs = 'ADD_URI_SAFE_ATTR' in v ? C(q(Cu), v.ADD_URI_SAFE_ATTR, Ie) : Cu),
                  (Pu = 'ADD_DATA_URI_TAGS' in v ? C(q(Tu), v.ADD_DATA_URI_TAGS, Ie) : Tu),
                  (vi = 'FORBID_CONTENTS' in v ? C({}, v.FORBID_CONTENTS, Ie) : Mu),
                  (sr = 'FORBID_TAGS' in v ? C({}, v.FORBID_TAGS, Ie) : {}),
                  (rs = 'FORBID_ATTR' in v ? C({}, v.FORBID_ATTR, Ie) : {}),
                  (gi = 'USE_PROFILES' in v ? v.USE_PROFILES : !1),
                  (ku = v.ALLOW_ARIA_ATTR !== !1),
                  (os = v.ALLOW_DATA_ATTR !== !1),
                  (Su = v.ALLOW_UNKNOWN_PROTOCOLS || !1),
                  (fi = v.SAFE_FOR_TEMPLATES || !1),
                  (Fn = v.WHOLE_DOCUMENT || !1),
                  (mi = v.RETURN_DOM || !1),
                  (co = v.RETURN_DOM_FRAGMENT || !1),
                  (uo = v.RETURN_TRUSTED_TYPE || !1),
                  (ss = v.FORCE_BODY || !1),
                  (Au = v.SANITIZE_DOM !== !1),
                  (wu = v.SANITIZE_NAMED_PROPS || !1),
                  (ls = v.KEEP_CONTENT !== !1),
                  (lr = v.IN_PLACE || !1),
                  (is = v.ALLOWED_URI_REGEXP || is),
                  (po = v.NAMESPACE || mn),
                  v.CUSTOM_ELEMENT_HANDLING &&
                    bu(v.CUSTOM_ELEMENT_HANDLING.tagNameCheck) &&
                    (Ee.tagNameCheck = v.CUSTOM_ELEMENT_HANDLING.tagNameCheck),
                  v.CUSTOM_ELEMENT_HANDLING &&
                    bu(v.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) &&
                    (Ee.attributeNameCheck = v.CUSTOM_ELEMENT_HANDLING.attributeNameCheck),
                  v.CUSTOM_ELEMENT_HANDLING &&
                    typeof v.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == 'boolean' &&
                    (Ee.allowCustomizedBuiltInElements = v.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements),
                  fi && (os = !1),
                  co && (mi = !0),
                  gi &&
                    ((be = C({}, a(dn))),
                    (De = []),
                    gi.html === !0 && (C(be, he), C(De, nr)),
                    gi.svg === !0 && (C(be, Ht), C(De, jn), C(De, pn)),
                    gi.svgFilters === !0 && (C(be, it), C(De, jn), C(De, pn)),
                    gi.mathMl === !0 && (C(be, pt), C(De, ci), C(De, pn))),
                  v.ADD_TAGS && (be === yu && (be = q(be)), C(be, v.ADD_TAGS, Ie)),
                  v.ADD_ATTR && (De === Eu && (De = q(De)), C(De, v.ADD_ATTR, Ie)),
                  v.ADD_URI_SAFE_ATTR && C(cs, v.ADD_URI_SAFE_ATTR, Ie),
                  v.FORBID_CONTENTS && (vi === Mu && (vi = q(vi)), C(vi, v.FORBID_CONTENTS, Ie)),
                  ls && (be['#text'] = !0),
                  Fn && C(be, ['html', 'head', 'body']),
                  be.table && (C(be, ['tbody']), delete sr.tbody),
                  p && p(v),
                  (xi = v));
              },
              Iu = C({}, ['mi', 'mo', 'mn', 'ms', 'mtext']),
              Lu = C({}, ['foreignobject', 'desc', 'title', 'annotation-xml']),
              Xm = C({}, ['title', 'style', 'font', 'a', 'script']),
              ho = C({}, Ht);
            C(ho, it), C(ho, On);
            var fs = C({}, pt);
            C(fs, un);
            var Zm = function (v) {
                var P = hi(v);
                (!P || !P.tagName) && (P = { namespaceURI: mn, tagName: 'template' });
                var H = Q(v.tagName),
                  ne = Q(P.tagName);
                return v.namespaceURI === ds
                  ? P.namespaceURI === mn
                    ? H === 'svg'
                    : P.namespaceURI === us
                      ? H === 'svg' && (ne === 'annotation-xml' || Iu[ne])
                      : Boolean(ho[H])
                  : v.namespaceURI === us
                    ? P.namespaceURI === mn
                      ? H === 'math'
                      : P.namespaceURI === ds
                        ? H === 'math' && Lu[ne]
                        : Boolean(fs[H])
                    : v.namespaceURI === mn
                      ? (P.namespaceURI === ds && !Lu[ne]) || (P.namespaceURI === us && !Iu[ne])
                        ? !1
                        : !fs[H] && (Xm[H] || !ho[H])
                      : !1;
              },
              Jt = function (v) {
                te(A.removed, { element: v });
                try {
                  v.parentNode.removeChild(v);
                } catch {
                  try {
                    v.outerHTML = or;
                  } catch {
                    v.remove();
                  }
                }
              },
              ms = function (v, P) {
                try {
                  te(A.removed, { attribute: P.getAttributeNode(v), from: P });
                } catch {
                  te(A.removed, { attribute: null, from: P });
                }
                if ((P.removeAttribute(v), v === 'is' && !De[v]))
                  if (mi || co)
                    try {
                      Jt(P);
                    } catch {}
                  else
                    try {
                      P.setAttribute(v, '');
                    } catch {}
              },
              Nu = function (v) {
                var P, H;
                if (ss) v = '<remove></remove>' + v;
                else {
                  var ne = Te(v, /^[\r\n\t ]+/);
                  H = ne && ne[0];
                }
                _i === 'application/xhtml+xml' &&
                  (v = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + v + '</body></html>');
                var ot = ht ? ht.createHTML(v) : v;
                if (po === mn)
                  try {
                    P = new hn().parseFromString(ot, _i);
                  } catch {}
                if (!P || !P.documentElement) {
                  P = Et.createDocument(po, 'template', null);
                  try {
                    P.documentElement.innerHTML = ps ? '' : ot;
                  } catch {}
                }
                var Ge = P.body || P.documentElement;
                return (
                  v && H && Ge.insertBefore(D.createTextNode(H), Ge.childNodes[0] || null),
                  po === mn ? Um.call(P, Fn ? 'html' : 'body')[0] : Fn ? P.documentElement : Ge
                );
              },
              Ru = function (v) {
                return ar.call(v.ownerDocument || v, v, Ce.SHOW_ELEMENT | Ce.SHOW_COMMENT | Ce.SHOW_TEXT, null, !1);
              },
              Ym = function (v) {
                return (
                  v instanceof di &&
                  (typeof v.nodeName != 'string' ||
                    typeof v.textContent != 'string' ||
                    typeof v.removeChild != 'function' ||
                    !(v.attributes instanceof Kt) ||
                    typeof v.removeAttribute != 'function' ||
                    typeof v.setAttribute != 'function' ||
                    typeof v.namespaceURI != 'string' ||
                    typeof v.insertBefore != 'function')
                );
              },
              cr = function (v) {
                return n(se) === 'object'
                  ? v instanceof se
                  : v && n(v) === 'object' && typeof v.nodeType == 'number' && typeof v.nodeName == 'string';
              },
              Xt = function (v, P, H) {
                !jt[v] ||
                  b(jt[v], function (ne) {
                    ne.call(A, P, H, xi);
                  });
              },
              Du = function (v) {
                var P;
                if ((Xt('beforeSanitizeElements', v, null), Ym(v) || Ae(/[\u0080-\uFFFF]/, v.nodeName)))
                  return Jt(v), !0;
                var H = Ie(v.nodeName);
                if (
                  (Xt('uponSanitizeElement', v, { tagName: H, allowedTags: be }),
                  (v.hasChildNodes() &&
                    !cr(v.firstElementChild) &&
                    (!cr(v.content) || !cr(v.content.firstElementChild)) &&
                    Ae(/<[/\w]/g, v.innerHTML) &&
                    Ae(/<[/\w]/g, v.textContent)) ||
                    (H === 'select' && Ae(/<template/i, v.innerHTML)))
                )
                  return Jt(v), !0;
                if (!be[H] || sr[H]) {
                  if (
                    !sr[H] &&
                    Ou(H) &&
                    ((Ee.tagNameCheck instanceof RegExp && Ae(Ee.tagNameCheck, H)) ||
                      (Ee.tagNameCheck instanceof Function && Ee.tagNameCheck(H)))
                  )
                    return !1;
                  if (ls && !vi[H]) {
                    var ne = hi(v) || v.parentNode,
                      ot = pi(v) || v.childNodes;
                    if (ot && ne)
                      for (var Ge = ot.length, He = Ge - 1; He >= 0; --He) ne.insertBefore(Be(ot[He], !0), Ot(v));
                  }
                  return Jt(v), !0;
                }
                return (v instanceof ze && !Zm(v)) ||
                  ((H === 'noscript' || H === 'noembed') && Ae(/<\/no(script|embed)/i, v.innerHTML))
                  ? (Jt(v), !0)
                  : (fi &&
                      v.nodeType === 3 &&
                      ((P = v.textContent),
                      (P = _e(P, ts, ' ')),
                      (P = _e(P, ns, ' ')),
                      v.textContent !== P && (te(A.removed, { element: v.cloneNode() }), (v.textContent = P))),
                    Xt('afterSanitizeElements', v, null),
                    !1);
              },
              Hu = function (v, P, H) {
                if (Au && (P === 'id' || P === 'name') && (H in D || H in Jm)) return !1;
                if (!(os && !rs[P] && Ae($m, P))) {
                  if (!(ku && Ae(qm, P))) {
                    if (!De[P] || rs[P]) {
                      if (
                        !(
                          (Ou(v) &&
                            ((Ee.tagNameCheck instanceof RegExp && Ae(Ee.tagNameCheck, v)) ||
                              (Ee.tagNameCheck instanceof Function && Ee.tagNameCheck(v))) &&
                            ((Ee.attributeNameCheck instanceof RegExp && Ae(Ee.attributeNameCheck, P)) ||
                              (Ee.attributeNameCheck instanceof Function && Ee.attributeNameCheck(P)))) ||
                          (P === 'is' &&
                            Ee.allowCustomizedBuiltInElements &&
                            ((Ee.tagNameCheck instanceof RegExp && Ae(Ee.tagNameCheck, H)) ||
                              (Ee.tagNameCheck instanceof Function && Ee.tagNameCheck(H))))
                        )
                      )
                        return !1;
                    } else if (!cs[P]) {
                      if (!Ae(is, _e(H, xu, ''))) {
                        if (
                          !(
                            (P === 'src' || P === 'xlink:href' || P === 'href') &&
                            v !== 'script' &&
                            Xe(H, 'data:') === 0 &&
                            Pu[v]
                          )
                        ) {
                          if (!(Su && !Ae(Vm, _e(H, xu, '')))) {
                            if (H) return !1;
                          }
                        }
                      }
                    }
                  }
                }
                return !0;
              },
              Ou = function (v) {
                return v.indexOf('-') > 0;
              },
              ju = function (v) {
                var P, H, ne, ot;
                Xt('beforeSanitizeAttributes', v, null);
                var Ge = v.attributes;
                if (Ge) {
                  var He = { attrName: '', attrValue: '', keepAttr: !0, allowedAttributes: De };
                  for (ot = Ge.length; ot--; ) {
                    P = Ge[ot];
                    var fo = P,
                      $e = fo.name,
                      gs = fo.namespaceURI;
                    if (
                      ((H = $e === 'value' ? P.value : li(P.value)),
                      (ne = Ie($e)),
                      (He.attrName = ne),
                      (He.attrValue = H),
                      (He.keepAttr = !0),
                      (He.forceKeepAttr = void 0),
                      Xt('uponSanitizeAttribute', v, He),
                      (H = He.attrValue),
                      !He.forceKeepAttr && (ms($e, v), !!He.keepAttr))
                    ) {
                      if (Ae(/\/>/i, H)) {
                        ms($e, v);
                        continue;
                      }
                      fi && ((H = _e(H, ts, ' ')), (H = _e(H, ns, ' ')));
                      var Fu = Ie(v.nodeName);
                      if (Hu(Fu, ne, H)) {
                        if (
                          (wu && (ne === 'id' || ne === 'name') && (ms($e, v), (H = Qm + H)),
                          ht && n(fn) === 'object' && typeof fn.getAttributeType == 'function' && !gs)
                        )
                          switch (fn.getAttributeType(Fu, ne)) {
                            case 'TrustedHTML':
                              H = ht.createHTML(H);
                              break;
                            case 'TrustedScriptURL':
                              H = ht.createScriptURL(H);
                              break;
                          }
                        try {
                          gs ? v.setAttributeNS(gs, $e, H) : v.setAttribute($e, H), z(A.removed);
                        } catch {}
                      }
                    }
                  }
                  Xt('afterSanitizeAttributes', v, null);
                }
              },
              eg = function U(v) {
                var P,
                  H = Ru(v);
                for (Xt('beforeSanitizeShadowDOM', v, null); (P = H.nextNode()); )
                  Xt('uponSanitizeShadowNode', P, null), !Du(P) && (P.content instanceof $ && U(P.content), ju(P));
                Xt('afterSanitizeShadowDOM', v, null);
              };
            return (
              (A.sanitize = function (U) {
                var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
                  P,
                  H,
                  ne,
                  ot,
                  Ge;
                if (((ps = !U), ps && (U = '<!-->'), typeof U != 'string' && !cr(U))) {
                  if (typeof U.toString != 'function') throw Wt('toString is not a function');
                  if (((U = U.toString()), typeof U != 'string')) throw Wt('dirty is not a string, aborting');
                }
                if (!A.isSupported) {
                  if (n(E.toStaticHTML) === 'object' || typeof E.toStaticHTML == 'function') {
                    if (typeof U == 'string') return E.toStaticHTML(U);
                    if (cr(U)) return E.toStaticHTML(U.outerHTML);
                  }
                  return U;
                }
                if ((as || hs(v), (A.removed = []), typeof U == 'string' && (lr = !1), lr)) {
                  if (U.nodeName) {
                    var He = Ie(U.nodeName);
                    if (!be[He] || sr[He]) throw Wt('root node is forbidden and cannot be sanitized in-place');
                  }
                } else if (U instanceof se)
                  (P = Nu('<!---->')),
                    (H = P.ownerDocument.importNode(U, !0)),
                    (H.nodeType === 1 && H.nodeName === 'BODY') || H.nodeName === 'HTML' ? (P = H) : P.appendChild(H);
                else {
                  if (!mi && !fi && !Fn && U.indexOf('<') === -1) return ht && uo ? ht.createHTML(U) : U;
                  if (((P = Nu(U)), !P)) return mi ? null : uo ? or : '';
                }
                P && ss && Jt(P.firstChild);
                for (var fo = Ru(lr ? U : P); (ne = fo.nextNode()); )
                  (ne.nodeType === 3 && ne === ot) ||
                    Du(ne) ||
                    (ne.content instanceof $ && eg(ne.content), ju(ne), (ot = ne));
                if (((ot = null), lr)) return U;
                if (mi) {
                  if (co) for (Ge = es.call(P.ownerDocument); P.firstChild; ) Ge.appendChild(P.firstChild);
                  else Ge = P;
                  return De.shadowroot && (Ge = Gm.call(I, Ge, !0)), Ge;
                }
                var $e = Fn ? P.outerHTML : P.innerHTML;
                return (
                  Fn &&
                    be['!doctype'] &&
                    P.ownerDocument &&
                    P.ownerDocument.doctype &&
                    P.ownerDocument.doctype.name &&
                    Ae(lo, P.ownerDocument.doctype.name) &&
                    ($e =
                      '<!DOCTYPE ' +
                      P.ownerDocument.doctype.name +
                      `>
` +
                      $e),
                  fi && (($e = _e($e, ts, ' ')), ($e = _e($e, ns, ' '))),
                  ht && uo ? ht.createHTML($e) : $e
                );
              }),
              (A.setConfig = function (U) {
                hs(U), (as = !0);
              }),
              (A.clearConfig = function () {
                (xi = null), (as = !1);
              }),
              (A.isValidAttribute = function (U, v, P) {
                xi || hs({});
                var H = Ie(U),
                  ne = Ie(v);
                return Hu(H, ne, P);
              }),
              (A.addHook = function (U, v) {
                typeof v == 'function' && ((jt[U] = jt[U] || []), te(jt[U], v));
              }),
              (A.removeHook = function (U) {
                if (jt[U]) return z(jt[U]);
              }),
              (A.removeHooks = function (U) {
                jt[U] && (jt[U] = []);
              }),
              (A.removeAllHooks = function () {
                jt = {};
              }),
              A
            );
          }
          var V = L();
          return V;
        });
      })(Zs)),
    Zs.exports
  );
}
var IE = window.DOMPurify || (window.DOMPurify = Ip().default || Ip());
function LE({ type: e, codeId: t, enterWidescreenModeButtonLabel: n, exitWidescreenModeButtonLabel: i }) {
  const r = B.exports.useRef(null),
    [o, a] = B.exports.useState(!1);
  let s = i;
  return (
    o || (s = n),
    _(ri, {
      children: W('div', {
        ref: r,
        className: o
          ? 'app__content--full-width code-ide--codesandbox code-ide code-ide--full-width'
          : 'code-ide code-ide--codesandbox code-ide--centered',
        children: [
          _('button', {
            className:
              'code-ide__widescreen-mode-button spectrum-Button spectrum-Button--primary spectrum-Button--sizeM',
            onClick: () => {
              a(!o), r.current.scrollIntoView();
            },
            children: s,
          }),
          e === 'codepen' && RE({ codeId: t }),
          e === 'codesandbox' && NE({ codeId: t }),
        ],
      }),
    })
  );
}
function NE({ title: e, codeId: t }) {
  return _('iframe', {
    src: `https://codesandbox.io/embed/${t}?fontsize=14&hidenavigation=1&theme=dark&codemirror=1`,
    className: 'code-ide__embed code-ide__embed--codesandboxio',
    title: e,
    allow:
      'accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking',
    sandbox: 'allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts',
  });
}
function RE({ title: e, codeId: t }) {
  const r = `<iframe 
        height="${800}" 
        style="width: 100%;" 
        scrolling="no" 
        title="${e}" 
        src="https://codepen.io/adobe-experience-league/embed/${t}?height=${800}&theme-id=default&default-tab=js,result&editable=true"" 
        frameborder="no" 
        loading="lazy" 
        allowtransparency="true" 
        allowfullscreen="true">`;
  return _('div', { dangerouslySetInnerHTML: { __html: r } });
}
function DE(e) {
  const { formatMessage: t } = e.intl,
    n = oo,
    [i, r] = B.exports.useState(!1);
  let { id: o } = k0(),
    a = n.code_index.code[o],
    { article: s, error: l } = Bm(a.articleId);
  if (!s) return;
  gu(document, s.title, s.description);
  let c = IE.sanitize(s.body);
  return (
    i || (HE(o), r(!0)),
    W(ri, {
      children: [
        _(vu, {}),
        _(Ja, {}),
        W('div', {
          className: 'app__content--centered',
          children: [
            W(_a, {
              className: 'code-by-ide__back-link',
              to: '/developer/code.html',
              children: ['\u2039 ', t(n.code_by_id.button_back)],
            }),
            _('div', {
              id: 'container',
              class: 'code-by-id__content',
              style: { marginTop: '2rem' },
              children: _('div', { 'data-id': 'main', dangerouslySetInnerHTML: { __html: c } }),
            }),
          ],
        }),
        _(LE, {
          type: a.type,
          codeId: a.codeId,
          enterWidescreenModeButtonLabel: t(n.code_by_id.button_enter_widescreen),
          exitWidescreenModeButtonLabel: t(n.code_by_id.button_exit_widescreen),
        }),
      ],
    })
  );
}
function HE(e) {
  (window.adobeDataLayer = window.adobeDataLayer || []),
    window.adobeDataLayer.push({
      event: 'page loaded',
      user: window.adobeDataLayer.getState().user || {},
      web: {
        webPageDetails: {
          pageViews: { value: 1 },
          pageTitle: `AEM Headless developer resources - Code playground - ${e}`,
          name: `xl:microsite:landing:experience-manager:headless:code-playground:${e}`,
          pageType: 'webpage',
          URL: `https://experienceleague.adobe.com/code/${e}`,
          domain: 'experienceleague.adobe.com',
          server: void 0,
          siteSection: 'microsite',
          siteSubSection1: 'microsite',
          siteSubSection2: ' ',
          siteSubSection3: ' ',
        },
      },
    });
}
const OE = er(DE),
  Lp = oo;
function jE(e) {
  const { formatMessage: t } = e.intl;
  return W(ri, {
    children: [
      _(vu, {}),
      _(Ja, {}),
      W('div', {
        className: 'app__content--centered',
        children: [
          _('h1', {
            className: 'is-extra-bold is-size-36 is-size-34-touch has-text-blackest',
            children: t(Lp.error.title),
          }),
          _('p', {
            className: 'is-size-18 has-text-weight-normal has-text-blackest',
            style: { marginBottom: '400px' },
            children: t(Lp.error.text),
          }),
        ],
      }),
    ],
  });
}
const Ys = er(jE);
function FE(e) {
  const [t, n] = B.exports.useState(e.intl.locale),
    i = R0(
      [
        { path: '/index.html', element: _(wE, {}), errorElement: _(Ys, {}) },
        { path: '/developer/code.html', element: _(bE, {}), errorElement: _(Ys, {}) },
        { path: '/developer/code/:id.html', element: _(OE, {}), errorElement: _(Ys, {}) },
      ],
      { basename: '/' },
    );
  return (
    B.exports.useEffect(() => {
      async function r() {
        await _y(t), await xy(t), await yy();
      }
      r();
    }, [t]),
    _('div', { className: 'app', children: _(b0, { router: i }) })
  );
}
const zE = er(FE),
  BE = {
    'app.hero.cta': 'Watch how it works',
    'app.hero.solution': 'Adobe Experience Manager Headless',
    'app.hero.text':
      'Everything you need to learn about AEM headless CMS to build and ship better applications and faster experiences.',
    'app.hero.title': 'Start building with AEM Headless CMS',
    'code_by_id.button.back': 'Back to code playground',
    'code_by_id.button.enter_widescreen': 'Enter widescreen mode',
    'code_by_id.button.exit_widescreen': 'Exit widescreen mode',
    'code_index.button.run_the_code': 'Run the code',
    'code_index.text': 'Test drive AEM Headless CMS in seconds using example JavaScript apps!',
    'code_index.title': 'Code playground',
    'community.links.0': 'Join the discussion',
    'community.text':
      'Discuss, ask questions and get answers about AEM Headless with the entire AEM developer community on Experience League Communities.',
    'community.title': 'Join the discussion',
    'error.text': 'Sorry! Something went wrong. Please try again later.',
    'error.title': 'Oops! An error occurred.',
    'example_apps_android.links.0': 'View the app',
    'example_apps_android.text': 'An example Java Android app that consumes content from AEM Headless APIs.',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': 'View the app',
    'example_apps_ios.text': 'An example SwiftUI iOS app that consumes content from AEM Headless APIs.',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'View the app',
    'example_apps_next_js.text': 'An example Next.js application that consumes content from AEM Headless APIs.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'View the app',
    'example_apps_node-js.text':
      'An example command-line Node.js application that consumes content from AEM Headless APIs.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': 'View the app',
    'example_apps_react.text': 'An example React application that consumes content from AEM Headless APIs.',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'View the app',
    'example_apps_web-component.text':
      'An example pure JavaScript Web Component that consumes content from AEM Headless APIs.',
    'example_apps_web-component.title': 'Web Component/JS',
    'experienced_developers.text1':
      'Go through { fiveSteps} for creating, managing, and delivering experiences using AEM. { break } Already done? Head over to our { advancedDocumentation }.',
    'experienced_developers.title': 'FOR { emphasis } AEM HEADLESS CMS DEVELOPERS',
    'experienced_developers.title.emphasis': 'EXPERIENCED',
    'get_involved_blog.links.0': 'Read the blog',
    'get_involved_blog.text': 'Read the latest on our tech blog.',
    'get_involved_blog.title': 'Adobe Tech Blog',
    'get_involved_community.links.0': 'Join the conversation',
    'get_involved_community.text': 'Join our community and get answers to your questions.',
    'get_involved_community.title': 'Experience League Communities',
    'nav.codePlayground': 'Code playground',
    'nav.home': 'Home',
    'nav.title': 'AEM Headless CMS developer portal',
    'new_developers.text':
      'Read this { guideLink }  to learn about headless CMS features of AEM and how to leverage them in a headless development project.',
    'new_developers.text.5_steps': '5 steps',
    'new_developers.text.advanced_documentation': 'advanced documentation',
    'new_developers.text.guide_link': 'guide',
    'new_developers.title': 'FOR DEVELOPERS { emphasis } TO AEM HEADLESS CMS',
    'new_developers.title.emphasis': 'NEW',
    'new_to_aem_headless.links.0': 'Read the guide',
    'page.description':
      'Visit the AEM Headless CMS developer resources and documentation. Learn how to build next generation apps using headless CMS technologies in Experience Manager as a Cloud Service.',
    'page.title': 'AEM Headless CMS Developer Resources and Documentation | Adobe Experience Manager',
    'quick_setup.links.0': 'Quick setup for Cloud Service',
    'quick_setup.links.1': 'Quick setup for local AEM SDK',
    'quick_setup.text': 'Setup and test drive AEM Headless in minutes using an example React app.',
    'quick_setup.title': 'Quick setup',
    'section_developer_resources.title': 'Advanced documentation',
    'section_example_apps.title': 'Example AEM Headless CMS apps',
    'section_get_involved.title': 'Get involved!',
    'section_spa_editor.text':
      'The AEM SPA Editor provides a framework to develop React or Angular apps that can be updated in-context by marketers using the AEM authoring UI.',
    'section_spa_editor.title': 'Explore the AEM SPA Editor',
    'spa_editor.links.0': 'Start the React tutorial',
    'spa_editor.text':
      'The AEM SPA Editor can be used to create a SPA whose components, routing, and views can be completely managed in AEM. The SPA Editor supports the React framework.',
    'spa_editor.title': 'Manage a SPA in AEM',
    'spa_editor_remote_spa.links.0': 'Start the tutorial',
    'spa_editor_remote_spa.text':
      "AEM's Remote SPA capabilities enables marketers to update targeted regions of a remotely hosted SPA.",
    'spa_editor_remote_spa.title': 'Author a remote SPA',
    'technical_docs.apis.section.formsapis': 'AEM Forms HTTP APIs',
    'technical_docs.apis.section.formsapis.links.0': 'AEM Forms API (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'GraphQL APIs',
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.1': 'Sample GraphQL queries',
    'technical_docs.apis.section.relatedhttpapis': 'Related HTTP APIs',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM Assets HTTP API',
    'technical_docs.apis.text': "Learn about AEM's GraphQL APIs and how to construct queries and HTTP requests.",
    'technical_docs.apis.title': 'APIs',
    'technical_docs.documentation.section.contentfragments': 'Content Fragments',
    'technical_docs.documentation.section.contentfragments.links.0': 'Enabling Contents Fragments',
    'technical_docs.documentation.section.contentfragments.links.1': 'Content Fragment Models',
    'technical_docs.documentation.section.contentfragments.links.2': 'Managing Content Fragments',
    'technical_docs.documentation.section.contentfragments.links.3': 'Variations',
    'technical_docs.documentation.section.contentfragments.links.4': 'Associated content',
    'technical_docs.documentation.section.contentfragments.links.5': 'Metadata',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': 'Structure tree',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON preview',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Headless Adaptive Forms',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL AEM endpoint',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': 'Enabling a GraphQL endpoint',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': 'Publishing a GraphQL endpoint',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': 'Persisted queries',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': 'Publish Persisted queries',
    'technical_docs.documentation.text':
      "View Adobe Experience Manager as a Cloud Services documentation for the complete description of AEM's capabilities and configurations.",
    'technical_docs.documentation.title': 'Additional documentation',
    'technical_docs.how-to.section.content': 'Content',
    'technical_docs.how-to.section.content.links.0': 'Rich Text',
    'technical_docs.how-to.section.content.links.1': 'Images',
    'technical_docs.how-to.section.content.links.2': 'Localized Content',
    'technical_docs.how-to.section.content.links.3': 'Large result sets',
    'technical_docs.how-to.section.content.links.4': 'Preview',
    'technical_docs.how-to.section.deployment': 'Deployment',
    'technical_docs.how-to.section.deployment.links.0': 'Single-page app',
    'technical_docs.how-to.section.deployment.links.1': 'Web component',
    'technical_docs.how-to.section.deployment.links.2': 'Mobile',
    'technical_docs.how-to.section.deployment.links.3': 'Server-to-server',
    'technical_docs.how-to.section.development': 'Development',
    'technical_docs.how-to.section.development.links.0': 'AEM Headless SDK',
    'technical_docs.how-to.section.development.links.1': 'Install GraphiQL IDE on AEM 6.5',
    'technical_docs.how-to.text': 'Learn how to approach different use cases with AEM Headless.',
    'technical_docs.how-to.title': 'How-to guides',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0': 'Client-side JS SDK',
    'technical_docs.sdks.section.javascript.links.1': 'Server-side JS SDK',
    'technical_docs.sdks.section.javascript.links.2': 'jwt-auth npm module',
    'technical_docs.sdks.text': 'Use AEM Headless SDKs to interact with AEM Headless APIs.',
    'technical_docs.sdks.title': 'SDKs',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'AEM 6.5 GraphiQL installation guide',
    'technical_docs.tools.text': "Explore AEM's headless developer tools.",
    'technical_docs.tools.title': 'Tools',
    'what_is_headless.text':
      "AEM Headless CMS gives developers the freedom to do what they do best: build faster and deliver exceptional experiences using the languages, frameworks, and tools they're already familiar with.",
    'what_is_headless.title': 'What is AEM Headless CMS?',
  },
  UE = {
    'app.hero.cta': 'Funktionsweise ansehen',
    'app.hero.solution': 'Adobe Experience Manager Headless',
    'app.hero.text':
      'Alles, was Sie \xFCber AEM Headless CMS wissen m\xFCssen, damit Sie bessere Programme und schnellere Erlebnisse erstellen und versenden k\xF6nnen.',
    'app.hero.title': 'Erste Schritte bei der Entwicklung mit AEM Headless CMS',
    'code_by_id.button.back': 'Zur\xFCck zum Code Playground',
    'code_by_id.button.enter_widescreen': 'Breitbildmodus starten',
    'code_by_id.button.exit_widescreen': 'Breitbildmodus beenden',
    'code_index.button.run_the_code': 'Code ausf\xFChren',
    'code_index.text': 'Testen Sie AEM Headless CMS in wenigen Sekunden mithilfe von JavaScript-Beispielanwendungen!',
    'code_index.title': 'Code Playground',
    'community.links.0': 'Teil der Community werden',
    'community.text':
      'Diskutieren Sie mit AEM-Entwicklern in den Experience League-Communities \xFCber AEM Headless, stellen Sie Fragen und erhalten Sie Antworten.',
    'community.title': 'Teil der Community werden',
    'error.text': 'Ein Problem ist aufgetreten. Versuchen Sie es sp\xE4ter erneut.',
    'error.title': 'Hoppla! Ein Fehler ist aufgetreten.',
    'example_apps_android.links.0': 'Programm zeigen',
    'example_apps_android.text':
      'Ein Beispiel f\xFCr eine Java-Android-Mobile-App, die Inhalte von AEM Headless-APIs nutzt.',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': 'Programm zeigen',
    'example_apps_ios.text':
      'Ein Beispiel f\xFCr eine SwiftUI-iOS-Mobile-App, die Inhalte von AEM Headless-APIs nutzt.',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'Programm zeigen',
    'example_apps_next_js.text': 'Ein Beispiel f\xFCr ein Next.js-Programm, das Inhalte von AEM Headless-APIs nutzt.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'Anwendung zeigen',
    'example_apps_node-js.text':
      'Ein Beispiel f\xFCr eine Node.js-Befehlszeilenanwendung, die Inhalte von AEM Headless-APIs nutzt.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': 'Programm zeigen',
    'example_apps_react.text': 'Ein Beispiel f\xFCr ein React-Programm, das Inhalte von AEM Headless-APIs nutzt.',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'Anwendung zeigen',
    'example_apps_web-component.text':
      'Ein Beispiel f\xFCr eine reine JavaScript-Web-Komponente, die Inhalte von AEM Headless-APIs nutzt.',
    'example_apps_web-component.title': 'Web-Komponente/JS',
    'experienced_developers.text1':
      'In { fiveSteps} erfahren Sie, wie Sie Erlebnisse mit AEM erstellen, verwalten und bereitstellen. { break } Bereits absolviert? Dann nutzen Sie unsere { advancedDocumentation }.',
    'experienced_developers.title': 'F\xDCR { emphasis } AEM HEADLESS CMS-ENTWICKELNDE',
    'experienced_developers.title.emphasis': 'ERFAHREN',
    'get_involved_blog.links.0': 'Blog lesen',
    'get_involved_blog.text': 'Die neuesten Informationen finden Sie in unserem Tech Blog.',
    'get_involved_blog.title': 'Adobe Tech Blog',
    'get_involved_community.links.0': 'Jetzt mitreden',
    'get_involved_community.text': 'Treten Sie unserer Community bei und erhalten Sie Antworten auf Ihre Fragen.',
    'get_involved_community.title': 'Experience League-Communities',
    'nav.codePlayground': 'Code Playground',
    'nav.home': 'Startseite',
    'nav.title': 'Entwicklerportal f\xFCr AEM Headless CMS',
    'new_developers.text':
      'Lesen Sie dieses { guideLink }, um mehr \xFCber die Headless-CMS-Funktionen von AEM und ihre Nutzung in einem Headless-Entwicklungsprojekt zu erfahren.',
    'new_developers.text.5_steps': 'F\xFCnf Schritte',
    'new_developers.text.advanced_documentation': 'erweiterte Dokumentation',
    'new_developers.text.guide_link': '-Handbuch',
    'new_developers.title': 'F\xDCR ENTWICKELNDE { emphasis } F\xDCR AEM HEADLESS CMS',
    'new_developers.title.emphasis': 'NEU',
    'new_to_aem_headless.links.0': 'Anleitung lesen',
    'page.description':
      'Besuchen Sie die Ressourcen und Dokumenation f\xFCr Entwickelnde f\xFCr AEM Headless CMS. Erfahren Sie, wie Sie mit den Technologien f\xFCr Headless-CMS in Experience Manager as a Cloud Service Anwendungen der n\xE4chsten Generation entwickeln.',
    'page.title': 'Ressourcen und Dokumentation f\xFCr Entwickelnde f\xFCr AEM Headless CMS | Adobe Experience Manager',
    'quick_setup.links.0': 'Schnelles Setup f\xFCr Cloud Service',
    'quick_setup.links.1': 'Schnelles Setup f\xFCr lokales AEM SDK',
    'quick_setup.text':
      'Richten Sie AEM Headless ein und testen Sie es in wenigen Minuten anhand eines React-Beispielprogramms.',
    'quick_setup.title': 'Schnell-Setup',
    'section_developer_resources.title': 'Erweiterte Dokumentation',
    'section_example_apps.title': 'Beispielanwendungen f\xFCr AEM Headless CMS',
    'section_get_involved.title': 'Seien Sie dabei!',
    'section_spa_editor.text':
      'Der AEM-SPA-Editor bietet ein Framework f\xFCr die Entwicklung von React- oder Angular-Programmen, die von Marketern \xFCber die AEM-Authoring-Benutzeroberfl\xE4che aktualisiert werden k\xF6nnen.',
    'section_spa_editor.title': 'Lernen Sie den AEM-SPA-Editor kennen',
    'spa_editor.links.0': 'React-Tutorial starten',
    'spa_editor.text':
      'Mit dem AEM-SPA-Editor k\xF6nnen Sie eine SPA erstellen, deren Komponenten, Routing und Ansichten vollst\xE4ndig in AEM verwaltet werden k\xF6nnen. Der SPA-Editor unterst\xFCtzt das React-Framework.',
    'spa_editor.title': 'Verwalten einer SPA in AEM',
    'spa_editor_remote_spa.links.0': 'Tutorial starten',
    'spa_editor_remote_spa.text':
      'Mit den Remote-SPA-Funktionen von AEM k\xF6nnen Marketer bestimmte Bereiche einer remote gehosteten SPA aktualisieren.',
    'spa_editor_remote_spa.title': 'Erstellen einer Remote-SPA',
    'technical_docs.apis.section.formsapis': 'AEM Forms-HTTP-APIs',
    'technical_docs.apis.section.formsapis.links.0': 'AEM Forms-API (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'GraphQL-APIs',
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL-API',
    'technical_docs.apis.section.graphqlapis.links.1': 'Beispiele f\xFCr GraphQL-Abfragen',
    'technical_docs.apis.section.relatedhttpapis': 'Zugeh\xF6rige HTTP-APIs',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM\xA0Assets-HTTP-API',
    'technical_docs.apis.text':
      'Lernen Sie die GraphQL-APIs von AEM kennen und erfahren Sie, wie Sie Abfragen und HTTP-Anfragen erstellen.',
    'technical_docs.apis.title': 'APIs',
    'technical_docs.documentation.section.contentfragments': 'Inhaltsfragmente',
    'technical_docs.documentation.section.contentfragments.links.0': 'Aktivieren von Inhaltsfragmenten',
    'technical_docs.documentation.section.contentfragments.links.1': 'Inhaltsfragmentmodelle',
    'technical_docs.documentation.section.contentfragments.links.2': 'Verwalten von Inhaltsfragmenten',
    'technical_docs.documentation.section.contentfragments.links.3': 'Varianten',
    'technical_docs.documentation.section.contentfragments.links.4': 'Zugeh\xF6rige Inhalte',
    'technical_docs.documentation.section.contentfragments.links.5': 'Metadaten',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': 'Strukturbaum',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON-Vorschau',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Adaptive Headless-Formulare',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL-AEM-Endpunkt',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': 'Aktivieren eines GraphQL-Endpunkts',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': 'Ver\xF6ffentlichen eines GraphQL-Endpunkts',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': 'Persistente Abfragen',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': 'Ver\xF6ffentlichen von persistenten Abfragen',
    'technical_docs.documentation.text':
      'Die vollst\xE4ndige Beschreibung der Funktionen und Konfigurationen von AEM finden Sie in der Dokumentation zu Adobe Experience Manager as a Cloud Service.',
    'technical_docs.documentation.title': 'Zus\xE4tzliche Dokumentation',
    'technical_docs.how-to.section.content': 'Inhalt',
    'technical_docs.how-to.section.content.links.0': 'Rich-Text',
    'technical_docs.how-to.section.content.links.1': 'Bilder',
    'technical_docs.how-to.section.content.links.2': 'Lokalisierter Inhalt',
    'technical_docs.how-to.section.content.links.3': 'Gro\xDFe Ergebnissets',
    'technical_docs.how-to.section.content.links.4': 'Vorschau',
    'technical_docs.how-to.section.deployment': 'Implementierung',
    'technical_docs.how-to.section.deployment.links.0': 'Single Page Applications',
    'technical_docs.how-to.section.deployment.links.1': 'Web-Komponente',
    'technical_docs.how-to.section.deployment.links.2': 'Mobilger\xE4t',
    'technical_docs.how-to.section.deployment.links.3': 'Server-zu-Server',
    'technical_docs.how-to.section.development': 'Entwicklung',
    'technical_docs.how-to.section.development.links.0': 'AEM Headless-SDK',
    'technical_docs.how-to.section.development.links.1': 'Installieren von GraphiQL IDE unter AEM 6.5',
    'technical_docs.how-to.text':
      'Erfahren Sie, wie Sie unterschiedliche Anwendungsf\xE4lle mit AEM Headless l\xF6sen k\xF6nnen.',
    'technical_docs.how-to.title': 'Handb\xFCcher',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java-SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0': 'Client-seitiges JS-SDK',
    'technical_docs.sdks.section.javascript.links.1': 'Server-seitiges JS-SDK',
    'technical_docs.sdks.section.javascript.links.2': 'NPM-Modul jwt-auth',
    'technical_docs.sdks.text': 'Verwenden Sie AEM Headless-SDKs, um mit AEM Headless-APIs zu interagieren.',
    'technical_docs.sdks.title': 'SDKs',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'Installationsleitfaden f\xFCr AEM 6.5 GraphiQL',
    'technical_docs.tools.text': 'Erkunden Sie die Headless-Entwickler-Tools von AEM.',
    'technical_docs.tools.title': 'Tools',
    'what_is_headless.text':
      'AEM Headless CMS bietet Entwickelnden die M\xF6glichkeit, das zu tun, was sie am besten k\xF6nnen: schnell au\xDFergew\xF6hnliche Erlebnisse mithilfe der Sprachen, Frameworks und Tools bereitstellen, mit denen sie bereits vertraut sind.',
    'what_is_headless.title': 'Was ist AEM Headless CMS?',
  },
  GE = {
    'app.hero.cta': 'Ver c\xF3mo funciona',
    'app.hero.solution': 'Adobe Experience Manager sin encabezado',
    'app.hero.text':
      'Todo lo que necesita saber sobre el CMS\xA0descentralizado de AEM para crear y ofrecer mejores aplicaciones y experiencias m\xE1s r\xE1pidas.',
    'app.hero.title': 'Empezar a crear con CMS sin encabezado de AEM',
    'code_by_id.button.back': 'Volver a Code Playground',
    'code_by_id.button.enter_widescreen': 'Entrar en el modo de pantalla panor\xE1mica',
    'code_by_id.button.exit_widescreen': 'Salir del modo de pantalla panor\xE1mica',
    'code_index.button.run_the_code': 'Ejecutar c\xF3digo',
    'code_index.text':
      '\xA1Use aplicaciones JavaScript de ejemplo para probar CMS sin encabezado de AEM en cuesti\xF3n de segundos!',
    'code_index.title': 'Code Playground',
    'community.links.0': 'Unirse al debate',
    'community.text':
      'Participe en debates, haga preguntas y obtenga respuestas sobre AEM Headless con toda la comunidad de desarrolladores de AEM en Experience League Communities.',
    'community.title': 'Unirse al debate',
    'error.text': 'Se ha producido un error. Int\xE9ntelo de nuevo m\xE1s tarde.',
    'error.title': '\xA1Vaya! Se ha producido un error.',
    'example_apps_android.links.0': 'Ver la aplicaci\xF3n',
    'example_apps_android.text':
      'Una aplicaci\xF3n Java Android de ejemplo que consume contenido de las API de AEM Headless.',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': 'Ver la aplicaci\xF3n',
    'example_apps_ios.text':
      'Una aplicaci\xF3n iOS SwiftUI de ejemplo que consume contenido de las API de AEM Headless.',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'Ver la aplicaci\xF3n',
    'example_apps_next_js.text':
      'Una aplicaci\xF3n Next.js de ejemplo que consume contenido de las API de AEM Headless.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'Ver la aplicaci\xF3n',
    'example_apps_node-js.text':
      'Una aplicaci\xF3n Node.js de l\xEDnea de comandos de ejemplo que consume contenido de las API de AEM Headless.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': 'Ver la aplicaci\xF3n',
    'example_apps_react.text': 'Una aplicaci\xF3n React de ejemplo que consume contenido de las API de AEM Headless.',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'Ver la aplicaci\xF3n',
    'example_apps_web-component.text':
      'Un componente web de JavaScript puro de ejemplo que consume contenido de las API de AEM Headless.',
    'example_apps_web-component.title': 'Componente web/JS',
    'experienced_developers.text1':
      'Siga { fiveSteps} para crear, gestionar y ofrecer experiencias con AEM. { break } \xBFYa ha terminado? Consulte nuestra { advancedDocumentation }.',
    'experienced_developers.title': 'PARA { emphasis } DESARROLLADORES DE CMS SIN ENCABEZADO DE AEM',
    'experienced_developers.title.emphasis': 'EXPERIMENTADO',
    'get_involved_blog.links.0': 'Leer el blog',
    'get_involved_blog.text': 'Lea las \xFAltimas novedades en nuestro blog sobre tecnolog\xEDa.',
    'get_involved_blog.title': 'Blog de Adobe Tech',
    'get_involved_community.links.0': '\xDAnase a la conversaci\xF3n',
    'get_involved_community.text': '\xDAnase a nuestra comunidad y reciba respuesta a sus preguntas.',
    'get_involved_community.title': 'Experience League Communities',
    'nav.codePlayground': 'Code Playground',
    'nav.home': 'P\xE1gina principal',
    'nav.title': 'Portal para desarrolladores de CMS sin encabezado de AEM',
    'new_developers.text':
      'Consulte esta { guideLink } para aprender m\xE1s sobre las funciones CMS sin encabezado de AEM y c\xF3mo aprovecharlas en un proyecto de desarrollo sin encabezado.',
    'new_developers.text.5_steps': '5\xA0pasos',
    'new_developers.text.advanced_documentation': 'documentaci\xF3n avanzada',
    'new_developers.text.guide_link': 'gu\xEDa',
    'new_developers.title': 'PARA LOS DESARROLLADORES { emphasis } PARA CMS SIN ENCABEZADO DE AEM',
    'new_developers.title.emphasis': 'NUEVO',
    'new_to_aem_headless.links.0': 'Leer la gu\xEDa',
    'page.description':
      'Visite la documentaci\xF3n y los recursos para desarrolladores de CMS sin encabezado de AEM. Aprenda a crear aplicaciones de pr\xF3xima generaci\xF3n usando las tecnolog\xEDas CMS en Experience Manager as a Cloud Service.',
    'page.title':
      'Documentaci\xF3n y recursos para desarrolladores de CMS sin encabezado de AEM | Adobe Experience Manager',
    'quick_setup.links.0': 'Configuraci\xF3n r\xE1pida de Cloud Service',
    'quick_setup.links.1': 'Configuraci\xF3n r\xE1pida de AEM SDK local',
    'quick_setup.text':
      'Configure y pruebe AEM Headless en cuesti\xF3n de minutos con una aplicaci\xF3n React de ejemplo.',
    'quick_setup.title': 'Configuraci\xF3n r\xE1pida',
    'section_developer_resources.title': 'Documentaci\xF3n avanzada',
    'section_example_apps.title': 'Aplicaciones CMS sin encabezado de AEM de ejemplo',
    'section_get_involved.title': '\xA1Empiece ya!',
    'section_spa_editor.text':
      'El Editor de SPA de AEM proporciona un marco de trabajo para desarrollar aplicaciones React o Angular que los responsables de marketing puedan actualizar en contexto mediante la interfaz de usuario de creaci\xF3n de AEM.',
    'section_spa_editor.title': 'Explorar el Editor de SPA de AEM',
    'spa_editor.links.0': 'Iniciar el tutorial de React',
    'spa_editor.text':
      'El Editor de SPA de AEM se puede utilizar para crear una SPA cuyos componentes, enrutamiento y vistas se puedan gestionar completamente en AEM. El Editor de SPA admite indistintamente marcos de trabajo de React.',
    'spa_editor.title': 'Administrar una SPA en AEM',
    'spa_editor_remote_spa.links.0': 'Iniciar el tutorial',
    'spa_editor_remote_spa.text':
      'Las prestaciones de SPA remotas de AEM permiten a los responsables de marketing actualizar regiones espec\xEDficas de una SPA alojada de forma remota.',
    'spa_editor_remote_spa.title': 'Crear una SPA remota',
    'technical_docs.apis.section.formsapis': 'API HTTP de AEM Forms',
    'technical_docs.apis.section.formsapis.links.0': 'API de AEM Forms (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'API de GraphQL',
    'technical_docs.apis.section.graphqlapis.links.0': 'API de GraphQL',
    'technical_docs.apis.section.graphqlapis.links.1': 'Consultas GraphQL de ejemplo',
    'technical_docs.apis.section.relatedhttpapis': 'API HTTP relacionadas',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'API HTTP de AEM Assets',
    'technical_docs.apis.text':
      'Obtenga informaci\xF3n acerca de las API de GraphQL de AEM y sobre c\xF3mo crear consultas y solicitudes HTTP.',
    'technical_docs.apis.title': 'API',
    'technical_docs.documentation.section.contentfragments': 'Fragmentos de contenido',
    'technical_docs.documentation.section.contentfragments.links.0': 'Activaci\xF3n de fragmentos de contenido',
    'technical_docs.documentation.section.contentfragments.links.1': 'Modelos de fragmento de contenido',
    'technical_docs.documentation.section.contentfragments.links.2': 'Administrar fragmentos de contenido',
    'technical_docs.documentation.section.contentfragments.links.3': 'Variaciones',
    'technical_docs.documentation.section.contentfragments.links.4': 'Contenido asociado',
    'technical_docs.documentation.section.contentfragments.links.5': 'Metadatos',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': '\xC1rbol de estructura',
    'technical_docs.documentation.section.contentfragments.links.8': 'Vista previa de JSON',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Formularios adaptables descentralizados',
    'technical_docs.documentation.section.graphqlaemendpoint': 'Punto final GraphQL de AEM',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': 'Activaci\xF3n de un punto final GraphQL',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': 'Publicaci\xF3n de un punto final GraphQL',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': 'Consultas persistentes',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': 'Publicar consultas persistentes',
    'technical_docs.documentation.text':
      'Consulte la documentaci\xF3n de Adobe Experience Manager as a Cloud Service para obtener una descripci\xF3n completa de las prestaciones y configuraciones de AEM.',
    'technical_docs.documentation.title': 'Documentaci\xF3n adicional',
    'technical_docs.how-to.section.content': 'Contenido',
    'technical_docs.how-to.section.content.links.0': 'Texto enriquecido',
    'technical_docs.how-to.section.content.links.1': 'Im\xE1genes',
    'technical_docs.how-to.section.content.links.2': 'Contenido localizado',
    'technical_docs.how-to.section.content.links.3': 'Conjuntos grandes de resultados',
    'technical_docs.how-to.section.content.links.4': 'Previsualizar',
    'technical_docs.how-to.section.deployment': 'Implementaci\xF3n',
    'technical_docs.how-to.section.deployment.links.0': 'Aplicaci\xF3n de p\xE1gina \xFAnica',
    'technical_docs.how-to.section.deployment.links.1': 'Componente web',
    'technical_docs.how-to.section.deployment.links.2': 'M\xF3vil',
    'technical_docs.how-to.section.deployment.links.3': 'Servidor a servidor',
    'technical_docs.how-to.section.development': 'Desarrollo',
    'technical_docs.how-to.section.development.links.0': 'SDK de AEM Headless',
    'technical_docs.how-to.section.development.links.1': 'Instalar GraphiQL IDE en AEM 6.5',
    'technical_docs.how-to.text': 'C\xF3mo enfocar diferentes casos de uso con AEM Headless.',
    'technical_docs.how-to.title': 'Gu\xEDas paso a paso',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0': 'JS SDK del lado del cliente',
    'technical_docs.sdks.section.javascript.links.1': 'JS SDK del lado del servidor',
    'technical_docs.sdks.section.javascript.links.2': 'M\xF3dulo jwt-auth npm',
    'technical_docs.sdks.text': 'Utilice el SDK de AEM Headless para interactuar con las API de AEM Headless.',
    'technical_docs.sdks.title': 'SDK',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'IDE de GraphiQL',
    'technical_docs.tools.section.graphiql.links.1': 'Gu\xEDa de instalaci\xF3n de GraphiQL en AEM\xA06.5',
    'technical_docs.tools.text': 'Explore las herramientas de desarrollo para entornos headless de AEM.',
    'technical_docs.tools.title': 'Herramientas',
    'what_is_headless.text':
      'El CMS sin encabezado de AEM ofrece a los desarrolladores la libertad de hacer lo que se les d\xE9 mejor: crear m\xE1s r\xE1pido y ofrecer experiencias excepcionales con los idiomas, los marcos de trabajo y las herramientas con las que ya est\xE1n familiarizados.',
    'what_is_headless.title': '\xBFQu\xE9 es un CMS sin encabezado de AEM?',
  },
  $E = {
    'app.hero.cta': 'D\xE9couvrir son fonctionnement',
    'app.hero.solution': 'Adobe\xA0Experience\xA0Manager d\xE9coupl\xE9',
    'app.hero.text':
      'Tout ce que vous devez savoir sur le syst\xE8me de gestion de contenu d\u2019AEM Headless pour cr\xE9er et offrir de meilleures applications et des exp\xE9riences plus rapides.',
    'app.hero.title': 'Commencez \xE0 cr\xE9er avec le CMS AEM d\xE9coupl\xE9',
    'code_by_id.button.back': 'Revenir \xE0 l\u2019aire de codage',
    'code_by_id.button.enter_widescreen': 'Passer en mode Grand \xE9cran',
    'code_by_id.button.exit_widescreen': 'Quitter le mode Grand \xE9cran',
    'code_index.button.run_the_code': 'Ex\xE9cuter le code',
    'code_index.text':
      '\xC9valuez les performances du CMS AEM d\xE9coupl\xE9 en quelques secondes \xE0 l\u2019aide des exemples d\u2019applications JavaScript\xA0!',
    'code_index.title': 'Aire de codage',
    'community.links.0': 'Rejoindre la discussion',
    'community.text':
      "Discutez, posez des questions et obtenez des r\xE9ponses \xE0 propos d'AEM\xA0Headless aupr\xE8s de toute la communaut\xE9 de d\xE9veloppeurs AEM dans les Communaut\xE9s Experience League.",
    'community.title': 'Rejoindre la discussion',
    'error.text': 'Une erreur s\u2019est produite. R\xE9essayez ult\xE9rieurement.',
    'error.title': 'Une erreur s\u2019est produite.',
    'example_apps_android.links.0': "Afficher l'application",
    'example_apps_android.text':
      "Un exemple d'application Android Java qui utilise du contenu des API AEM\xA0Headless.",
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': "Afficher l'application",
    'example_apps_ios.text': "Un exemple d'application iOS\xA0SwiftUI qui utilise du contenu des API AEM\xA0Headless.",
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'Afficher l\u2019application',
    'example_apps_next_js.text':
      'Un exemple d\u2019application Next.js qui utilise du contenu des API AEM\xA0Headless.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'Afficher l\u2019application',
    'example_apps_node-js.text':
      'Exemple d\u2019application de ligne de commande Node.js qui utilise du contenu provenant des API AEM\xA0Headless.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': "Afficher l'application",
    'example_apps_react.text': "Un exemple d'application React qui utilise du contenu des API AEM\xA0Headless.",
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'Afficher l\u2019application',
    'example_apps_web-component.text':
      'Un exemple de composant Web JavaScript pur qui utilise du contenu provenant des API d\xE9coupl\xE9es AEM.',
    'example_apps_web-component.title': 'Composants et JS Web',
    'experienced_developers.text1':
      'Suivez { fiveSteps} pour cr\xE9er, g\xE9rer et diffuser des exp\xE9riences \xE0 l\u2019aide d\u2019AEM. { break } Vous avez d\xE9j\xE0 termin\xE9\xA0? Acc\xE9dez \xE0 notre { advancedDocumentation }.',
    'experienced_developers.title': 'POUR LES D\xC9VELOPPEURS { emphasis } DU CMS AEM D\xC9COUPL\xC9',
    'experienced_developers.title.emphasis': 'EXP\xC9RIMENT\xC9S',
    'get_involved_blog.links.0': 'Lire le blog',
    'get_involved_blog.text': 'Lisez les derni\xE8res informations sur notre blog technologique.',
    'get_involved_blog.title': 'Adobe Tech Blog',
    'get_involved_community.links.0': 'Rejoindre la conversation',
    'get_involved_community.text': 'Rejoignez notre communaut\xE9 et obtenez des r\xE9ponses \xE0 vos questions.',
    'get_involved_community.title': 'Communaut\xE9s Experience\xA0League',
    'nav.codePlayground': 'Aire de codage',
    'nav.home': 'Accueil',
    'nav.title': 'Portail de d\xE9veloppement du CMS AEM d\xE9coupl\xE9',
    'new_developers.text':
      'Lisez ce guide { guideLink } pour d\xE9couvrir les fonctionnalit\xE9s du syst\xE8me de gestion de contenu headless d\u2019AEM et comment les utiliser dans un projet de d\xE9veloppement headless.',
    'new_developers.text.5_steps': '5\xA0\xE9tapes',
    'new_developers.text.advanced_documentation': 'Documentation avanc\xE9e',
    'new_developers.text.guide_link': 'guide',
    'new_developers.title': 'POUR LES { emphasis } D\xC9VELOPPEURS DU CMS AEM D\xC9COUPL\xC9',
    'new_developers.title.emphasis': 'NOUVEAU',
    'new_to_aem_headless.links.0': 'Lire le guide',
    'page.description':
      'Consultez la documentation et les ressources pour les d\xE9veloppeurs du CMS AEM d\xE9coupl\xE9. D\xE9couvrez comment cr\xE9er des applications de nouvelle g\xE9n\xE9ration en utilisant les technologies du CMS d\xE9coupl\xE9 dans Experience Manager as a Cloud Service.',
    'page.title':
      'Documentation et ressources pour le d\xE9veloppement du CMS AEM d\xE9coupl\xE9\xA0| Adobe\xA0Experience\xA0Manager',
    'quick_setup.links.0': 'Installation rapide pour Cloud\xA0Service',
    'quick_setup.links.1': 'Installation rapide pour un SDK AEM local',
    'quick_setup.text':
      "Configurez et testez AEM\xA0Headless en quelques minutes \xE0 l'aide d'un exemple d'appli React.",
    'quick_setup.title': 'Configuration rapide',
    'section_developer_resources.title': 'Documentation avanc\xE9e',
    'section_example_apps.title': 'Exemples d\u2019applications de CMS AEM d\xE9coupl\xE9',
    'section_get_involved.title': 'Participez\xA0!',
    'section_spa_editor.text':
      "L'\xC9diteur de SPA AEM fournit un cadre pour d\xE9velopper des applications React ou Angular pouvant \xEAtre mises \xE0 jour en contexte par les sp\xE9cialistes du marketing gr\xE2ce \xE0 l'interface utilisateur de cr\xE9ation AEM.",
    'section_spa_editor.title': 'Explorer l\u2019\xC9diteur de SPA AEM',
    'spa_editor.links.0': 'D\xE9marrer le tutoriel React',
    'spa_editor.text':
      'L\u2019\xC9diteur de SPA AEM peut \xEAtre utilis\xE9 pour cr\xE9er un SPA dont les composants, le routage et l\u2019affichage sont enti\xE8rement g\xE9r\xE9s dans AEM. L\u2019\xC9diteur de SPA AEM prend en charge le framework React.',
    'spa_editor.title': 'G\xE9rer un SPA dans AEM',
    'spa_editor_remote_spa.links.0': 'D\xE9marrer le tutoriel',
    'spa_editor_remote_spa.text':
      'Les capacit\xE9s de SPA \xE0 distance d\u2019AEM donnent aux sp\xE9cialistes du marketing la possibilit\xE9 de mettre \xE0 jour des r\xE9gions cibl\xE9es d\u2019un SPA h\xE9berg\xE9 \xE0 distance. ',
    'spa_editor_remote_spa.title': 'Cr\xE9er un SPA distant',
    'technical_docs.apis.section.formsapis': 'API HTTP AEM\xA0Forms',
    'technical_docs.apis.section.formsapis.links.0': 'API AEM\xA0Forms (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'Les API GraphQL',
    'technical_docs.apis.section.graphqlapis.links.0': 'API GraphQL',
    'technical_docs.apis.section.graphqlapis.links.1': 'Exemples de requ\xEAtes GraphQL',
    'technical_docs.apis.section.relatedhttpapis': 'API HTTP connexes',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'API HTTP AEM Assets',
    'technical_docs.apis.text':
      "D\xE9couvrez les API GraphQL d'AEM et comment construire des requ\xEAtes en g\xE9n\xE9ral, et des requ\xEAtes HTTP en particulier.",
    'technical_docs.apis.title': 'API',
    'technical_docs.documentation.section.contentfragments': 'Fragments de contenu',
    'technical_docs.documentation.section.contentfragments.links.0': 'Activation des fragments de contenu',
    'technical_docs.documentation.section.contentfragments.links.1': 'Mod\xE8les de fragment de contenu',
    'technical_docs.documentation.section.contentfragments.links.2': 'Gestion des fragments de contenu',
    'technical_docs.documentation.section.contentfragments.links.3': 'Variations',
    'technical_docs.documentation.section.contentfragments.links.4': 'Contenu associ\xE9',
    'technical_docs.documentation.section.contentfragments.links.5': 'M\xE9tadonn\xE9es',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': 'Arborescence de la structure',
    'technical_docs.documentation.section.contentfragments.links.8': 'Pr\xE9visualisation JSON',
    'technical_docs.documentation.section.forms': 'AEM\xA0Forms',
    'technical_docs.documentation.section.forms.links.0': 'Formulaires adaptatifs headless',
    'technical_docs.documentation.section.graphqlaemendpoint': 'Point d\u2019entr\xE9e AEM de GraphQL ',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': "Activation d'un point d\u2019entr\xE9e GraphQL",
    'technical_docs.documentation.section.graphqlaemendpoint.links.1':
      "Publication d'un point d\u2019entr\xE9e GraphQL",
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': 'Requ\xEAtes persistantes',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': 'Publier des requ\xEAtes persistantes',
    'technical_docs.documentation.text':
      "Consultez la documentation d'Adobe\xA0Experience\xA0Manager as a Cloud\xA0Service pour obtenir une description compl\xE8te des fonctionnalit\xE9s et configurations d'AEM.",
    'technical_docs.documentation.title': 'Documentation suppl\xE9mentaire',
    'technical_docs.how-to.section.content': 'Contenu',
    'technical_docs.how-to.section.content.links.0': 'Texte enrichi',
    'technical_docs.how-to.section.content.links.1': 'Images',
    'technical_docs.how-to.section.content.links.2': 'Contenu localis\xE9',
    'technical_docs.how-to.section.content.links.3': 'Ensembles de r\xE9sultats volumineux',
    'technical_docs.how-to.section.content.links.4': 'Aper\xE7u',
    'technical_docs.how-to.section.deployment': 'D\xE9ploiement',
    'technical_docs.how-to.section.deployment.links.0': 'Application monopage',
    'technical_docs.how-to.section.deployment.links.1': 'Composant web',
    'technical_docs.how-to.section.deployment.links.2': 'Mobile',
    'technical_docs.how-to.section.deployment.links.3': 'De serveur \xE0 serveur',
    'technical_docs.how-to.section.development': 'D\xE9veloppement',
    'technical_docs.how-to.section.development.links.0': 'SDK d\xE9coupl\xE9 AEM',
    'technical_docs.how-to.section.development.links.1': 'Installer GraphiQL IDE sur AEM\xA06.5',
    'technical_docs.how-to.text':
      'D\xE9couvrez comment faire face \xE0 diff\xE9rents cas d\u2019utilisation du d\xE9couplage AEM.',
    'technical_docs.how-to.title': 'Guides pratiques',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'SDK Java',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0': 'SDK JS c\xF4t\xE9 client',
    'technical_docs.sdks.section.javascript.links.1': 'SDK JS c\xF4t\xE9 serveur',
    'technical_docs.sdks.section.javascript.links.2': 'Module npm jwt-auth',
    'technical_docs.sdks.text': 'Utilisation des SDK AEM\xA0Headless pour interagir avec les API AEM\xA0Headless.',
    'technical_docs.sdks.title': 'Kits de d\xE9veloppement logiciel (SDK)',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'Guide d\u2019installation AEM 6.5 GraphiQL',
    'technical_docs.tools.text': "D\xE9couvrir les outils de d\xE9veloppement d\xE9coupl\xE9s d'AEM",
    'technical_docs.tools.title': 'Outils',
    'what_is_headless.text':
      'Le CMS AEM d\xE9coupl\xE9 offre aux \xE9quipes de d\xE9veloppement la libert\xE9 de faire ce qu\u2019elles font de mieux, \xE0 savoir\xA0: concevoir plus rapidement des exp\xE9riences d\u2019exception, et les diffuser \xE0 l\u2019aide de langages, de frameworks et d\u2019outils familiers.',
    'what_is_headless.title': 'Qu\u2019est-ce que le CMS AEM d\xE9coupl\xE9\xA0?',
  },
  qE = {
    'app.hero.cta': 'Guarda come funziona',
    'app.hero.solution': 'Adobe Experience Manager Headless',
    'app.hero.text':
      'Tutto sul CMS di AEM Headless per creare e pubblicare applicazioni migliori ed esperienze pi\xF9 veloci.',
    'app.hero.title': 'Inizia a sviluppare con AEM Headless CMS',
    'code_by_id.button.back': 'Torna al playground per codice',
    'code_by_id.button.enter_widescreen': 'Passa alla modalit\xE0 widescreen',
    'code_by_id.button.exit_widescreen': 'Esci dalla modalit\xE0 widescreen',
    'code_index.button.run_the_code': 'Esegui il codice',
    'code_index.text': 'Prova AEM Headless CMS in pochi secondi con le app JavaScript di esempio!',
    'code_index.title': 'Playground per codice',
    'community.links.0': 'Partecipa alla discussione',
    'community.text':
      'Partecipa alla community di sviluppatori AEM in Experience League Communities: contribuisci alle discussioni, pubblica le tue domande e ricevi risposte su AEM Headless.',
    'community.title': 'Partecipa alla discussione',
    'error.text': 'Si \xE8 verificato un errore. Riprova pi\xF9 tardi.',
    'error.title': 'Si \xE8 verificato un errore.',
    'example_apps_android.links.0': 'Guarda l\u2019app',
    'example_apps_android.text':
      'Esempio di un\u2019app Java per Android che utilizza contenuti dalle API di AEM Headless.',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': 'Guarda l\u2019app',
    'example_apps_ios.text': 'Esempio di un\u2019app SwiftUI per iOS che utilizza contenuti dalle API di AEM Headless.',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'Guarda l\u2019app',
    'example_apps_next_js.text':
      'Esempio di un\u2019applicazione Next.js che utilizza contenuti dalle API di AEM Headless.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'Guarda l\u2019app',
    'example_apps_node-js.text':
      'Esempio di applicazione Node.js a riga di comando che utilizza contenuti dalle API di AEM Headless.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': 'Guarda l\u2019app',
    'example_apps_react.text':
      'Esempio di un\u2019applicazione React che utilizza contenuti dalle API di AEM Headless.',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'Guarda l\u2019app',
    'example_apps_web-component.text':
      'Esempio di componente web puramente basato su JavaScript che utilizza contenuti dalle API di AEM Headless.',
    'example_apps_web-component.title': 'Componente web/JS',
    'experienced_developers.text1':
      'Segui { fiveSteps} per creare, gestire e consegnare esperienze utilizzando AEM. { break } Lo hai gi\xE0 fatto? passa alla { advancedDocumentation }.',
    'experienced_developers.title': 'PER { emphasis } SVILUPPATORI AEM HEADLESS CMS',
    'experienced_developers.title.emphasis': 'ESPERTI',
    'get_involved_blog.links.0': 'Leggi il blog',
    'get_involved_blog.text': 'Leggi le ultime novit\xE0 sul nostro blog tecnico.',
    'get_involved_blog.title': 'Blog tecnico di Adobe',
    'get_involved_community.links.0': 'Partecipa alla conversazione',
    'get_involved_community.text': 'Partecipa alla nostra community e trova le risposte alle tue domande.',
    'get_involved_community.title': 'Community Experience League',
    'nav.codePlayground': 'Playground per codice',
    'nav.home': 'Home',
    'nav.title': 'Portale AEM Headless CMS per sviluppatori',
    'new_developers.text':
      'Leggi questa { guideLink } per scoprire le funzioni CMS headless di AEM e come sfruttarle in un progetto di sviluppo headless.',
    'new_developers.text.5_steps': '5 passaggi',
    'new_developers.text.advanced_documentation': 'documentazione avanzata',
    'new_developers.text.guide_link': 'guida',
    'new_developers.title': 'PER SVILUPPATORI { emphasis } IN AEM HEADLESS CMS',
    'new_developers.title.emphasis': 'NUOVO',
    'new_to_aem_headless.links.0': 'Leggi la guida',
    'page.description':
      'Visita le risorse e la documentazione di AEM Headless CMS per sviluppatori. Scopri come creare app di nuova generazione con le tecnologie CMS in Experience Manager as a Cloud Service.',
    'page.title': 'Risorse e documentazione per sviluppatori di AEM Headless CMS | Adobe Experience Manager',
    'quick_setup.links.0': 'Impostazione rapida per Cloud Service',
    'quick_setup.links.1': 'Impostazione rapida per AEM SDK locale',
    'quick_setup.text': 'Imposta e prova AEM Headless in pochi minuti con un\u2019app React di esempio.',
    'quick_setup.title': 'Impostazione rapida',
    'section_developer_resources.title': 'Documentazione avanzata',
    'section_example_apps.title': 'Esempi di app AEM Headless CMS',
    'section_get_involved.title': 'Partecipa anche tu!',
    'section_spa_editor.text':
      'L\u2019editor per applicazioni a pagina singola (SPA) di AEM fornisce un pratico framework per lo sviluppo di app React o Angular che possono essere aggiornate direttamente nel loro contesto dagli esperti marketing utilizzando l\u2019interfaccia di authoring di AEM.',
    'section_spa_editor.title': 'Scopri l\u2019editor SPA di AEM',
    'spa_editor.links.0': 'Avvia il tutorial React',
    'spa_editor.text':
      'Con l\u2019editor per applicazioni a pagina singola (SPA) di AEM puoi creare una SPA con componenti, indirizzamenti e viste che potrai gestire interamente in AEM. L\u2019editor SPA supporta il framework React.',
    'spa_editor.title': 'Gestisci una SPA in AEM',
    'spa_editor_remote_spa.links.0': 'Avvia il tutorial',
    'spa_editor_remote_spa.text':
      'Le funzionalit\xE0 di AEM per applicazioni a pagina singola (SPA) remote consentono agli esperti di marketing di aggiornare specifiche aree di una SPA gestita in remoto.',
    'spa_editor_remote_spa.title': 'Crea una SPA remota',
    'technical_docs.apis.section.formsapis': 'API HTTP di AEM Forms',
    'technical_docs.apis.section.formsapis.links.0': 'API di AEM Forms (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'API di GraphQL',
    'technical_docs.apis.section.graphqlapis.links.0': 'API GraphQL',
    'technical_docs.apis.section.graphqlapis.links.1': 'Query GraphQL di esempio',
    'technical_docs.apis.section.relatedhttpapis': 'API HTTP correlate',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'API HTTP per AEM Assets',
    'technical_docs.apis.text': 'Scopri le API GraphQL di AEM e come creare query e richieste HTTP.',
    'technical_docs.apis.title': 'API',
    'technical_docs.documentation.section.contentfragments': 'Frammenti di contenuto',
    'technical_docs.documentation.section.contentfragments.links.0': 'Abilitazione dei frammenti di contenuto',
    'technical_docs.documentation.section.contentfragments.links.1': 'Modelli per frammenti di contenuto',
    'technical_docs.documentation.section.contentfragments.links.2': 'Gestione dei frammenti di contenuto',
    'technical_docs.documentation.section.contentfragments.links.3': 'Varianti',
    'technical_docs.documentation.section.contentfragments.links.4': 'Contenuti associati',
    'technical_docs.documentation.section.contentfragments.links.5': 'Metadati',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': 'Struttura ad albero',
    'technical_docs.documentation.section.contentfragments.links.8': 'Anteprima JSON',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Moduli adattivi headless',
    'technical_docs.documentation.section.graphqlaemendpoint': 'Endpoint GraphQL in AEM',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': 'Abilitazione di un endpoint GraphQL',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': 'Pubblicazione di un endpoint GraphQL',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': 'Query persistenti',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': 'Pubblicare query persistenti',
    'technical_docs.documentation.text':
      'Consulta la documentazione di Adobe Experience Manager as a Cloud Service per una descrizione completa delle funzionalit\xE0 e delle configurazioni di AEM.',
    'technical_docs.documentation.title': 'Documentazione aggiuntiva',
    'technical_docs.how-to.section.content': 'Contenuto',
    'technical_docs.how-to.section.content.links.0': 'Testo formattato',
    'technical_docs.how-to.section.content.links.1': 'Immagini',
    'technical_docs.how-to.section.content.links.2': 'Contenuti localizzati',
    'technical_docs.how-to.section.content.links.3': 'Grandi set di risultati',
    'technical_docs.how-to.section.content.links.4': 'Anteprima',
    'technical_docs.how-to.section.deployment': 'Implementazione',
    'technical_docs.how-to.section.deployment.links.0': 'App a pagina singola',
    'technical_docs.how-to.section.deployment.links.1': 'Componente web',
    'technical_docs.how-to.section.deployment.links.2': 'Mobile',
    'technical_docs.how-to.section.deployment.links.3': 'Server-to-server',
    'technical_docs.how-to.section.development': 'Sviluppo',
    'technical_docs.how-to.section.development.links.0': 'SDK di AEM Headless',
    'technical_docs.how-to.section.development.links.1': 'Installa GraphiQL IDE in AEM 6.5',
    'technical_docs.how-to.text': 'Scopri come affrontare diversi casi d\u2019uso con AEM Headless.',
    'technical_docs.how-to.title': 'Guide pratiche',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'SDK Java',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0': 'SDK JS lato client',
    'technical_docs.sdks.section.javascript.links.1': 'SDK JS lato server',
    'technical_docs.sdks.section.javascript.links.2': 'Modulo npm jwt-auth',
    'technical_docs.sdks.text': 'Utilizza gli SDK di AEM Headless per interagire con le API di AEM Headless.',
    'technical_docs.sdks.title': 'SDK',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'IDE GraphiQL',
    'technical_docs.tools.section.graphiql.links.1': 'Guida all\u2019installazione di AEM 6.5 GraphiQL',
    'technical_docs.tools.text': 'Scopri gli strumenti di sviluppo headless di AEM.',
    'technical_docs.tools.title': 'Strumenti',
    'what_is_headless.text':
      'AEM Headless CMS offre agli sviluppatori la libert\xE0 di fare ci\xF2 che sanno fare meglio: sviluppare pi\xF9 rapidamente e fornire esperienze eccezionali utilizzando i linguaggi, i framework e gli strumenti che conoscono gi\xE0.',
    'what_is_headless.title': 'Cos\u2019\xE8 AEM Headless CMS?',
  },
  VE = {
    'app.hero.cta': '\u4ED5\u7D44\u307F\u3092\u898B\u308B',
    'app.hero.solution': 'Adobe Experience Manager \u30D8\u30C3\u30C9\u30EC\u30B9',
    'app.hero.text':
      'AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u306B\u3064\u3044\u3066\u3001\u3088\u308A\u512A\u308C\u305F\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3067\u3088\u308A\u9AD8\u901F\u306A\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u69CB\u7BC9\u3057\u3066\u63D0\u4F9B\u3059\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u3053\u3068\u3092\u3059\u3079\u3066\u5B66\u3073\u307E\u3059\u3002',
    'app.hero.title': 'AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u3067\u69CB\u7BC9\u3092\u958B\u59CB',
    'code_by_id.button.back': '\u30B3\u30FC\u30C9\u30D7\u30EC\u30FC\u30B0\u30E9\u30A6\u30F3\u30C9\u306B\u623B\u308B',
    'code_by_id.button.enter_widescreen':
      '\u30EF\u30A4\u30C9\u30B9\u30AF\u30EA\u30FC\u30F3\u30E2\u30FC\u30C9\u306B\u30A8\u30F3\u30C8\u30EA',
    'code_by_id.button.exit_widescreen':
      '\u30EF\u30A4\u30C9\u30B9\u30AF\u30EA\u30FC\u30F3\u30E2\u30FC\u30C9\u3092\u7D42\u4E86',
    'code_index.button.run_the_code': '\u30B3\u30FC\u30C9\u3092\u5B9F\u884C',
    'code_index.text':
      'JavaScript \u30A2\u30D7\u30EA\u306E\u30B5\u30F3\u30D7\u30EB\u3092\u4F7F\u7528\u3057\u3066\u3001AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u3092\u6570\u79D2\u3067\u30C6\u30B9\u30C8\u30C9\u30E9\u30A4\u30D6',
    'code_index.title': '\u30B3\u30FC\u30C9\u30D7\u30EC\u30FC\u30B0\u30E9\u30A6\u30F3\u30C9',
    'community.links.0': '\u30C7\u30A3\u30B9\u30AB\u30C3\u30B7\u30E7\u30F3\u306B\u53C2\u52A0',
    'community.text':
      'Experience League \u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306E\u3059\u3079\u3066\u306E AEM \u958B\u767A\u8005\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u3067\u3001AEM Headless \u306B\u3064\u3044\u3066\u8A71\u3057\u5408\u3063\u305F\u308A\u3001\u8CEA\u554F\u3057\u305F\u308A\u3001\u56DE\u7B54\u3092\u5F97\u305F\u308A\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002',
    'community.title': '\u30C7\u30A3\u30B9\u30AB\u30C3\u30B7\u30E7\u30F3\u306B\u53C2\u52A0',
    'error.text':
      '\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u5F8C\u3067\u3082\u3046\u4E00\u5EA6\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
    'error.title': '\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002',
    'example_apps_android.links.0': '\u30A2\u30D7\u30EA\u3092\u8868\u793A',
    'example_apps_android.text':
      'AEM Headless API \u304B\u3089\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F7F\u7528\u3059\u308B Java Android \u30A2\u30D7\u30EA\u306E\u4F8B\u3002',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': '\u30A2\u30D7\u30EA\u3092\u8868\u793A',
    'example_apps_ios.text':
      'AEM Headless API \u304B\u3089\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F7F\u7528\u3059\u308B SwiftUI iOS \u30A2\u30D7\u30EA\u306E\u4F8B\u3002',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': '\u30A2\u30D7\u30EA\u3092\u8868\u793A',
    'example_apps_next_js.text':
      'AEM Headless API \u304B\u3089\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F7F\u7528\u3059\u308B Next.js \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u4F8B\u3002',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': '\u30A2\u30D7\u30EA\u3092\u8868\u793A',
    'example_apps_node-js.text':
      'AEM Headless API \u304B\u3089\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F7F\u7528\u3059\u308B\u30B3\u30DE\u30F3\u30C9\u30E9\u30A4\u30F3 Node.js \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u4F8B\u3002',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': '\u30A2\u30D7\u30EA\u3092\u8868\u793A',
    'example_apps_react.text':
      'AEM Headless API \u304B\u3089\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F7F\u7528\u3059\u308B React \u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u4F8B\u3002',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': '\u30A2\u30D7\u30EA\u3092\u8868\u793A',
    'example_apps_web-component.text':
      'AEM Headless API \u304B\u3089\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u4F7F\u7528\u3059\u308B\u7D14\u7C8B\u306A JavaScript Web \u30B3\u30F3\u30DD\u30FC\u30CD\u30F3\u30C8\u306E\u4F8B\u3002',
    'example_apps_web-component.title': 'Web \u30B3\u30F3\u30DD\u30FC\u30CD\u30F3\u30C8/JS',
    'experienced_developers.text1':
      'AEM \u3092\u4F7F\u7528\u3057\u3066\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u4F5C\u6210\u3001\u7BA1\u7406\u3001\u914D\u4FE1\u3059\u308B\u305F\u3081\u306E { fiveSteps} \u3092\u5B9F\u884C\u3057\u307E\u3059\u3002 { break } \u3059\u3067\u306B\u5B8C\u4E86\u3057\u3066\u3044\u307E\u3059\u304B\u3002 { advancedDocumentation } \u306B\u79FB\u52D5\u3057\u307E\u3059\u3002',
    'experienced_developers.title':
      '{ emphasis } AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u958B\u767A\u8005\u5411\u3051',
    'experienced_developers.title.emphasis': '\u4F53\u9A13\u6E08',
    'get_involved_blog.links.0': '\u30D6\u30ED\u30B0\u3092\u8AAD\u3080',
    'get_involved_blog.text':
      '\u6280\u8853\u30D6\u30ED\u30B0\u3067\u6700\u65B0\u60C5\u5831\u3092\u304A\u8AAD\u307F\u304F\u3060\u3055\u3044\u3002',
    'get_involved_blog.title': '\u30A2\u30C9\u30D3\u306E\u6280\u8853\u30D6\u30ED\u30B0',
    'get_involved_community.links.0': '\u4F1A\u8A71\u306B\u53C2\u52A0\u3059\u308B',
    'get_involved_community.text':
      '\u79C1\u305F\u3061\u306E\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306B\u53C2\u52A0\u3057\u3066\u3001\u3054\u4E0D\u660E\u306A\u70B9\u3092\u89E3\u6C7A\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
    'get_involved_community.title': 'Experience League \u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u30FC',
    'nav.codePlayground': '\u30B3\u30FC\u30C9\u30D7\u30EC\u30FC\u30B0\u30E9\u30A6\u30F3\u30C9',
    'nav.home': '\u30DB\u30FC\u30E0',
    'nav.title': 'AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u958B\u767A\u8005\u30DD\u30FC\u30BF\u30EB',
    'new_developers.text':
      '\u3053\u306E { guideLink } \u3092\u8AAD\u3093\u3067\u3001AEM \u306E\u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u6A5F\u80FD\u3068\u3001\u30D8\u30C3\u30C9\u30EC\u30B9\u958B\u767A\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3067\u6D3B\u7528\u3059\u308B\u65B9\u6CD5\u306B\u3064\u3044\u3066\u5B66\u3073\u307E\u3059\u3002',
    'new_developers.text.5_steps': '5 \u3064\u306E\u30B9\u30C6\u30C3\u30D7',
    'new_developers.text.advanced_documentation': '\u8A73\u7D30\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8',
    'new_developers.text.guide_link': '\u30AC\u30A4\u30C9',
    'new_developers.title':
      '\u958B\u767A\u8005\u5411\u3051 { emphasis } AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u306B\u79FB\u52D5',
    'new_developers.title.emphasis': '\u65B0\u898F',
    'new_to_aem_headless.links.0': '\u30AC\u30A4\u30C9\u3092\u8AAD\u3080',
    'page.description':
      'AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u958B\u767A\u8005\u5411\u3051\u30EA\u30BD\u30FC\u30B9\u304A\u3088\u3073\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002Experience Manager as a Cloud Service \u306E\u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u30C6\u30AF\u30CE\u30ED\u30B8\u30FC\u3092\u4F7F\u7528\u3057\u3066\u3001\u6B21\u4E16\u4EE3\u306E\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u69CB\u7BC9\u3059\u308B\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3057\u3087\u3046\u3002',
    'page.title':
      'AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u958B\u767A\u8005\u5411\u3051\u30EA\u30BD\u30FC\u30B9\u3068\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8 | Adobe Experience Manager',
    'quick_setup.links.0': 'Cloud Service \u306E\u30AF\u30A4\u30C3\u30AF\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7',
    'quick_setup.links.1':
      '\u30ED\u30FC\u30AB\u30EB AEM SDK \u306E\u30AF\u30A4\u30C3\u30AF\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7',
    'quick_setup.text':
      'React \u30A2\u30D7\u30EA\u306E\u30B5\u30F3\u30D7\u30EB\u3092\u4F7F\u7528\u3057\u3066\u3001\u6570\u5206\u3067 AEM Headless \u3092\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u304A\u3088\u3073\u30C6\u30B9\u30C8\u3057\u307E\u3059\u3002',
    'quick_setup.title': '\u30AF\u30A4\u30C3\u30AF\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7',
    'section_developer_resources.title': '\u8A73\u7D30\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8',
    'section_example_apps.title': 'AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u30A2\u30D7\u30EA\u306E\u4F8B',
    'section_get_involved.title': '\u53C2\u52A0\u3057\u307E\u3057\u3087\u3046\u3002',
    'section_spa_editor.text':
      'AEM SPA \u30A8\u30C7\u30A3\u30BF\u30FC\u306F\u3001React \u30A2\u30D7\u30EA\u307E\u305F\u306F Angular \u30A2\u30D7\u30EA\u3092\u958B\u767A\u3059\u308B\u305F\u3081\u306E\u30D5\u30EC\u30FC\u30E0\u30EF\u30FC\u30AF\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002\u30DE\u30FC\u30B1\u30BF\u30FC\u306F\u3001\u305D\u308C\u3089\u306E\u30A2\u30D7\u30EA\u3092\u3001AEM \u30AA\u30FC\u30B5\u30EA\u30F3\u30B0 UI \u3092\u4F7F\u7528\u3057\u3066\u30B3\u30F3\u30C6\u30AD\u30B9\u30C8\u5185\u3067\u66F4\u65B0\u3067\u304D\u307E\u3059\u3002',
    'section_spa_editor.title': 'AEM SPA \u30A8\u30C7\u30A3\u30BF\u30FC\u306E\u5B66\u7FD2',
    'spa_editor.links.0': 'React \u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB\u3092\u958B\u59CB',
    'spa_editor.text':
      'AEM SPA \u30A8\u30C7\u30A3\u30BF\u30FC\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001AEM \u3067\u30B3\u30F3\u30DD\u30FC\u30CD\u30F3\u30C8\u3001\u30EB\u30FC\u30C6\u30A3\u30F3\u30B0\u3001\u8868\u793A\u3092\u5B8C\u5168\u306B\u5236\u5FA1\u3067\u304D\u308B SPA \u3092\u4F5C\u6210\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002SPA \u30A8\u30C7\u30A3\u30BF\u30FC\u306F\u3001React \u306E\u30D5\u30EC\u30FC\u30E0\u30EF\u30FC\u30AF\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002',
    'spa_editor.title': 'AEM \u3067 SPA \u3092\u7BA1\u7406',
    'spa_editor_remote_spa.links.0': '\u30C1\u30E5\u30FC\u30C8\u30EA\u30A2\u30EB\u3092\u958B\u59CB',
    'spa_editor_remote_spa.text':
      'AEM \u306E\u30EA\u30E2\u30FC\u30C8 SPA \u6A5F\u80FD\u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u30DE\u30FC\u30B1\u30BF\u30FC\u306F\u3001\u30EA\u30E2\u30FC\u30C8\u3067\u30DB\u30B9\u30C8\u3055\u308C\u305F SPA \u306E\u5BFE\u8C61\u9818\u57DF\u3092\u66F4\u65B0\u3067\u304D\u307E\u3059\u3002',
    'spa_editor_remote_spa.title': '\u30EA\u30E2\u30FC\u30C8 SPA \u3092\u30AA\u30FC\u30B5\u30EA\u30F3\u30B0',
    'technical_docs.apis.section.formsapis': 'AEM Forms HTTP API',
    'technical_docs.apis.section.formsapis.links.0': 'AEM Forms API\uFF08OpenAPI\uFF09',
    'technical_docs.apis.section.graphqlapis': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.1': '\u30B5\u30F3\u30D7\u30EB GraphQL \u30AF\u30A8\u30EA',
    'technical_docs.apis.section.relatedhttpapis': '\u95A2\u9023\u3059\u308B HTTP API',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM Assets HTTP API',
    'technical_docs.apis.text':
      'AEM \u306E GraphQL API \u3068\u3001\u30AF\u30A8\u30EA\u304A\u3088\u3073 HTTP \u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u69CB\u6210\u65B9\u6CD5\u306B\u3064\u3044\u3066\u5B66\u7FD2\u3057\u307E\u3059\u3002',
    'technical_docs.apis.title': 'API',
    'technical_docs.documentation.section.contentfragments':
      '\u30B3\u30F3\u30C6\u30F3\u30C4\u30D5\u30E9\u30B0\u30E1\u30F3\u30C8',
    'technical_docs.documentation.section.contentfragments.links.0':
      '\u30B3\u30F3\u30C6\u30F3\u30C4\u30D5\u30E9\u30B0\u30E1\u30F3\u30C8\u306E\u6709\u52B9\u5316',
    'technical_docs.documentation.section.contentfragments.links.1':
      '\u30B3\u30F3\u30C6\u30F3\u30C4\u30D5\u30E9\u30B0\u30E1\u30F3\u30C8\u30E2\u30C7\u30EB',
    'technical_docs.documentation.section.contentfragments.links.2':
      '\u30B3\u30F3\u30C6\u30F3\u30C4\u30D5\u30E9\u30B0\u30E1\u30F3\u30C8\u306E\u7BA1\u7406',
    'technical_docs.documentation.section.contentfragments.links.3': '\u30D0\u30EA\u30A8\u30FC\u30B7\u30E7\u30F3',
    'technical_docs.documentation.section.contentfragments.links.4': '\u95A2\u9023\u30B3\u30F3\u30C6\u30F3\u30C4',
    'technical_docs.documentation.section.contentfragments.links.5': '\u30E1\u30BF\u30C7\u30FC\u30BF',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': '\u69CB\u9020\u30C4\u30EA\u30FC',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON \u30D7\u30EC\u30D3\u30E5\u30FC',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0':
      '\u30D8\u30C3\u30C9\u30EC\u30B9\u30A2\u30C0\u30D7\u30C6\u30A3\u30D6\u30D5\u30A9\u30FC\u30E0',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL AEM \u30A8\u30F3\u30C9\u30DD\u30A4\u30F3\u30C8',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0':
      'GraphQL \u30A8\u30F3\u30C9\u30DD\u30A4\u30F3\u30C8\u306E\u6709\u52B9\u5316',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1':
      'GraphQL \u30A8\u30F3\u30C9\u30DD\u30A4\u30F3\u30C8\u306E\u516C\u958B',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': '\u6C38\u7D9A\u30AF\u30A8\u30EA',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3':
      '\u6C38\u7D9A\u30AF\u30A8\u30EA\u3092\u516C\u958B',
    'technical_docs.documentation.text':
      'AEM \u306E\u6A5F\u80FD\u304A\u3088\u3073\u8A2D\u5B9A\u306B\u3064\u3044\u3066\u8A73\u3057\u304F\u306F\u3001Adobe Experience Manager as a Cloud Service \u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u53C2\u7167\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
    'technical_docs.documentation.title': '\u8FFD\u52A0\u306E\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8',
    'technical_docs.how-to.section.content': '\u30B3\u30F3\u30C6\u30F3\u30C4',
    'technical_docs.how-to.section.content.links.0': '\u30EA\u30C3\u30C1\u30C6\u30AD\u30B9\u30C8',
    'technical_docs.how-to.section.content.links.1': '\u753B\u50CF',
    'technical_docs.how-to.section.content.links.2':
      '\u30ED\u30FC\u30AB\u30E9\u30A4\u30BA\u3055\u308C\u305F\u30B3\u30F3\u30C6\u30F3\u30C4',
    'technical_docs.how-to.section.content.links.3': '\u5927\u304D\u306A\u7D50\u679C\u30BB\u30C3\u30C8',
    'technical_docs.how-to.section.content.links.4': '\u30D7\u30EC\u30D3\u30E5\u30FC',
    'technical_docs.how-to.section.deployment': '\u30C7\u30D7\u30ED\u30A4\u30E1\u30F3\u30C8',
    'technical_docs.how-to.section.deployment.links.0':
      '\u5358\u4E00\u30DA\u30FC\u30B8\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3',
    'technical_docs.how-to.section.deployment.links.1': 'Web \u30B3\u30F3\u30DD\u30FC\u30CD\u30F3\u30C8',
    'technical_docs.how-to.section.deployment.links.2': '\u30E2\u30D0\u30A4\u30EB',
    'technical_docs.how-to.section.deployment.links.3': '\u30B5\u30FC\u30D0\u30FC\u30C4\u30FC\u30B5\u30FC\u30D0\u30FC',
    'technical_docs.how-to.section.development': '\u958B\u767A',
    'technical_docs.how-to.section.development.links.0': 'AEM \u30D8\u30C3\u30C9\u30EC\u30B9 SDK',
    'technical_docs.how-to.section.development.links.1':
      'AEM 6.5 \u306B GraphiQL IDE \u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB',
    'technical_docs.how-to.text':
      'AEM Headless \u3092\u4F7F\u7528\u3057\u305F\u7570\u306A\u308B\u30E6\u30FC\u30B9\u30B1\u30FC\u30B9\u306E\u30A2\u30D7\u30ED\u30FC\u30C1\u306E\u65B9\u6CD5\u3092\u5B66\u3073\u307E\u3059\u3002',
    'technical_docs.how-to.title': '\u30CF\u30A6\u30C4\u30FC\u30AC\u30A4\u30C9',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0': '\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8\u30B5\u30A4\u30C9 JS SDK',
    'technical_docs.sdks.section.javascript.links.1': '\u30B5\u30FC\u30D0\u30FC\u30B5\u30A4\u30C9 JS SDK',
    'technical_docs.sdks.section.javascript.links.2': 'jwt-auth npm \u30E2\u30B8\u30E5\u30FC\u30EB',
    'technical_docs.sdks.text':
      'AEM Headless SDK \u3092\u4F7F\u7528\u3057\u3066\u3001AEM Headless API \u3068\u3084\u308A\u53D6\u308A\u3057\u307E\u3059\u3002',
    'technical_docs.sdks.title': 'SDK',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1':
      'AEM 6.5 GraphiQL \u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u30AC\u30A4\u30C9',
    'technical_docs.tools.text':
      'AEM \u306E\u30D8\u30C3\u30C9\u30EC\u30B9\u958B\u767A\u8005\u30C4\u30FC\u30EB\u306B\u3064\u3044\u3066\u5B66\u7FD2\u3057\u307E\u3059\u3002',
    'technical_docs.tools.title': '\u30C4\u30FC\u30EB',
    'what_is_headless.text':
      'AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u3092\u4F7F\u7528\u3059\u308B\u3068\u3001\u958B\u767A\u8005\u304C\u6700\u3082\u5F97\u610F\u3068\u3059\u308B\u3053\u3068\u3092\u81EA\u7531\u306B\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u3064\u307E\u308A\u3001\u4F7F\u3044\u6163\u308C\u305F\u8A00\u8A9E\u3001\u30D5\u30EC\u30FC\u30E0\u30EF\u30FC\u30AF\u304A\u3088\u3073\u30C4\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u3066\u3001\u3088\u308A\u8FC5\u901F\u306B\u69CB\u7BC9\u3057\u3001\u512A\u308C\u305F\u30A8\u30AF\u30B9\u30DA\u30EA\u30A8\u30F3\u30B9\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002',
    'what_is_headless.title': 'AEM \u30D8\u30C3\u30C9\u30EC\u30B9 CMS \u3068\u306F',
  },
  QE = {
    'app.hero.cta': '\uC791\uB3D9\uD558\uB294 \uBC95 \uC54C\uC544\uBCF4\uAE30',
    'app.hero.solution': 'Adobe Experience Manager \uD5E4\uB4DC\uB9AC\uC2A4',
    'app.hero.text':
      '\uBCF4\uB2E4 \uC6B0\uC218\uD55C \uC560\uD50C\uB9AC\uCF00\uC774\uC158\uACFC \uBE60\uB978 \uACBD\uD5D8\uC744 \uC791\uC131, \uBC30\uD3EC\uD558\uAE30 \uC704\uD574 AEM\uC758 \uD5E4\uB4DC\uB9AC\uC2A4 CMS\uC5D0 \uB300\uD574 \uC54C\uC544 \uB450\uC5B4\uC57C \uD560 \uBAA8\uB4E0 \uB0B4\uC6A9\uC744 \uB2E4\uB8F9\uB2C8\uB2E4.',
    'app.hero.title': 'AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS\uB85C \uBE4C\uB4DC \uC2DC\uC791',
    'code_by_id.button.back': '\uCF54\uB4DC \uB180\uC774\uD130\uB85C \uB3CC\uC544\uAC00\uAE30',
    'code_by_id.button.enter_widescreen': '\uB113\uC740 \uD654\uBA74 \uBAA8\uB4DC \uC2DC\uC791',
    'code_by_id.button.exit_widescreen': '\uB113\uC740 \uD654\uBA74 \uBAA8\uB4DC \uC885\uB8CC',
    'code_index.button.run_the_code': '\uCF54\uB4DC \uC2E4\uD589',
    'code_index.text':
      'AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS\uB97C \uD14C\uC2A4\uD2B8 \uAC00\uB3D9\uD574 \uBCF4\uC138\uC694! JavaScript \uC571 \uC608\uC2DC\uB85C \uBA87 \uCD08 \uB9CC\uC5D0 \uC2DC\uC791\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'code_index.title': '\uCF54\uB4DC \uB180\uC774\uD130',
    'community.links.0': '\uB300\uD654 \uCC38\uC5EC\uD558\uAE30',
    'community.text':
      'Experience League \uCEE4\uBBA4\uB2C8\uD2F0\uC5D0 \uC788\uB294 AEM \uAC1C\uBC1C\uC790 \uCEE4\uBBA4\uB2C8\uD2F0\uC5D0\uC11C AEM \uD5E4\uB4DC\uB9AC\uC2A4\uC5D0 \uB300\uD574 \uB300\uD654\uD558\uACE0, \uC9C8\uBB38\uD558\uACE0, \uB2F5\uBCC0\uC744 \uC5BB\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'community.title': '\uB300\uD654 \uCC38\uC5EC\uD558\uAE30',
    'error.text':
      '\uC8C4\uC1A1\uD569\uB2C8\uB2E4. \uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4. \uB098\uC911\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.',
    'error.title': '\uC774\uB7F0! \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4.',
    'example_apps_android.links.0': '\uC571 \uBCF4\uAE30',
    'example_apps_android.text':
      'AEM \uD5E4\uB4DC\uB9AC\uC2A4 API\uC5D0\uC11C \uCEE8\uD150\uCE20\uB97C \uC774\uC6A9\uD558\uB294 Android \uC571 \uC608\uC2DC',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': '\uC571 \uBCF4\uAE30',
    'example_apps_ios.text':
      'AEM \uD5E4\uB4DC\uB9AC\uC2A4 API\uC5D0\uC11C \uCEE8\uD150\uCE20\uB97C \uC774\uC6A9\uD558\uB294 SwiftUI iOS \uC571 \uC608\uC2DC',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': '\uC571 \uBCF4\uAE30',
    'example_apps_next_js.text':
      'AEM Headless API\uC758 \uCF58\uD150\uCE20\uB97C \uC774\uC6A9\uD558\uB294 Next.js \uC560\uD50C\uB9AC\uCF00\uC774\uC158\uC758 \uC608\uC2DC\uC785\uB2C8\uB2E4.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': '\uC571 \uBCF4\uAE30',
    'example_apps_node-js.text':
      'AEM Headless API\uC758 \uCF58\uD150\uCE20\uB97C \uC774\uC6A9\uD558\uB294 \uBA85\uB839\uC904 Node.js \uC560\uD50C\uB9AC\uCF00\uC774\uC158\uC758 \uC608\uC2DC\uC785\uB2C8\uB2E4.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': '\uC571 \uBCF4\uAE30',
    'example_apps_react.text':
      'AEM \uD5E4\uB4DC\uB9AC\uC2A4 API\uC5D0\uC11C \uCEE8\uD150\uCE20\uB97C \uC774\uC6A9\uD558\uB294 React \uC560\uD50C\uB9AC\uCF00\uC774\uC158 \uC608\uC2DC',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': '\uC571 \uBCF4\uAE30',
    'example_apps_web-component.text':
      'AEM Headless API\uC758 \uCF58\uD150\uCE20\uB97C \uC774\uC6A9\uD558\uB294 \uC21C\uC218 JavaScript \uC6F9 \uAD6C\uC131 \uC694\uC18C\uC758 \uC608\uC2DC\uC785\uB2C8\uB2E4.',
    'example_apps_web-component.title': '\uC6F9 \uAD6C\uC131 \uC694\uC18C/JS',
    'experienced_developers.text1':
      'AEM\uC744 \uC0AC\uC6A9\uD558\uC5EC \uACBD\uD5D8\uC744 \uB9CC\uB4E4\uACE0 \uAD00\uB9AC\uD558\uBA70 \uAC8C\uC7AC\uD558\uB294 { fiveSteps}\uB97C \uC9C4\uD589\uD574 \uBCF4\uC138\uC694. { break } \uC774\uBBF8 \uC644\uB8CC\uD558\uC168\uB098\uC694? \uADF8\uB807\uB2E4\uBA74 { advancedDocumentation }\uB3C4 \uD655\uC778\uD558\uC138\uC694.',
    'experienced_developers.title': '\uB300\uC0C1: { emphasis } AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS \uAC1C\uBC1C\uC790',
    'experienced_developers.title.emphasis': '\uC219\uB828',
    'get_involved_blog.links.0': '\uBE14\uB85C\uADF8 \uC77D\uAE30',
    'get_involved_blog.text':
      'Adobe \uAE30\uC220 \uBE14\uB85C\uADF8\uC5D0\uC11C \uCD5C\uC2E0 \uC815\uBCF4\uB97C \uD655\uC778\uD558\uC138\uC694.',
    'get_involved_blog.title': 'Adobe \uAE30\uC220 \uBE14\uB85C\uADF8',
    'get_involved_community.links.0': '\uB300\uD654 \uCC38\uC5EC',
    'get_involved_community.text':
      '\uCEE4\uBBA4\uB2C8\uD2F0\uC5D0 \uAC00\uC785\uD558\uC5EC \uC9C8\uBB38\uC5D0 \uB300\uD55C \uB2F5\uBCC0\uC744 \uD655\uC778\uD558\uC138\uC694.',
    'get_involved_community.title': 'Experience League \uCEE4\uBBA4\uB2C8\uD2F0',
    'nav.codePlayground': '\uCF54\uB4DC \uB180\uC774\uD130',
    'nav.home': '\uD648',
    'nav.title': 'AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS \uAC1C\uBC1C\uC790 \uD3EC\uD138',
    'new_developers.text':
      '\uC774 { guideLink }\uC5D0\uC11C AEM\uC758 headless CMS \uAE30\uB2A5\uACFC \uC774\uB97C \uD5E4\uB4DC\uB9AC\uC2A4 \uAC1C\uBC1C \uD504\uB85C\uC81D\uD2B8\uC5D0 \uD65C\uC6A9\uD558\uB294 \uBC29\uBC95\uC744 \uC54C\uC544\uBCF4\uC138\uC694.',
    'new_developers.text.5_steps': '\uB2E4\uC12F \uB2E8\uACC4',
    'new_developers.text.advanced_documentation': '\uACE0\uAE09 \uC124\uBA85\uC11C',
    'new_developers.text.guide_link': '\uC548\uB0B4\uC11C',
    'new_developers.title': '\uB300\uC0C1: AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS { emphasis } \uAC1C\uBC1C\uC790',
    'new_developers.title.emphasis': '\uC2E0\uADDC',
    'new_to_aem_headless.links.0': '\uAC00\uC774\uB4DC \uC77D\uAE30',
    'page.description':
      'AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS \uAC1C\uBC1C\uC790 \uB9AC\uC18C\uC2A4 \uBC0F \uC124\uBA85\uC11C\uB97C \uBC29\uBB38\uD558\uC138\uC694. Experience Manager as a Cloud Service\uC5D0\uC11C \uD5E4\uB4DC\uB9AC\uC2A4 CMS \uAE30\uC220\uC744 \uC0AC\uC6A9\uD558\uC5EC \uCC28\uC138\uB300 \uC571\uC744 \uBE4C\uB4DC\uD558\uB294 \uBC29\uBC95\uC744 \uC54C\uC544\uBCF4\uC138\uC694.',
    'page.title':
      'AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS \uAC1C\uBC1C\uC790 \uB9AC\uC18C\uC2A4 \uBC0F \uC124\uBA85\uC11C | Adobe Experience Manager',
    'quick_setup.links.0': 'Cloud Service \uBE60\uB974\uAC8C \uC124\uC815\uD558\uAE30',
    'quick_setup.links.1': '\uB85C\uCEEC AEM SDK \uBE60\uB974\uAC8C \uC124\uC815\uD558\uAE30',
    'quick_setup.text':
      'React \uC571\uC744 \uC774\uC6A9\uD574 \uB2E8 \uBA87 \uBD84\uB9CC\uC5D0 AEM \uD5E4\uB4DC\uB9AC\uC2A4 \uC124\uCE58 \uBC0F \uD14C\uC2A4\uD2B8 \uB4DC\uB77C\uC774\uBE0C',
    'quick_setup.title': '\uBE60\uB978 \uC124\uCE58',
    'section_developer_resources.title': '\uACE0\uAE09 \uC124\uBA85\uC11C',
    'section_example_apps.title': 'AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS \uC571 \uC608\uC2DC',
    'section_get_involved.title': '\uCC38\uC5EC\uD574 \uBCF4\uC138\uC694!',
    'section_spa_editor.text':
      'AEM SPA \uD3B8\uC9D1\uAE30\uC758 \uD504\uB808\uC784\uC6CC\uD06C\uC5D0\uC11C\uB294 \uB9C8\uCF00\uD130\uAC00 AEM\uC5D0\uC11C \uC791\uC131\uD55C UI\uB97C \uC774\uC6A9\uD574 \uCEE8\uD14D\uC2A4\uD2B8 \uB0B4\uC5D0 \uC5C5\uB370\uC774\uD2B8\uD560 \uC218 \uC788\uB294 React\uB098 Angular \uC571\uC744 \uB9CC\uB4E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'section_spa_editor.title': 'AEM SPA \uD3B8\uC9D1\uAE30 \uC54C\uC544\uBCF4\uAE30',
    'spa_editor.links.0': 'React \uD29C\uD1A0\uB9AC\uC5BC \uC2DC\uC791\uD558\uAE30',
    'spa_editor.text':
      'AEM SPA \uD3B8\uC9D1\uAE30\uB294 SPA\uB97C \uC0DD\uC131\uD558\uB294\uB370 \uC0AC\uC6A9\uB429\uB2C8\uB2E4. SPA\uC758 \uAD6C\uC131\uC694\uC18C, \uB77C\uC6B0\uD305, \uBCF4\uAE30\uB294 AEM\uC5D0\uC11C \uC644\uC804\uD788 \uAD00\uB9AC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. SPA \uD3B8\uC9D1\uAE30\uB294 React \uD504\uB808\uC784\uC6CC\uD06C\uB97C \uC9C0\uC6D0\uD569\uB2C8\uB2E4.',
    'spa_editor.title': 'AEM\uC5D0\uC11C SPA \uAD00\uB9AC\uD558\uAE30',
    'spa_editor_remote_spa.links.0': '\uD29C\uD1A0\uB9AC\uC5BC \uC2DC\uC791\uD558\uAE30',
    'spa_editor_remote_spa.text':
      'AEM\uC758 Remote SPA \uAE30\uB2A5\uC744 \uD1B5\uD574 \uB9C8\uCF00\uD130\uB294 \uC6D0\uACA9\uC73C\uB85C \uD638\uC2A4\uD305\uB41C SPA\uC758 \uD0C0\uAC9F \uC9C0\uC5ED\uC744 \uC5C5\uB370\uC774\uD2B8\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'spa_editor_remote_spa.title': '\uC6D0\uACA9 SPA \uC791\uC131',
    'technical_docs.apis.section.formsapis': 'AEM Forms HTTP API',
    'technical_docs.apis.section.formsapis.links.0': 'AEM Forms API(OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'GraphQL APIs',
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.1': '\uC0D8\uD50C GraphQL \uCFFC\uB9AC',
    'technical_docs.apis.section.relatedhttpapis': '\uAD00\uB828\uB41C HTTP API',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM Assets HTTP API',
    'technical_docs.apis.text':
      'AEM\uC758 GraphQL API\uC640 \uCFFC\uB9AC \uBC0F HTTP \uC694\uCCAD \uB9CC\uB4DC\uB294 \uBC29\uBC95 \uC54C\uC544\uBCF4\uAE30',
    'technical_docs.apis.title': 'API',
    'technical_docs.documentation.section.contentfragments': '\uCF58\uD150\uCE20 \uC870\uAC01',
    'technical_docs.documentation.section.contentfragments.links.0':
      '\uCEE8\uD150\uCE20 \uC870\uAC01 \uD65C\uC131\uD654',
    'technical_docs.documentation.section.contentfragments.links.1': '\uCF58\uD150\uCE20 \uC870\uAC01 \uBAA8\uB378',
    'technical_docs.documentation.section.contentfragments.links.2': '\uCF58\uD150\uCE20 \uC870\uAC01 \uAD00\uB9AC',
    'technical_docs.documentation.section.contentfragments.links.3': '\uBCC0\uD615',
    'technical_docs.documentation.section.contentfragments.links.4': '\uAD00\uB828 \uCEE8\uD150\uCE20',
    'technical_docs.documentation.section.contentfragments.links.5': '\uBA54\uD0C0\uB370\uC774\uD130',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': '\uAD6C\uC870 \uD2B8\uB9AC',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON \uBBF8\uB9AC \uBCF4\uAE30',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': '\uD5E4\uB4DC\uB9AC\uC2A4 \uC801\uC751\uD615 \uC591\uC2DD',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL AEM \uC5D4\uB4DC\uD3EC\uC778\uD2B8',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0':
      'GraphQL \uC5D4\uB4DC\uD3EC\uC778\uD2B8 \uD65C\uC131\uD654',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1':
      'GraphQL \uC5D4\uB4DC\uD3EC\uC778\uD2B8 \uAC8C\uC2DC',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': '\uC9C0\uC18D\uD615 \uCFFC\uB9AC',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': '\uC601\uC18D\uD654 \uCFFC\uB9AC \uAC8C\uC2DC',
    'technical_docs.documentation.text':
      'AEM\uC758 \uC804\uCCB4 \uAE30\uB2A5\uACFC \uAD6C\uD604 \uC124\uBA85\uC744 \uBCF4\uB824\uBA74 Adobe Experience Manager as a Cloud Service \uC124\uBA85\uC11C\uB97C \uBCF4\uC138\uC694.',
    'technical_docs.documentation.title': '\uCD94\uAC00 \uC124\uBA85\uC11C',
    'technical_docs.how-to.section.content': '\uCF58\uD150\uCE20',
    'technical_docs.how-to.section.content.links.0': '\uB9AC\uCE58 \uD14D\uC2A4\uD2B8',
    'technical_docs.how-to.section.content.links.1': '\uC774\uBBF8\uC9C0',
    'technical_docs.how-to.section.content.links.2': '\uC9C0\uC5ED\uD654 \uCF58\uD150\uCE20',
    'technical_docs.how-to.section.content.links.3': '\uB300\uADDC\uBAA8 \uACB0\uACFC \uC9D1\uD569',
    'technical_docs.how-to.section.content.links.4': '\uBBF8\uB9AC\uBCF4\uAE30',
    'technical_docs.how-to.section.deployment': '\uBC30\uD3EC',
    'technical_docs.how-to.section.deployment.links.0': '\uB2E8\uC77C \uD398\uC774\uC9C0 \uC571',
    'technical_docs.how-to.section.deployment.links.1': '\uC6F9 \uAD6C\uC131 \uC694\uC18C',
    'technical_docs.how-to.section.deployment.links.2': '\uBAA8\uBC14\uC77C',
    'technical_docs.how-to.section.deployment.links.3': '\uC11C\uBC84 \uD22C \uC11C\uBC84',
    'technical_docs.how-to.section.development': '\uAC1C\uBC1C',
    'technical_docs.how-to.section.development.links.0': 'AEM Headless SDK',
    'technical_docs.how-to.section.development.links.1': 'AEM 6.5\uC5D0 GraphiQL IDE \uC124\uCE58',
    'technical_docs.how-to.text':
      'AEM Headless\uC758 \uB2E4\uC591\uD55C \uC0AC\uC6A9 \uC0AC\uB840\uC5D0 \uC811\uADFC\uD558\uB294 \uBC29\uBC95\uC744 \uC54C\uC544\uBD05\uB2C8\uB2E4.',
    'technical_docs.how-to.title': '\uBC29\uBC95 \uC548\uB0B4\uC11C',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0': '\uD074\uB77C\uC774\uC5B8\uD2B8 \uCE21 JS SDK',
    'technical_docs.sdks.section.javascript.links.1': '\uC11C\uBC84 \uCE21 JS SDK',
    'technical_docs.sdks.section.javascript.links.2': 'jwt-auth npm \uBAA8\uB4C8',
    'technical_docs.sdks.text':
      'AEM \uD5E4\uB4DC\uB9AC\uC2A4 SDK\uB97C \uC774\uC6A9\uD574 AEM \uD5E4\uB4DC\uB9AC\uC2A4 API\uC640 \uC0C1\uD638\uC791\uC6A9\uD558\uAE30',
    'technical_docs.sdks.title': 'SDKs',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'AEM 6.5 GraphiQL \uC124\uCE58 \uAC00\uC774\uB4DC',
    'technical_docs.tools.text':
      'AEM\uC758 \uD5E4\uB4DC\uB9AC\uC2A4 \uAC1C\uBC1C\uC790 \uB3C4\uAD6C \uC54C\uC544\uBCF4\uAE30',
    'technical_docs.tools.title': '\uB3C4\uAD6C',
    'what_is_headless.text':
      'AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS\uB97C \uC0AC\uC6A9\uD558\uBA74 \uAC1C\uBC1C\uC790\uB294 \uC790\uC2E0\uC774 \uAC00\uC7A5 \uC798\uD558\uB294 \uC791\uC5C5\uC5D0 \uC790\uC720\uB86D\uAC8C \uC9D1\uC911\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC774\uBBF8 \uC775\uC219\uD55C \uC5B8\uC5B4, \uD504\uB808\uC784\uC6CC\uD06C, \uB3C4\uAD6C\uB97C \uC0AC\uC6A9\uD558\uC5EC \uB354 \uBE60\uB974\uAC8C \uC791\uC131\uD558\uACE0 \uD0C1\uC6D4\uD55C \uACBD\uD5D8\uC744 \uC81C\uACF5\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'what_is_headless.title': 'AEM \uD5E4\uB4DC\uB9AC\uC2A4 CMS\uB780 \uBB34\uC5C7\uC785\uB2C8\uAE4C?',
  },
  WE = {
    'app.hero.cta': 'Zie hoe het werkt',
    'app.hero.solution': 'Adobe Experience Manager Headless',
    'app.hero.text':
      'Alles wat u moet leren over AEM Headless CMS om betere applicaties en snellere ervaringen te kunnen samenstellen en leveren.',
    'app.hero.title': 'Begin met het ontwikkelen van AEM Headless CMS',
    'code_by_id.button.back': 'Terug naar code playground',
    'code_by_id.button.enter_widescreen': 'Breedbeeldmodus activeren',
    'code_by_id.button.exit_widescreen': 'Breedbeeldmodus afsluiten',
    'code_index.button.run_the_code': 'De code uitvoeren',
    'code_index.text': 'Test AEM Headless CMS in luttele seconden met behulp van JavaScript-voorbeeldapps.',
    'code_index.title': 'Code playground',
    'community.links.0': 'Deelnemen aan de discussie',
    'community.text':
      'Doe mee aan discussies en stel vragen over AEM Headless op Experience League Communities en krijg antwoorden van de gehele AEM-ontwikkelaarscommunity.',
    'community.title': 'Deelnemen aan de discussie',
    'error.text': 'Er is iets fout gegaan. Probeer het later opnieuw.',
    'error.title': 'Er is een fout opgetreden.',
    'example_apps_android.links.0': 'De app bekijken',
    'example_apps_android.text': "Voorbeeld van een Java Android-app die content gebruikt van AEM Headless-API's.",
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': 'De app bekijken',
    'example_apps_ios.text': "Voorbeeld van een SwiftUI iOS-app die content gebruikt van AEM Headless-API's.",
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'De app bekijken',
    'example_apps_next_js.text': "Voorbeeld van een Next.js-applicatie die content gebruikt van AEM Headless-API's.",
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'De app bekijken',
    'example_apps_node-js.text':
      "Voorbeeld van een command-line Node.js-applicatie die content gebruikt van AEM Headless-API's.",
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': 'De app bekijken',
    'example_apps_react.text': "Voorbeeld van een React-app die content gebruikt van AEM Headless-API's.",
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'De app bekijken',
    'example_apps_web-component.text':
      "Voorbeeld van een zuivere JavaScript-webcomponent die content gebruikt van AEM Headless-API's.",
    'example_apps_web-component.title': 'Webcomponent/JS',
    'experienced_developers.text1':
      'Doorloop { fiveSteps} voor het maken, beheren en leveren van ervaringen met AEM. { break } Al klaar? Ga dan naar de { advancedDocumentation }.',
    'experienced_developers.title': 'VOOR { emphasis } AEM HEADLESS CMS-ONTWIKKELAARS',
    'experienced_developers.title.emphasis': 'ERVAREN',
    'get_involved_blog.links.0': 'De blog lezen',
    'get_involved_blog.text': 'Lees al het nieuws in onze tech blog.',
    'get_involved_blog.title': 'Adobe Tech Blog',
    'get_involved_community.links.0': 'Praat mee',
    'get_involved_community.text': 'Word lid van onze community en vind antwoorden op uw vragen.',
    'get_involved_community.title': 'Experience League Communities',
    'nav.codePlayground': 'Code playground',
    'nav.home': 'Startpagina',
    'nav.title': 'AEM Headless CMS-portal voor ontwikkelaars',
    'new_developers.text':
      'In { guideLink } vindt u meer informatie over de Headless CMS-functies van AEM en over het gebruik ervan in een Headless-ontwikkelingsproject.',
    'new_developers.text.5_steps': '5 stappen',
    'new_developers.text.advanced_documentation': 'documentatie voor geavanceerde gebruikers',
    'new_developers.text.guide_link': 'handleiding',
    'new_developers.title': 'VOOR ONTWIKKELAARS { emphasis } NAAR AEM HEADLESS CMS',
    'new_developers.title.emphasis': 'NIEUW',
    'new_to_aem_headless.links.0': 'De gids lezen',
    'page.description':
      'Bezoek de AEM Headless CMS-resources en -documentatie voor ontwikkelaars. Ontdek hoe u apps van de volgende generatie kunt ontwikkelen met behulp van Headless CMS-technologie\xEBn in Experience Manager as a Cloud Service.',
    'page.title': 'AEM Headless CMS-resources en -documentatie voor ontwikkelaars | Adobe Experience Manager',
    'quick_setup.links.0': 'Snelle set-up voor Cloud Service',
    'quick_setup.links.1': 'Snelle set-up voor lokale AEM SDK',
    'quick_setup.text': 'Installeer en test AEM Headless binnen enkele minuten met behulp van een React-voorbeeldapp.',
    'quick_setup.title': 'Snelle installatie',
    'section_developer_resources.title': 'Documentatie voor geavanceerde gebruikers',
    'section_example_apps.title': 'Voorbeeld van AEM Headless CMS-apps',
    'section_get_involved.title': 'Doe mee.',
    'section_spa_editor.text':
      'De AEM SPA Editor biedt een ontwikkelkader voor React- of Angular-apps die in-context kunnen worden bijgewerkt door marketeers met gebruik van de AEM-ontwerpinterface.',
    'section_spa_editor.title': 'De AEM SPA Editor verkennen',
    'spa_editor.links.0': 'React-tutorial starten',
    'spa_editor.text':
      'Met de AEM SPA Editor kunt u een SPA maken waarvan de componenten, routering en weergaven volledig kunnen worden beheerd in AEM. De SPA Editor biedt ondersteuning voor het React-kader.',
    'spa_editor.title': 'Een SPA beheren in AEM',
    'spa_editor_remote_spa.links.0': 'Tutorial starten',
    'spa_editor_remote_spa.text':
      "Met de externe SPA-capaciteiten van AEM kunnen marketeers de getargete regio's van een extern gehoste SPA bijwerken.",
    'spa_editor_remote_spa.title': 'Een externe SPA ontwerpen',
    'technical_docs.apis.section.formsapis': "AEM Forms HTTP-API's",
    'technical_docs.apis.section.formsapis.links.0': 'AEM Forms-API (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': "GraphQL-API's",
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL-API',
    'technical_docs.apis.section.graphqlapis.links.1': "Voorbeeldquery's van GraphQL",
    'technical_docs.apis.section.relatedhttpapis': "Verwante HTTP-API's",
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM Assets HTTP-API',
    'technical_docs.apis.text':
      "Leer van alles over de GraphQL-API's van AEM en over hoe u query's and HTTP-aanvragen opstelt.",
    'technical_docs.apis.title': "API's",
    'technical_docs.documentation.section.contentfragments': 'Contentfragmenten',
    'technical_docs.documentation.section.contentfragments.links.0': 'Contentfragmenten inschakelen',
    'technical_docs.documentation.section.contentfragments.links.1': 'Modellen van contentfragmenten',
    'technical_docs.documentation.section.contentfragments.links.2': 'Contentfragmenten beheren',
    'technical_docs.documentation.section.contentfragments.links.3': 'Variaties',
    'technical_docs.documentation.section.contentfragments.links.4': 'Gekoppelde content',
    'technical_docs.documentation.section.contentfragments.links.5': 'Metadata',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': 'Boomstructuur',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON-voorvertoning',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Headless Adaptive Forms',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL AEM-eindpunt',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': 'Een GraphQL-eindpunt inschakelen',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': 'Een GraphQL-eindpunt publiceren',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': "Permanente query's",
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': "Standhoudende query's publiceren",
    'technical_docs.documentation.text':
      'Raadpleeg de documentatie van Adobe Experience Manager as a Cloud Service voor een volledige beschrijving van de mogelijkheden en configuraties van AEM.',
    'technical_docs.documentation.title': 'Aanvullende documentatie',
    'technical_docs.how-to.section.content': 'Content',
    'technical_docs.how-to.section.content.links.0': 'Rich Text',
    'technical_docs.how-to.section.content.links.1': 'Afbeeldingen',
    'technical_docs.how-to.section.content.links.2': 'Gelokaliseerde content',
    'technical_docs.how-to.section.content.links.3': 'Grote resultatensets',
    'technical_docs.how-to.section.content.links.4': 'Voorvertoning',
    'technical_docs.how-to.section.deployment': 'Implementatie',
    'technical_docs.how-to.section.deployment.links.0': 'Single-page application',
    'technical_docs.how-to.section.deployment.links.1': 'Webcomponent',
    'technical_docs.how-to.section.deployment.links.2': 'Mobiel',
    'technical_docs.how-to.section.deployment.links.3': 'Server-naar-server',
    'technical_docs.how-to.section.development': 'Ontwikkeling',
    'technical_docs.how-to.section.development.links.0': 'AEM Headless SDK',
    'technical_docs.how-to.section.development.links.1': 'GraphiQL IDE installeren op AEM 6.5',
    'technical_docs.how-to.text': "Leer hoe u verschillende gebruiksscenario's aanpakt met AEM Headless.",
    'technical_docs.how-to.title': 'Instructiegidsen',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java-SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0': 'JS-SDK aan clientzijde',
    'technical_docs.sdks.section.javascript.links.1': 'JS-SDK aan serverzijde',
    'technical_docs.sdks.section.javascript.links.2': 'jwt-auth npm-module',
    'technical_docs.sdks.text': "AEM Headless SDK's gebruiken voor interactie met AEM Headless-API's.",
    'technical_docs.sdks.title': "SDK's",
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'AEM 6.5 GraphiQL-installatiegids',
    'technical_docs.tools.text': 'Ontdek de AEM Headless-tools voor ontwikkelaars.',
    'technical_docs.tools.title': 'Tools',
    'what_is_headless.text':
      'AEM Headless CMS geeft ontwikkelaars de vrijheid om sneller uitzonderlijke ervaringen te ontwikkelen en te leveren met gebruik van vertrouwde talen, frameworks en tools.',
    'what_is_headless.title': 'Wat is AEM Headless CMS?',
  },
  KE = {
    'app.hero.cta': 'Veja como ele funciona',
    'app.hero.solution': 'Headless do Adobe Experience Manager',
    'app.hero.text':
      'Tudo o que voc\xEA precisa aprender sobre o AEM Headless CMS para criar e enviar melhores aplicativos e experi\xEAncias mais r\xE1pidas.',
    'app.hero.title': 'Comece a criar com o CMS headless do AEM',
    'code_by_id.button.back': 'Voltar ao playground de c\xF3digo',
    'code_by_id.button.enter_widescreen': 'Entrar no modo widescreen',
    'code_by_id.button.exit_widescreen': 'Sair do modo widescreen',
    'code_index.button.run_the_code': 'Executar o c\xF3digo',
    'code_index.text': 'Experimente o CMS headless do AEM em segundos usando os aplicativos JavaScript de exemplo!',
    'code_index.title': 'Playground de c\xF3digo',
    'community.links.0': 'Participar da conversa',
    'community.text':
      'Converse, fa\xE7a perguntas e receba respostas sobre o AEM Headless com toda a comunidade de desenvolvedores do AEM nas Experience League Communities.',
    'community.title': 'Participar da conversa',
    'error.text': 'Algo deu errado. Tente novamente mais tarde.',
    'error.title': 'Ops, ocorreu um erro.',
    'example_apps_android.links.0': 'Ver o aplicativo',
    'example_apps_android.text':
      'Um exemplo de aplicativo Android Java que consome conte\xFAdo das APIs do AEM Headless.',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': 'Ver o aplicativo',
    'example_apps_ios.text':
      'Um exemplo de aplicativo SwiftUI para iOS que consome conte\xFAdo das APIs do AEM Headless.',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'Ver o aplicativo',
    'example_apps_next_js.text': 'Um exemplo de aplicativo Next.js que consome conte\xFAdo das APIs do AEM Headless.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'Ver o aplicativo',
    'example_apps_node-js.text':
      'Um exemplo de aplicativo de Node.js da linha de comando que consome conte\xFAdo das APIs do AEM Headless.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': 'Ver o aplicativo',
    'example_apps_react.text': 'Um exemplo de aplicativo React que consome conte\xFAdo das APIs do AEM Headless.',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'Ver o aplicativo',
    'example_apps_web-component.text':
      'Um exemplo puro de Componente da Web do JavaScript que consome conte\xFAdo das APIs do AEM Headless.',
    'example_apps_web-component.title': 'Componente da Web/JS',
    'experienced_developers.text1':
      'Siga os { fiveSteps} para criar, gerenciar e fornecer experi\xEAncias usando o AEM. { break } Tudo pronto? Acesse nossa { advancedDocumentation }.',
    'experienced_developers.title': 'PARA { emphasis } DESENVOLVEDORES DO CMS HEADLESS DO AEM',
    'experienced_developers.title.emphasis': 'COM EXPERI\xCANCIA',
    'get_involved_blog.links.0': 'Ler o blog',
    'get_involved_blog.text': 'Leia as novidades em nosso blog de tecnologia.',
    'get_involved_blog.title': 'Blog de tecnologia da Adobe',
    'get_involved_community.links.0': 'Participar da conversa',
    'get_involved_community.text': 'Junte-se a nossa comunidade e tire suas d\xFAvidas.',
    'get_involved_community.title': 'Comunidades da Experience League',
    'nav.codePlayground': 'Playground de c\xF3digo',
    'nav.home': 'In\xEDcio',
    'nav.title': 'Portal do desenvolvedor do CMS headless do AEM',
    'new_developers.text':
      'Leia este { guideLink } para aprender sobre os recursos do AEM Headless CMS e como aproveit\xE1-los em um projeto de desenvolvimento de Headless.',
    'new_developers.text.5_steps': '5 etapas',
    'new_developers.text.advanced_documentation': 'documenta\xE7\xE3o avan\xE7ada',
    'new_developers.text.guide_link': 'guia',
    'new_developers.title': 'PARA DESENVOLVEDORES { emphasis } PARA CMS HEADLESS DO AEM',
    'new_developers.title.emphasis': 'NOVO',
    'new_to_aem_headless.links.0': 'Ler o guia',
    'page.description':
      'Visite os recursos e a documenta\xE7\xE3o do desenvolvedor do CMS headless do AEM. Saiba como criar aplicativos de \xFAltima gera\xE7\xE3o usando tecnologias CMS headless no Experience Manager como Cloud Service.',
    'page.title': 'Documenta\xE7\xE3o e recursos do desenvolvedor do CMS headless do AEM | Adobe Experience Manager',
    'quick_setup.links.0': 'Configura\xE7\xE3o r\xE1pida do Cloud Service',
    'quick_setup.links.1': 'Configura\xE7\xE3o r\xE1pida para SDK local do AEM',
    'quick_setup.text': 'Configure e experimente o AEM Headless em poucos minutos com um exemplo do aplicativo React',
    'quick_setup.title': 'Configura\xE7\xE3o r\xE1pida',
    'section_developer_resources.title': 'Documenta\xE7\xE3o avan\xE7ada',
    'section_example_apps.title': 'Exemplo de aplicativos do CMS headless do AEM',
    'section_get_involved.title': 'Envolva-se!',
    'section_spa_editor.text':
      'O Editor de aplicativo de p\xE1gina \xFAnica (SPA) do AEM oferece uma estrutura para desenvolver aplicativos React ou Angular que podem ser atualizados no contexto por profissionais de marketing que usam a UI de cria\xE7\xE3o do AEM.',
    'section_spa_editor.title': 'Explore o Editor de SPA do AEM',
    'spa_editor.links.0': 'Iniciar o tutorial sobre o React',
    'spa_editor.text':
      'O Editor de SPA do AEM pode ser usado para criar um SPA com componentes, roteamento e exibi\xE7\xF5es que podem ser gerenciados completamente no AEM. O Editor de SPA \xE9 compat\xEDvel com a estrutura React.',
    'spa_editor.title': 'Gerencie um SPA no AEM',
    'spa_editor_remote_spa.links.0': 'Iniciar o tutorial',
    'spa_editor_remote_spa.text':
      'Os recursos de SPA remoto do AEM permite que os profissionais de marketing atualizem regi\xF5es segmentadas de um SPA hospedado remotamente.',
    'spa_editor_remote_spa.title': 'Crie um SPA remoto',
    'technical_docs.apis.section.formsapis': 'APIs HTTP do AEM Forms',
    'technical_docs.apis.section.formsapis.links.0': 'API do AEM Forms (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'APIs do GraphQL',
    'technical_docs.apis.section.graphqlapis.links.0': 'API do GraphQL',
    'technical_docs.apis.section.graphqlapis.links.1': 'Amostra de consultas do GraphQL',
    'technical_docs.apis.section.relatedhttpapis': 'APIs HTTP relacionadas',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'API HTTP do AEM Assets',
    'technical_docs.apis.text':
      'Conhe\xE7a as APIs GraphQL do AEM e veja como criar consultas e solicita\xE7\xF5es HTTP.',
    'technical_docs.apis.title': 'APIs',
    'technical_docs.documentation.section.contentfragments': 'Fragmentos de conte\xFAdo',
    'technical_docs.documentation.section.contentfragments.links.0': 'Habilita\xE7\xE3o de fragmentos de conte\xFAdo',
    'technical_docs.documentation.section.contentfragments.links.1': 'Modelos de fragmentos do conte\xFAdo',
    'technical_docs.documentation.section.contentfragments.links.2': 'Gerenciamento dos fragmentos de conte\xFAdo',
    'technical_docs.documentation.section.contentfragments.links.3': 'Varia\xE7\xF5es',
    'technical_docs.documentation.section.contentfragments.links.4': 'Conte\xFAdo associado',
    'technical_docs.documentation.section.contentfragments.links.5': 'Metadados',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': '\xC1rvore de estrutura',
    'technical_docs.documentation.section.contentfragments.links.8': 'Pr\xE9-visualiza\xE7\xE3o do JSON',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Headless Adaptive Forms',
    'technical_docs.documentation.section.graphqlaemendpoint': 'Endpoint AEM do GraphQL',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': 'Ativa\xE7\xE3o de um endpoint do GraphQL',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': 'Publica\xE7\xE3o de um endpoint do GraphQL',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': 'Consultas persistentes',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': 'Publicar consultas persistentes',
    'technical_docs.documentation.text':
      'Veja a documenta\xE7\xE3o do Adobe Experience Manager as a Cloud Service para uma descri\xE7\xE3o completa dos recursos e das configura\xE7\xF5es do AEM.',
    'technical_docs.documentation.title': 'Documenta\xE7\xE3o adicional',
    'technical_docs.how-to.section.content': 'Conte\xFAdo',
    'technical_docs.how-to.section.content.links.0': 'Rich text',
    'technical_docs.how-to.section.content.links.1': 'Imagens',
    'technical_docs.how-to.section.content.links.2': 'Conte\xFAdo localizado',
    'technical_docs.how-to.section.content.links.3': 'Conjuntos grandes de resultados',
    'technical_docs.how-to.section.content.links.4': 'Visualizar',
    'technical_docs.how-to.section.deployment': 'Implanta\xE7\xE3o',
    'technical_docs.how-to.section.deployment.links.0': 'Aplicativo com uma \xFAnica p\xE1gina',
    'technical_docs.how-to.section.deployment.links.1': 'Componente da Web',
    'technical_docs.how-to.section.deployment.links.2': 'M\xF3vel',
    'technical_docs.how-to.section.deployment.links.3': 'Servidor para servidor',
    'technical_docs.how-to.section.development': 'Desenvolvimento',
    'technical_docs.how-to.section.development.links.0': 'SDK do AEM Headless',
    'technical_docs.how-to.section.development.links.1': 'Instalar o GraphiQL IDE no AEM 6.5',
    'technical_docs.how-to.text': 'Aprenda como abordar diferentes casos de uso com o AEM Headless.',
    'technical_docs.how-to.title': 'Guias de instru\xE7\xF5es',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0': 'SDK do JS do lado do cliente',
    'technical_docs.sdks.section.javascript.links.1': 'SDK do JS do lado do servidor',
    'technical_docs.sdks.section.javascript.links.2': 'M\xF3dulo jwt-auth npm',
    'technical_docs.sdks.text': 'Use os SDKs do AEM Headless para interagir com as APIs do AEM Headless.',
    'technical_docs.sdks.title': 'SDKs',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'IDE GraphiQL',
    'technical_docs.tools.section.graphiql.links.1': 'Guia de instala\xE7\xE3o do AEM 6.5 GraphiQL',
    'technical_docs.tools.text': 'Explore ferramentas de desenvolvedor de headless do AEM.',
    'technical_docs.tools.title': 'Ferramentas',
    'what_is_headless.text':
      'O CMS headless do AEM d\xE1 aos desenvolvedores a liberdade de fazer o que eles fazem de melhor: criar mais r\xE1pido e proporcionar experi\xEAncias excepcionais usando linguagens, estruturas e ferramentas que eles j\xE1 est\xE3o familiarizados.',
    'what_is_headless.title': 'O que \xE9 o CMS headless do AEM?',
  },
  JE = {
    'app.hero.cta': 'Se hur det fungerar',
    'app.hero.solution': 'Adobe Experience Manager Headless',
    'app.hero.text':
      'Allt du beh\xF6ver l\xE4ra dig om AEM headless CMS f\xF6r att bygga och leverera b\xE4ttre appar och snabbare upplevelser.',
    'app.hero.title': 'B\xF6rja bygga med AEM Headless CMS',
    'code_by_id.button.back': 'Tillbaka till kodningssandl\xE5dan',
    'code_by_id.button.enter_widescreen': '\xD6ppna bredbildsl\xE4ge',
    'code_by_id.button.exit_widescreen': 'St\xE4ng bredbildsl\xE4ge',
    'code_index.button.run_the_code': 'K\xF6r koden',
    'code_index.text': 'Provk\xF6r AEM Headless CMS p\xE5 n\xE5gra sekunder med exempel p\xE5 JavaScript-appar!',
    'code_index.title': 'Kodningssandl\xE5da',
    'community.links.0': 'G\xE5 med i diskussionen',
    'community.text':
      'Diskutera, fr\xE5ga och f\xE5 svar om AEM Headless tillsammans med hela AEM-utvecklargemenskapen i Experience Leagues communityer.',
    'community.title': 'G\xE5 med i diskussionen',
    'error.text': 'N\xE5got gick tyv\xE4rr fel. F\xF6rs\xF6k igen senare.',
    'error.title': 'Hoppsan! Ett fel uppstod.',
    'example_apps_android.links.0': 'Visa appen',
    'example_apps_android.text': 'En exempel-Java Android-app som anv\xE4nder inneh\xE5ll fr\xE5n AEM Headless-API:er.',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': 'Visa appen',
    'example_apps_ios.text': 'En exempel-SwiftUI iOS-app som anv\xE4nder inneh\xE5ll fr\xE5n AEM Headless-API:er.',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': 'Visa appen',
    'example_apps_next_js.text':
      'Ett exempel p\xE5 en Next.js-app som anv\xE4nder inneh\xE5ll fr\xE5n AEM Headless API:er.',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': 'Visa appen',
    'example_apps_node-js.text':
      'En exempelkommandorad f\xF6r Node.js-applikation som anv\xE4nder inneh\xE5ll fr\xE5n AEM Headless-API:er.',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': 'Visa appen',
    'example_apps_react.text': 'En exempel-React-app som anv\xE4nder inneh\xE5ll fr\xE5n AEM Headless-API:er.',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': 'Visa appen',
    'example_apps_web-component.text':
      'En exempel p\xE5 en ren JavaScript-webbkomponent som anv\xE4nder inneh\xE5ll fr\xE5n AEM Headless-API:er.',
    'example_apps_web-component.title': 'Webbkomponent/JS',
    'experienced_developers.text1':
      'G\xE5 igenom { fiveSteps} n\xE4r du vill skapa, hantera och leverera upplevelser med AEM. { break } Har du redan gjort det? G\xE5 till { advancedDocumentation }.',
    'experienced_developers.title': 'F\xD6R { emphasis } AEM HEADLESS CMS-UTVECKLARE',
    'experienced_developers.title.emphasis': 'ERFAREN',
    'get_involved_blog.links.0': 'L\xE4s bloggen',
    'get_involved_blog.text': 'L\xE4s det senaste p\xE5 v\xE5r teknikblogg.',
    'get_involved_blog.title': 'Adobes teknikblogg',
    'get_involved_community.links.0': 'Delta i konversationen',
    'get_involved_community.text': 'G\xE5 med i v\xE5r community och f\xE5 svar p\xE5 dina fr\xE5gor.',
    'get_involved_community.title': 'Experience League Communities',
    'nav.codePlayground': 'Kodningssandl\xE5da',
    'nav.home': 'Hem',
    'nav.title': 'Utvecklarportal f\xF6r AEM Headless CMS',
    'new_developers.text':
      'L\xE4s den h\xE4r { guideLink } n\xE4r du vill veta mer om headless CMS-funktioner i AEM och hur du anv\xE4nder dem n\xE4r du utvecklar ett headless-projekt.',
    'new_developers.text.5_steps': '5 steg',
    'new_developers.text.advanced_documentation': 'avancerad dokumentation',
    'new_developers.text.guide_link': 'v\xE4gledning',
    'new_developers.title': 'F\xD6R UTVECKLARE { emphasis } AV AEM HEADLESS CMS',
    'new_developers.title.emphasis': 'NYTT',
    'new_to_aem_headless.links.0': 'L\xE4s v\xE4gledningen',
    'page.description':
      'G\xE5 till resurserna och dokumentationen f\xF6r AEM Headless CMS-utvecklare. L\xE4s mer om hur du bygger n\xE4sta generations appar med hj\xE4lp av headless CMS-tekniker i Experience Manager as a Cloud Service.',
    'page.title': 'Resurser och dokumentation f\xF6r AEM Headless CMS-utvecklare | Adobe Experience Manager',
    'quick_setup.links.0': 'Snabb konfigurering f\xF6r molntj\xE4nst',
    'quick_setup.links.1': 'Snabb konfigurering f\xF6r lokal AEM SDK',
    'quick_setup.text': 'Installera och testk\xF6r AEM Headless p\xE5 n\xE5gra minuter med en exempel-React-app.',
    'quick_setup.title': 'Snabbinstallation',
    'section_developer_resources.title': 'Avancerad dokumentation',
    'section_example_apps.title': 'Exempel p\xE5 AEM Headless CMS-appar',
    'section_get_involved.title': 'Engagera dig!',
    'section_spa_editor.text':
      'AEM SPA-redigeraren erbjuder ett ramverk f\xF6r utveckling av React- eller Angular-appar som marknadsf\xF6rare kan uppdatera i det aktuella sammanhanget med AEM-redigeringsgr\xE4nssnittet.',
    'section_spa_editor.title': 'Utforska AEM SPA-redigeraren',
    'spa_editor.links.0': 'Starta React-v\xE4gledningen',
    'spa_editor.text':
      'AEM SPA-redigeraren kan anv\xE4ndas till att skapa ett SPA vars komponenter, dirigering och vyer kan hanteras helt och h\xE5llet i AEM. SPA-redigeraren st\xF6der ramverket React.',
    'spa_editor.title': 'Hantera ett SPA i AEM',
    'spa_editor_remote_spa.links.0': 'Starta v\xE4gledningen',
    'spa_editor_remote_spa.text':
      'AEM:s Remote SPA-funktioner ger marknadsf\xF6rare m\xF6jlighet att uppdatera utvalda regioner hos ett fj\xE4rrhyst SPA.',
    'spa_editor_remote_spa.title': 'F\xF6rfatta ett fj\xE4rr-SPA',
    'technical_docs.apis.section.formsapis': 'HTTP-API:er f\xF6r AEM Forms',
    'technical_docs.apis.section.formsapis.links.0': 'API f\xF6r AEM Forms (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'GraphQL-API:er',
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL-API',
    'technical_docs.apis.section.graphqlapis.links.1': 'Sampla GraphQL-fr\xE5gor',
    'technical_docs.apis.section.relatedhttpapis': 'Relaterade HTTP-API:er',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM Assets HTTP-API',
    'technical_docs.apis.text':
      'L\xE4s om AEM:s GraphQL-API:er och hur du konstruerar fr\xE5gor och HTTP-f\xF6rfr\xE5gningar.',
    'technical_docs.apis.title': 'API:er',
    'technical_docs.documentation.section.contentfragments': 'Inneh\xE5llsfragment',
    'technical_docs.documentation.section.contentfragments.links.0': 'Aktivera inneh\xE5llsfragment',
    'technical_docs.documentation.section.contentfragments.links.1': 'Modeller f\xF6r inneh\xE5llsfragment',
    'technical_docs.documentation.section.contentfragments.links.2': 'Hantera inneh\xE5llsfragment',
    'technical_docs.documentation.section.contentfragments.links.3': 'Variationer',
    'technical_docs.documentation.section.contentfragments.links.4': 'Associerat inneh\xE5ll',
    'technical_docs.documentation.section.contentfragments.links.5': 'Metadata',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': 'Strukturtr\xE4d',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON-f\xF6rhandsgranskning',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Anpassningsbara headless-formul\xE4r',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL AEM-slutpunkt',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': 'Aktivera en GraphQL-slutpunkt',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': 'Publicera en GraphQL-slutpunkt',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': 'Best\xE4ndiga fr\xE5gor',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': 'Publicera best\xE4ndiga fr\xE5gor',
    'technical_docs.documentation.text':
      'Visa Adobe Experience Manager as a Cloud Services-dokumentation f\xF6r hela beskrivningen av AEM:s funktioner och konfigurationer.',
    'technical_docs.documentation.title': 'Ytterligare dokumentation',
    'technical_docs.how-to.section.content': 'Inneh\xE5ll',
    'technical_docs.how-to.section.content.links.0': 'RTF',
    'technical_docs.how-to.section.content.links.1': 'Bilder',
    'technical_docs.how-to.section.content.links.2': 'Lokaliserat inneh\xE5ll',
    'technical_docs.how-to.section.content.links.3': 'Stora resultatupps\xE4ttningar',
    'technical_docs.how-to.section.content.links.4': 'F\xF6rhandsgranskning',
    'technical_docs.how-to.section.deployment': 'Distribution',
    'technical_docs.how-to.section.deployment.links.0': 'Ensidig app',
    'technical_docs.how-to.section.deployment.links.1': 'Webbkomponent',
    'technical_docs.how-to.section.deployment.links.2': 'Mobil',
    'technical_docs.how-to.section.deployment.links.3': 'Server-till-server',
    'technical_docs.how-to.section.development': 'Utveckling',
    'technical_docs.how-to.section.development.links.0': 'AEM Headless SDK',
    'technical_docs.how-to.section.development.links.1': 'Installera GraphiQL IDE p\xE5 AEM 6.5',
    'technical_docs.how-to.text': 'L\xE4s om hur du kan hantera olika anv\xE4ndningar med AEM Headless.',
    'technical_docs.how-to.title': 'G\xF6r s\xE5 h\xE4r-guider',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0': 'JS SDK p\xE5 klientsidan',
    'technical_docs.sdks.section.javascript.links.1': 'JS SDK p\xE5 serversidam',
    'technical_docs.sdks.section.javascript.links.2': 'jwt-auth npm modul',
    'technical_docs.sdks.text': 'Anv\xE4nd AEM Headless-SDK:er f\xF6r att interagera med AEM Headless-API:er.',
    'technical_docs.sdks.title': 'SDK:er',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'Installationsv\xE4gledning f\xF6r AEM 6.5 GraphiQL',
    'technical_docs.tools.text': 'Utforska AEM:s utvecklingsverktyg f\xF6r headless',
    'technical_docs.tools.title': 'Verktyg',
    'what_is_headless.text':
      'AEM Headless CMS ger utvecklarna friheten att g\xF6ra det som de \xE4r b\xE4st p\xE5: att bygga snabbare och leverera exceptionella upplevelser med hj\xE4lp av de spr\xE5k, ramverk och verktyg som de \xE4r vana vid.',
    'what_is_headless.title': 'Vad \xE4r AEM Headless CMS?',
  },
  XE = {
    'app.hero.cta': '\u89C2\u770B\u5B83\u662F\u5982\u4F55\u8FD0\u4F5C\u7684',
    'app.hero.solution': 'Adobe Experience Manager Headless',
    'app.hero.text':
      '\u4E86\u89E3\u901A\u8FC7 AEM Headless CMS \u6784\u5EFA\u548C\u6295\u653E\u66F4\u597D\u7684\u5E94\u7528\u7A0B\u5E8F\u548C\u66F4\u5FEB\u7684\u4F53\u9A8C\u6240\u9700\u7684\u4E00\u5207\u3002',
    'app.hero.title': '\u5F00\u59CB\u4F7F\u7528 AEM Headless CMS \u6784\u5EFA',
    'code_by_id.button.back': '\u8FD4\u56DE\u4EE3\u7801\u5E7F\u573A',
    'code_by_id.button.enter_widescreen': '\u8FDB\u5165\u5BBD\u5C4F\u6A21\u5F0F',
    'code_by_id.button.exit_widescreen': '\u9000\u51FA\u5BBD\u5C4F\u6A21\u5F0F',
    'code_index.button.run_the_code': '\u8FD0\u884C\u4EE3\u7801',
    'code_index.text':
      '\u4F7F\u7528 JavaScript \u5E94\u7528\u7A0B\u5E8F\u793A\u4F8B\uFF0C\u5728\u51E0\u79D2\u5185\u6D4B\u8BD5 AEM Headless CMS',
    'code_index.title': '\u4EE3\u7801\u5E7F\u573A',
    'community.links.0': '\u52A0\u5165\u8BA8\u8BBA',
    'community.text':
      '\u5728 Experience League Communities \u4E0A\u4E0E\u6574\u4E2A AEM \u5F00\u53D1\u4EBA\u5458\u793E\u533A\u8BA8\u8BBA\u3001\u63D0\u95EE\u5E76\u83B7\u5F97\u6709\u5173 AEM Headless \u7684\u95EE\u9898\u89E3\u7B54\u3002',
    'community.title': '\u52A0\u5165\u8BA8\u8BBA',
    'error.text': '\u62B1\u6B49\uFF01\u51FA\u73B0\u9519\u8BEF\u3002\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002',
    'error.title': '\u54CE\u5440\uFF01\u51FA\u73B0\u9519\u8BEF\u3002',
    'example_apps_android.links.0': '\u67E5\u770B\u5E94\u7528\u7A0B\u5E8F',
    'example_apps_android.text':
      '\u4E00\u4E2A\u4F7F\u7528 AEM Headless API \u5185\u5BB9\u7684 Java Android \u5E94\u7528\u793A\u4F8B\u3002',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': '\u67E5\u770B\u5E94\u7528\u7A0B\u5E8F',
    'example_apps_ios.text':
      '\u4E00\u4E2A\u4F7F\u7528 AEM Headless API \u5185\u5BB9\u7684 SwiftUI iOS \u5E94\u7528\u793A\u4F8B\u3002',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': '\u67E5\u770B\u5E94\u7528\u7A0B\u5E8F',
    'example_apps_next_js.text':
      '\u4E00\u4E2A\u4F7F\u7528 AEM Headless API \u5185\u5BB9\u7684 Next.js \u5E94\u7528\u7A0B\u5E8F\u793A\u4F8B\u3002',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': '\u67E5\u770B\u5E94\u7528\u7A0B\u5E8F',
    'example_apps_node-js.text':
      '\u4E00\u4E2A\u4F7F\u7528 AEM Headless API \u5185\u5BB9\u7684\u547D\u4EE4\u884C Node.js \u5E94\u7528\u7A0B\u5E8F\u793A\u4F8B\u3002',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': '\u67E5\u770B\u5E94\u7528\u7A0B\u5E8F',
    'example_apps_react.text':
      '\u4E00\u4E2A\u4F7F\u7528 AEM Headless API \u5185\u5BB9\u7684 React \u5E94\u7528\u7A0B\u5E8F\u793A\u4F8B\u3002',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': '\u67E5\u770B\u5E94\u7528\u7A0B\u5E8F',
    'example_apps_web-component.text':
      '\u4E00\u4E2A\u4F7F\u7528 AEM Headless API \u5185\u5BB9\u7684\u7EAF JavaScript Web \u7EC4\u4EF6\u793A\u4F8B\u3002',
    'example_apps_web-component.title': 'Web \u7EC4\u4EF6/JS',
    'experienced_developers.text1':
      '\u901A\u8FC7 { fiveSteps} \u4F7F\u7528 AEM \u521B\u5EFA\u3001\u7BA1\u7406\u548C\u6295\u653E\u4F53\u9A8C\u3002{ break } \u5DF2\u7ECF\u5B8C\u6210\u4E86\uFF1F\u8BF7\u8BBF\u95EE\u6211\u4EEC\u7684 { advancedDocumentation }\u3002',
    'experienced_developers.title': '\u9762\u5411 { emphasis } AEM HEADLESS CMS \u5F00\u53D1\u4EBA\u5458',
    'experienced_developers.title.emphasis': '\u6709\u7ECF\u9A8C\u7684',
    'get_involved_blog.links.0': '\u9605\u8BFB\u535A\u5BA2',
    'get_involved_blog.text':
      '\u5728\u6211\u4EEC\u7684\u6280\u672F\u535A\u5BA2\u4E0A\u9605\u8BFB\u6700\u65B0\u6D88\u606F\u3002',
    'get_involved_blog.title': 'Adobe \u6280\u672F\u535A\u5BA2',
    'get_involved_community.links.0': '\u52A0\u5165\u5BF9\u8BDD',
    'get_involved_community.text':
      '\u52A0\u5165\u6211\u4EEC\u7684\u793E\u533A\u5E76\u4E3A\u60A8\u7684\u95EE\u9898\u627E\u5230\u7B54\u6848\u3002',
    'get_involved_community.title': 'Experience League \u793E\u533A',
    'nav.codePlayground': '\u4EE3\u7801\u5E7F\u573A',
    'nav.home': '\u4E3B\u9875',
    'nav.title': 'AEM Headless CMS \u5F00\u53D1\u4EBA\u5458\u95E8\u6237',
    'new_developers.text':
      '\u9605\u8BFB\u6B64 { guideLink } \u4EE5\u4E86\u89E3 AEM \u7684\u65E0\u5934 CMS \u529F\u80FD\u4EE5\u53CA\u5982\u4F55\u5728\u65E0\u5934\u5F00\u53D1\u9879\u76EE\u4E2D\u5229\u7528\u8FD9\u4E9B\u529F\u80FD\u3002',
    'new_developers.text.5_steps': '5 \u4E2A\u6B65\u9AA4',
    'new_developers.text.advanced_documentation': '\u9AD8\u7EA7\u6587\u6863',
    'new_developers.text.guide_link': '\u6307\u5357',
    'new_developers.title': '\u9762\u5411 { emphasis } AEM HEADLESS CMS \u7684\u5F00\u53D1\u4EBA\u5458',
    'new_developers.title.emphasis': '\u65B0\u7684',
    'new_to_aem_headless.links.0': '\u9605\u8BFB\u6307\u5357',
    'page.description':
      '\u8BBF\u95EE AEM Headless CMS \u5F00\u53D1\u4EBA\u5458\u8D44\u6E90\u548C\u6587\u6863\u3002\u4E86\u89E3\u5982\u4F55\u4F7F\u7528 Experience Manager as a Cloud Service \u4E2D\u7684\u65E0\u5934 CMS \u6280\u672F\u6784\u5EFA\u4E0B\u4E00\u4EE3\u5E94\u7528\u7A0B\u5E8F\u3002',
    'page.title': 'AEM Headless CMS \u5F00\u53D1\u4EBA\u5458\u8D44\u6E90\u548C\u6587\u6863 | Adobe Experience Manager',
    'quick_setup.links.0': '\u4E91\u670D\u52A1\u7684\u5FEB\u901F\u8BBE\u7F6E',
    'quick_setup.links.1': '\u672C\u5730 AEM SDK \u7684\u5FEB\u901F\u8BBE\u7F6E',
    'quick_setup.text':
      '\u4F7F\u7528 React \u5E94\u7528\u7A0B\u5E8F\u793A\u4F8B\uFF0C\u5728\u51E0\u5206\u949F\u5185\u8BBE\u7F6E\u548C\u6D4B\u8BD5 AEM Headless\u3002',
    'quick_setup.title': '\u5FEB\u901F\u8BBE\u7F6E',
    'section_developer_resources.title': '\u9AD8\u7EA7\u6587\u6863',
    'section_example_apps.title': 'AEM Headless CMS \u5E94\u7528\u7A0B\u5E8F\u793A\u4F8B',
    'section_get_involved.title': '\u53C2\u4E0E\u5176\u4E2D\uFF01',
    'section_spa_editor.text':
      'AEM SPA \u7F16\u8F91\u5668\u63D0\u4F9B\u4E86\u4E00\u4E2A\u7528\u6765\u5F00\u53D1 React \u6216 Angular \u5E94\u7528\u7A0B\u5E8F\u7684\u6846\u67B6\uFF0C\u8425\u9500\u4EBA\u5458\u53EF\u4EE5\u4F7F\u7528 AEM \u521B\u4F5C UI \u5728\u4E0A\u4E0B\u6587\u4E2D\u66F4\u65B0\u8FD9\u4E9B\u5E94\u7528\u7A0B\u5E8F\u3002',
    'section_spa_editor.title': '\u63A2\u7D22 AEM SPA \u7F16\u8F91\u5668',
    'spa_editor.links.0': '\u5F00\u59CB React \u6559\u7A0B',
    'spa_editor.text':
      'AEM SPA \u7F16\u8F91\u5668\u53EF\u7528\u4E8E\u521B\u5EFA\u5176\u7EC4\u4EF6\u3001\u8DEF\u7531\u548C\u89C6\u56FE\u53EF\u5B8C\u5168\u5728 AEM \u4E2D\u7BA1\u7406\u7684 SPA\u3002SPA \u7F16\u8F91\u5668\u652F\u6301 React \u6846\u67B6\u3002',
    'spa_editor.title': '\u5728 AEM \u4E2D\u7BA1\u7406 SPA',
    'spa_editor_remote_spa.links.0': '\u5F00\u59CB\u6559\u7A0B',
    'spa_editor_remote_spa.text':
      '\u5229\u7528 AEM \u7684\u8FDC\u7A0B SPA \u529F\u80FD\uFF0C\u8425\u9500\u4EBA\u5458\u80FD\u591F\u66F4\u65B0\u8FDC\u7A0B\u6258\u7BA1 SPA \u7684\u76EE\u6807\u533A\u57DF\u3002',
    'spa_editor_remote_spa.title': '\u7F16\u5199\u8FDC\u7A0B SPA',
    'technical_docs.apis.section.formsapis': 'AEM Forms HTTP API',
    'technical_docs.apis.section.formsapis.links.0': 'AEM Forms API (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.1': 'GraphQL \u67E5\u8BE2\u6837\u672C',
    'technical_docs.apis.section.relatedhttpapis': '\u76F8\u5173 HTTP API',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM Assets HTTP API',
    'technical_docs.apis.text':
      '\u4E86\u89E3 AEM \u7684 GraphQL API \u4EE5\u53CA\u5982\u4F55\u6784\u5EFA\u67E5\u8BE2\u548C HTTP \u8BF7\u6C42\u3002',
    'technical_docs.apis.title': 'API',
    'technical_docs.documentation.section.contentfragments': '\u5185\u5BB9\u7247\u6BB5',
    'technical_docs.documentation.section.contentfragments.links.0': '\u542F\u7528\u5185\u5BB9\u7247\u6BB5',
    'technical_docs.documentation.section.contentfragments.links.1': '\u5185\u5BB9\u7247\u6BB5\u6A21\u578B',
    'technical_docs.documentation.section.contentfragments.links.2': '\u7BA1\u7406\u5185\u5BB9\u7247\u6BB5',
    'technical_docs.documentation.section.contentfragments.links.3': '\u53D8\u5316',
    'technical_docs.documentation.section.contentfragments.links.4': '\u76F8\u5173\u5185\u5BB9',
    'technical_docs.documentation.section.contentfragments.links.5': '\u5143\u6570\u636E',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': '\u7ED3\u6784\u6811',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON \u9884\u89C8',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Headless \u81EA\u9002\u5E94\u8868\u5355',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL AEM \u7AEF\u70B9',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': '\u542F\u7528 GraphQL \u7AEF\u70B9',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': '\u53D1\u5E03 GraphQL \u7AEF\u70B9',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': '\u6301\u7EED\u67E5\u8BE2',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': '\u53D1\u5E03\u6301\u4E45\u67E5\u8BE2',
    'technical_docs.documentation.text':
      '\u67E5\u770B Adobe Experience Manager as a Cloud Service \u6587\u6863\uFF0C\u4E86\u89E3 AEM \u529F\u80FD\u548C\u914D\u7F6E\u7684\u5B8C\u6574\u63CF\u8FF0\u3002',
    'technical_docs.documentation.title': '\u5176\u4ED6\u6587\u6863',
    'technical_docs.how-to.section.content': '\u5185\u5BB9',
    'technical_docs.how-to.section.content.links.0': '\u5BCC\u6587\u672C',
    'technical_docs.how-to.section.content.links.1': '\u56FE\u50CF',
    'technical_docs.how-to.section.content.links.2': '\u672C\u5730\u5316\u5185\u5BB9',
    'technical_docs.how-to.section.content.links.3': '\u5927\u578B\u7ED3\u679C\u96C6',
    'technical_docs.how-to.section.content.links.4': '\u9884\u89C8',
    'technical_docs.how-to.section.deployment': '\u90E8\u7F72',
    'technical_docs.how-to.section.deployment.links.0': '\u5355\u9875\u5E94\u7528',
    'technical_docs.how-to.section.deployment.links.1': 'Web \u7EC4\u4EF6',
    'technical_docs.how-to.section.deployment.links.2': '\u79FB\u52A8\u8BBE\u5907',
    'technical_docs.how-to.section.deployment.links.3': '\u670D\u52A1\u5668\u5230\u670D\u52A1\u5668',
    'technical_docs.how-to.section.development': '\u5F00\u53D1',
    'technical_docs.how-to.section.development.links.0': 'AEM Headless SDK',
    'technical_docs.how-to.section.development.links.1': '\u5728 AEM 6.5 \u4E0A\u5B89\u88C5 GraphiQL IDE',
    'technical_docs.how-to.text':
      '\u4E86\u89E3\u5982\u4F55\u4F7F\u7528 AEM Headless \u5904\u7406\u4E0D\u540C\u7684\u7528\u4F8B\u3002',
    'technical_docs.how-to.title': '\u64CD\u4F5C\u6307\u5357',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0': '\u5BA2\u6237\u7AEF JS SDK',
    'technical_docs.sdks.section.javascript.links.1': '\u670D\u52A1\u5668\u7AEF JS SDK',
    'technical_docs.sdks.section.javascript.links.2': 'jwt-auth npm \u6A21\u5757',
    'technical_docs.sdks.text': '\u4F7F\u7528 AEM Headless SDK \u4E0E AEM Headless API \u4EA4\u4E92\u3002',
    'technical_docs.sdks.title': 'SDK',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'AEM 6.5 GraphiQL \u5B89\u88C5\u6307\u5357',
    'technical_docs.tools.text': '\u63A2\u7D22 AEM \u7684\u65E0\u5934\u5F00\u53D1\u4EBA\u5458\u5DE5\u5177\u3002',
    'technical_docs.tools.title': '\u5DE5\u5177',
    'what_is_headless.text':
      'AEM Headless CMS \u8BA9\u5F00\u53D1\u4EBA\u5458\u53EF\u4EE5\u81EA\u7531\u5730\u505A\u81EA\u5DF1\u6700\u64C5\u957F\u7684\u4E8B\u60C5\uFF1A\u4F7F\u7528\u4ED6\u4EEC\u5DF2\u7ECF\u719F\u6089\u7684\u8BED\u8A00\u3001\u6846\u67B6\u548C\u5DE5\u5177\u66F4\u5FEB\u5730\u6784\u5EFA\u5E76\u63D0\u4F9B\u5353\u8D8A\u7684\u4F53\u9A8C\u3002',
    'what_is_headless.title': '\u4EC0\u4E48\u662F AEM Headless CMS\uFF1F',
  },
  ZE = {
    'app.hero.cta': '\u89C0\u770B\u904B\u4F5C\u65B9\u5F0F',
    'app.hero.solution': 'Adobe Experience Manager \u7121\u5468\u908A',
    'app.hero.text':
      '\u95DC\u65BC\u5B78\u7FD2 AEM headless CMS \u4EE5\u5EFA\u7ACB\u548C\u63D0\u4EA4\u66F4\u7CBE\u5F69\u7684\u61C9\u7528\u7A0B\u5F0F\u548C\u66F4\u5FEB\u901F\u7684\u9AD4\u9A57\u6240\u9700\u7684\u4E00\u5207\u5167\u5BB9\u3002',
    'app.hero.title': '\u958B\u59CB\u4F7F\u7528 AEM \u7121\u5468\u908A CMS',
    'code_by_id.button.back': '\u8FD4\u56DE\u7A0B\u5F0F\u78BC\u6E2C\u8A66\u7DB2',
    'code_by_id.button.enter_widescreen': '\u9032\u5165\u5BEC\u7192\u5E55\u6A21\u5F0F',
    'code_by_id.button.exit_widescreen': '\u9000\u51FA\u5BEC\u7192\u5E55\u6A21\u5F0F',
    'code_index.button.run_the_code': '\u57F7\u884C\u7A0B\u5F0F\u78BC',
    'code_index.text':
      '\u4F7F\u7528 JavaScript \u61C9\u7528\u7A0B\u5F0F\u7BC4\u4F8B\u5728\u6578\u79D2\u5167\u6E2C\u8A66 AEM \u7121\u5468\u908A CMS\uFF01',
    'code_index.title': '\u7A0B\u5F0F\u78BC\u6E2C\u8A66\u7DB2',
    'community.links.0': '\u52A0\u5165\u8A0E\u8AD6',
    'community.text':
      '\u85C9\u52A9 Experience League \u793E\u7FA4\u4E0A\u7684 AEM \u958B\u767C\u4EBA\u54E1\u793E\u7FA4\uFF0C\u5C31 AEM Headless \u76F8\u95DC\u554F\u984C\u5C55\u958B\u8A0E\u8AD6\u3001\u54A8\u8A62\u4EE5\u53CA\u7372\u53D6\u89E3\u7B54\u3002',
    'community.title': '\u52A0\u5165\u8A0E\u8AD6',
    'error.text': '\u62B1\u6B49\uFF0C\u767C\u751F\u932F\u8AA4\u3002\u8ACB\u7A0D\u5F8C\u518D\u8A66\u3002',
    'error.title': '\u7CDF\u7CD5\uFF01\u767C\u751F\u932F\u8AA4\u3002',
    'example_apps_android.links.0': '\u6AA2\u8996\u61C9\u7528\u7A0B\u5F0F',
    'example_apps_android.text':
      '\u900F\u904E AEM Headless API \u53D6\u7528\u5167\u5BB9\u7684 Java Android \u61C9\u7528\u7A0B\u5F0F\u7BC4\u4F8B\u3002',
    'example_apps_android.title': 'Android',
    'example_apps_ios.links.0': '\u6AA2\u8996\u61C9\u7528\u7A0B\u5F0F',
    'example_apps_ios.text':
      '\u900F\u904E AEM Headless API \u53D6\u7528\u5167\u5BB9\u7684 SwiftUI iOS \u61C9\u7528\u7A0B\u5F0F\u7BC4\u4F8B\u3002',
    'example_apps_ios.title': 'iOS',
    'example_apps_next_js.links.0': '\u6AA2\u8996\u61C9\u7528\u7A0B\u5F0F',
    'example_apps_next_js.text':
      '\u900F\u904E AEM Headless API \u53D6\u7528\u5167\u5BB9\u7684 Next.js \u61C9\u7528\u7A0B\u5F0F\u7BC4\u4F8B\u3002',
    'example_apps_next_js.title': 'Next.js',
    'example_apps_node-js.links.0': '\u6AA2\u8996\u61C9\u7528\u7A0B\u5F0F',
    'example_apps_node-js.text':
      '\u900F\u904E AEM Headless API \u53D6\u7528\u5167\u5BB9\u7684\u6307\u4EE4\u5217 Node.js \u61C9\u7528\u7A0B\u5F0F\u7BC4\u4F8B\u3002',
    'example_apps_node-js.title': 'Node.js',
    'example_apps_react.links.0': '\u6AA2\u8996\u61C9\u7528\u7A0B\u5F0F',
    'example_apps_react.text':
      '\u900F\u904E AEM Headless API \u53D6\u7528\u5167\u5BB9\u7684 React \u61C9\u7528\u7A0B\u5F0F\u7BC4\u4F8B\u3002',
    'example_apps_react.title': 'React',
    'example_apps_web-component.links.0': '\u6AA2\u8996\u61C9\u7528\u7A0B\u5F0F',
    'example_apps_web-component.text':
      '\u900F\u904E AEM Headless API \u53D6\u7528\u5167\u5BB9\u7684\u7D14 JavaScript Web \u5143\u4EF6\u7BC4\u4F8B\u3002',
    'example_apps_web-component.title': 'Web \u5143\u4EF6/JS',
    'experienced_developers.text1':
      '\u700F\u89BD\u4F7F\u7528 AEM \u5EFA\u7ACB\u3001\u7BA1\u7406\u548C\u4EA4\u4ED8\u9AD4\u9A57\u7684 { fiveSteps}\u3002{ break } \u5982\u679C\u5DF2\u5B8C\u6210\uFF0C\u8ACB\u524D\u5F80\u700F\u89BD\u6211\u5011\u7684 { advancedDocumentation }\u3002',
    'experienced_developers.title':
      '\u9069\u7528\u65BC { emphasis } AEM \u7121\u5468\u908A CMS \u958B\u767C\u4EBA\u54E1',
    'experienced_developers.title.emphasis': '\u7D93\u9A57\u8C50\u5BCC\u7684',
    'get_involved_blog.links.0': '\u95B1\u8B80\u90E8\u843D\u683C',
    'get_involved_blog.text':
      '\u95B1\u8B80\u6211\u5011\u7684\u6280\u8853\u90E8\u843D\u683C\u4E0A\u7684\u6700\u65B0\u8CC7\u8A0A\u3002',
    'get_involved_blog.title': 'Adobe \u6280\u8853\u90E8\u843D\u683C',
    'get_involved_community.links.0': '\u52A0\u5165\u6703\u8A71',
    'get_involved_community.text':
      '\u52A0\u5165\u6211\u5011\u7684\u793E\u7FA4\uFF0C\u7372\u53D6\u554F\u984C\u7684\u7B54\u6848\u3002',
    'get_involved_community.title': 'Experience League \u793E\u7FA4',
    'nav.codePlayground': '\u7A0B\u5F0F\u78BC\u6E2C\u8A66\u7DB2',
    'nav.home': '\u9996\u9801',
    'nav.title': 'AEM \u7121\u5468\u908A CMS \u958B\u767C\u4EBA\u54E1\u5165\u53E3\u7DB2\u7AD9',
    'new_developers.text':
      '\u95B1\u8B80\u6B64 { guideLink }\uFF0C\u4E86\u89E3 AEM \u7684\u7121\u5468\u908A CMS \u529F\u80FD\uFF0C\u4EE5\u53CA\u5982\u4F55\u5728\u7121\u5468\u908A\u958B\u767C\u5C08\u6848\u4E2D\u52A0\u4EE5\u5229\u7528\u3002',
    'new_developers.text.5_steps': '5 \u500B\u6B65\u9A5F',
    'new_developers.text.advanced_documentation': '\u9032\u968E\u6587\u4EF6',
    'new_developers.text.guide_link': '\u6307\u5357',
    'new_developers.title': '\u9069\u7528\u65BC { emphasis } AEM \u7121\u5468\u908A CMS \u958B\u767C\u4EBA\u54E1',
    'new_developers.title.emphasis': '\u65B0',
    'new_to_aem_headless.links.0': '\u95B1\u8B80\u6307\u5357',
    'page.description':
      '\u9020\u8A2A AEM \u7121\u5468\u908A CMS \u958B\u767C\u4EBA\u54E1\u8CC7\u6E90\u8207\u6587\u4EF6\u3002\u4E86\u89E3\u5982\u4F55\u4F7F\u7528 Experience Manager as a Cloud Service \u4E2D\u7684\u7121\u5468\u908A CMS \u6280\u8853\u5EFA\u7F6E\u4E0B\u4E00\u4EE3\u61C9\u7528\u7A0B\u5F0F\u3002',
    'page.title':
      'AEM \u7121\u5468\u908A CMS \u958B\u767C\u4EBA\u54E1\u8CC7\u6E90\u548C\u6587\u4EF6 | Adobe Experience Manager',
    'quick_setup.links.0': 'Cloud Service \u7684\u5FEB\u901F\u8A2D\u5B9A',
    'quick_setup.links.1': '\u672C\u6A5F AEM SDK \u7684\u5FEB\u901F\u8A2D\u5B9A',
    'quick_setup.text':
      '\u4F7F\u7528 React \u61C9\u7528\u7A0B\u5F0F\u7BC4\u4F8B\u6578\u5206\u9418\u5167\u8A2D\u5B9A\u548C\u8A66\u904B\u884C AEM Headless',
    'quick_setup.title': '\u5FEB\u901F\u8A2D\u5B9A',
    'section_developer_resources.title': '\u9032\u968E\u6587\u4EF6',
    'section_example_apps.title': 'AEM \u7121\u5468\u908A CMS \u61C9\u7528\u7A0B\u5F0F\u7BC4\u4F8B',
    'section_get_involved.title': '\u5FEB\u4F86\u53C3\u8207\uFF01',
    'section_spa_editor.text':
      'AEM SPA Editor \u63D0\u4F9B\u958B\u767C React \u6216 Angular \u61C9\u7528\u7A0B\u5F0F\u7684\u6846\u67B6\uFF0C\u884C\u92B7\u4EBA\u54E1\u53EF\u4EE5\u4F7F\u7528 AEM \u88FD\u4F5C UI \u5728\u60C5\u5883\u4E2D\u66F4\u65B0 React \u6216 Angular \u61C9\u7528\u7A0B\u5F0F\u3002',
    'section_spa_editor.title': '\u63A2\u7D22 AEM SPA Editor',
    'spa_editor.links.0': '\u958B\u59CB\u5B78\u7FD2 React \u6559\u5B78\u8AB2\u7A0B',
    'spa_editor.text':
      'AEM SPA Editor \u53EF\u7528\u65BC\u5EFA\u7ACB\u4E00\u500B SPA\uFF0C\u4E26\u4E14\u53EF\u4EE5\u5728 AEM \u4E2D\u5168\u9762\u7BA1\u7406\u8A72 SPA \u7684\u5143\u4EF6\u3001\u8DEF\u7531\u4EE5\u53CA\u6AA2\u8996\u3002SPA Editor \u652F\u63F4 React \u6846\u67B6\u3002',
    'spa_editor.title': '\u7BA1\u7406 AEM \u4E2D\u7684 SPA',
    'spa_editor_remote_spa.links.0': '\u958B\u59CB\u5B78\u7FD2\u6559\u5B78\u8AB2\u7A0B',
    'spa_editor_remote_spa.text':
      'AEM \u7684\u9060\u8DDD SPA \u529F\u80FD\u652F\u6301\u884C\u92B7\u4EBA\u54E1\u66F4\u65B0\u9060\u8DDD\u8A17\u7BA1\u7684 SPA \u7684\u76EE\u6A19\u5340\u57DF\u3002',
    'spa_editor_remote_spa.title': '\u88FD\u4F5C\u9060\u8DDD SPA',
    'technical_docs.apis.section.formsapis': 'AEM Forms HTTP API',
    'technical_docs.apis.section.formsapis.links.0': 'AEM Forms API (OpenAPI)',
    'technical_docs.apis.section.graphqlapis': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.0': 'GraphQL API',
    'technical_docs.apis.section.graphqlapis.links.1': 'GraphQL \u67E5\u8A62\u7BC4\u4F8B',
    'technical_docs.apis.section.relatedhttpapis': '\u76F8\u95DC\u7684 HTTP API',
    'technical_docs.apis.section.relatedhttpapis.links.0': 'AEM Assets HTTP API',
    'technical_docs.apis.text':
      '\u77AD\u89E3 AEM \u7684 GraphQL API \u4EE5\u53CA\u5982\u4F55\u5EFA\u69CB\u67E5\u8A62\u548C HTTP \u8ACB\u6C42\u3002',
    'technical_docs.apis.title': 'API',
    'technical_docs.documentation.section.contentfragments': '\u5167\u5BB9\u7247\u6BB5',
    'technical_docs.documentation.section.contentfragments.links.0': '\u958B\u555F\u5167\u5BB9\u7247\u6BB5',
    'technical_docs.documentation.section.contentfragments.links.1': '\u5167\u5BB9\u7247\u6BB5\u6A21\u578B',
    'technical_docs.documentation.section.contentfragments.links.2': '\u7BA1\u7406\u5167\u5BB9\u7247\u6BB5',
    'technical_docs.documentation.section.contentfragments.links.3': '\u8B8A\u9AD4',
    'technical_docs.documentation.section.contentfragments.links.4': '\u76F8\u95DC\u5167\u5BB9',
    'technical_docs.documentation.section.contentfragments.links.5': '\u4E2D\u7E7C\u8CC7\u6599',
    'technical_docs.documentation.section.contentfragments.links.6': 'Markdown',
    'technical_docs.documentation.section.contentfragments.links.7': '\u7D50\u69CB\u6A39',
    'technical_docs.documentation.section.contentfragments.links.8': 'JSON \u9810\u89BD',
    'technical_docs.documentation.section.forms': 'AEM Forms',
    'technical_docs.documentation.section.forms.links.0': 'Headless Adaptive Forms',
    'technical_docs.documentation.section.graphqlaemendpoint': 'GraphQL AEM \u7AEF\u9EDE',
    'technical_docs.documentation.section.graphqlaemendpoint.links.0': '\u555F\u7528 GraphQL \u7AEF\u9EDE',
    'technical_docs.documentation.section.graphqlaemendpoint.links.1': '\u767C\u4F48 GraphQL \u7AEF\u9EDE',
    'technical_docs.documentation.section.graphqlaemendpoint.links.2': '\u4FDD\u5B58\u7684\u67E5\u8A62',
    'technical_docs.documentation.section.graphqlaemendpoint.links.3': '\u767C\u4F48\u6C38\u7E8C\u67E5\u8A62',
    'technical_docs.documentation.text':
      '\u6AA2\u8996 Adobe Experience Manager as a Cloud Services \u6587\u4EF6\uFF0C\u7372\u53D6 AEM \u7684\u529F\u80FD\u548C\u8A2D\u5B9A\u7684\u5B8C\u6574\u8AAA\u660E\u3002',
    'technical_docs.documentation.title': '\u5176\u4ED6\u6587\u4EF6',
    'technical_docs.how-to.section.content': '\u5167\u5BB9',
    'technical_docs.how-to.section.content.links.0': 'Rich Text',
    'technical_docs.how-to.section.content.links.1': '\u5F71\u50CF',
    'technical_docs.how-to.section.content.links.2': '\u672C\u5730\u5316\u7684\u5167\u5BB9',
    'technical_docs.how-to.section.content.links.3': '\u5927\u578B\u7D50\u679C\u96C6',
    'technical_docs.how-to.section.content.links.4': '\u9810\u89BD',
    'technical_docs.how-to.section.deployment': '\u90E8\u7F72',
    'technical_docs.how-to.section.deployment.links.0': '\u55AE\u4E00\u9801\u9762\u61C9\u7528\u7A0B\u5F0F',
    'technical_docs.how-to.section.deployment.links.1': 'Web \u5143\u4EF6',
    'technical_docs.how-to.section.deployment.links.2': '\u884C\u52D5',
    'technical_docs.how-to.section.deployment.links.3': '\u4F3A\u670D\u5668\u5C0D\u4F3A\u670D\u5668',
    'technical_docs.how-to.section.development': '\u958B\u767C',
    'technical_docs.how-to.section.development.links.0': 'AEM Headless SDK',
    'technical_docs.how-to.section.development.links.1': '\u5728 AEM 6.5 \u4E0A\u5B89\u88DD GraphiQL IDE',
    'technical_docs.how-to.text':
      '\u4E86\u89E3\u5982\u4F55\u85C9\u52A9 AEM Headless \u8655\u7406\u4E0D\u540C\u7684\u4F7F\u7528\u6848\u4F8B\u3002',
    'technical_docs.how-to.title': '\u4F7F\u7528\u65B9\u6CD5\u6307\u5357',
    'technical_docs.sdks.section.java': 'Java',
    'technical_docs.sdks.section.java.links.0': 'Java SDK',
    'technical_docs.sdks.section.javascript': 'JavaScript',
    'technical_docs.sdks.section.javascript.links.0': '\u7528\u6236\u7AEF JS SDK',
    'technical_docs.sdks.section.javascript.links.1': '\u4F3A\u670D\u5668\u7AEF JS SDK',
    'technical_docs.sdks.section.javascript.links.2': 'jwt-auth npm \u6A21\u7D44',
    'technical_docs.sdks.text': '\u4F7F\u7528 AEM Headless SDK \u8207 AEM Headless API \u4E92\u52D5\u3002',
    'technical_docs.sdks.title': 'SDK',
    'technical_docs.tools.section.graphiql': 'GraphiQL',
    'technical_docs.tools.section.graphiql.links.0': 'GraphiQL IDE',
    'technical_docs.tools.section.graphiql.links.1': 'AEM 6.5 GraphiQL \u5B89\u88DD\u6307\u5357',
    'technical_docs.tools.text': '\u63A2\u7D22 AEM \u4E2D\u7684\u7121 UI \u958B\u767C\u4EBA\u54E1\u5DE5\u5177\u3002',
    'technical_docs.tools.title': '\u5DE5\u5177',
    'what_is_headless.text':
      'AEM \u7121\u5468\u908A CMS \u8B93\u958B\u767C\u4EBA\u54E1\u53EF\u4EE5\u81EA\u7531\u5730\u767C\u63EE\u5176\u512A\u52E2\uFF1A\u4F7F\u7528\u4ED6\u5011\u65E9\u5DF2\u719F\u77E5\u7684\u8A9E\u8A00\u3001\u6846\u67B6\u548C\u5DE5\u5177\u66F4\u5FEB\u901F\u5EFA\u7ACB\u548C\u4EA4\u4ED8\u975E\u51E1\u7684\u9AD4\u9A57\u3002',
    'what_is_headless.title': '\u4EC0\u9EBC\u662F AEM \u7121\u5468\u908A CMS\uFF1F',
  },
  YE = 'modulepreload',
  ek = function (e) {
    return '/' + e;
  },
  Np = {},
  tk = function (t, n, i) {
    if (!n || n.length === 0) return t();
    const r = document.getElementsByTagName('link');
    return Promise.all(
      n.map((o) => {
        if (((o = ek(o)), o in Np)) return;
        Np[o] = !0;
        const a = o.endsWith('.css'),
          s = a ? '[rel="stylesheet"]' : '';
        if (i)
          for (let u = r.length - 1; u >= 0; u--) {
            const f = r[u];
            if (f.href === o && (!a || f.rel === 'stylesheet')) return;
          }
        else if (document.querySelector(`link[href="${o}"]${s}`)) return;
        const c = document.createElement('link');
        if (
          ((c.rel = a ? 'stylesheet' : YE),
          a || ((c.as = 'script'), (c.crossOrigin = '')),
          (c.href = o),
          document.head.appendChild(c),
          a)
        )
          return new Promise((u, f) => {
            c.addEventListener('load', u),
              c.addEventListener('error', () => f(new Error(`Unable to preload CSS for ${o}`)));
          });
      }),
    ).then(() => t());
  },
  nk = (e) => {
    e &&
      e instanceof Function &&
      tk(() => import('./web-vitals.c993bc77.js'), []).then(
        ({ getCLS: t, getFID: n, getFCP: i, getLCP: r, getTTFB: o }) => {
          t(e), n(e), i(e), r(e), o(e);
        },
      );
  };
class ik {
  constructor(t) {
    vs(this, 'windowLocation');
    this.windowLocation = t;
  }
  getLanguage() {
    let t = 'en';
    return (
      (t = document.getElementsByTagName('html')[0].getAttribute('lang') || 'en'), t.indexOf('<') === 0 && (t = 'en'), t
    );
  }
}
const rk = {
    de: UE,
    en: BE,
    fr: $E,
    ko: QE,
    es: GE,
    ja: VE,
    it: qE,
    nl: WE,
    'pt-BR': KE,
    sv: JE,
    'zh-Hans': XE,
    'zh-Hant': ZE,
  },
  el = new ik(window.location).getLanguage(),
  ok = document.getElementById('microsite-root'),
  ak = $f(ok);
ak.render(
  _(pc.StrictMode, {
    children: _(vy, { locale: el, messages: rk[el], children: _(hE, { value: el, children: _(zE, {}) }) }),
  }),
);
nk();
